// 49 CFR 172.101 — Hazardous Materials Table
// Source: https://www.ecfr.gov/current/title-49/subtitle-B/chapter-I/subchapter-C/part-172/subpart-B/section-172.101
// Fetched from eCFR on 2026-07-12 (Title 49 latest amendment: 2026-07-06)
// Re-generate: node hazwaste-backend/scripts/generate-cfr-172-101-hazmat-table.mjs

export interface HazmatTableEntry {
  /** Column 1: Symbols (+, A, D, G, I, W) */ symbols: string;
  /** Column 2: Proper shipping name */ properShippingName: string;
  /** Column 3: Hazard class or division */ hazardClass: string;
  /** Column 4: UN/NA identification number */ idNumber: string;
  /** Column 5: Packing Group */ packingGroup: 'I' | 'II' | 'III' | null;
  /** Column 6: Label codes */ labelCodes: string;
  /** Column 7: Special provisions (172.102 codes) */ specialProvisions: string;
  /** Column 8a: Packaging 173.xxx Exceptions */ packagingExceptions: string;
  /** Column 8b: Packaging 173.xxx Non-bulk */ packagingNonBulk: string;
  /** Column 8c: Packaging 173.xxx Bulk */ packagingBulk: string;
  /** Column 9a: Passenger aircraft/rail quantity limit */ passengerQtyLimit: string;
  /** Column 9b: Cargo aircraft only quantity limit */ cargoQtyLimit: string;
  /** Column 10a: Vessel stowage location */ vesselStowageLocation: string;
  /** Column 10b: Vessel stowage other codes */ vesselStowageOther: string;
}

/** All entries from 49 CFR 172.101 Hazardous Materials Table. */
export const HAZMAT_TABLE: readonly HazmatTableEntry[] = [
  {
    symbols: '',
    properShippingName: 'Acetal',
    hazardClass: '3',
    idNumber: 'UN1088',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Acetaldehyde',
    hazardClass: '3',
    idNumber: 'UN1089',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'B16, T11, TP2, TP7',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: 'A',
    properShippingName: 'Acetaldehyde ammonia',
    hazardClass: '9',
    idNumber: 'UN1841',
    packingGroup: 'III',
    labelCodes: '9',
    specialProvisions: 'IB8, IP3, IP7, T1, TP33',
    packagingExceptions: '155',
    packagingNonBulk: '204',
    packagingBulk: '240',
    passengerQtyLimit: '200 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '34',
  },
  {
    symbols: '',
    properShippingName: 'Acetaldehyde oxime',
    hazardClass: '3',
    idNumber: 'UN2332',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Acetic acid, glacial or Acetic acid solution, with more than 80 percent acid, by mass',
    hazardClass: '8',
    idNumber: 'UN2789',
    packingGroup: 'II',
    labelCodes: '8, 3',
    specialProvisions: 'A3, A7, A10, B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Acetic acid solution, not less than 50 percent but not more than 80 percent acid, by mass',
    hazardClass: '8',
    idNumber: 'UN2790',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: '148, A3, A7, A10, B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Acetic acid solution, with more than 10 percent and less than 50 percent acid, by mass',
    hazardClass: '8',
    idNumber: 'UN2790',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: '148, IB3, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Acetic anhydride',
    hazardClass: '8',
    idNumber: 'UN1715',
    packingGroup: 'II',
    labelCodes: '8, 3',
    specialProvisions: 'A3, A7, A10, B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Acetone',
    hazardClass: '3',
    idNumber: 'UN1090',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Acetone cyanohydrin, stabilized',
    hazardClass: '6.1',
    idNumber: 'UN1541',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '2, B9, B14, B32, B76, B77, N34, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40, 52, 53',
  },
  {
    symbols: '',
    properShippingName: 'Acetone oils',
    hazardClass: '3',
    idNumber: 'UN1091',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1, TP8',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Acetonitrile',
    hazardClass: '3',
    idNumber: 'UN1648',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Acetyl bromide',
    hazardClass: '8',
    idNumber: 'UN1716',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T8, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Acetyl chloride',
    hazardClass: '3',
    idNumber: 'UN1717',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'A3, A7, IB1, N34, T8, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Acetyl iodide',
    hazardClass: '8',
    idNumber: 'UN1898',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T7, TP2, TP13',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Acetyl methyl carbinol',
    hazardClass: '3',
    idNumber: 'UN2621',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Acetylene, dissolved',
    hazardClass: '2.1',
    idNumber: 'UN1001',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'N86, N88',
    packagingExceptions: 'None',
    packagingNonBulk: '303',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40, 57',
  },
  {
    symbols: '',
    properShippingName: 'Acridine',
    hazardClass: '6.1',
    idNumber: 'UN2713',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Acrolein dimer, stabilized',
    hazardClass: '3',
    idNumber: 'UN2607',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: '387, B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Acrolein, stabilized',
    hazardClass: '6.1',
    idNumber: 'UN1092',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '1, 380, 387, B9, B14, B30, B42, B77, T22, TP2, TP7, TP13, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Acrylamide, solid',
    hazardClass: '6.1',
    idNumber: 'UN2074',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 25',
  },
  {
    symbols: '',
    properShippingName: 'Acrylamide solution',
    hazardClass: '6.1',
    idNumber: 'UN3426',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 25',
  },
  {
    symbols: '',
    properShippingName: 'Acrylic acid, stabilized',
    hazardClass: '8',
    idNumber: 'UN2218',
    packingGroup: 'II',
    labelCodes: '8, 3',
    specialProvisions: '387, B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '25, 40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Acrylonitrile, stabilized',
    hazardClass: '3',
    idNumber: 'UN1093',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: '387, B9, T14, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Adhesives, containing a flammable liquid',
    hazardClass: '3',
    idNumber: 'UN1133',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'T11, TP1, TP8, TP27',
    packagingExceptions: '150',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Adiponitrile',
    hazardClass: '6.1',
    idNumber: 'UN2205',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T3, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, n.o.s',
    hazardClass: '2.2',
    idNumber: 'UN3511',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, flammable, n.o.s',
    hazardClass: '2.1',
    idNumber: 'UN3510',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, oxidizing, n.o.s',
    hazardClass: '2.2',
    idNumber: 'UN3513',
    packingGroup: null,
    labelCodes: '2.2, 5.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, toxic, n.o.s. Inhalation hazard zone A',
    hazardClass: '2.3',
    idNumber: 'UN3512',
    packingGroup: null,
    labelCodes: '2.3',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, toxic, n.o.s. Inhalation hazard zone B',
    hazardClass: '2.3',
    idNumber: 'UN3512',
    packingGroup: null,
    labelCodes: '2.3',
    specialProvisions: '2, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, toxic, n.o.s. Inhalation hazard zone C',
    hazardClass: '2.3',
    idNumber: 'UN3512',
    packingGroup: null,
    labelCodes: '2.3',
    specialProvisions: '3, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, toxic, n.o.s. Inhalation hazard zone D',
    hazardClass: '2.3',
    idNumber: 'UN3512',
    packingGroup: null,
    labelCodes: '2.3',
    specialProvisions: '4',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, toxic, corrosive, n.o.s. Inhalation hazard zone A',
    hazardClass: '2.3',
    idNumber: 'UN3516',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '1, 379',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, toxic, corrosive, n.o.s. Inhalation hazard zone B',
    hazardClass: '2.3',
    idNumber: 'UN3516',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '2, 379, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, toxic, corrosive, n.o.s. Inhalation hazard zone C',
    hazardClass: '2.3',
    idNumber: 'UN3516',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '3, 379, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, toxic, corrosive, n.o.s. Inhalation hazard zone D',
    hazardClass: '2.3',
    idNumber: 'UN3516',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '4, 379',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, toxic, flammable, n.o.s. Inhalation hazard zone A',
    hazardClass: '2.3',
    idNumber: 'UN3514',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, toxic, flammable, n.o.s. Inhalation hazard zone B',
    hazardClass: '2.3',
    idNumber: 'UN3514',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '2, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, toxic, flammable, n.o.s. Inhalation hazard zone C',
    hazardClass: '2.3',
    idNumber: 'UN3514',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '3, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, toxic, flammable, n.o.s. Inhalation hazard zone D',
    hazardClass: '2.3',
    idNumber: 'UN3514',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '4',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, toxic, flammable, corrosive, n.o.s. Inhalation hazard zone A',
    hazardClass: '2.3',
    idNumber: 'UN3517',
    packingGroup: null,
    labelCodes: '2.3, 2.1, 8',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '17, 40',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, toxic, flammable, corrosive, n.o.s. Inhalation hazard zone B',
    hazardClass: '2.3',
    idNumber: 'UN3517',
    packingGroup: null,
    labelCodes: '2.3, 2.1, 8',
    specialProvisions: '2, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '17, 40',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, toxic, flammable, corrosive, n.o.s. Inhalation hazard zone C',
    hazardClass: '2.3',
    idNumber: 'UN3517',
    packingGroup: null,
    labelCodes: '2.3, 2.1, 8',
    specialProvisions: '3, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '17, 40',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, toxic, flammable, corrosive, n.o.s. Inhalation hazard zone D',
    hazardClass: '2.3',
    idNumber: 'UN3517',
    packingGroup: null,
    labelCodes: '2.3, 2.1, 8',
    specialProvisions: '4',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '17, 40',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, toxic, oxidizing, n.o.s. Inhalation hazard zone A',
    hazardClass: '2.3',
    idNumber: 'UN3515',
    packingGroup: null,
    labelCodes: '2.3, 5.1',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, toxic, oxidizing, n.o.s. Inhalation hazard zone B',
    hazardClass: '2.3',
    idNumber: 'UN3515',
    packingGroup: null,
    labelCodes: '2.3, 5.1',
    specialProvisions: '2, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, toxic, oxidizing, n.o.s. Inhalation hazard zone C',
    hazardClass: '2.3',
    idNumber: 'UN3515',
    packingGroup: null,
    labelCodes: '2.3, 5.1',
    specialProvisions: '3, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, toxic, oxidizing, n.o.s. Inhalation hazard zone D',
    hazardClass: '2.3',
    idNumber: 'UN3515',
    packingGroup: null,
    labelCodes: '2.3, 5.1',
    specialProvisions: '4',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, toxic, oxidizing, corrosive, n.o.s. Inhalation hazard zone A',
    hazardClass: '2.3',
    idNumber: 'UN3518',
    packingGroup: null,
    labelCodes: '2.3, 5.1, 8',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 89, 90',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, toxic, oxidizing, corrosive, n.o.s. Inhalation hazard zone B',
    hazardClass: '2.3',
    idNumber: 'UN3518',
    packingGroup: null,
    labelCodes: '2.3, 5.1, 8',
    specialProvisions: '2, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 89, 90',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, toxic, oxidizing, corrosive, n.o.s. Inhalation hazard zone C',
    hazardClass: '2.3',
    idNumber: 'UN3518',
    packingGroup: null,
    labelCodes: '2.3, 5.1, 8',
    specialProvisions: '3, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 89, 90',
  },
  {
    symbols: 'G',
    properShippingName: 'Adsorbed gas, toxic, oxidizing, corrosive, n.o.s. Inhalation hazard zone D',
    hazardClass: '2.3',
    idNumber: 'UN3518',
    packingGroup: null,
    labelCodes: '2.3, 5.1, 8',
    specialProvisions: '4',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 89, 90',
  },
  {
    symbols: '',
    properShippingName: 'Aerosols, corrosive, Packing Group II or III, (each not exceeding 1 L capacity)',
    hazardClass: '2.2',
    idNumber: 'UN1950',
    packingGroup: null,
    labelCodes: '2.2, 8',
    specialProvisions: 'A34',
    packagingExceptions: '306',
    packagingNonBulk: 'None',
    packagingBulk: 'None',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '25, 87, 126, 157',
  },
  {
    symbols: '',
    properShippingName: 'Aerosols, flammable, (each not exceeding 1 L capacity)',
    hazardClass: '2.1',
    idNumber: 'UN1950',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'N82',
    packagingExceptions: '306',
    packagingNonBulk: 'None',
    packagingBulk: 'None',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '25, 87, 126, 157',
  },
  {
    symbols: '',
    properShippingName: 'Aerosols, flammable, n.o.s. (engine starting fluid) (each not exceeding 1 L capacity)',
    hazardClass: '2.1',
    idNumber: 'UN1950',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'N82',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '25, 87, 126, 157',
  },
  {
    symbols: '',
    properShippingName: 'Aerosols, non-flammable, (each not exceeding 1 L capacity)',
    hazardClass: '2.2',
    idNumber: 'UN1950',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: 'None',
    packagingBulk: 'None',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '25, 87, 126, 157',
  },
  {
    symbols: '',
    properShippingName: 'Aerosols, poison, Packing Group III (each not exceeding 1 L capacity)',
    hazardClass: '2.2',
    idNumber: 'UN1950',
    packingGroup: null,
    labelCodes: '2.2, 6.1',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: 'None',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '25, 87, 126, 157',
  },
  {
    symbols: '',
    properShippingName: 'Air, compressed',
    hazardClass: '2.2',
    idNumber: 'UN1002',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '78',
    packagingExceptions: '306, 307',
    packagingNonBulk: '302',
    packagingBulk: '302',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Air, refrigerated liquid, (cryogenic liquid)',
    hazardClass: '2.2',
    idNumber: 'UN1003',
    packingGroup: null,
    labelCodes: '2.2, 5.1',
    specialProvisions: 'T75, TP5, TP22',
    packagingExceptions: '320',
    packagingNonBulk: '316',
    packagingBulk: '318, 319',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '51',
  },
  {
    symbols: '',
    properShippingName: 'Air, refrigerated liquid, (cryogenic liquid) non-pressurized',
    hazardClass: '2.2',
    idNumber: 'UN1003',
    packingGroup: null,
    labelCodes: '2.2, 5.1',
    specialProvisions: 'T75, TP5, TP22',
    packagingExceptions: '320',
    packagingNonBulk: '316',
    packagingBulk: '318, 319',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '51',
  },
  {
    symbols: '',
    properShippingName:
      'Aircraft hydraulic power unit fuel tank (containing a mixture of anhydrous hydrazine and monomethyl hydrazine) (M86 fuel)',
    hazardClass: '3',
    idNumber: 'UN3165',
    packingGroup: 'I',
    labelCodes: '3, 6.1, 8',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '172',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '42 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '21, 40, 49, 100',
  },
  {
    symbols: 'G',
    properShippingName: 'Alcoholates solution, n.o.s., in alcohol',
    hazardClass: '3',
    idNumber: 'UN3274',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'IB2',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Alcoholic beverages',
    hazardClass: '3',
    idNumber: 'UN3065',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: '24, 149, B1, IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Alcohols, n.o.s.',
    hazardClass: '3',
    idNumber: 'UN1987',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: '172, T11, TP1, TP8, TP27',
    packagingExceptions: '4b',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Alcohols, flammable, toxic n.o.s',
    hazardClass: '3',
    idNumber: 'UN1986',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Aldehydes, n.o.s.',
    hazardClass: '3',
    idNumber: 'UN1989',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'T11, TP1, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Aldehydes, flammable, toxic, n.o.s.',
    hazardClass: '3',
    idNumber: 'UN1988',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Aldol',
    hazardClass: '6.1',
    idNumber: 'UN2839',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 25',
  },
  {
    symbols: 'G',
    properShippingName: 'Alkali metal alcoholates, self-heating, corrosive, n.o.s.',
    hazardClass: '4.2',
    idNumber: 'UN3206',
    packingGroup: 'II',
    labelCodes: '4.2, 8',
    specialProvisions: '64, A7, IB5, IP2, T3, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Alkali metal alloys, liquid, n.o.s',
    hazardClass: '4.3',
    idNumber: 'UN1421',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A2, A7, B48, N34, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '1 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Alkali metal amalgam, liquid',
    hazardClass: '4.3',
    idNumber: 'UN1389',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A2, A7, N34, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '1 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 40, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Alkali metal amalgam, solid',
    hazardClass: '4.3',
    idNumber: 'UN3401',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'IB4, IP1, N40, T9, TP7, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Alkali metal amides',
    hazardClass: '4.3',
    idNumber: 'UN1390',
    packingGroup: 'II',
    labelCodes: '4.3',
    specialProvisions: 'A6, A7, A8, A19, A20, IB7, IP2, IP21, T3, TP33, W31, W40',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Alkali metal dispersions, flammable or Alkaline earth metal dispersions, flammable',
    hazardClass: '4.3',
    idNumber: 'UN3482',
    packingGroup: 'I',
    labelCodes: '4.3, 3',
    specialProvisions: 'A2, A7, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '1 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Alkali metal dispersions, or Alkaline earth metal dispersions',
    hazardClass: '4.3',
    idNumber: 'UN1391',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A2, A7, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '1 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Alkaline earth metal alcoholates, n.o.s',
    hazardClass: '4.2',
    idNumber: 'UN3205',
    packingGroup: 'II',
    labelCodes: '4.2',
    specialProvisions: '65, A7, IB6, IP2, T3, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Alkaline earth metal alloys, n.o.s',
    hazardClass: '4.3',
    idNumber: 'UN1393',
    packingGroup: 'II',
    labelCodes: '4.3',
    specialProvisions: 'A19, IB7, IP2, IP4, T3, TP33, W31, W40',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Alkaline earth metal amalgams, liquid',
    hazardClass: '4.3',
    idNumber: 'UN1392',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A19, N34, N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '1 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Alkaline earth metal amalgams, solid',
    hazardClass: '4.3',
    idNumber: 'UN3402',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A19, N34, N40, T9, TP7, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Alkaloids, liquid, n.o.s., or Alkaloid salts, liquid, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN3140',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'A4, T14, TP2, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Alkaloids, solid, n.o.s. or Alkaloid salts, solid, n.o.s. poisonous',
    hazardClass: '6.1',
    idNumber: 'UN1544',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Alkyl sulfonic acids, liquid or Aryl sulfonic acids, liquid with more than 5 percent free sulfuric acid',
    hazardClass: '8',
    idNumber: 'UN2584',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T8, TP2, TP13',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName:
      'Alkyl sulfonic acids, liquid or Aryl sulfonic acids, liquid with not more than 5 percent free sulfuric acid',
    hazardClass: '8',
    idNumber: 'UN2586',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName:
      'Alkyl sulfonic acids, solid or Aryl sulfonic acids, solid, with more than 5 percent free sulfuric acid',
    hazardClass: '8',
    idNumber: 'UN2583',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName:
      'Alkyl sulfonic acids, solid or Aryl sulfonic acids, solid with not more than 5 percent free sulfuric acid',
    hazardClass: '8',
    idNumber: 'UN2585',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Alkylphenols, liquid, n.o.s. (including C2-C12 homologues)',
    hazardClass: '8',
    idNumber: 'UN3145',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'T14, TP2',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Alkylphenols, solid, n.o.s. (including C2-C12 homologues)',
    hazardClass: '8',
    idNumber: 'UN2430',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Alkylsulfuric acids',
    hazardClass: '8',
    idNumber: 'UN2571',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T8, TP2, TP13, TP28',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '14, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Allyl acetate',
    hazardClass: '3',
    idNumber: 'UN2333',
    packingGroup: 'II',
    labelCodes: '3, 6.1',
    specialProvisions: 'IB2, T7, TP1, TP13',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Allyl alcohol',
    hazardClass: '6.1',
    idNumber: 'UN1098',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '2, B9, B14, B32, B77, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Allyl bromide',
    hazardClass: '3',
    idNumber: 'UN1099',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: 'T14, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Allyl chloride',
    hazardClass: '3',
    idNumber: 'UN1100',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: 'T14, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Allyl chloroformate',
    hazardClass: '6.1',
    idNumber: 'UN1722',
    packingGroup: 'I',
    labelCodes: '6.1, 3, 8',
    specialProvisions: '2, B9, B14, B32, N41, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '21, 40, 53, 58, 100',
  },
  {
    symbols: '',
    properShippingName: 'Allyl ethyl ether',
    hazardClass: '3',
    idNumber: 'UN2335',
    packingGroup: 'II',
    labelCodes: '3, 6.1',
    specialProvisions: 'IB2, T7, TP1, TP13',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Allyl formate',
    hazardClass: '3',
    idNumber: 'UN2336',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: 'T14, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Allyl glycidyl ether',
    hazardClass: '3',
    idNumber: 'UN2219',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Allyl iodide',
    hazardClass: '3',
    idNumber: 'UN1723',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'A3, IB1, N34, T7, TP2, TP13',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Allyl isothiocyanate, stabilized',
    hazardClass: '6.1',
    idNumber: 'UN1545',
    packingGroup: 'II',
    labelCodes: '6.1, 3',
    specialProvisions: '387, A3, A7, IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Allylamine',
    hazardClass: '6.1',
    idNumber: 'UN2334',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '2, B9, B14, B32, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Allyltrichlorosilane, stabilized',
    hazardClass: '8',
    idNumber: 'UN1724',
    packingGroup: 'II',
    labelCodes: '8, 3',
    specialProvisions: '387, A7, B2, B6, N34, T10, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '25, 40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Aluminum borohydride or Aluminum borohydride in devices',
    hazardClass: '4.2',
    idNumber: 'UN2870',
    packingGroup: 'I',
    labelCodes: '4.2, 4.3',
    specialProvisions: 'B11, T21, TP7, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '181',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: '',
    properShippingName: 'Aluminum bromide, anhydrous',
    hazardClass: '8',
    idNumber: 'UN1725',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Aluminum bromide, solution',
    hazardClass: '8',
    idNumber: 'UN2580',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Aluminum carbide',
    hazardClass: '4.3',
    idNumber: 'UN1394',
    packingGroup: 'II',
    labelCodes: '4.3',
    specialProvisions: 'A20, IB7, IP2, IP21, N41, T3, TP33, W31, W40',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Aluminum chloride, anhydrous',
    hazardClass: '8',
    idNumber: 'UN1726',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Aluminum chloride, solution',
    hazardClass: '8',
    idNumber: 'UN2581',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Aluminum ferrosilicon powder',
    hazardClass: '4.3',
    idNumber: 'UN1395',
    packingGroup: 'II',
    labelCodes: '4.3, 6.1',
    specialProvisions: 'A19, IB5, IP2, T3, TP33, W31, W40',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 39, 40, 52, 53, 85, 103, 148',
  },
  {
    symbols: '',
    properShippingName: 'Aluminum hydride',
    hazardClass: '4.3',
    idNumber: 'UN2463',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A19, N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: 'D',
    properShippingName: 'Aluminum, molten',
    hazardClass: '9',
    idNumber: 'NA9260',
    packingGroup: 'III',
    labelCodes: '9',
    specialProvisions: 'IB3, T1, TP3',
    packagingExceptions: 'None',
    packagingNonBulk: 'None',
    packagingBulk: '247',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Aluminum nitrate',
    hazardClass: '5.1',
    idNumber: 'UN1438',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: 'A1, A29, IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Aluminum phosphide',
    hazardClass: '4.3',
    idNumber: 'UN1397',
    packingGroup: 'I',
    labelCodes: '4.3, 6.1',
    specialProvisions: 'A8, A19, N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 52, 85, 148',
  },
  {
    symbols: '',
    properShippingName: 'Aluminum phosphide pesticides',
    hazardClass: '6.1',
    idNumber: 'UN3048',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'A8, IB7, IP1, T6, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40, 85',
  },
  {
    symbols: '',
    properShippingName: 'Aluminum powder, coated',
    hazardClass: '4.1',
    idNumber: 'UN1309',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: 'IB8, IP2, IP21, T3, TP33, W100',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 39, 52, 53, 74, 101, 147, 148',
  },
  {
    symbols: '',
    properShippingName: 'Aluminum powder, uncoated',
    hazardClass: '4.3',
    idNumber: 'UN1396',
    packingGroup: 'II',
    labelCodes: '4.3',
    specialProvisions: 'A19, A20, IB7, IP2, IP21, T3, TP33, W31, W40',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 39, 52, 53, 148',
  },
  {
    symbols: '',
    properShippingName: 'Aluminum resinate',
    hazardClass: '4.1',
    idNumber: 'UN2715',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: 'IB6, T1, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Aluminum silicon powder, uncoated',
    hazardClass: '4.3',
    idNumber: 'UN1398',
    packingGroup: 'III',
    labelCodes: '4.3',
    specialProvisions: 'A1, A19, B136, IB8, IP4, T1, TP33, W31',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '241',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 39, 40, 52, 53, 85, 103, 148',
  },
  {
    symbols: '',
    properShippingName: 'Aluminum smelting by-products or Aluminum remelting by-products',
    hazardClass: '4.3',
    idNumber: 'UN3170',
    packingGroup: 'II',
    labelCodes: '4.3',
    specialProvisions: '128, B115, IB7, IP2, IP21, T3, TP33, W31, W40',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '13, 85, 103, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Amine, flammable, corrosive, n.o.s. or Polyamines, flammable, corrosive, n.o.s',
    hazardClass: '3',
    idNumber: 'UN2733',
    packingGroup: 'I',
    labelCodes: '3, 8',
    specialProvisions: 'T14, TP1, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: 'G',
    properShippingName:
      'Amine, liquid, corrosive, flammable, n.o.s. or Polyamines, liquid, corrosive, flammable, n.o.s.',
    hazardClass: '8',
    idNumber: 'UN2734',
    packingGroup: 'I',
    labelCodes: '8, 3',
    specialProvisions: 'A3, N34, T14, TP2, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: 'G',
    properShippingName: 'Amines, liquid, corrosive, n.o.s. or Polyamines, liquid, corrosive, n.o.s',
    hazardClass: '8',
    idNumber: 'UN2735',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'B10, N34, T14, TP2, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: 'G',
    properShippingName: 'Amines, solid, corrosive, n.o.s., or Polyamines, solid, corrosive n.o.s.',
    hazardClass: '8',
    idNumber: 'UN3259',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: '2-Amino-4-chlorophenol',
    hazardClass: '6.1',
    idNumber: 'UN2673',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '2-Amino-5-diethylaminopentane',
    hazardClass: '6.1',
    idNumber: 'UN2946',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '2-Amino-4,6-Dinitrophenol, wetted with not less than 20 percent water by mass',
    hazardClass: '4.1',
    idNumber: 'UN3317',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '23, A8, A19, A20, N41, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: '2-(2-Aminoethoxy) ethanol',
    hazardClass: '8',
    idNumber: 'UN3055',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'N-Aminoethylpiperazine',
    hazardClass: '8',
    idNumber: 'UN2815',
    packingGroup: 'III',
    labelCodes: '8, 6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '12, 25, 40, 52',
  },
  {
    symbols: '+',
    properShippingName: 'Aminophenols (o-; m-; p-)',
    hazardClass: '6.1',
    idNumber: 'UN2512',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Aminopyridines (o-; m-; p-)',
    hazardClass: '6.1',
    idNumber: 'UN2671',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '12, 25, 40, 52',
  },
  {
    symbols: 'I',
    properShippingName: 'Ammonia, anhydrous',
    hazardClass: '2.3',
    idNumber: 'UN1005',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '4, 379, N87, T50',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 52, 57',
  },
  {
    symbols: 'D',
    properShippingName: 'Ammonia, anhydrous',
    hazardClass: '2.2',
    idNumber: 'UN1005',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '13, 379, T50',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 52, 57',
  },
  {
    symbols: '',
    properShippingName:
      'Ammonia solution, relative density less than 0.880 at 15 degrees C in water, with more than 35 percent but not more than 50 percent ammonia',
    hazardClass: '2.2',
    idNumber: 'UN2073',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'N87',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40, 52, 57',
  },
  {
    symbols: '',
    properShippingName:
      'Ammonia solution, relative density between 0.880 and 0.957 at 15 degrees C in water, with more than 10 percent but not more than 35 percent ammonia',
    hazardClass: '8',
    idNumber: 'UN2672',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: '336, IB3, IP8, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 52, 85',
  },
  {
    symbols: 'I',
    properShippingName:
      'Ammonia solution, relative density less than 0.880 at 15 degrees C in water, with more than 50 percent ammonia',
    hazardClass: '2.3',
    idNumber: 'UN3318',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '4, N87, T50',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 52, 57',
  },
  {
    symbols: 'D',
    properShippingName:
      'Ammonia solution, relative density less than 0.880 at 15 degrees C in water, with more than 50 percent ammonia',
    hazardClass: '2.2',
    idNumber: 'UN3318',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '13, T50',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 52, 57',
  },
  {
    symbols: '',
    properShippingName: 'Ammonium arsenate',
    hazardClass: '6.1',
    idNumber: 'UN1546',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53',
  },
  {
    symbols: '',
    properShippingName: 'Ammonium dichromate',
    hazardClass: '5.1',
    idNumber: 'UN1439',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Ammonium dinitro-o-cresolate, solid',
    hazardClass: '6.1',
    idNumber: 'UN1843',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '36, 65, 66, 77',
  },
  {
    symbols: '',
    properShippingName: 'Ammonium dinitro-o-cresolate solution',
    hazardClass: '6.1',
    idNumber: 'UN3424',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '36, 66, 78, 91',
  },
  {
    symbols: '',
    properShippingName: 'Ammonium fluoride',
    hazardClass: '6.1',
    idNumber: 'UN2505',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Ammonium fluorosilicate',
    hazardClass: '6.1',
    idNumber: 'UN2854',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Ammonium hydrogen sulfate',
    hazardClass: '8',
    idNumber: 'UN2506',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Ammonium hydrogendifluoride, solid',
    hazardClass: '8',
    idNumber: 'UN1727',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB8, IP2, IP4, N34, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '25, 40, 52, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Ammonium hydrogendifluoride, solution',
    hazardClass: '8',
    idNumber: 'UN2817',
    packingGroup: 'II',
    labelCodes: '8, 6.1',
    specialProvisions: 'IB2, N34, T8, TP2, TP13',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Ammonium metavanadate',
    hazardClass: '6.1',
    idNumber: 'UN2859',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '44, 89, 100, 141',
  },
  {
    symbols: '',
    properShippingName: 'Ammonium nitrate based fertilizer',
    hazardClass: '5.1',
    idNumber: 'UN2067',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: '52, 148, 150, B120, IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '25, 59, 60, 66, 117, 124*',
  },
  {
    symbols: 'A W',
    properShippingName: 'Ammonium nitrate based fertilizer',
    hazardClass: '9',
    idNumber: 'UN2071',
    packingGroup: 'III',
    labelCodes: '9',
    specialProvisions: '132, B136, IB8, IP3',
    packagingExceptions: '155',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '200 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Ammonium nitrate emulsion or Ammonium nitrate suspension or Ammonium nitrate gel, intermediate for blasting explosives',
    hazardClass: '5.1',
    idNumber: 'UN3375',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: '147, 148, 163, IB2, IP16, TP48',
    packagingExceptions: 'None',
    packagingNonBulk: '231',
    packagingBulk: '251',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 59, 60, 66, 124',
  },
  {
    symbols: '',
    properShippingName: 'Ammonium nitrate-fuel oil mixture containing only prilled ammonium nitrate and fuel oil',
    hazardClass: '1.5D',
    idNumber: 'NA0331',
    packingGroup: null,
    labelCodes: '1.5D',
    specialProvisions: '148',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25, 19E',
  },
  {
    symbols: '',
    properShippingName: 'Ammonium nitrate, liquid (hot concentrated solution)',
    hazardClass: '5.1',
    idNumber: 'UN2426',
    packingGroup: null,
    labelCodes: '5.1',
    specialProvisions: '148, B5, T7',
    packagingExceptions: 'None',
    packagingNonBulk: 'None',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '59, 60, 124',
  },
  {
    symbols: '',
    properShippingName:
      'Ammonium nitrate, with more than 0.2 percent combustible substances, including any organic substance calculated as carbon, to the exclusion of any other added substance',
    hazardClass: '1.1D',
    idNumber: 'UN0222',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '370',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 19E',
  },
  {
    symbols: '',
    properShippingName:
      'Ammonium nitrate, with not more than 0.2% combustible substances, including any organic substance calculated as carbon, to the exclusion of any other added substance',
    hazardClass: '5.1',
    idNumber: 'UN1942',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: '148, A1, A29, B120, IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '25, 59, 60, 66, 116, 124',
  },
  {
    symbols: '',
    properShippingName: 'Ammonium perchlorate',
    hazardClass: '1.1D',
    idNumber: 'UN0402',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '107',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 19E',
  },
  {
    symbols: '',
    properShippingName: 'Ammonium perchlorate',
    hazardClass: '5.1',
    idNumber: 'UN1442',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: '107, A9, IB6, IP2, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '58, 69',
  },
  {
    symbols: '',
    properShippingName: 'Ammonium persulfate',
    hazardClass: '5.1',
    idNumber: 'UN1444',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: 'A1, A29, IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ammonium picrate, dry or wetted with less than 10 percent water, by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0004',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 5E, 19E',
  },
  {
    symbols: '',
    properShippingName: 'Ammonium picrate, wetted with not less than 10 percent water, by mass',
    hazardClass: '4.1',
    idNumber: 'UN1310',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '23, A2, N41, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: '0.5 kg',
    cargoQtyLimit: '0.5 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Ammonium polysulfide, solution',
    hazardClass: '8',
    idNumber: 'UN2818',
    packingGroup: 'II',
    labelCodes: '8, 6.1',
    specialProvisions: 'IB2, T7, TP2, TP13',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '12, 25, 40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Ammonium polyvanadate',
    hazardClass: '6.1',
    idNumber: 'UN2861',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '44, 89, 100, 141',
  },
  {
    symbols: '',
    properShippingName: 'Ammonium sulfide solution',
    hazardClass: '8',
    idNumber: 'UN2683',
    packingGroup: 'II',
    labelCodes: '8, 6.1, 3',
    specialProvisions: 'IB1, T7, TP2, TP13',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '12, 22, 25, 52, 100',
  },
  {
    symbols: '',
    properShippingName: 'Ammunition, illuminating with or without burster, expelling charge or propelling charge',
    hazardClass: '1.2G',
    idNumber: 'UN0171',
    packingGroup: null,
    labelCodes: '1.2G',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Ammunition, illuminating with or without burster, expelling charge or propelling charge',
    hazardClass: '1.3G',
    idNumber: 'UN0254',
    packingGroup: null,
    labelCodes: '1.3G',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Ammunition, illuminating with or without burster, expelling charge or propelling charge',
    hazardClass: '1.4G',
    idNumber: 'UN0297',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Ammunition, incendiary liquid or gel, with burster, expelling charge or propelling charge',
    hazardClass: '1.3J',
    idNumber: 'UN0247',
    packingGroup: null,
    labelCodes: '1.3J',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 23E',
  },
  {
    symbols: '',
    properShippingName: 'Ammunition, incendiary, white phosphorus, with burster, expelling charge or propelling charge',
    hazardClass: '1.2H',
    idNumber: 'UN0243',
    packingGroup: null,
    labelCodes: '1.2H',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 14E, 15E, 17E',
  },
  {
    symbols: '',
    properShippingName: 'Ammunition, incendiary, white phosphorus, with burster, expelling charge or propelling charge',
    hazardClass: '1.3H',
    idNumber: 'UN0244',
    packingGroup: null,
    labelCodes: '1.3H',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 14E, 15E, 17E',
  },
  {
    symbols: '',
    properShippingName: 'Ammunition, incendiary with or without burster, expelling charge, or propelling charge',
    hazardClass: '1.2G',
    idNumber: 'UN0009',
    packingGroup: null,
    labelCodes: '1.2G',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Ammunition, incendiary with or without burster, expelling charge, or propelling charge',
    hazardClass: '1.3G',
    idNumber: 'UN0010',
    packingGroup: null,
    labelCodes: '1.3G',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Ammunition, incendiary with or without burster, expelling charge or propelling charge',
    hazardClass: '1.4G',
    idNumber: 'UN0300',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Ammunition, practice',
    hazardClass: '1.4G',
    idNumber: 'UN0362',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Ammunition, practice',
    hazardClass: '1.3G',
    idNumber: 'UN0488',
    packingGroup: null,
    labelCodes: '1.3G',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Ammunition, proof',
    hazardClass: '1.4G',
    idNumber: 'UN0363',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Ammunition smoke, white phosphorus with burster, expelling charge, or propelling charge',
    hazardClass: '1.2H',
    idNumber: 'UN0245',
    packingGroup: null,
    labelCodes: '1.2H',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 14E, 15E, 17E',
  },
  {
    symbols: '',
    properShippingName: 'Ammunition, smoke, white phosphorus with burster, expelling charge, or propelling charge',
    hazardClass: '1.3H',
    idNumber: 'UN0246',
    packingGroup: null,
    labelCodes: '1.3H',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 14E, 15E, 17E',
  },
  {
    symbols: '',
    properShippingName: 'Ammunition, smoke with or without burster, expelling charge or propelling charge',
    hazardClass: '1.2G',
    idNumber: 'UN0015',
    packingGroup: null,
    labelCodes: '1.2G',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25, 17E',
  },
  {
    symbols: '',
    properShippingName: 'Ammunition, smoke with or without burster, expelling charge or propelling charge',
    hazardClass: '1.3G',
    idNumber: 'UN0016',
    packingGroup: null,
    labelCodes: '1.3G',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25, 17E',
  },
  {
    symbols: '',
    properShippingName: 'Ammunition, smoke with or without burster, expelling charge or propelling charge',
    hazardClass: '1.4G',
    idNumber: 'UN0303',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25, 14E, 15E, 17E',
  },
  {
    symbols: '',
    properShippingName: 'Ammunition, tear-producing, non-explosive, without burster or expelling charge, non-fuzed',
    hazardClass: '6.1',
    idNumber: 'UN2017',
    packingGroup: null,
    labelCodes: '6.1, 8',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40',
  },
  {
    symbols: '',
    properShippingName: 'Ammunition, tear-producing with burster, expelling charge or propelling charge',
    hazardClass: '1.2G',
    idNumber: 'UN0018',
    packingGroup: null,
    labelCodes: '1.2G, 8, 6.1',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25, 17E',
  },
  {
    symbols: '',
    properShippingName: 'Ammunition, tear-producing with burster, expelling charge or propelling charge',
    hazardClass: '1.3G',
    idNumber: 'UN0019',
    packingGroup: null,
    labelCodes: '1.3G, 8, 6.1',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25, 17E',
  },
  {
    symbols: '',
    properShippingName: 'Ammunition, tear-producing with burster, expelling charge or propelling charge',
    hazardClass: '1.4G',
    idNumber: 'UN0301',
    packingGroup: null,
    labelCodes: '1.4G, 8, 6.1',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25, 14E, 15E, 17E',
  },
  {
    symbols: '',
    properShippingName: 'Ammunition, toxic, non-explosive, without burster or expelling charge, non-fuzed',
    hazardClass: '6.1',
    idNumber: 'UN2016',
    packingGroup: null,
    labelCodes: '6.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40',
  },
  {
    symbols: 'G',
    properShippingName: 'Ammunition, toxic with burster, expelling charge, or propelling charge',
    hazardClass: '1.2K',
    idNumber: 'UN0020',
    packingGroup: null,
    labelCodes: '1.2K, 6.1',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 14E, 15E, 17E',
  },
  {
    symbols: 'G',
    properShippingName: 'Ammunition, toxic with burster, expelling charge, or propelling charge',
    hazardClass: '1.3K',
    idNumber: 'UN0021',
    packingGroup: null,
    labelCodes: '1.3K, 6.1',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 14E, 15E, 17E',
  },
  {
    symbols: '',
    properShippingName: 'Amyl acetates',
    hazardClass: '3',
    idNumber: 'UN1104',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Amyl acid phosphate',
    hazardClass: '8',
    idNumber: 'UN2819',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Amyl butyrates',
    hazardClass: '3',
    idNumber: 'UN2620',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Amyl chloride',
    hazardClass: '3',
    idNumber: 'UN1107',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Amyl formates',
    hazardClass: '3',
    idNumber: 'UN1109',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Amyl mercaptan',
    hazardClass: '3',
    idNumber: 'UN1111',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'A3, IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '95, 102',
  },
  {
    symbols: '',
    properShippingName: 'n-Amyl methyl ketone',
    hazardClass: '3',
    idNumber: 'UN1110',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Amyl nitrate',
    hazardClass: '3',
    idNumber: 'UN1112',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Amyl nitrite',
    hazardClass: '3',
    idNumber: 'UN1113',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Amylamines',
    hazardClass: '3',
    idNumber: 'UN1106',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'IB2, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Amyltrichlorosilane',
    hazardClass: '8',
    idNumber: 'UN1728',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, B2, B6, N34, T10, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '+',
    properShippingName: 'Aniline',
    hazardClass: '6.1',
    idNumber: 'UN1547',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Aniline hydrochloride',
    hazardClass: '6.1',
    idNumber: 'UN1548',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Anisidines',
    hazardClass: '6.1',
    idNumber: 'UN2431',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Anisole',
    hazardClass: '3',
    idNumber: 'UN2222',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Anisoyl chloride',
    hazardClass: '8',
    idNumber: 'UN1729',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, B4, IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: 'G',
    properShippingName: 'Antimony compounds, inorganic, liquid, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN3141',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: '35, IB3, T7, TP1, TP28',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Antimony compounds, inorganic, solid, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN1549',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: '35, IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Antimony lactate',
    hazardClass: '6.1',
    idNumber: 'UN1550',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Antimony pentachloride, liquid',
    hazardClass: '8',
    idNumber: 'UN1730',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Antimony pentachloride, solutions',
    hazardClass: '8',
    idNumber: 'UN1731',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Antimony pentafluoride',
    hazardClass: '8',
    idNumber: 'UN1732',
    packingGroup: 'II',
    labelCodes: '8, 6.1',
    specialProvisions: 'A3, A7, A10, IB2, N3, N36, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 44, 53, 58, 89, 100, 141',
  },
  {
    symbols: '',
    properShippingName: 'Antimony potassium tartrate',
    hazardClass: '6.1',
    idNumber: 'UN1551',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Antimony powder',
    hazardClass: '6.1',
    idNumber: 'UN2871',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Antimony trichloride, liquid',
    hazardClass: '8',
    idNumber: 'UN1733',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Antimony trichloride, solid',
    hazardClass: '8',
    idNumber: 'UN1733',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Argon, compressed',
    hazardClass: '2.2',
    idNumber: 'UN1006',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '',
    packagingExceptions: '306, 307',
    packagingNonBulk: '302',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Argon, refrigerated liquid (cryogenic liquid)',
    hazardClass: '2.2',
    idNumber: 'UN1951',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T75, TP5',
    packagingExceptions: '320',
    packagingNonBulk: '316',
    packagingBulk: '318',
    passengerQtyLimit: '50 kg',
    cargoQtyLimit: '500 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Arsenic',
    hazardClass: '6.1',
    idNumber: 'UN1558',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Arsenic acid, liquid',
    hazardClass: '6.1',
    idNumber: 'UN1553',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T20, TP2, TP7, TP13, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '46',
  },
  {
    symbols: '',
    properShippingName: 'Arsenic acid, solid',
    hazardClass: '6.1',
    idNumber: 'UN1554',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Arsenic bromide',
    hazardClass: '6.1',
    idNumber: 'UN1555',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 25, 40',
  },
  {
    symbols: 'G',
    properShippingName:
      'Arsenic compounds, liquid, n.o.s. inorganic, including arsenates, n.o.s.; arsenites, n.o.s.; arsenic sulfides, n.o.s.; and organic compounds of arsenic, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN1556',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 137',
  },
  {
    symbols: 'G',
    properShippingName:
      'Arsenic compounds, solid, n.o.s. inorganic, including arsenates, n.o.s.; arsenites, n.o.s.; arsenic sulfides, n.o.s.; and organic compounds of arsenic, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN1557',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '137',
  },
  {
    symbols: '',
    properShippingName: 'Arsenic pentoxide',
    hazardClass: '6.1',
    idNumber: 'UN1559',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Arsenic trichloride',
    hazardClass: '6.1',
    idNumber: 'UN1560',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '2, B9, B14, B32, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Arsenic trioxide',
    hazardClass: '6.1',
    idNumber: 'UN1561',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Arsenical dust',
    hazardClass: '6.1',
    idNumber: 'UN1562',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Arsenical pesticides, liquid, flammable, toxic, flash point less than 23 degrees C',
    hazardClass: '3',
    idNumber: 'UN2760',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Arsenical pesticides, liquid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN2994',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Arsenical pesticides, liquid, toxic, flammable, flash point not less than 23 degrees C',
    hazardClass: '6.1',
    idNumber: 'UN2993',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Arsenical pesticides, solid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN2759',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Arsine',
    hazardClass: '2.3',
    idNumber: 'UN2188',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '192',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Arsine, adsorbed',
    hazardClass: '2.3',
    idNumber: 'UN3522',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles containing a substance liable to spontaneous combustion, n.o.s.',
    hazardClass: '4.2',
    idNumber: 'UN3542',
    packingGroup: null,
    labelCodes: '4.2',
    specialProvisions: '131, 391',
    packagingExceptions: 'None',
    packagingNonBulk: '214',
    packagingBulk: '214',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles containing a substance which in contact with water emits flammable gases, n.o.s.',
    hazardClass: '4.3',
    idNumber: 'UN3543',
    packingGroup: null,
    labelCodes: '4.3',
    specialProvisions: '131, 391',
    packagingExceptions: 'None',
    packagingNonBulk: '214',
    packagingBulk: '214',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles containing corrosive substance, n.o.s.',
    hazardClass: '8',
    idNumber: 'UN3547',
    packingGroup: null,
    labelCodes: '8',
    specialProvisions: '391',
    packagingExceptions: 'None',
    packagingNonBulk: '232',
    packagingBulk: '232',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles containing flammable gas, n.o.s.',
    hazardClass: '2.1',
    idNumber: 'UN3537',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '391',
    packagingExceptions: 'None',
    packagingNonBulk: '232',
    packagingBulk: '232',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles containing flammable liquid, n.o.s.',
    hazardClass: '3',
    idNumber: 'UN3540',
    packingGroup: null,
    labelCodes: '3',
    specialProvisions: '391',
    packagingExceptions: 'None',
    packagingNonBulk: '232',
    packagingBulk: '232',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles containing flammable solid, n.o.s.',
    hazardClass: '4.1',
    idNumber: 'UN3541',
    packingGroup: null,
    labelCodes: '4.1',
    specialProvisions: '391',
    packagingExceptions: 'None',
    packagingNonBulk: '232',
    packagingBulk: '232',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles containing miscellaneous dangerous goods, n.o.s.',
    hazardClass: '9',
    idNumber: 'UN3548',
    packingGroup: null,
    labelCodes: '9',
    specialProvisions: '391, A224',
    packagingExceptions: 'None',
    packagingNonBulk: '232',
    packagingBulk: '232',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles containing non-flammable, non-toxic gas, n.o.s.',
    hazardClass: '2.2',
    idNumber: 'UN3538',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '391,396, A225',
    packagingExceptions: 'None',
    packagingNonBulk: '232',
    packagingBulk: '232',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles containing organic peroxide, n.o.s.',
    hazardClass: '5.2',
    idNumber: 'UN3545',
    packingGroup: null,
    labelCodes: '5.2',
    specialProvisions: '131, 391',
    packagingExceptions: 'None',
    packagingNonBulk: '214',
    packagingBulk: '214',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles containing oxidizing substance, n.o.s.',
    hazardClass: '5.1',
    idNumber: 'UN3544',
    packingGroup: null,
    labelCodes: '5.1',
    specialProvisions: '131, 391',
    packagingExceptions: 'None',
    packagingNonBulk: '214',
    packagingBulk: '214',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles containing toxic gas, n.o.s.',
    hazardClass: '2.3',
    idNumber: 'UN3539',
    packingGroup: null,
    labelCodes: '2.3',
    specialProvisions: '131, 391',
    packagingExceptions: 'None',
    packagingNonBulk: '214',
    packagingBulk: '214',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles containing toxic substance, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN3546',
    packingGroup: null,
    labelCodes: '6.1',
    specialProvisions: '391',
    packagingExceptions: 'None',
    packagingNonBulk: '232',
    packagingBulk: '232',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Articles, explosive, extremely insensitive or Articles, EEI',
    hazardClass: '1.6N',
    idNumber: 'UN0486',
    packingGroup: null,
    labelCodes: '1.6N',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles, explosive, n.o.s',
    hazardClass: '1.4S',
    idNumber: 'UN0349',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '101, 148, 347, 382',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles, explosive, n.o.s.',
    hazardClass: '1.4B',
    idNumber: 'UN0350',
    packingGroup: null,
    labelCodes: '1.4B',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles, explosive, n.o.s.',
    hazardClass: '1.4C',
    idNumber: 'UN0351',
    packingGroup: null,
    labelCodes: '1.4C',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles, explosive, n.o.s.',
    hazardClass: '1.4D',
    idNumber: 'UN0352',
    packingGroup: null,
    labelCodes: '1.4D',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles, explosive, n.o.s.',
    hazardClass: '1.4G',
    idNumber: 'UN0353',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles, explosive, n.o.s.',
    hazardClass: '1.1L',
    idNumber: 'UN0354',
    packingGroup: null,
    labelCodes: '1.1L',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '02',
    vesselStowageOther: '25, 14E, 15E',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles, explosive, n.o.s.',
    hazardClass: '1.2L',
    idNumber: 'UN0355',
    packingGroup: null,
    labelCodes: '1.2L',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 14E, 15E',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles, explosive, n.o.s.',
    hazardClass: '1.3L',
    idNumber: 'UN0356',
    packingGroup: null,
    labelCodes: '1.3L',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 14E, 15E',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles, explosive, n.o.s',
    hazardClass: '1.1C',
    idNumber: 'UN0462',
    packingGroup: null,
    labelCodes: '1.1C',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles, explosive, n.o.s',
    hazardClass: '1.1D',
    idNumber: 'UN0463',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles, explosive, n.o.s',
    hazardClass: '1.1E',
    idNumber: 'UN0464',
    packingGroup: null,
    labelCodes: '1.1E',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles, explosive, n.o.s',
    hazardClass: '1.1F',
    idNumber: 'UN0465',
    packingGroup: null,
    labelCodes: '1.1F',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles, explosive, n.o.s',
    hazardClass: '1.2C',
    idNumber: 'UN0466',
    packingGroup: null,
    labelCodes: '1.2C',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles, explosive, n.o.s',
    hazardClass: '1.2D',
    idNumber: 'UN0467',
    packingGroup: null,
    labelCodes: '1.2D',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles, explosive, n.o.s',
    hazardClass: '1.2E',
    idNumber: 'UN0468',
    packingGroup: null,
    labelCodes: '1.2E',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles, explosive, n.o.s',
    hazardClass: '1.2F',
    idNumber: 'UN0469',
    packingGroup: null,
    labelCodes: '1.2F',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles, explosive, n.o.s',
    hazardClass: '1.3C',
    idNumber: 'UN0470',
    packingGroup: null,
    labelCodes: '1.3C',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles, explosive, n.o.s.',
    hazardClass: '1.4E',
    idNumber: 'UN0471',
    packingGroup: null,
    labelCodes: '1.4E',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Articles, explosive, n.o.s',
    hazardClass: '1.4F',
    idNumber: 'UN0472',
    packingGroup: null,
    labelCodes: '1.4F',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Articles, pressurized pneumatic or hydraulic containing non-flammable gas',
    hazardClass: '2.2',
    idNumber: 'UN3164',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '371',
    packagingExceptions: '306',
    packagingNonBulk: '302, 304',
    packagingBulk: 'None',
    passengerQtyLimit: 'No limit',
    cargoQtyLimit: 'No limit',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Articles, pyrophoric',
    hazardClass: '1.2L',
    idNumber: 'UN0380',
    packingGroup: null,
    labelCodes: '1.2L',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 14E, 15E, 17E',
  },
  {
    symbols: '',
    properShippingName: 'Articles, pyrotechnic for technical purposes',
    hazardClass: '1.1G',
    idNumber: 'UN0428',
    packingGroup: null,
    labelCodes: '1.1G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Articles, pyrotechnic for technical purposes',
    hazardClass: '1.2G',
    idNumber: 'UN0429',
    packingGroup: null,
    labelCodes: '1.2G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Articles, pyrotechnic for technical purposes',
    hazardClass: '1.3G',
    idNumber: 'UN0430',
    packingGroup: null,
    labelCodes: '1.3G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Articles, pyrotechnic for technical purposes',
    hazardClass: '1.4G',
    idNumber: 'UN0431',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '381',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Articles, pyrotechnic for technical purposes',
    hazardClass: '1.4S',
    idNumber: 'UN0432',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: 'D',
    properShippingName: 'Asbestos',
    hazardClass: '9',
    idNumber: 'NA2212',
    packingGroup: 'III',
    labelCodes: '9',
    specialProvisions: '156, IB8, IP2, IP4',
    packagingExceptions: '155',
    packagingNonBulk: '216',
    packagingBulk: '216, 240',
    passengerQtyLimit: '200 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '34, 40',
  },
  {
    symbols: 'G I',
    properShippingName: 'Asbestos, amphibole amosite, tremolite, actinolite, anthophyllite, or crocidolite',
    hazardClass: '9',
    idNumber: 'UN2212',
    packingGroup: 'II',
    labelCodes: '9',
    specialProvisions: '156, IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '155',
    packagingNonBulk: '216',
    packagingBulk: '216, 240',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '34, 40',
  },
  {
    symbols: 'I',
    properShippingName: 'Asbestos, chrysotile',
    hazardClass: '9',
    idNumber: 'UN2590',
    packingGroup: 'III',
    labelCodes: '9',
    specialProvisions: '156, IB8, IP2, IP3, T1, TP33',
    packagingExceptions: '155',
    packagingNonBulk: '216',
    packagingBulk: '216, 240',
    passengerQtyLimit: '200 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '34, 40',
  },
  {
    symbols: 'D',
    properShippingName: 'Asphalt, at or above its flash point',
    hazardClass: '3',
    idNumber: 'NA1999',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'IB3, T1, TP3',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '247',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: 'A, G',
    properShippingName: 'Aviation regulated liquid, n.o.s',
    hazardClass: '9',
    idNumber: 'UN3334',
    packingGroup: null,
    labelCodes: '9',
    specialProvisions: 'A35, A189',
    packagingExceptions: '155',
    packagingNonBulk: '204',
    packagingBulk: '',
    passengerQtyLimit: '450 L',
    cargoQtyLimit: '450 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'A, G',
    properShippingName: 'Aviation regulated solid, n.o.s',
    hazardClass: '9',
    idNumber: 'UN3335',
    packingGroup: null,
    labelCodes: '9',
    specialProvisions: 'A35',
    packagingExceptions: '155',
    packagingNonBulk: '204',
    packagingBulk: '',
    passengerQtyLimit: '400 kg',
    cargoQtyLimit: '400 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Azodicarbonamide',
    hazardClass: '4.1',
    idNumber: 'UN3242',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: '38, IB8, T3, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '223',
    packagingBulk: '240',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '2, 52, 53, 74',
  },
  {
    symbols: '',
    properShippingName: 'Barium',
    hazardClass: '4.3',
    idNumber: 'UN1400',
    packingGroup: 'II',
    labelCodes: '4.3',
    specialProvisions: 'A19, IB7, IP2, IP21, T3, TP33, W31, W40',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Barium alloys, pyrophoric',
    hazardClass: '4.2',
    idNumber: 'UN1854',
    packingGroup: 'I',
    labelCodes: '4.2',
    specialProvisions: 'T21, TP7, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '181',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: '',
    properShippingName: 'Barium azide, dry or wetted with less than 50 percent water, by mass',
    hazardClass: '1.1A',
    idNumber: 'UN0224',
    packingGroup: null,
    labelCodes: '1.1A, 6.1',
    specialProvisions: '111, 117',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Barium azide, wetted with not less than 50 percent water, by mass',
    hazardClass: '4.1',
    idNumber: 'UN1571',
    packingGroup: 'I',
    labelCodes: '4.1, 6.1',
    specialProvisions: '162, A2, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '182',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '0.5 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Barium bromate',
    hazardClass: '5.1',
    idNumber: 'UN2719',
    packingGroup: 'II',
    labelCodes: '5.1, 6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Barium chlorate, solid',
    hazardClass: '5.1',
    idNumber: 'UN1445',
    packingGroup: 'II',
    labelCodes: '5.1, 6.1',
    specialProvisions: 'A9, IB6, IP2, N34, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Barium chlorate, solution',
    hazardClass: '5.1',
    idNumber: 'UN3405',
    packingGroup: 'II',
    labelCodes: '5.1, 6.1',
    specialProvisions: 'A9, IB2, N34, T4, TP1',
    packagingExceptions: '152',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58, 133',
  },
  {
    symbols: 'G',
    properShippingName: 'Barium compounds, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN1564',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Barium cyanide',
    hazardClass: '6.1',
    idNumber: 'UN1565',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, N74, N75, T6, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Barium hypochlorite with more than 22 percent available chlorine',
    hazardClass: '5.1',
    idNumber: 'UN2741',
    packingGroup: 'II',
    labelCodes: '5.1, 6.1',
    specialProvisions: 'A7, A9, IB8, IP2, IP4, N34, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: 'None',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '4, 52, 56, 58, 106',
  },
  {
    symbols: '',
    properShippingName: 'Barium nitrate',
    hazardClass: '5.1',
    idNumber: 'UN1446',
    packingGroup: 'II',
    labelCodes: '5.1, 6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Barium oxide',
    hazardClass: '6.1',
    idNumber: 'UN1884',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Barium perchlorate, solid',
    hazardClass: '5.1',
    idNumber: 'UN1447',
    packingGroup: 'II',
    labelCodes: '5.1, 6.1',
    specialProvisions: 'IB6, IP2, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Barium perchlorate, solution',
    hazardClass: '5.1',
    idNumber: 'UN3406',
    packingGroup: 'II',
    labelCodes: '5.1, 6.1',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '152',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58, 133',
  },
  {
    symbols: '',
    properShippingName: 'Barium permanganate',
    hazardClass: '5.1',
    idNumber: 'UN1448',
    packingGroup: 'II',
    labelCodes: '5.1, 6.1',
    specialProvisions: 'IB6, IP2, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '56, 58, 138',
  },
  {
    symbols: '',
    properShippingName: 'Barium peroxide',
    hazardClass: '5.1',
    idNumber: 'UN1449',
    packingGroup: 'II',
    labelCodes: '5.1, 6.1',
    specialProvisions: 'A9, IB6, IP2, T3, TP33, W100',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '13, 52, 66, 75, 148',
  },
  {
    symbols: '',
    properShippingName: 'Batteries, containing sodium',
    hazardClass: '4.3',
    idNumber: 'UN3292',
    packingGroup: null,
    labelCodes: '4.3',
    specialProvisions: '',
    packagingExceptions: '189',
    packagingNonBulk: '189',
    packagingBulk: '189',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '400 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: '',
    properShippingName: 'Batteries, dry, containing potassium hydroxide solid, electric storage',
    hazardClass: '8',
    idNumber: 'UN3028',
    packingGroup: null,
    labelCodes: '8',
    specialProvisions: '237',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '230 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: 'W',
    properShippingName:
      'Batteries, nickel-metal hydride see Batteries, dry, sealed, n.o.s. for nickel-metal hydride batteries transported by modes other than vessel',
    hazardClass: '9',
    idNumber: 'UN3496',
    packingGroup: null,
    labelCodes: '9',
    specialProvisions: '340',
    packagingExceptions: '',
    packagingNonBulk: '',
    packagingBulk: '',
    passengerQtyLimit: '',
    cargoQtyLimit: '',
    vesselStowageLocation: 'A',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Batteries, wet, filled with acid, electric storage',
    hazardClass: '8',
    idNumber: 'UN2794',
    packingGroup: null,
    labelCodes: '8',
    specialProvisions: 'A51',
    packagingExceptions: '159',
    packagingNonBulk: '159',
    packagingBulk: '159',
    passengerQtyLimit: '30 kg',
    cargoQtyLimit: '400 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58, 146',
  },
  {
    symbols: '',
    properShippingName: 'Batteries, wet, filled with alkali, electric storage',
    hazardClass: '8',
    idNumber: 'UN2795',
    packingGroup: null,
    labelCodes: '8',
    specialProvisions: 'A51',
    packagingExceptions: '159',
    packagingNonBulk: '159',
    packagingBulk: '159',
    passengerQtyLimit: '30 kg',
    cargoQtyLimit: '400 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52, 146',
  },
  {
    symbols: '',
    properShippingName: 'Batteries, wet, non-spillable, electric storage',
    hazardClass: '8',
    idNumber: 'UN2800',
    packingGroup: null,
    labelCodes: '8',
    specialProvisions: '',
    packagingExceptions: '159a',
    packagingNonBulk: '159',
    packagingBulk: '159',
    passengerQtyLimit: 'No limit',
    cargoQtyLimit: 'No limit',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Battery fluid, acid',
    hazardClass: '8',
    idNumber: 'UN2796',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A3, A7, B2, B15, IB2, N6, N34, T8, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Battery fluid, alkali',
    hazardClass: '8',
    idNumber: 'UN2797',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, N6, T7, TP2, TP28',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '29',
  },
  {
    symbols: '',
    properShippingName: 'Battery-powered vehicle or Battery-powered equipment',
    hazardClass: '9',
    idNumber: 'UN3171',
    packingGroup: null,
    labelCodes: '9',
    specialProvisions: '134, 360',
    packagingExceptions: '220',
    packagingNonBulk: '220',
    packagingBulk: 'None',
    passengerQtyLimit: 'No limit',
    cargoQtyLimit: 'No limit',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '+',
    properShippingName: 'Benzaldehyde',
    hazardClass: '9',
    idNumber: 'UN1990',
    packingGroup: 'III',
    labelCodes: '9',
    specialProvisions: 'IB3, T2, TP1',
    packagingExceptions: '155',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '100 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Benzene',
    hazardClass: '3',
    idNumber: 'UN1114',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Benzene sulfonyl chloride',
    hazardClass: '8',
    idNumber: 'UN2225',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Benzidine',
    hazardClass: '6.1',
    idNumber: 'UN1885',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Benzonitrile',
    hazardClass: '6.1',
    idNumber: 'UN2224',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Benzoquinone',
    hazardClass: '6.1',
    idNumber: 'UN2587',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Benzotrichloride',
    hazardClass: '8',
    idNumber: 'UN2226',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Benzotrifluoride',
    hazardClass: '3',
    idNumber: 'UN2338',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Benzoyl chloride',
    hazardClass: '8',
    idNumber: 'UN1736',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T8, TP2, TP13',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Benzyl bromide',
    hazardClass: '6.1',
    idNumber: 'UN1737',
    packingGroup: 'II',
    labelCodes: '6.1, 8',
    specialProvisions: 'A3, A7, IB2, N33, N34, T8, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Benzyl chloride',
    hazardClass: '6.1',
    idNumber: 'UN1738',
    packingGroup: 'II',
    labelCodes: '6.1, 8',
    specialProvisions: 'A3, A7, B70, IB2, N33, N42, T8, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Benzyl chloride unstabilized',
    hazardClass: '6.1',
    idNumber: 'UN1738',
    packingGroup: 'II',
    labelCodes: '6.1, 8',
    specialProvisions: 'A3, A7, B8, B11, IB2, N33, N34, N43, T8, TP2, TP13',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Benzyl chloroformate',
    hazardClass: '8',
    idNumber: 'UN1739',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'B4, N41, T10, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Benzyl iodide',
    hazardClass: '6.1',
    idNumber: 'UN2653',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '12, 40',
  },
  {
    symbols: '',
    properShippingName: 'Benzyldimethylamine',
    hazardClass: '8',
    idNumber: 'UN2619',
    packingGroup: 'II',
    labelCodes: '8, 3',
    specialProvisions: 'B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '25, 40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Benzylidene chloride',
    hazardClass: '6.1',
    idNumber: 'UN1886',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Beryllium compounds, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN1566',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Beryllium nitrate',
    hazardClass: '5.1',
    idNumber: 'UN2464',
    packingGroup: 'II',
    labelCodes: '5.1, 6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Beryllium, powder',
    hazardClass: '6.1',
    idNumber: 'UN1567',
    packingGroup: 'II',
    labelCodes: '6.1, 4.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33, W100',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 147, 148',
  },
  {
    symbols: '',
    properShippingName: 'Bicyclo [2,2,1] hepta-2,5-diene, stabilized or 2,5-Norbornadiene, stabilized',
    hazardClass: '3',
    idNumber: 'UN2251',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: '387, IB2, T7, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Biological substance, Category B',
    hazardClass: '6.2',
    idNumber: 'UN3373',
    packingGroup: null,
    labelCodes: '',
    specialProvisions: 'A82',
    packagingExceptions: '134',
    packagingNonBulk: '199',
    packagingBulk: 'None',
    passengerQtyLimit: '4 L or 4 kg',
    cargoQtyLimit: '4 L or 4 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Bipyridilium pesticides, liquid, flammable, toxic, flash point less than 23 degrees C',
    hazardClass: '3',
    idNumber: 'UN2782',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Bipyridilium pesticides, liquid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN3016',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Bipyridilium pesticides, liquid, toxic, flammable, flash point not less than 23 degrees C',
    hazardClass: '6.1',
    idNumber: 'UN3015',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '21, 40',
  },
  {
    symbols: '',
    properShippingName: 'Bipyridilium pesticides, solid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN2781',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Bisulfate, aqueous solution',
    hazardClass: '8',
    idNumber: 'UN2837',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, B2, IB2, N34, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Bisulfites, aqueous solutions, n.o.s.',
    hazardClass: '8',
    idNumber: 'UN2693',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T7, TP1, TP28',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName:
      'Black powder, compressed or Gunpowder, compressed or Black powder, in pellets or Gunpowder, in pellets',
    hazardClass: '1.1D',
    idNumber: 'UN0028',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Black powder or Gunpowder, granular or as a meal',
    hazardClass: '1.1D',
    idNumber: 'UN0027',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: 'D',
    properShippingName: 'Black powder for small arms',
    hazardClass: '4.1',
    idNumber: 'NA0027',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '70',
    packagingExceptions: 'None',
    packagingNonBulk: '170',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Bombs, photo-flash',
    hazardClass: '1.1F',
    idNumber: 'UN0037',
    packingGroup: null,
    labelCodes: '1.1F',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Bombs, photo-flash',
    hazardClass: '1.1D',
    idNumber: 'UN0038',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Bombs, photo-flash',
    hazardClass: '1.2G',
    idNumber: 'UN0039',
    packingGroup: null,
    labelCodes: '1.2G',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Bombs, photo-flash',
    hazardClass: '1.3G',
    idNumber: 'UN0299',
    packingGroup: null,
    labelCodes: '1.3G',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Bombs, smoke, non-explosive, with corrosive liquid, without initiating device',
    hazardClass: '8',
    idNumber: 'UN2028',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '160',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Bombs, with bursting charge',
    hazardClass: '1.1F',
    idNumber: 'UN0033',
    packingGroup: null,
    labelCodes: '1.1F',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Bombs, with bursting charge',
    hazardClass: '1.1D',
    idNumber: 'UN0034',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Bombs, with bursting charge',
    hazardClass: '1.2D',
    idNumber: 'UN0035',
    packingGroup: null,
    labelCodes: '1.2D',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Bombs, with bursting charge',
    hazardClass: '1.2F',
    idNumber: 'UN0291',
    packingGroup: null,
    labelCodes: '1.2F',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Bombs with flammable liquid, with bursting charge',
    hazardClass: '1.1J',
    idNumber: 'UN0399',
    packingGroup: null,
    labelCodes: '1.1J',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 23E',
  },
  {
    symbols: '',
    properShippingName: 'Bombs with flammable liquid, with bursting charge',
    hazardClass: '1.2J',
    idNumber: 'UN0400',
    packingGroup: null,
    labelCodes: '1.2J',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 23E',
  },
  {
    symbols: '',
    properShippingName: 'Boosters with detonator',
    hazardClass: '1.1B',
    idNumber: 'UN0225',
    packingGroup: null,
    labelCodes: '1.1B',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Boosters with detonator',
    hazardClass: '1.2B',
    idNumber: 'UN0268',
    packingGroup: null,
    labelCodes: '1.2B',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Boosters, without detonator',
    hazardClass: '1.1D',
    idNumber: 'UN0042',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '148',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Boosters, without detonator',
    hazardClass: '1.2D',
    idNumber: 'UN0283',
    packingGroup: null,
    labelCodes: '1.2D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Borneol',
    hazardClass: '4.1',
    idNumber: 'UN1312',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: 'A1, IB8, IP3, T1, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '+',
    properShippingName: 'Boron tribromide',
    hazardClass: '8',
    idNumber: 'UN2692',
    packingGroup: 'I',
    labelCodes: '8, 6.1',
    specialProvisions: '2, B9, B14, B32, N34, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'C',
    vesselStowageOther: '12, 25, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Boron trichloride',
    hazardClass: '2.3',
    idNumber: 'UN1741',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '3, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Boron trifluoride',
    hazardClass: '2.3',
    idNumber: 'UN1008',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '2, 238, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Boron trifluoride acetic acid complex, liquid',
    hazardClass: '8',
    idNumber: 'UN1742',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, B6, IB2, T8, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Boron trifluoride acetic acid complex, solid',
    hazardClass: '8',
    idNumber: 'UN3419',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, B6, IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Boron trifluoride, adsorbed',
    hazardClass: '2.3',
    idNumber: 'UN3519',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '2, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Boron trifluoride diethyl etherate',
    hazardClass: '8',
    idNumber: 'UN2604',
    packingGroup: 'I',
    labelCodes: '8, 3',
    specialProvisions: 'A19, T10, TP2, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Boron trifluoride dihydrate',
    hazardClass: '8',
    idNumber: 'UN2851',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '12, 25, 40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Boron trifluoride dimethyl etherate',
    hazardClass: '4.3',
    idNumber: 'UN2965',
    packingGroup: 'I',
    labelCodes: '4.3, 8, 3',
    specialProvisions: 'A19, T10, TP2, TP7, TP13, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '1 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '21, 25, 40, 49, 100',
  },
  {
    symbols: '',
    properShippingName: 'Boron trifluoride propionic acid complex, liquid',
    hazardClass: '8',
    idNumber: 'UN1743',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T8, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Boron trifluoride propionic acid complex, solid',
    hazardClass: '8',
    idNumber: 'UN3420',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: 'G',
    properShippingName: 'Bromates, inorganic, aqueous solution, n.o.s',
    hazardClass: '5.1',
    idNumber: 'UN3213',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: '350, IB2, T4, TP1',
    packagingExceptions: '152',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '56, 58, 133',
  },
  {
    symbols: 'G',
    properShippingName: 'Bromates, inorganic, n.o.s',
    hazardClass: '5.1',
    idNumber: 'UN1450',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: '350, IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '+',
    properShippingName: 'Bromine',
    hazardClass: '8',
    idNumber: 'UN1744',
    packingGroup: 'I',
    labelCodes: '8, 6.1',
    specialProvisions: '1, B9, B85, N34, N43, T22, TP2, TP10, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '249',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 40, 53, 58, 66, 74, 89, 90',
  },
  {
    symbols: '',
    properShippingName: 'Bromine chloride',
    hazardClass: '2.3',
    idNumber: 'UN2901',
    packingGroup: null,
    labelCodes: '2.3, 8, 5.1',
    specialProvisions: '2, B9, B14, N86',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 89, 90',
  },
  {
    symbols: '+',
    properShippingName: 'Bromine pentafluoride',
    hazardClass: '5.1',
    idNumber: 'UN1745',
    packingGroup: 'I',
    labelCodes: '5.1, 6.1, 8',
    specialProvisions: '1, B9, B14, B30, T22, TP2, TP13, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '228',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40, 53, 58, 66, 90',
  },
  {
    symbols: '+',
    properShippingName: 'Bromine solutions',
    hazardClass: '8',
    idNumber: 'UN1744',
    packingGroup: 'I',
    labelCodes: '8, 6.1',
    specialProvisions: '1, B9, B85, N34, N43, T22, TP2, TP10, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '249',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 40, 53, 58, 66, 74, 89, 90',
  },
  {
    symbols: '+',
    properShippingName: 'Bromine solutions',
    hazardClass: '8',
    idNumber: 'UN1744',
    packingGroup: 'I',
    labelCodes: '8, 6.1',
    specialProvisions: '2, B9, B85, N34, N43, T22, TP2, TP10, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '249',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 40, 53, 58, 66, 74, 89, 90',
  },
  {
    symbols: '+',
    properShippingName: 'Bromine trifluoride',
    hazardClass: '5.1',
    idNumber: 'UN1746',
    packingGroup: 'I',
    labelCodes: '5.1, 6.1, 8',
    specialProvisions: '2, B9, B14, B32, T22, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '228',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40, 53, 58, 66, 90',
  },
  {
    symbols: '',
    properShippingName: '1-Bromo-3-chloropropane',
    hazardClass: '6.1',
    idNumber: 'UN2688',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '1-Bromo-3-methylbutane',
    hazardClass: '3',
    idNumber: 'UN2341',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '2-Bromo-2-nitropropane-1,3-diol',
    hazardClass: '4.1',
    idNumber: 'UN3241',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: '46, IB8, IP3',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '12, 25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Bromoacetic acid, solid',
    hazardClass: '8',
    idNumber: 'UN3425',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, IB8, IP2, IP4, N34, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Bromoacetic acid solution',
    hazardClass: '8',
    idNumber: 'UN1938',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '+',
    properShippingName: 'Bromoacetone',
    hazardClass: '6.1',
    idNumber: 'UN1569',
    packingGroup: 'II',
    labelCodes: '6.1, 3',
    specialProvisions: '2, T20, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '193',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Bromoacetyl bromide',
    hazardClass: '8',
    idNumber: 'UN2513',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T8, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Bromobenzene',
    hazardClass: '3',
    idNumber: 'UN2514',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Bromobenzyl cyanides, liquid',
    hazardClass: '6.1',
    idNumber: 'UN1694',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T14, TP2, TP13, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Bromobenzyl cyanides, solid',
    hazardClass: '6.1',
    idNumber: 'UN3449',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T6, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 40, 52',
  },
  {
    symbols: '',
    properShippingName: '1-Bromobutane',
    hazardClass: '3',
    idNumber: 'UN1126',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: '2-Bromobutane',
    hazardClass: '3',
    idNumber: 'UN2339',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'B1, IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Bromochloromethane',
    hazardClass: '6.1',
    idNumber: 'UN1887',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '2-Bromoethyl ethyl ether',
    hazardClass: '3',
    idNumber: 'UN2340',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Bromoform',
    hazardClass: '6.1',
    idNumber: 'UN2515',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Bromomethylpropanes',
    hazardClass: '3',
    idNumber: 'UN2342',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '2-Bromopentane',
    hazardClass: '3',
    idNumber: 'UN2343',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Bromopropanes',
    hazardClass: '3',
    idNumber: 'UN2344',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: '3-Bromopropyne',
    hazardClass: '3',
    idNumber: 'UN2345',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Bromotrifluoroethylene',
    hazardClass: '2.1',
    idNumber: 'UN2419',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Bromotrifluoromethane or Refrigerant gas, R 13B1.',
    hazardClass: '2.2',
    idNumber: 'UN1009',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Brucine',
    hazardClass: '6.1',
    idNumber: 'UN1570',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Bursters, explosive',
    hazardClass: '1.1D',
    idNumber: 'UN0043',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName:
      'Butadienes, stabilized or Butadienes and Hydrocarbon mixture, stabilized containing more than 40% butadienes',
    hazardClass: '2.1',
    idNumber: 'UN1010',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '387, T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Butane see also Petroleum gases, liquefied',
    hazardClass: '2.1',
    idNumber: 'UN1011',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '19, T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Butanedione',
    hazardClass: '3',
    idNumber: 'UN2346',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Butanols',
    hazardClass: '3',
    idNumber: 'UN1120',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1, TP29',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Butyl acetates',
    hazardClass: '3',
    idNumber: 'UN1123',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Butyl acid phosphate',
    hazardClass: '8',
    idNumber: 'UN1718',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Butyl acrylates, stabilized',
    hazardClass: '3',
    idNumber: 'UN2348',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: '387, B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Butyl benzenes',
    hazardClass: '3',
    idNumber: 'UN2709',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'n-Butyl chloroformate',
    hazardClass: '6.1',
    idNumber: 'UN2743',
    packingGroup: 'I',
    labelCodes: '6.1, 8, 3',
    specialProvisions: '2, B9, B14, B32, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 13, 21, 25, 40, 53, 58, 100',
  },
  {
    symbols: '',
    properShippingName: 'n-Butyl formate',
    hazardClass: '3',
    idNumber: 'UN1128',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'tert-Butyl hypochlorite',
    hazardClass: '4.2',
    idNumber: 'UN3255',
    packingGroup: 'I',
    labelCodes: '4.2, 8',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'N-n-Butyl imidazole',
    hazardClass: '6.1',
    idNumber: 'UN2690',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'tert-Butyl isocyanate',
    hazardClass: '6.1',
    idNumber: 'UN2484',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '1, B9, B14, B30, T20, TP2, TP13, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'n-Butyl isocyanate',
    hazardClass: '6.1',
    idNumber: 'UN2485',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '2, B9, B14, B32, B77, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Butyl mercaptan',
    hazardClass: '3',
    idNumber: 'UN2347',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'A3, IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '52, 95, 102',
  },
  {
    symbols: '',
    properShippingName: 'n-Butyl methacrylate, stabilized',
    hazardClass: '3',
    idNumber: 'UN2227',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: '387, B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Butyl methyl ether',
    hazardClass: '3',
    idNumber: 'UN2350',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Butyl nitrites',
    hazardClass: '3',
    idNumber: 'UN2351',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'T11, TP1, TP8, TP27',
    packagingExceptions: '150',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Butyl propionates',
    hazardClass: '3',
    idNumber: 'UN1914',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '5-tert-Butyl-2,4,6-trinitro-m-xylene or Musk xylene',
    hazardClass: '4.1',
    idNumber: 'UN2956',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: '159',
    packagingExceptions: '151',
    packagingNonBulk: '223',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 40, 127',
  },
  {
    symbols: '',
    properShippingName: 'Butyl vinyl ether, stabilized',
    hazardClass: '3',
    idNumber: 'UN2352',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: '387, IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'n-Butylamine',
    hazardClass: '3',
    idNumber: 'UN1125',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'IB2, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'N-Butylaniline',
    hazardClass: '6.1',
    idNumber: 'UN2738',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '74',
  },
  {
    symbols: '',
    properShippingName: 'tert-Butylcyclohexylchloroformate',
    hazardClass: '6.1',
    idNumber: 'UN2747',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 13, 25',
  },
  {
    symbols: '',
    properShippingName: 'Butylene see also Petroleum gases, liquefied',
    hazardClass: '2.1',
    idNumber: 'UN1012',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '19, 398, T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: '1,2-Butylene oxide, stabilized',
    hazardClass: '3',
    idNumber: 'UN3022',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: '387, IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '25, 27, 49',
  },
  {
    symbols: '',
    properShippingName: 'Butyltoluenes',
    hazardClass: '6.1',
    idNumber: 'UN2667',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Butyltrichlorosilane',
    hazardClass: '8',
    idNumber: 'UN1747',
    packingGroup: 'II',
    labelCodes: '8, 3',
    specialProvisions: 'A7, B2, B6, N34, T10, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: '1,4-Butynediol',
    hazardClass: '6.1',
    idNumber: 'UN2716',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'A1, IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '52, 53, 70',
  },
  {
    symbols: '',
    properShippingName: 'Butyraldehyde',
    hazardClass: '3',
    idNumber: 'UN1129',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Butyraldoxime',
    hazardClass: '3',
    idNumber: 'UN2840',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Butyric acid',
    hazardClass: '8',
    idNumber: 'UN2820',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 25, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Butyric anhydride',
    hazardClass: '8',
    idNumber: 'UN2739',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Butyronitrile',
    hazardClass: '3',
    idNumber: 'UN2411',
    packingGroup: 'II',
    labelCodes: '3, 6.1',
    specialProvisions: 'IB2, T7, TP1, TP13',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Butyryl chloride',
    hazardClass: '3',
    idNumber: 'UN2353',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'IB2, T8, TP2, TP13',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Cacodylic acid',
    hazardClass: '6.1',
    idNumber: 'UN1572',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '52, 53, 58',
  },
  {
    symbols: 'G',
    properShippingName: 'Cadmium compounds',
    hazardClass: '6.1',
    idNumber: 'UN2570',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Caesium hydroxide',
    hazardClass: '8',
    idNumber: 'UN2682',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '29, 52.',
  },
  {
    symbols: '',
    properShippingName: 'Caesium hydroxide solution',
    hazardClass: '8',
    idNumber: 'UN2681',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '29, 52',
  },
  {
    symbols: '',
    properShippingName: 'Calcium',
    hazardClass: '4.3',
    idNumber: 'UN1401',
    packingGroup: 'II',
    labelCodes: '4.3',
    specialProvisions: 'IB7, IP2, IP21, T3, TP33, W31, W40',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Calcium arsenate',
    hazardClass: '6.1',
    idNumber: 'UN1573',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Calcium arsenate and calcium arsenite, mixtures, solid',
    hazardClass: '6.1',
    idNumber: 'UN1574',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Calcium carbide',
    hazardClass: '4.3',
    idNumber: 'UN1402',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A1, A8, B55, B59, IB4, IP1, N34, T9, TP7, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Calcium chlorate',
    hazardClass: '5.1',
    idNumber: 'UN1452',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'A9, IB8, IP2, IP4, N34, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Calcium chlorate aqueous solution',
    hazardClass: '5.1',
    idNumber: 'UN2429',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'A2, IB2, N41, T4, TP1',
    packagingExceptions: '152',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '56, 58, 133',
  },
  {
    symbols: '',
    properShippingName: 'Calcium chlorite',
    hazardClass: '5.1',
    idNumber: 'UN1453',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'A9, IB8, IP2, IP4, N34, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Calcium cyanamide with more than 0.1 percent of calcium carbide',
    hazardClass: '4.3',
    idNumber: 'UN1403',
    packingGroup: 'III',
    labelCodes: '4.3',
    specialProvisions: 'A1, A19, IB8, IP4, T1, TP33, W31',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '241',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Calcium cyanide',
    hazardClass: '6.1',
    idNumber: 'UN1575',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, N79, N80, T6, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Calcium dithionite or Calcium hydrosulfite',
    hazardClass: '4.2',
    idNumber: 'UN1923',
    packingGroup: 'II',
    labelCodes: '4.2',
    specialProvisions: 'A19, A20, IB6, IP2, T3, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13',
  },
  {
    symbols: '',
    properShippingName: 'Calcium hydride',
    hazardClass: '4.3',
    idNumber: 'UN1404',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A19, N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName:
      'Calcium hypochlorite, dry, corrosive or Calcium hypochlorite mixture, dry, corrosive with more than 39% available chlorine (8.8% available oxygen)',
    hazardClass: '5.1',
    idNumber: 'UN3485',
    packingGroup: 'II',
    labelCodes: '5.1, 8',
    specialProvisions: '165, 166, A7, A9, IB8, IP2, IP4, IP13, N34, W9',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: 'None',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '4, 25, 52, 56, 58, 69, 142',
  },
  {
    symbols: '',
    properShippingName:
      'Calcium hypochlorite, dry or Calcium hypochlorite mixture dry with more than 39% available chlorine (8.8% available oxygen)',
    hazardClass: '5.1',
    idNumber: 'UN1748',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: '165, 166, A7, A9, IB8, IP2, IP4, IP13, N34, W9',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: 'None',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '4, 25, 52, 56, 58, 69, 142',
  },
  {
    symbols: '',
    properShippingName:
      'Calcium hypochlorite, hydrated, corrosive or Calcium hypochlorite, hydrated mixture, corrosive with not less than 5.5% but not more than 16% water',
    hazardClass: '5.1',
    idNumber: 'UN3487',
    packingGroup: 'II',
    labelCodes: '5.1, 8',
    specialProvisions: '165, IB8, IP2, IP4, IP13, W9',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '4, 25, 52, 56, 58, 69, 142',
  },
  {
    symbols: '',
    properShippingName:
      'Calcium hypochlorite, hydrated or Calcium hypochlorite, hydrated mixture, with not less than 5.5% but not more than 16% water',
    hazardClass: '5.1',
    idNumber: 'UN2880',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: '165, IB8, IP2, IP4, IP13, W9',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '4, 25, 52, 56, 58, 69, 142',
  },
  {
    symbols: '',
    properShippingName:
      'Calcium hypochlorite mixture, dry, corrosive with more than 10% but not more than 39% available chlorine',
    hazardClass: '5.1',
    idNumber: 'UN3486',
    packingGroup: 'III',
    labelCodes: '5.1, 8',
    specialProvisions: '165, A1, A29, IB8, IP3, IP13, N34, W9, W10',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '4, 25, 52, 56, 58, 69, 142',
  },
  {
    symbols: '',
    properShippingName:
      'Calcium hypochlorite mixture, dry, with more than 10% but not more than 39% available chlorine',
    hazardClass: '5.1',
    idNumber: 'UN2208',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: '165, A1, A29, IB8, IP3, IP13, N34, W9, W10',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '4, 25, 52, 56, 58, 69, 142',
  },
  {
    symbols: '',
    properShippingName: 'Calcium manganese silicon',
    hazardClass: '4.3',
    idNumber: 'UN2844',
    packingGroup: 'III',
    labelCodes: '4.3',
    specialProvisions: 'A1, A19, IB8, IP4, T1, TP33, W31',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '241',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 52, 85, 103, 148',
  },
  {
    symbols: '',
    properShippingName: 'Calcium nitrate',
    hazardClass: '5.1',
    idNumber: 'UN1454',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: '34, B120, IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'A',
    properShippingName: 'Calcium oxide',
    hazardClass: '8',
    idNumber: 'UN1910',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Calcium perchlorate',
    hazardClass: '5.1',
    idNumber: 'UN1455',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB6, IP2, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Calcium permanganate',
    hazardClass: '5.1',
    idNumber: 'UN1456',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB6, IP2, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '56, 58, 138',
  },
  {
    symbols: '',
    properShippingName: 'Calcium peroxide',
    hazardClass: '5.1',
    idNumber: 'UN1457',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB6, IP2, T3, TP33, W100',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '13, 52, 66, 75, 148',
  },
  {
    symbols: '',
    properShippingName: 'Calcium phosphide',
    hazardClass: '4.3',
    idNumber: 'UN1360',
    packingGroup: 'I',
    labelCodes: '4.3, 6.1',
    specialProvisions: 'A8, A19, N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 52, 85, 148',
  },
  {
    symbols: '',
    properShippingName: 'Calcium, pyrophoric or Calcium alloys, pyrophoric',
    hazardClass: '4.2',
    idNumber: 'UN1855',
    packingGroup: 'I',
    labelCodes: '4.2',
    specialProvisions: 'W31',
    packagingExceptions: 'None',
    packagingNonBulk: '187',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: '',
    properShippingName: 'Calcium resinate',
    hazardClass: '4.1',
    idNumber: 'UN1313',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: 'A1, A19, IB6, T1, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Calcium resinate, fused',
    hazardClass: '4.1',
    idNumber: 'UN1314',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: 'A1, A19, IB4, T1, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Calcium silicide',
    hazardClass: '4.3',
    idNumber: 'UN1405',
    packingGroup: 'II',
    labelCodes: '4.3',
    specialProvisions: 'A19, IB7, IP2, IP21, T3, TP33, W31',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '13, 52, 85, 103, 148',
  },
  {
    symbols: '',
    properShippingName: 'Camphor oil',
    hazardClass: '3',
    idNumber: 'UN1130',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Camphor, synthetic',
    hazardClass: '4.1',
    idNumber: 'UN2717',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: 'A1, IB8, IP3, T1, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Capacitor, asymmetric with an energy storage capacity greater than 0.3 Wh',
    hazardClass: '9',
    idNumber: 'UN3508',
    packingGroup: null,
    labelCodes: '9',
    specialProvisions: '372',
    packagingExceptions: '176',
    packagingNonBulk: '176',
    packagingBulk: '176',
    passengerQtyLimit: 'No limit',
    cargoQtyLimit: 'No Limit',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Capacitor, electric double layer with an energy storage capacity greater than 0.3 Wh',
    hazardClass: '9',
    idNumber: 'UN3499',
    packingGroup: null,
    labelCodes: '9',
    specialProvisions: '361',
    packagingExceptions: '176',
    packagingNonBulk: '176',
    packagingBulk: '176',
    passengerQtyLimit: 'No limit',
    cargoQtyLimit: 'No limit',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Caproic acid',
    hazardClass: '8',
    idNumber: 'UN2829',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Carbamate pesticides, liquid, flammable, toxic, flash point less than 23 degrees C',
    hazardClass: '3',
    idNumber: 'UN2758',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Carbamate pesticides, liquid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN2992',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Carbamate pesticides, liquid, toxic, flammable, flash point not less than 23 degrees C',
    hazardClass: '6.1',
    idNumber: 'UN2991',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Carbamate pesticides, solid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN2757',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: 'I',
    properShippingName: 'Carbon, activated',
    hazardClass: '4.2',
    idNumber: 'UN1362',
    packingGroup: 'III',
    labelCodes: '4.2',
    specialProvisions: 'IB8, IP3, T1, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '213',
    packagingBulk: '241',
    passengerQtyLimit: '0.5 kg',
    cargoQtyLimit: '0.5 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 25',
  },
  {
    symbols: 'I',
    properShippingName: 'Carbon, animal or vegetable origin',
    hazardClass: '4.2',
    idNumber: 'UN1361',
    packingGroup: 'II',
    labelCodes: '4.2',
    specialProvisions: 'IB6, T3, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 25',
  },
  {
    symbols: '',
    properShippingName: 'Carbon dioxide',
    hazardClass: '2.2',
    idNumber: 'UN1013',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '302, 304',
    packagingBulk: '302, 314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Carbon dioxide, refrigerated liquid',
    hazardClass: '2.2',
    idNumber: 'UN2187',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T75, TP5',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '50 kg',
    cargoQtyLimit: '500 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: 'A W',
    properShippingName: 'Carbon dioxide, solid or Dry ice',
    hazardClass: '9',
    idNumber: 'UN1845',
    packingGroup: null,
    labelCodes: 'None',
    specialProvisions: '',
    packagingExceptions: '217',
    packagingNonBulk: '217',
    packagingBulk: '240',
    passengerQtyLimit: '200 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Carbon disulfide',
    hazardClass: '3',
    idNumber: 'UN1131',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: 'B16, T14, TP2, TP7, TP13, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 78, 115',
  },
  {
    symbols: '',
    properShippingName: 'Carbon monoxide, compressed',
    hazardClass: '2.3',
    idNumber: 'UN1016',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '4',
    packagingExceptions: 'None',
    packagingNonBulk: '302',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'D',
    properShippingName: 'Carbon monoxide, refrigerated liquid (cryogenic liquid)',
    hazardClass: '2.3',
    idNumber: 'NA9202',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '4, T75, TP5',
    packagingExceptions: 'None',
    packagingNonBulk: '316',
    packagingBulk: '318',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Carbon tetrabromide',
    hazardClass: '6.1',
    idNumber: 'UN2516',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Carbon tetrachloride',
    hazardClass: '6.1',
    idNumber: 'UN1846',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, N36, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Carbonyl fluoride',
    hazardClass: '2.3',
    idNumber: 'UN2417',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '2',
    packagingExceptions: 'None',
    packagingNonBulk: '302',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Carbonyl sulfide',
    hazardClass: '2.3',
    idNumber: 'UN2204',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '3, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges, flash',
    hazardClass: '1.1G',
    idNumber: 'UN0049',
    packingGroup: null,
    labelCodes: '1.1G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges, flash',
    hazardClass: '1.3G',
    idNumber: 'UN0050',
    packingGroup: null,
    labelCodes: '1.3G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges for weapons, blank',
    hazardClass: '1.1C',
    idNumber: 'UN0326',
    packingGroup: null,
    labelCodes: '1.1C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges for weapons, blank',
    hazardClass: '1.2C',
    idNumber: 'UN0413',
    packingGroup: null,
    labelCodes: '1.2C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges for weapons, blank or Cartridges, small arms, blank',
    hazardClass: '1.3C',
    idNumber: 'UN0327',
    packingGroup: null,
    labelCodes: '1.3C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges for weapons, blank or Cartridges, small arms, blank',
    hazardClass: '1.4C',
    idNumber: 'UN0338',
    packingGroup: null,
    labelCodes: '1.4C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges for weapons, blank or Cartridges, small arms, blank or Cartridges for tools, blank',
    hazardClass: '1.4S',
    idNumber: 'UN0014',
    packingGroup: null,
    labelCodes: 'None',
    specialProvisions: '',
    packagingExceptions: '63',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges for weapons, inert projectile',
    hazardClass: '1.2C',
    idNumber: 'UN0328',
    packingGroup: null,
    labelCodes: '1.2C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges for weapons, inert projectile or Cartridges, small arms',
    hazardClass: '1.4S',
    idNumber: 'UN0012',
    packingGroup: null,
    labelCodes: 'None',
    specialProvisions: '',
    packagingExceptions: '63',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges for weapons, inert projectile or Cartridges, small arms',
    hazardClass: '1.4C',
    idNumber: 'UN0339',
    packingGroup: null,
    labelCodes: '1.4C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges for weapons, inert projectile or Cartridges, small arms',
    hazardClass: '1.3C',
    idNumber: 'UN0417',
    packingGroup: null,
    labelCodes: '1.3C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges for weapons, with bursting charge',
    hazardClass: '1.1F',
    idNumber: 'UN0005',
    packingGroup: null,
    labelCodes: '1.1F',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges for weapons, with bursting charge',
    hazardClass: '1.1E',
    idNumber: 'UN0006',
    packingGroup: null,
    labelCodes: '1.1E',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges for weapons, with bursting charge',
    hazardClass: '1.2F',
    idNumber: 'UN0007',
    packingGroup: null,
    labelCodes: '1.2F',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges for weapons, with bursting charge',
    hazardClass: '1.2E',
    idNumber: 'UN0321',
    packingGroup: null,
    labelCodes: '1.2E',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges for weapons, with bursting charge',
    hazardClass: '1.4F',
    idNumber: 'UN0348',
    packingGroup: null,
    labelCodes: '1.4F',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges for weapons, with bursting charge',
    hazardClass: '1.4E',
    idNumber: 'UN0412',
    packingGroup: null,
    labelCodes: '1.4E',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges, oil well',
    hazardClass: '1.3C',
    idNumber: 'UN0277',
    packingGroup: null,
    labelCodes: '1.3C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges, oil well',
    hazardClass: '1.4C',
    idNumber: 'UN0278',
    packingGroup: null,
    labelCodes: '1.4C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges, power device',
    hazardClass: '1.3C',
    idNumber: 'UN0275',
    packingGroup: null,
    labelCodes: '1.3C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges, power device',
    hazardClass: '1.4C',
    idNumber: 'UN0276',
    packingGroup: null,
    labelCodes: '1.4C',
    specialProvisions: '110',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges, power device',
    hazardClass: '1.4S',
    idNumber: 'UN0323',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '110, 347',
    packagingExceptions: '63',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges, power device',
    hazardClass: '1.2C',
    idNumber: 'UN0381',
    packingGroup: null,
    labelCodes: '1.2C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges, signal',
    hazardClass: '1.3G',
    idNumber: 'UN0054',
    packingGroup: null,
    labelCodes: '1.3G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges, signal',
    hazardClass: '1.4G',
    idNumber: 'UN0312',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cartridges, signal',
    hazardClass: '1.4S',
    idNumber: 'UN0405',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cases, cartridge, empty with primer',
    hazardClass: '1.4S',
    idNumber: 'UN0055',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '50',
    packagingExceptions: '63',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cases, cartridges, empty with primer',
    hazardClass: '1.4C',
    idNumber: 'UN0379',
    packingGroup: null,
    labelCodes: '1.4C',
    specialProvisions: '50',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cases, combustible, empty, without primer',
    hazardClass: '1.4C',
    idNumber: 'UN0446',
    packingGroup: null,
    labelCodes: '1.4C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cases, combustible, empty, without primer',
    hazardClass: '1.3C',
    idNumber: 'UN0447',
    packingGroup: null,
    labelCodes: '1.3C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: 'A W',
    properShippingName: 'Castor beans or Castor meal or Castor pomace or Castor flake',
    hazardClass: '9',
    idNumber: 'UN2969',
    packingGroup: 'II',
    labelCodes: 'None',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '155',
    packagingNonBulk: '204',
    packagingBulk: '240',
    passengerQtyLimit: 'No limit',
    cargoQtyLimit: 'No limit',
    vesselStowageLocation: 'E',
    vesselStowageOther: '34, 40, 44, 122',
  },
  {
    symbols: 'G',
    properShippingName: 'Caustic alkali liquids, n.o.s.',
    hazardClass: '8',
    idNumber: 'UN1719',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T11, TP2, TP27',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '29, 52',
  },
  {
    symbols: '',
    properShippingName: 'Cells, containing sodium',
    hazardClass: '4.3',
    idNumber: 'UN3292',
    packingGroup: null,
    labelCodes: '4.3',
    specialProvisions: '',
    packagingExceptions: '189',
    packagingNonBulk: '189',
    packagingBulk: '189',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: 'No limit',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Celluloid, in block, rods, rolls, sheets, tubes, etc., except scrap',
    hazardClass: '4.1',
    idNumber: 'UN2000',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: '420',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Celluloid, scrap',
    hazardClass: '4.2',
    idNumber: 'UN2002',
    packingGroup: 'III',
    labelCodes: '4.2',
    specialProvisions: 'IB8, IP3',
    packagingExceptions: 'None',
    packagingNonBulk: '213',
    packagingBulk: '241',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Cerium, slabs, ingots, or rods',
    hazardClass: '4.1',
    idNumber: 'UN1333',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: 'IB8, IP2, IP4, N34, W100',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 74, 91, 147, 148',
  },
  {
    symbols: '',
    properShippingName: 'Cerium, turnings or gritty powder',
    hazardClass: '4.3',
    idNumber: 'UN3078',
    packingGroup: 'II',
    labelCodes: '4.3',
    specialProvisions: 'A1, IB7, IP2, IP21, T3, TP33, W31, W40',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Cesium or Caesium',
    hazardClass: '4.3',
    idNumber: 'UN1407',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A7, A19, IB4, IP1, N34, N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Cesium nitrate or Caesium nitrate',
    hazardClass: '5.1',
    idNumber: 'UN1451',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: 'A1, A29, IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'D',
    properShippingName: 'Charcoal briquettes, shell, screenings, wood, etc.',
    hazardClass: '4.2',
    idNumber: 'NA1361',
    packingGroup: 'III',
    labelCodes: '4.2',
    specialProvisions: 'IB8, T1, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12',
  },
  {
    symbols: '',
    properShippingName: 'Charges, bursting, plastics bonded',
    hazardClass: '1.1D',
    idNumber: 'UN0457',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Charges, bursting, plastics bonded',
    hazardClass: '1.2D',
    idNumber: 'UN0458',
    packingGroup: null,
    labelCodes: '1.2D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Charges, bursting, plastics bonded',
    hazardClass: '1.4D',
    idNumber: 'UN0459',
    packingGroup: null,
    labelCodes: '1.4D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Charges, bursting, plastics bonded',
    hazardClass: '1.4S',
    idNumber: 'UN0460',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '347',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Charges, demolition',
    hazardClass: '1.1D',
    idNumber: 'UN0048',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Charges, depth',
    hazardClass: '1.1D',
    idNumber: 'UN0056',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Charges, explosive, commercial without detonator',
    hazardClass: '1.1D',
    idNumber: 'UN0442',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Charges, explosive, commercial without detonator',
    hazardClass: '1.2D',
    idNumber: 'UN0443',
    packingGroup: null,
    labelCodes: '1.2D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Charges, explosive, commercial without detonator',
    hazardClass: '1.4D',
    idNumber: 'UN0444',
    packingGroup: null,
    labelCodes: '1.4D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Charges, explosive, commercial without detonator',
    hazardClass: '1.4S',
    idNumber: 'UN0445',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '347',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Charges, propelling',
    hazardClass: '1.1C',
    idNumber: 'UN0271',
    packingGroup: null,
    labelCodes: '1.1C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Charges, propelling',
    hazardClass: '1.3C',
    idNumber: 'UN0272',
    packingGroup: null,
    labelCodes: '1.3C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Charges, propelling',
    hazardClass: '1.2C',
    idNumber: 'UN0415',
    packingGroup: null,
    labelCodes: '1.2C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Charges, propelling',
    hazardClass: '1.4C',
    idNumber: 'UN0491',
    packingGroup: null,
    labelCodes: '1.4C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Charges, propelling, for cannon',
    hazardClass: '1.3C',
    idNumber: 'UN0242',
    packingGroup: null,
    labelCodes: '1.3C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Charges, propelling, for cannon',
    hazardClass: '1.1C',
    idNumber: 'UN0279',
    packingGroup: null,
    labelCodes: '1.1C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Charges, propelling, for cannon',
    hazardClass: '1.2C',
    idNumber: 'UN0414',
    packingGroup: null,
    labelCodes: '1.2C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Charges, shaped, flexible, linear',
    hazardClass: '1.4D',
    idNumber: 'UN0237',
    packingGroup: null,
    labelCodes: '1.4D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Charges, shaped, flexible, linear',
    hazardClass: '1.1D',
    idNumber: 'UN0288',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Charges, shaped, without detonator',
    hazardClass: '1.1D',
    idNumber: 'UN0059',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Charges, shaped, without detonator',
    hazardClass: '1.2D',
    idNumber: 'UN0439',
    packingGroup: null,
    labelCodes: '1.2D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Charges, shaped, without detonator',
    hazardClass: '1.4D',
    idNumber: 'UN0440',
    packingGroup: null,
    labelCodes: '1.4D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Charges, shaped, without detonator',
    hazardClass: '1.4S',
    idNumber: 'UN0441',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '347',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Charges, supplementary explosive',
    hazardClass: '1.1D',
    idNumber: 'UN0060',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: 'D',
    properShippingName: 'Chemical kit',
    hazardClass: '8',
    idNumber: 'NA1760',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: '',
    packagingExceptions: '154',
    packagingNonBulk: '161',
    packagingBulk: 'None',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Chemical kit',
    hazardClass: '9',
    idNumber: 'UN3316',
    packingGroup: null,
    labelCodes: '9',
    specialProvisions: '15',
    packagingExceptions: '161',
    packagingNonBulk: '161',
    packagingBulk: 'None',
    passengerQtyLimit: '10 kg',
    cargoQtyLimit: '10 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Chemical under pressure, corrosive, n.o.s',
    hazardClass: '2.2',
    idNumber: 'UN3503',
    packingGroup: null,
    labelCodes: '2.2, 8',
    specialProvisions: '362, T50, TP40',
    packagingExceptions: 'None',
    packagingNonBulk: '335',
    packagingBulk: '313, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Chemical under pressure, flammable, corrosive, n.o.s',
    hazardClass: '2.1',
    idNumber: 'UN3505',
    packingGroup: null,
    labelCodes: '2.1, 8',
    specialProvisions: '362, T50, TP40',
    packagingExceptions: 'None',
    packagingNonBulk: '335',
    packagingBulk: '313, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Chemical under pressure, flammable, n.o.s',
    hazardClass: '2.1',
    idNumber: 'UN3501',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '362, T50, TP40',
    packagingExceptions: 'None',
    packagingNonBulk: '335',
    packagingBulk: '313, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Chemical under pressure, flammable, toxic, n.o.s',
    hazardClass: '2.1',
    idNumber: 'UN3504',
    packingGroup: null,
    labelCodes: '2.1, 6.1',
    specialProvisions: '362, T50, TP40',
    packagingExceptions: 'None',
    packagingNonBulk: '335',
    packagingBulk: '313, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Chemical under pressure, n.o.s',
    hazardClass: '2.2',
    idNumber: 'UN3500',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '362, T50, TP40',
    packagingExceptions: 'None',
    packagingNonBulk: '335',
    packagingBulk: '313, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Chemical under pressure, toxic, n.o.s',
    hazardClass: '2.2',
    idNumber: 'UN3502',
    packingGroup: null,
    labelCodes: '2.2, 6.1',
    specialProvisions: '362, T50, TP40',
    packagingExceptions: 'None',
    packagingNonBulk: '335',
    packagingBulk: '313, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Chloral, anhydrous, stabilized',
    hazardClass: '6.1',
    idNumber: 'UN2075',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Chlorate and borate mixtures',
    hazardClass: '5.1',
    idNumber: 'UN1458',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'A9, IB8, IP2, IP4, N34, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Chlorate and magnesium chloride mixture solid',
    hazardClass: '5.1',
    idNumber: 'UN1459',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'A9, IB8, IP2, IP4, N34, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Chlorate and magnesium chloride mixture solution',
    hazardClass: '5.1',
    idNumber: 'UN3407',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'A9, IB2, N34, T4, TP1',
    packagingExceptions: '152',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58, 133',
  },
  {
    symbols: 'G',
    properShippingName: 'Chlorates, inorganic, aqueous solution, n.o.s',
    hazardClass: '5.1',
    idNumber: 'UN3210',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: '351, IB2, T4, TP1',
    packagingExceptions: '152',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '56, 58, 133',
  },
  {
    symbols: 'G',
    properShippingName: 'Chlorates, inorganic, n.o.s',
    hazardClass: '5.1',
    idNumber: 'UN1461',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: '351, A9, IB6, IP2, N34, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Chloric acid aqueous solution, with not more than 10 percent chloric acid',
    hazardClass: '5.1',
    idNumber: 'UN2626',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB2, T4, TP1, W31',
    packagingExceptions: '152',
    packagingNonBulk: '229',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '53, 56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Chlorine',
    hazardClass: '2.3',
    idNumber: 'UN1017',
    packingGroup: null,
    labelCodes: '2.3, 5.1, 8',
    specialProvisions: '2, B9, B14, N86, T50, TP19',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 51, 55, 62, 68, 89, 90',
  },
  {
    symbols: '',
    properShippingName: 'Chlorine, adsorbed',
    hazardClass: '2.3',
    idNumber: 'UN3520',
    packingGroup: null,
    labelCodes: '2.3, 5.1, 8',
    specialProvisions: '2, B9, B14, N86',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 89, 90',
  },
  {
    symbols: 'D',
    properShippingName: 'Chlorine dioxide, hydrate, frozen',
    hazardClass: '5.1',
    idNumber: 'NA9191',
    packingGroup: 'II',
    labelCodes: '5.1, 6.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '229',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Chlorine pentafluoride',
    hazardClass: '2.3',
    idNumber: 'UN2548',
    packingGroup: null,
    labelCodes: '2.3, 5.1, 8',
    specialProvisions: '1, B7, B9, B14, N86',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 89, 90',
  },
  {
    symbols: '',
    properShippingName: 'Chlorine trifluoride',
    hazardClass: '2.3',
    idNumber: 'UN1749',
    packingGroup: null,
    labelCodes: '2.3, 5.1, 8',
    specialProvisions: '2, B7, B9, B14, N86',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 89, 90',
  },
  {
    symbols: '',
    properShippingName: 'Chlorite solution',
    hazardClass: '8',
    idNumber: 'UN1908',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A3, A7, B2, IB2, N34, T7, TP2, TP24',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '26, 44, 89, 100, 141',
  },
  {
    symbols: 'G',
    properShippingName: 'Chlorites, inorganic, n.o.s',
    hazardClass: '5.1',
    idNumber: 'UN1462',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: '352, A7, IB6, IP2, N34, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: '1-Chloro-1,1-difluoroethane or Refrigerant gas R 142b',
    hazardClass: '2.1',
    idNumber: 'UN2517',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: '3-Chloro-4-methylphenyl isocyanate, liquid',
    hazardClass: '6.1',
    idNumber: 'UN2236',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: '3-Chloro-4-methylphenyl isocyanate, solid',
    hazardClass: '6.1',
    idNumber: 'UN3428',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: '1-Chloro-1,2,2,2-tetrafluoroethaneor Refrigerant gas R 124',
    hazardClass: '2.2',
    idNumber: 'UN1021',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '4-Chloro-o-toluidine hydrochloride, solid',
    hazardClass: '6.1',
    idNumber: 'UN1579',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '4-Chloro-o-toluidine hydrochloride, solution',
    hazardClass: '6.1',
    idNumber: 'UN3410',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '1-Chloro-2,2,2-trifluoroethane or Refrigerant gas R 133a',
    hazardClass: '2.2',
    idNumber: 'UN1983',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Chloroacetic acid, molten',
    hazardClass: '6.1',
    idNumber: 'UN3250',
    packingGroup: 'II',
    labelCodes: '6.1, 8',
    specialProvisions: 'IB1, T7, TP3, TP28',
    packagingExceptions: 'None',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Chloroacetic acid, solid',
    hazardClass: '6.1',
    idNumber: 'UN1751',
    packingGroup: 'II',
    labelCodes: '6.1, 8',
    specialProvisions: 'A3, A7, IB8, IP2, IP4, N34, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Chloroacetic acid, solution',
    hazardClass: '6.1',
    idNumber: 'UN1750',
    packingGroup: 'II',
    labelCodes: '6.1, 8',
    specialProvisions: 'A7, IB2, N34, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Chloroacetone, stabilized',
    hazardClass: '6.1',
    idNumber: 'UN1695',
    packingGroup: 'I',
    labelCodes: '6.1, 3, 8',
    specialProvisions: '2, B9, B14, B32, N12, N32, N34, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '21, 40, 100',
  },
  {
    symbols: '+',
    properShippingName: 'Chloroacetonitrile',
    hazardClass: '6.1',
    idNumber: 'UN2668',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '2, B9, B14, B32, IB9, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 25, 40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Chloroacetophenone, liquid, (CN)',
    hazardClass: '6.1',
    idNumber: 'UN3416',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'A3, IB2, N12, N32, N33, T7, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Chloroacetophenone, solid, (CN)',
    hazardClass: '6.1',
    idNumber: 'UN1697',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'A3, IB8, IP2, IP4, N12, N32, N33, N34, T3, TP2, TP13, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Chloroacetyl chloride',
    hazardClass: '6.1',
    idNumber: 'UN1752',
    packingGroup: 'I',
    labelCodes: '6.1, 8',
    specialProvisions: '2, B3, B8, B9, B14, B32, B77, N34, N43, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Chloroanilines, liquid',
    hazardClass: '6.1',
    idNumber: 'UN2019',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Chloroanilines, solid',
    hazardClass: '6.1',
    idNumber: 'UN2018',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Chloroanisidines',
    hazardClass: '6.1',
    idNumber: 'UN2233',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Chlorobenzene',
    hazardClass: '3',
    idNumber: 'UN1134',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Chlorobenzotrifluorides',
    hazardClass: '3',
    idNumber: 'UN2234',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Chlorobenzyl chlorides, liquid',
    hazardClass: '6.1',
    idNumber: 'UN2235',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Chlorobenzyl chlorides, solid',
    hazardClass: '6.1',
    idNumber: 'UN3427',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Chlorobutanes',
    hazardClass: '3',
    idNumber: 'UN1127',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Chlorocresols solution',
    hazardClass: '6.1',
    idNumber: 'UN2669',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 25',
  },
  {
    symbols: '',
    properShippingName: 'Chlorocresols, solid',
    hazardClass: '6.1',
    idNumber: 'UN3437',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 25',
  },
  {
    symbols: '',
    properShippingName: 'Chlorodifluorobromomethane or Refrigerant gas R 12B1',
    hazardClass: '2.2',
    idNumber: 'UN1974',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Chlorodifluoromethane and chloropentafluoroethane mixture or Refrigerant gas R 502 with fixed boiling point, with approximately 49 percent chlorodifluoromethane',
    hazardClass: '2.2',
    idNumber: 'UN1973',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Chlorodifluoromethane or Refrigerant gas R 22',
    hazardClass: '2.2',
    idNumber: 'UN1018',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '+',
    properShippingName: 'Chlorodinitrobenzenes, liquid.',
    hazardClass: '6.1',
    idNumber: 'UN1577',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '91',
  },
  {
    symbols: '+',
    properShippingName: 'Chlorodinitrobenzenes, solid',
    hazardClass: '6.1',
    idNumber: 'UN3441',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '91',
  },
  {
    symbols: '',
    properShippingName: '2-Chloroethanal',
    hazardClass: '6.1',
    idNumber: 'UN2232',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '2, B9, B14, B32, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Chloroform',
    hazardClass: '6.1',
    idNumber: 'UN1888',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, N36, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Chloroformates, toxic, corrosive, flammable, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN2742',
    packingGroup: 'II',
    labelCodes: '6.1, 8, 3',
    specialProvisions: '5, IB1, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 13, 21, 25, 40, 53, 58,100',
  },
  {
    symbols: 'G',
    properShippingName: 'Chloroformates, toxic, corrosive, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN3277',
    packingGroup: 'II',
    labelCodes: '6.1, 8',
    specialProvisions: 'IB2, T8, TP2, TP13, TP28',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 13, 25, 40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Chloromethyl chloroformate',
    hazardClass: '6.1',
    idNumber: 'UN2745',
    packingGroup: 'II',
    labelCodes: '6.1, 8',
    specialProvisions: 'IB2, T7, TP2, TP13',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 13, 25, 40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Chloromethyl ethyl ether',
    hazardClass: '3',
    idNumber: 'UN2354',
    packingGroup: 'II',
    labelCodes: '3, 6.1',
    specialProvisions: 'IB2, T7, TP1, TP13',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Chloronitroanilines',
    hazardClass: '6.1',
    idNumber: 'UN2237',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '+',
    properShippingName: 'Chloronitrobenzenes, liquid',
    hazardClass: '6.1',
    idNumber: 'UN3409',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '44, 89, 100, 141',
  },
  {
    symbols: '+',
    properShippingName: 'Chloronitrobenzenes, solid',
    hazardClass: '6.1',
    idNumber: 'UN1578',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Chloronitrotoluenes, liquid',
    hazardClass: '6.1',
    idNumber: 'UN2433',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '44, 89, 100, 141',
  },
  {
    symbols: '',
    properShippingName: 'Chloronitrotoluenes, solid',
    hazardClass: '6.1',
    idNumber: 'UN3457',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3,T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Chloropentafluoroethane or Refrigerant gas R 115',
    hazardClass: '2.2',
    idNumber: 'UN1020',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Chlorophenolates, liquid or Phenolates, liquid',
    hazardClass: '8',
    idNumber: 'UN2904',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Chlorophenolates, solid or Phenolates, solid',
    hazardClass: '8',
    idNumber: 'UN2905',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Chlorophenols, liquid',
    hazardClass: '6.1',
    idNumber: 'UN2021',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Chlorophenols, solid',
    hazardClass: '6.1',
    idNumber: 'UN2020',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Chlorophenyltrichlorosilane',
    hazardClass: '8',
    idNumber: 'UN1753',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, B2, B6, N34, T10, TP2, TP7',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '+',
    properShippingName: 'Chloropicrin',
    hazardClass: '6.1',
    idNumber: 'UN1580',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '2, B7, B9, B14, B32, B46, T22, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Chloropicrin and methyl bromide mixtures',
    hazardClass: '2.3',
    idNumber: 'UN1581',
    packingGroup: null,
    labelCodes: '2.3',
    specialProvisions: '2, B9, B14, N86, T50',
    packagingExceptions: 'None',
    packagingNonBulk: '193',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Chloropicrin and methyl chloride mixtures',
    hazardClass: '2.3',
    idNumber: 'UN1582',
    packingGroup: null,
    labelCodes: '2.3',
    specialProvisions: '2, N86, T50',
    packagingExceptions: 'None',
    packagingNonBulk: '193',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: 'G',
    properShippingName: 'Chloropicrin mixtures, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN1583',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '5',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40',
  },
  {
    symbols: 'D',
    properShippingName: 'Chloropivaloyl chloride',
    hazardClass: '6.1',
    idNumber: 'NA9263',
    packingGroup: 'I',
    labelCodes: '6.1, 8',
    specialProvisions: '2, B9, B14, B32, T20, TP4, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Chloroplatinic acid, solid',
    hazardClass: '8',
    idNumber: 'UN2507',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Chloroprene, stabilized',
    hazardClass: '3',
    idNumber: 'UN1991',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: '387, B57, T14, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: '1-Chloropropane',
    hazardClass: '3',
    idNumber: 'UN1278',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, IP8, N34, T7, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '2-Chloropropane',
    hazardClass: '3',
    idNumber: 'UN2356',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'N36, T11, TP2, TP13',
    packagingExceptions: '150',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '3-Chloropropanol-1',
    hazardClass: '6.1',
    idNumber: 'UN2849',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '2-Chloropropene',
    hazardClass: '3',
    idNumber: 'UN2456',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'N36, T11, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '2-Chloropropionic acid',
    hazardClass: '8',
    idNumber: 'UN2511',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T4, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '8, 53, 58',
  },
  {
    symbols: '',
    properShippingName: '2-Chloropyridine',
    hazardClass: '6.1',
    idNumber: 'UN2822',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Chlorosilanes, corrosive, flammable, n.o.s',
    hazardClass: '8',
    idNumber: 'UN2986',
    packingGroup: 'II',
    labelCodes: '8, 3',
    specialProvisions: 'T14, TP2, TP7, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Chlorosilanes, corrosive, n.o.s',
    hazardClass: '8',
    idNumber: 'UN2987',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, T14, TP2, TP7, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Chlorosilanes, flammable, corrosive, n.o.s',
    hazardClass: '3',
    idNumber: 'UN2985',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'T14, TP2, TP7, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: 'G',
    properShippingName: 'Chlorosilanes, toxic, corrosive, flammable, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN3362',
    packingGroup: 'II',
    labelCodes: '6.1, 8, 3',
    specialProvisions: 'T14, TP2, TP7, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58, 125',
  },
  {
    symbols: 'G',
    properShippingName: 'Chlorosilanes, toxic, corrosive, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN3361',
    packingGroup: 'II',
    labelCodes: '6.1, 8',
    specialProvisions: 'T14, TP2, TP7, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Chlorosilanes, water-reactive, flammable, corrosive, n.o.s',
    hazardClass: '4.3',
    idNumber: 'UN2988',
    packingGroup: 'I',
    labelCodes: '4.3, 3, 8',
    specialProvisions: 'A2, T14, TP2, TP7, TP13, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '1 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 21, 40, 49, 53, 58, 100, 147, 148',
  },
  {
    symbols: '+',
    properShippingName: 'Chlorosulfonic acid (with or without sulfur trioxide)',
    hazardClass: '8',
    idNumber: 'UN1754',
    packingGroup: 'I',
    labelCodes: '8, 6.1',
    specialProvisions: '2, B9, B10, B14, B32, T20, TP2, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Chlorotoluenes',
    hazardClass: '3',
    idNumber: 'UN2238',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Chlorotoluidines, liquid',
    hazardClass: '6.1',
    idNumber: 'UN3429',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Chlorotoluidines, solid',
    hazardClass: '6.1',
    idNumber: 'UN2239',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Chlorotrifluoromethane and trifluoromethane azeotropic mixture or Refrigerant gas R 503 with approximately 60 percent chlorotrifluoromethane',
    hazardClass: '2.2',
    idNumber: 'UN2599',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Chlorotrifluoromethane or Refrigerant gas R 13',
    hazardClass: '2.2',
    idNumber: 'UN1022',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Chromic acid solution',
    hazardClass: '8',
    idNumber: 'UN1755',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T8, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 44, 53, 58, 89, 100, 141',
  },
  {
    symbols: '',
    properShippingName: 'Chromic fluoride, solid',
    hazardClass: '8',
    idNumber: 'UN1756',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Chromic fluoride, solution',
    hazardClass: '8',
    idNumber: 'UN1757',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Chromium nitrate',
    hazardClass: '5.1',
    idNumber: 'UN2720',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: 'A1, A29, IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Chromium oxychloride',
    hazardClass: '8',
    idNumber: 'UN1758',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'A7, B10, N34, T10, TP2',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58, 66, 74, 89, 90',
  },
  {
    symbols: '',
    properShippingName: 'Chromium trioxide, anhydrous',
    hazardClass: '5.1',
    idNumber: 'UN1463',
    packingGroup: 'II',
    labelCodes: '5.1, 6.1, 8',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33, W31',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '66, 90',
  },
  {
    symbols: '',
    properShippingName: 'Chromosulfuric acid',
    hazardClass: '8',
    idNumber: 'UN2240',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'A7, B4, B6, N34, T10, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 53, 58, 66, 74, 89, 90',
  },
  {
    symbols: '',
    properShippingName: 'Coal gas, compressed',
    hazardClass: '2.3',
    idNumber: 'UN1023',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '3',
    packagingExceptions: 'None',
    packagingNonBulk: '302',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Coal tar distillates, flammable',
    hazardClass: '3',
    idNumber: 'UN1136',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Coating solution (includes surface treatments or coatings used for industrial or other purposes such as vehicle undercoating, drum or barrel lining)',
    hazardClass: '3',
    idNumber: 'UN1139',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'T11, TP1, TP8, TP27',
    packagingExceptions: '150',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Cobalt dihydroxide powder, containing not less than 10% respirable particles',
    hazardClass: '6.1',
    idNumber: 'UN3550',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IP22, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Cobalt naphthenates, powder',
    hazardClass: '4.1',
    idNumber: 'UN2001',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: 'A19, IB8, IP3, T1, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Cobalt resinate, precipitated',
    hazardClass: '4.1',
    idNumber: 'UN1318',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: 'A1, A19, IB6, T1, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'D G',
    properShippingName: 'Combustible liquid, n.o.s.',
    hazardClass: 'Comb liq',
    idNumber: 'NA1993',
    packingGroup: 'III',
    labelCodes: 'None',
    specialProvisions: '148, IB3, T1, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Components, explosive train, n.o.s.',
    hazardClass: '1.2B',
    idNumber: 'UN0382',
    packingGroup: null,
    labelCodes: '1.2B',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Components, explosive train, n.o.s.',
    hazardClass: '1.4B',
    idNumber: 'UN0383',
    packingGroup: null,
    labelCodes: '1.4B',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Components, explosive train, n.o.s',
    hazardClass: '1.4S',
    idNumber: 'UN0384',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '101, 347',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Components, explosive train, n.o.s.',
    hazardClass: '1.1B',
    idNumber: 'UN0461',
    packingGroup: null,
    labelCodes: '1.1B',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: 'D G',
    properShippingName: 'Compounds, cleaning liquid',
    hazardClass: '8',
    idNumber: 'NA1760',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'A7, B10, T14, TP2, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: 'D G',
    properShippingName: 'Compounds, cleaning liquid',
    hazardClass: '3',
    idNumber: 'NA1993',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'T11, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: 'D G',
    properShippingName: 'Compounds, tree killing, liquid or Compounds, weed killing, liquid',
    hazardClass: '8',
    idNumber: 'NA1760',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'A7, B10, T14, TP2, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: 'D G',
    properShippingName: 'Compounds, tree killing, liquid or Compounds, weed killing, liquid',
    hazardClass: '3',
    idNumber: 'NA1993',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'T11, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: 'D G',
    properShippingName: 'Compounds, tree killing, liquid or Compounds, weed killing, liquid',
    hazardClass: '6.1',
    idNumber: 'NA2810',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Compressed gas, flammable, n.o.s.',
    hazardClass: '2.1',
    idNumber: 'UN1954',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '302, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Compressed gas, n.o.s',
    hazardClass: '2.2',
    idNumber: 'UN1956',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '',
    packagingExceptions: '306, 307',
    packagingNonBulk: '302, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Compressed gas, oxidizing, n.o.s.',
    hazardClass: '2.2',
    idNumber: 'UN3156',
    packingGroup: null,
    labelCodes: '2.2, 5.1',
    specialProvisions: 'A14',
    packagingExceptions: '306',
    packagingNonBulk: '302',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: 'G I',
    properShippingName: 'Compressed gas, toxic, corrosive, n.o.s. Inhalation Hazard Zone A',
    hazardClass: '2.3',
    idNumber: 'UN3304',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '192',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G I',
    properShippingName: 'Compressed gas, toxic, corrosive, n.o.s. Inhalation Hazard Zone B',
    hazardClass: '2.3',
    idNumber: 'UN3304',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '2, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G I',
    properShippingName: 'Compressed gas, toxic, corrosive, n.o.s. Inhalation Hazard Zone C',
    hazardClass: '2.3',
    idNumber: 'UN3304',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '3, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G I',
    properShippingName: 'Compressed gas, toxic, corrosive, n.o.s. Inhalation Hazard Zone D',
    hazardClass: '2.3',
    idNumber: 'UN3304',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '4',
    packagingExceptions: 'None',
    packagingNonBulk: '302, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G I',
    properShippingName: 'Compressed gas, toxic, flammable, corrosive, n.o.s. Inhalation Hazard Zone A',
    hazardClass: '2.3',
    idNumber: 'UN3305',
    packingGroup: null,
    labelCodes: '2.3, 2.1, 8',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '192',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '17, 40',
  },
  {
    symbols: 'G I',
    properShippingName: 'Compressed gas, toxic, flammable, corrosive, n.o.s. Inhalation Hazard Zone B',
    hazardClass: '2.3',
    idNumber: 'UN3305',
    packingGroup: null,
    labelCodes: '2.3, 2.1, 8',
    specialProvisions: '2, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '17, 40',
  },
  {
    symbols: 'G I',
    properShippingName: 'Compressed gas, toxic, flammable, corrosive, n.o.s. Inhalation Hazard Zone C',
    hazardClass: '2.3',
    idNumber: 'UN3305',
    packingGroup: null,
    labelCodes: '2.3, 2.1, 8',
    specialProvisions: '3, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '17, 40',
  },
  {
    symbols: 'G I',
    properShippingName: 'Compressed gas, toxic, flammable, corrosive, n.o.s. Inhalation Hazard Zone D',
    hazardClass: '2.3',
    idNumber: 'UN3305',
    packingGroup: null,
    labelCodes: '2.3, 2.1, 8',
    specialProvisions: '4',
    packagingExceptions: 'None',
    packagingNonBulk: '302, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '17, 40',
  },
  {
    symbols: 'G',
    properShippingName: 'Compressed gas, toxic, flammable, n.o.s. Inhalation hazard Zone A',
    hazardClass: '2.3',
    idNumber: 'UN1953',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '192',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Compressed gas, toxic, flammable, n.o.s. Inhalation hazard Zone B',
    hazardClass: '2.3',
    idNumber: 'UN1953',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '2, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Compressed gas, toxic, flammable, n.o.s. Inhalation Hazard Zone C',
    hazardClass: '2.3',
    idNumber: 'UN1953',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '3, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Compressed gas, toxic, flammable, n.o.s. Inhalation Hazard Zone D',
    hazardClass: '2.3',
    idNumber: 'UN1953',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '4',
    packagingExceptions: 'None',
    packagingNonBulk: '302, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Compressed gas, toxic, n.o.s. Inhalation Hazard Zone A',
    hazardClass: '2.3',
    idNumber: 'UN1955',
    packingGroup: null,
    labelCodes: '2.3',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '192',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Compressed gas, toxic, n.o.s. Inhalation Hazard Zone B',
    hazardClass: '2.3',
    idNumber: 'UN1955',
    packingGroup: null,
    labelCodes: '2.3',
    specialProvisions: '2, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Compressed gas, toxic, n.o.s. Inhalation Hazard Zone C',
    hazardClass: '2.3',
    idNumber: 'UN1955',
    packingGroup: null,
    labelCodes: '2.3',
    specialProvisions: '3, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Compressed gas, toxic, n.o.s. Inhalation Hazard Zone D',
    hazardClass: '2.3',
    idNumber: 'UN1955',
    packingGroup: null,
    labelCodes: '2.3',
    specialProvisions: '4',
    packagingExceptions: 'None',
    packagingNonBulk: '302, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G I',
    properShippingName: 'Compressed gas, toxic, oxdizing, corrosive, n.o.s. Inhalation Hazard Zone A',
    hazardClass: '2.3',
    idNumber: 'UN3306',
    packingGroup: null,
    labelCodes: '2.3, 5.1, 8',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '192',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 89, 90',
  },
  {
    symbols: 'G I',
    properShippingName: 'Compressed gas, toxic, oxidizing, corrosive, n.o.s. Inhalation Hazard Zone B',
    hazardClass: '2.3',
    idNumber: 'UN3306',
    packingGroup: null,
    labelCodes: '2.3, 5.1, 8',
    specialProvisions: '2, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 89, 90',
  },
  {
    symbols: 'G I',
    properShippingName: 'Compressed gas, toxic, oxidizing, corrosive, n.o.s. Inhalation Hazard Zone C',
    hazardClass: '2.3',
    idNumber: 'UN3306',
    packingGroup: null,
    labelCodes: '2.3, 5.1, 8',
    specialProvisions: '3, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 89, 90',
  },
  {
    symbols: 'G I',
    properShippingName: 'Compressed gas, toxic, oxidizing, corrosive, n.o.s. Inhalation Hazard Zone D',
    hazardClass: '2.3',
    idNumber: 'UN3306',
    packingGroup: null,
    labelCodes: '2.3, 5.1, 8',
    specialProvisions: '4',
    packagingExceptions: 'None',
    packagingNonBulk: '302, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 89, 90',
  },
  {
    symbols: 'G',
    properShippingName: 'Compressed gas, toxic, oxidizing, n.o.s. Inhalation Hazard Zone A',
    hazardClass: '2.3',
    idNumber: 'UN3303',
    packingGroup: null,
    labelCodes: '2.3, 5.1',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '192',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Compressed gas, toxic, oxidizing, n.o.s. Inhalation Hazard Zone B',
    hazardClass: '2.3',
    idNumber: 'UN3303',
    packingGroup: null,
    labelCodes: '2.3, 5.1',
    specialProvisions: '2, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Compressed gas, toxic, oxidizing, n.o.s. Inhalation Hazard Zone C',
    hazardClass: '2.3',
    idNumber: 'UN3303',
    packingGroup: null,
    labelCodes: '2.3, 5.1',
    specialProvisions: '3, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Compressed gas, toxic, oxidizing, n.o.s. Inhalation Hazard Zone D',
    hazardClass: '2.3',
    idNumber: 'UN3303',
    packingGroup: null,
    labelCodes: '2.3, 5.1',
    specialProvisions: '4',
    packagingExceptions: 'None',
    packagingNonBulk: '302, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Contrivances, water-activated, with burster, expelling charge or propelling charge',
    hazardClass: '1.2L',
    idNumber: 'UN0248',
    packingGroup: null,
    labelCodes: '1.2L',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 14E, 15E, 17E',
  },
  {
    symbols: 'G',
    properShippingName: 'Contrivances, water-activated, with burster, expelling charge or propelling charge',
    hazardClass: '1.3L',
    idNumber: 'UN0249',
    packingGroup: null,
    labelCodes: '1.3L',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 14E, 15E, 17E',
  },
  {
    symbols: '',
    properShippingName: 'Copper acetoarsenite',
    hazardClass: '6.1',
    idNumber: 'UN1585',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Copper arsenite',
    hazardClass: '6.1',
    idNumber: 'UN1586',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Copper based pesticides, liquid, flammable, toxic, flash point less than 23 degrees C',
    hazardClass: '3',
    idNumber: 'UN2776',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Copper based pesticides, liquid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN3010',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Copper based pesticides, liquid, toxic, flammable, flash point not less than 23 degrees C',
    hazardClass: '6.1',
    idNumber: 'UN3009',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Copper based pesticides, solid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN2775',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Copper chlorate',
    hazardClass: '5.1',
    idNumber: 'UN2721',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'A1, IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Copper chloride',
    hazardClass: '8',
    idNumber: 'UN2802',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Copper cyanide',
    hazardClass: '6.1',
    idNumber: 'UN1587',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '204',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: 'A,W',
    properShippingName: 'Copra',
    hazardClass: '4.2',
    idNumber: 'UN1363',
    packingGroup: 'III',
    labelCodes: '4.2',
    specialProvisions: 'B136, IB8, IP3, IP7',
    packagingExceptions: 'None',
    packagingNonBulk: '213',
    packagingBulk: '241',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 25, 119',
  },
  {
    symbols: '',
    properShippingName: 'Cord, detonating, flexible',
    hazardClass: '1.1D',
    idNumber: 'UN0065',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '102, 148',
    packagingExceptions: '63(a)',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cord, detonating, flexible',
    hazardClass: '1.4D',
    idNumber: 'UN0289',
    packingGroup: null,
    labelCodes: '1.4D',
    specialProvisions: '148',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cord, detonating or Fuze, detonating metal clad',
    hazardClass: '1.2D',
    idNumber: 'UN0102',
    packingGroup: null,
    labelCodes: '1.2D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cord, detonating or Fuze, detonating metal clad',
    hazardClass: '1.1D',
    idNumber: 'UN0290',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cord, detonating, mild effect or Fuse, detonating, mild effect metal clad',
    hazardClass: '1.4D',
    idNumber: 'UN0104',
    packingGroup: null,
    labelCodes: '1.4D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cord, igniter',
    hazardClass: '1.4G',
    idNumber: 'UN0066',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Corrosive liquid, acidic, inorganic, n.o.s',
    hazardClass: '8',
    idNumber: 'UN3264',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'B10, T14, TP2, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: 'G',
    properShippingName: 'Corrosive liquid, acidic, organic, n.o.s',
    hazardClass: '8',
    idNumber: 'UN3265',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'B10, T14, TP2, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: 'G',
    properShippingName: 'Corrosive liquid, basic, inorganic, n.o.s',
    hazardClass: '8',
    idNumber: 'UN3266',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'T14, TP2, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: 'G',
    properShippingName: 'Corrosive liquid, basic, organic, n.o.s',
    hazardClass: '8',
    idNumber: 'UN3267',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'B10, T14, TP2, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: 'G',
    properShippingName: 'Corrosive liquid, self-heating, n.o.s',
    hazardClass: '8',
    idNumber: 'UN3301',
    packingGroup: 'I',
    labelCodes: '8, 4.2',
    specialProvisions: 'B10',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Corrosive liquids, flammable, n.o.s.',
    hazardClass: '8',
    idNumber: 'UN2920',
    packingGroup: 'I',
    labelCodes: '8, 3',
    specialProvisions: 'B10, T14, TP2, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: 'G',
    properShippingName: 'Corrosive liquids, n.o.s',
    hazardClass: '8',
    idNumber: 'UN1760',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'A7, B10, T14, TP2, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Corrosive liquids, oxidizing, n.o.s.',
    hazardClass: '8',
    idNumber: 'UN3093',
    packingGroup: 'I',
    labelCodes: '8, 5.1',
    specialProvisions: 'A7',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '89',
  },
  {
    symbols: 'G',
    properShippingName: 'Corrosive liquids, toxic, n.o.s.',
    hazardClass: '8',
    idNumber: 'UN2922',
    packingGroup: 'I',
    labelCodes: '8, 6.1',
    specialProvisions: 'A4, A7, B10, T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Corrosive liquids, water-reactive, n.o.s',
    hazardClass: '8',
    idNumber: 'UN3094',
    packingGroup: 'I',
    labelCodes: '8, 4.3',
    specialProvisions: 'A7',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '1 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Corrosive solid, acidic, inorganic, n.o.s',
    hazardClass: '8',
    idNumber: 'UN3260',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: 'G',
    properShippingName: 'Corrosive solid, acidic, organic, n.o.s',
    hazardClass: '8',
    idNumber: 'UN3261',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: 'G',
    properShippingName: 'Corrosive solid, basic, inorganic, n.o.s.',
    hazardClass: '8',
    idNumber: 'UN3262',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '52',
  },
  {
    symbols: 'G',
    properShippingName: 'Corrosive solid, basic, organic, n.o.s.',
    hazardClass: '8',
    idNumber: 'UN3263',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '52',
  },
  {
    symbols: 'G',
    properShippingName: 'Corrosive solids, flammable, n.o.s.',
    hazardClass: '8',
    idNumber: 'UN2921',
    packingGroup: 'I',
    labelCodes: '8, 4.1',
    specialProvisions: 'IB6, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '12, 25',
  },
  {
    symbols: 'G',
    properShippingName: 'Corrosive solids, n.o.s.',
    hazardClass: '8',
    idNumber: 'UN1759',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Corrosive solids, oxidizing, n.o.s.',
    hazardClass: '8',
    idNumber: 'UN3084',
    packingGroup: 'I',
    labelCodes: '8, 5.1',
    specialProvisions: 'T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Corrosive solids, self-heating, n.o.s',
    hazardClass: '8',
    idNumber: 'UN3095',
    packingGroup: 'I',
    labelCodes: '8, 4.2',
    specialProvisions: 'T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '243',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Corrosive solids, toxic, n.o.s.',
    hazardClass: '8',
    idNumber: 'UN2923',
    packingGroup: 'I',
    labelCodes: '8, 6.1',
    specialProvisions: 'A5, IB7, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Corrosive solids, water-reactive, n.o.s',
    hazardClass: '8',
    idNumber: 'UN3096',
    packingGroup: 'I',
    labelCodes: '8, 4.3',
    specialProvisions: 'IB4, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '243',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: 'D W',
    properShippingName: 'Cotton',
    hazardClass: '9',
    idNumber: 'NA1365',
    packingGroup: null,
    labelCodes: '9',
    specialProvisions: '137, IB8, IP2, IP4, W41',
    packagingExceptions: 'None',
    packagingNonBulk: 'None',
    packagingBulk: 'None',
    passengerQtyLimit: 'No limit',
    cargoQtyLimit: 'No limit',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'A W',
    properShippingName: 'Cotton waste, oily',
    hazardClass: '4.2',
    idNumber: 'UN1364',
    packingGroup: 'III',
    labelCodes: '4.2',
    specialProvisions: 'IB8, IP3, IP7',
    packagingExceptions: 'None',
    packagingNonBulk: '213',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '54',
  },
  {
    symbols: 'A I W',
    properShippingName: 'Cotton, wet',
    hazardClass: '4.2',
    idNumber: 'UN1365',
    packingGroup: 'III',
    labelCodes: '4.2',
    specialProvisions: 'IB8, IP3, IP7',
    packagingExceptions: 'None',
    packagingNonBulk: '204',
    packagingBulk: '241',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Coumarin derivative pesticides, liquid, flammable, toxic, flash point less than 23 degrees C',
    hazardClass: '3',
    idNumber: 'UN3024',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Coumarin derivative pesticides, liquid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN3026',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName:
      'Coumarin derivative pesticides, liquid, toxic, flammable, flash point not less than 23 degrees C',
    hazardClass: '6.1',
    idNumber: 'UN3025',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Coumarin derivative pesticides, solid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN3027',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Cresols, liquid',
    hazardClass: '6.1',
    idNumber: 'UN2076',
    packingGroup: 'II',
    labelCodes: '6.1, 8',
    specialProvisions: 'IB2, IP2, IP4, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Cresols, solid',
    hazardClass: '6.1',
    idNumber: 'UN3455',
    packingGroup: 'II',
    labelCodes: '6.1, 8',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Cresylic acid',
    hazardClass: '6.1',
    idNumber: 'UN2022',
    packingGroup: 'II',
    labelCodes: '6.1, 8',
    specialProvisions: 'IB2, T7, TP2, TP13',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Crotonaldehyde or Crotonaldehyde, stabilized',
    hazardClass: '6.1',
    idNumber: 'UN1143',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '2, 175, 387, B9, B14, B32, B77, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Crotonic acid, liquid',
    hazardClass: '8',
    idNumber: 'UN3472',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, T1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 25, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Crotonic acid, solid',
    hazardClass: '8',
    idNumber: 'UN2823',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 25, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Crotonylene',
    hazardClass: '3',
    idNumber: 'UN1144',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'T11, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Cupriethylenediamine solution',
    hazardClass: '8',
    idNumber: 'UN1761',
    packingGroup: 'II',
    labelCodes: '8, 6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Cutters, cable, explosive',
    hazardClass: '1.4S',
    idNumber: 'UN0070',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Cyanide solutions, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN1935',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Cyanides, inorganic, solid, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN1588',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, N74, N75, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Cyanogen',
    hazardClass: '2.3',
    idNumber: 'UN1026',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '2',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Cyanogen bromide',
    hazardClass: '6.1',
    idNumber: 'UN1889',
    packingGroup: 'I',
    labelCodes: '6.1, 8',
    specialProvisions: 'A6, A8, T6, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Cyanogen chloride, stabilized',
    hazardClass: '2.3',
    idNumber: 'UN1589',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '1, 387',
    packagingExceptions: 'None',
    packagingNonBulk: '192',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Cyanuric chloride',
    hazardClass: '8',
    idNumber: 'UN2670',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 25, 40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Cyclobutane',
    hazardClass: '2.1',
    idNumber: 'UN2601',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Cyclobutyl chloroformate',
    hazardClass: '6.1',
    idNumber: 'UN2744',
    packingGroup: 'II',
    labelCodes: '6.1, 8, 3',
    specialProvisions: 'IB1, T7, TP2, TP13',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 13, 21, 25, 40, 53, 58, 100',
  },
  {
    symbols: '',
    properShippingName: '1,5,9-Cyclododecatriene',
    hazardClass: '6.1',
    idNumber: 'UN2518',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Cycloheptane',
    hazardClass: '3',
    idNumber: 'UN2241',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Cycloheptatriene',
    hazardClass: '3',
    idNumber: 'UN2603',
    packingGroup: 'II',
    labelCodes: '3, 6.1',
    specialProvisions: 'IB2, T7, TP1, TP13',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Cycloheptene',
    hazardClass: '3',
    idNumber: 'UN2242',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'B1, IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Cyclohexane',
    hazardClass: '3',
    idNumber: 'UN1145',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Cyclohexanone',
    hazardClass: '3',
    idNumber: 'UN1915',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Cyclohexene',
    hazardClass: '3',
    idNumber: 'UN2256',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Cyclohexenyltrichlorosilane',
    hazardClass: '8',
    idNumber: 'UN1762',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, B2, N34, T10, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Cyclohexyl acetate',
    hazardClass: '3',
    idNumber: 'UN2243',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Cyclohexyl isocyanate',
    hazardClass: '6.1',
    idNumber: 'UN2488',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '2, B9, B14, B32, B77, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Cyclohexyl mercaptan',
    hazardClass: '3',
    idNumber: 'UN3054',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 95, 102',
  },
  {
    symbols: '',
    properShippingName: 'Cyclohexylamine',
    hazardClass: '8',
    idNumber: 'UN2357',
    packingGroup: 'II',
    labelCodes: '8, 3',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Cyclohexyltrichlorosilane',
    hazardClass: '8',
    idNumber: 'UN1763',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, B2, N34, T10, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Cyclooctadienes',
    hazardClass: '3',
    idNumber: 'UN2520',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Cyclooctatetraene',
    hazardClass: '3',
    idNumber: 'UN2358',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Cyclopentane',
    hazardClass: '3',
    idNumber: 'UN1146',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Cyclopentanol',
    hazardClass: '3',
    idNumber: 'UN2244',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Cyclopentanone',
    hazardClass: '3',
    idNumber: 'UN2245',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Cyclopentene',
    hazardClass: '3',
    idNumber: 'UN2246',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, IP8, T7, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Cyclopropane',
    hazardClass: '2.1',
    idNumber: 'UN1027',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Cyclotetramethylenetetranitramine, desensitized or Octogen, desensitized or HMX, desensitized',
    hazardClass: '1.1D',
    idNumber: 'UN0484',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName:
      'Cyclotetramethylenetetranitramine, wetted or HMX, wetted or Octogen, wetted with not less than 15 percent water, by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0226',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName:
      'Cyclotrimethylenetrinitramine, desensitized or Cyclonite, desensitized or Hexogen, desensitized or RDX, desensitized',
    hazardClass: '1.1D',
    idNumber: 'UN0483',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName:
      'Cyclotrimethylenetrinitramine, wetted or Cyclonite, wetted or Hexogen, wetted or RDX, wetted with not less than 15 percent water by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0072',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Cymenes',
    hazardClass: '3',
    idNumber: 'UN2046',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Dangerous goods in articles or Dangerous goods in machinery or Dangerous goods in apparatus',
    hazardClass: '9',
    idNumber: 'UN3363',
    packingGroup: null,
    labelCodes: '9',
    specialProvisions: '136, A105',
    packagingExceptions: 'None',
    packagingNonBulk: '222',
    packagingBulk: 'None',
    passengerQtyLimit: 'See A105',
    cargoQtyLimit: 'See A105',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Decaborane',
    hazardClass: '4.1',
    idNumber: 'UN1868',
    packingGroup: 'II',
    labelCodes: '4.1, 6.1',
    specialProvisions: 'A19, A20, IB6, IP2, T3, TP33, W31',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '74',
  },
  {
    symbols: '',
    properShippingName: 'Decahydronaphthalene',
    hazardClass: '3',
    idNumber: 'UN1147',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'n-Decane',
    hazardClass: '3',
    idNumber: 'UN2247',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Deflagrating metal salts of aromatic nitroderivatives, n.o.s.',
    hazardClass: '1.3C',
    idNumber: 'UN0132',
    packingGroup: null,
    labelCodes: '1.3C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 5E',
  },
  {
    symbols: 'D',
    properShippingName: 'Denatured alcohol',
    hazardClass: '3',
    idNumber: 'NA1987',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: '172, T8',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Desensitized explosive, liquid, n.o.s.',
    hazardClass: '3',
    idNumber: 'UN3379',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: '164',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '36',
  },
  {
    symbols: 'G',
    properShippingName: 'Desensitized explosive, solid, n.o.s.',
    hazardClass: '4.1',
    idNumber: 'UN3380',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '164, 197',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Detonator assemblies, non-electric for blasting',
    hazardClass: '1.1B',
    idNumber: 'UN0360',
    packingGroup: null,
    labelCodes: '1.1B',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Detonator assemblies, non-electric, for blasting',
    hazardClass: '1.4B',
    idNumber: 'UN0361',
    packingGroup: null,
    labelCodes: '1.4B',
    specialProvisions: '148',
    packagingExceptions: '63(f), 63(g)',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Detonator assemblies, non-electric, for blasting',
    hazardClass: '1.4S',
    idNumber: 'UN0500',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '148, 347',
    packagingExceptions: '63(f), 63(g)',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Detonators, electric, for blasting',
    hazardClass: '1.1B',
    idNumber: 'UN0030',
    packingGroup: null,
    labelCodes: '1.1B',
    specialProvisions: '148',
    packagingExceptions: '63(f), 63(g)',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Detonators, electric, for blasting',
    hazardClass: '1.4B',
    idNumber: 'UN0255',
    packingGroup: null,
    labelCodes: '1.4B',
    specialProvisions: '148',
    packagingExceptions: '63(f), 63(g)',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Detonators, electric for blasting',
    hazardClass: '1.4S',
    idNumber: 'UN0456',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '148, 347',
    packagingExceptions: '63(f), 63(g)',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Detonators, electronic programmable for blasting',
    hazardClass: '1.1B',
    idNumber: 'UN0511',
    packingGroup: null,
    labelCodes: '1.1B',
    specialProvisions: '148',
    packagingExceptions: '63(f), 63(g)',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Detonators, electronic programmable for blasting',
    hazardClass: '1.4B',
    idNumber: 'UN0512',
    packingGroup: null,
    labelCodes: '1.4B',
    specialProvisions: '148',
    packagingExceptions: '63(f), 63(g)',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Detonators, electronic programmable for blasting',
    hazardClass: '1.4S',
    idNumber: 'UN0513',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '148, 347',
    packagingExceptions: '63(f), 63(g)',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Detonators for ammunition',
    hazardClass: '1.1B',
    idNumber: 'UN0073',
    packingGroup: null,
    labelCodes: '1.1B',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Detonators for ammunition',
    hazardClass: '1.2B',
    idNumber: 'UN0364',
    packingGroup: null,
    labelCodes: '1.2B',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Detonators for ammunition',
    hazardClass: '1.4B',
    idNumber: 'UN0365',
    packingGroup: null,
    labelCodes: '1.4B',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Detonators for ammunition',
    hazardClass: '1.4S',
    idNumber: 'UN0366',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '347',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Detonators, non-electric, for blasting',
    hazardClass: '1.1B',
    idNumber: 'UN0029',
    packingGroup: null,
    labelCodes: '1.1B',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Detonators, non-electric, for blasting',
    hazardClass: '1.4B',
    idNumber: 'UN0267',
    packingGroup: null,
    labelCodes: '1.4B',
    specialProvisions: '',
    packagingExceptions: '63(f), 63(g)',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Detonators, non-electric, for blasting',
    hazardClass: '1.4S',
    idNumber: 'UN0455',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '148, 347',
    packagingExceptions: '63(f), 63(g)',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Deuterium, compressed',
    hazardClass: '2.1',
    idNumber: 'UN1957',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'N89',
    packagingExceptions: '306',
    packagingNonBulk: '302',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName:
      'Devices, small, hydrocarbon gas powered or Hydrocarbon gas refills for small devices with release device',
    hazardClass: '2.1',
    idNumber: 'UN3150',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: 'None',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Di-n-amylamine',
    hazardClass: '3',
    idNumber: 'UN2841',
    packingGroup: 'III',
    labelCodes: '3, 6.1',
    specialProvisions: 'B1, IB3, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Di-n-butylamine',
    hazardClass: '8',
    idNumber: 'UN2248',
    packingGroup: 'II',
    labelCodes: '8, 3',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: '1,2-Di-(dimethylamino)ethane',
    hazardClass: '3',
    idNumber: 'UN2372',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Diacetone alcohol',
    hazardClass: '3',
    idNumber: 'UN1148',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Diallylamine',
    hazardClass: '3',
    idNumber: 'UN2359',
    packingGroup: 'II',
    labelCodes: '3, 6.1, 8',
    specialProvisions: 'IB2, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '21, 40, 52, 100',
  },
  {
    symbols: '',
    properShippingName: 'Diallylether',
    hazardClass: '3',
    idNumber: 'UN2360',
    packingGroup: 'II',
    labelCodes: '3, 6.1',
    specialProvisions: 'IB2, N12, T7, TP1, TP13',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: '4,4′-Diaminodiphenyl methane',
    hazardClass: '6.1',
    idNumber: 'UN2651',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Diazodinitrophenol, wetted with not less than 40 percent water or mixture of alcohol and water, by mass',
    hazardClass: '1.1A',
    idNumber: 'UN0074',
    packingGroup: null,
    labelCodes: '1.1A',
    specialProvisions: '111, 117',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Dibenzyldichlorosilane',
    hazardClass: '8',
    idNumber: 'UN2434',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, T10, TP2, TP7, TP13',
    packagingExceptions: '154',
    packagingNonBulk: '206',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Diborane',
    hazardClass: '2.3',
    idNumber: 'UN1911',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '1, N89',
    packagingExceptions: 'None',
    packagingNonBulk: '302',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 57',
  },
  {
    symbols: 'D',
    properShippingName: 'Diborane mixtures',
    hazardClass: '2.1',
    idNumber: 'NA1911',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '5',
    packagingExceptions: 'None',
    packagingNonBulk: '302',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 57',
  },
  {
    symbols: '',
    properShippingName: '1,2-Dibromobutan-3-one',
    hazardClass: '6.1',
    idNumber: 'UN2648',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Dibromochloropropane',
    hazardClass: '6.1',
    idNumber: 'UN2872',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'A',
    properShippingName: 'Dibromodifluoromethane, R12B2',
    hazardClass: '9',
    idNumber: 'UN1941',
    packingGroup: 'III',
    labelCodes: 'None',
    specialProvisions: 'T11, TP2',
    packagingExceptions: '155',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '100 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Dibromomethane',
    hazardClass: '6.1',
    idNumber: 'UN2664',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Dibutyl ethers',
    hazardClass: '3',
    idNumber: 'UN1149',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Dibutylaminoethanol',
    hazardClass: '6.1',
    idNumber: 'UN2873',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '1,1-Dichloro-1-nitroethane',
    hazardClass: '6.1',
    idNumber: 'UN2650',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 25, 40, 74',
  },
  {
    symbols: 'D',
    properShippingName: '3,5-Dichloro-2,4,6-trifluoropyridine',
    hazardClass: '6.1',
    idNumber: 'NA9264',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '2, B9, B14, B32, T20, TP4, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Dichloroacetic acid',
    hazardClass: '8',
    idNumber: 'UN1764',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A3, A7, B2, IB2, N34, T8, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: '1,3-Dichloroacetone',
    hazardClass: '6.1',
    idNumber: 'UN2649',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '12, 25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Dichloroacetyl chloride',
    hazardClass: '8',
    idNumber: 'UN1765',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A3, A7, B2, B6, IB2, N34, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '+',
    properShippingName: 'Dichloroanilines, liquid',
    hazardClass: '6.1',
    idNumber: 'UN1590',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Dichloroanilines, solid',
    hazardClass: '6.1',
    idNumber: 'UN3442',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '+',
    properShippingName: 'o-Dichlorobenzene',
    hazardClass: '6.1',
    idNumber: 'UN1591',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '2,2′-Dichlorodiethyl ether',
    hazardClass: '6.1',
    idNumber: 'UN1916',
    packingGroup: 'II',
    labelCodes: '6.1, 3',
    specialProvisions: 'IB2, N33, N34, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Dichlorodifluoromethane and difluoroethane azeotropic mixture or Refrigerant gas R 500 with approximately 74 percent dichlorodifluoromethane',
    hazardClass: '2.2',
    idNumber: 'UN2602',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Dichlorodifluoromethane or Refrigerant gas R 12',
    hazardClass: '2.2',
    idNumber: 'UN1028',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Dichlorodimethyl ether, symmetrical',
    hazardClass: '6.1',
    idNumber: 'UN2249',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: '1,1-Dichloroethane',
    hazardClass: '3',
    idNumber: 'UN2362',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: '1,2-Dichloroethylene',
    hazardClass: '3',
    idNumber: 'UN1150',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Dichlorofluoromethane or Refrigerant gas R21',
    hazardClass: '2.2',
    idNumber: 'UN1029',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Dichloroisocyanuric acid, dry or Dichloroisocyanuric acid salts',
    hazardClass: '5.1',
    idNumber: 'UN2465',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: '28, IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13',
  },
  {
    symbols: '',
    properShippingName: 'Dichloroisopropyl ether',
    hazardClass: '6.1',
    idNumber: 'UN2490',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Dichloromethane',
    hazardClass: '6.1',
    idNumber: 'UN1593',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, IP8, N36, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Dichloropentanes',
    hazardClass: '3',
    idNumber: 'UN1152',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Dichlorophenyl isocyanates',
    hazardClass: '6.1',
    idNumber: 'UN2250',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Dichlorophenyltrichlorosilane',
    hazardClass: '8',
    idNumber: 'UN1766',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, B2, B6, N34, T10, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: '1,2-Dichloropropane',
    hazardClass: '3',
    idNumber: 'UN1279',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, N36, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '1,3-Dichloropropanol-2',
    hazardClass: '6.1',
    idNumber: 'UN2750',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Dichloropropenes',
    hazardClass: '3',
    idNumber: 'UN2047',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Dichlorosilane',
    hazardClass: '2.3',
    idNumber: 'UN2189',
    packingGroup: null,
    labelCodes: '2.3, 2.1, 8',
    specialProvisions: '2, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '17, 40',
  },
  {
    symbols: '',
    properShippingName: '1,2-Dichloro-1,1,2,2- tetrafluoroethane or Refrigerant gas R 114',
    hazardClass: '2.2',
    idNumber: 'UN1958',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Dicyclohexylamine',
    hazardClass: '8',
    idNumber: 'UN2565',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Dicyclohexylammonium nitrite',
    hazardClass: '4.1',
    idNumber: 'UN2687',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Dicyclopentadiene',
    hazardClass: '3',
    idNumber: 'UN2048',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Didymium nitrate',
    hazardClass: '5.1',
    idNumber: 'UN1465',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: 'A1, IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'D',
    properShippingName: 'Diesel fuel',
    hazardClass: '3',
    idNumber: 'NA1993',
    packingGroup: 'III',
    labelCodes: 'None',
    specialProvisions: '144, B1, IB3, T4, TP1, TP29',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'I',
    properShippingName: 'Diesel fuel',
    hazardClass: '3',
    idNumber: 'UN1202',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: '144, B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Diethoxymethane',
    hazardClass: '3',
    idNumber: 'UN2373',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '3,3-Diethoxypropene',
    hazardClass: '3',
    idNumber: 'UN2374',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Diethyl carbonate',
    hazardClass: '3',
    idNumber: 'UN2366',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Diethyl ether or Ethyl ether',
    hazardClass: '3',
    idNumber: 'UN1155',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'T11, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Diethyl ketone',
    hazardClass: '3',
    idNumber: 'UN1156',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Diethyl sulfate',
    hazardClass: '6.1',
    idNumber: 'UN1594',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Diethyl sulfide',
    hazardClass: '3',
    idNumber: 'UN2375',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T7, TP1, TP13',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Diethylamine',
    hazardClass: '3',
    idNumber: 'UN1154',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'A3, IB2, N34, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: '2-Diethylaminoethanol',
    hazardClass: '8',
    idNumber: 'UN2686',
    packingGroup: 'II',
    labelCodes: '8, 3',
    specialProvisions: 'B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: '3-Diethyamino-propylamine',
    hazardClass: '3',
    idNumber: 'UN2684',
    packingGroup: 'III',
    labelCodes: '3, 8',
    specialProvisions: 'B1, IB3, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '+',
    properShippingName: 'N, N-Diethylaniline',
    hazardClass: '6.1',
    idNumber: 'UN2432',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Diethylbenzene',
    hazardClass: '3',
    idNumber: 'UN2049',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Diethyldichlorosilane',
    hazardClass: '8',
    idNumber: 'UN1767',
    packingGroup: 'II',
    labelCodes: '8, 3',
    specialProvisions: 'A7, B6, N34, T10, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName:
      'Diethyleneglycol dinitrate, desensitized with not less than 25 percent non-volatile water-insoluble phlegmatizer, by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0075',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 21E',
  },
  {
    symbols: '',
    properShippingName: 'Diethylenetriamine',
    hazardClass: '8',
    idNumber: 'UN2079',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'N,N-Diethylethylenediamine',
    hazardClass: '8',
    idNumber: 'UN2685',
    packingGroup: 'II',
    labelCodes: '8, 3',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Diethylthiophosphoryl chloride',
    hazardClass: '8',
    idNumber: 'UN2751',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: '1,1-Difluoroethane or Refrigerant gas R 152a',
    hazardClass: '2.1',
    idNumber: 'UN1030',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: '1,1-Difluoroethylene or Refrigerant gas R 1132a',
    hazardClass: '2.1',
    idNumber: 'UN1959',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Difluoromethane or Refrigerant gas R 32',
    hazardClass: '2.1',
    idNumber: 'UN3252',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Difluorophosphoric acid, anhydrous',
    hazardClass: '8',
    idNumber: 'UN1768',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, B2, IB2, N5, N34, T8, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: '2,3-Dihydropyran',
    hazardClass: '3',
    idNumber: 'UN2376',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Diisobutyl ketone',
    hazardClass: '3',
    idNumber: 'UN1157',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Diisobutylamine',
    hazardClass: '3',
    idNumber: 'UN2361',
    packingGroup: 'III',
    labelCodes: '3, 8',
    specialProvisions: 'B1, IB3, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Diisobutylene, isomeric compounds',
    hazardClass: '3',
    idNumber: 'UN2050',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Diisooctyl acid phosphate',
    hazardClass: '8',
    idNumber: 'UN1902',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Diisopropyl ether',
    hazardClass: '3',
    idNumber: 'UN1159',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Diisopropylamine',
    hazardClass: '3',
    idNumber: 'UN1158',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'IB2, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Diketene, stabilized',
    hazardClass: '6.1',
    idNumber: 'UN2521',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '2, 387, B9, B14, B32, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 26, 27, 40',
  },
  {
    symbols: '',
    properShippingName: '1,2-Dimethoxyethane',
    hazardClass: '3',
    idNumber: 'UN2252',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '1,1-Dimethoxyethane',
    hazardClass: '3',
    idNumber: 'UN2377',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Dimethyl carbonate',
    hazardClass: '3',
    idNumber: 'UN1161',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Dimethyl disulfide',
    hazardClass: '3',
    idNumber: 'UN2381',
    packingGroup: 'II',
    labelCodes: '3, 6.1',
    specialProvisions: 'IB2, T7, TP2, TP13',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Dimethyl ether',
    hazardClass: '2.1',
    idNumber: 'UN1033',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Dimethyl-N-propylamine',
    hazardClass: '3',
    idNumber: 'UN2266',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'IB2, T7, TP2, TP13',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Dimethyl sulfate',
    hazardClass: '6.1',
    idNumber: 'UN1595',
    packingGroup: 'I',
    labelCodes: '6.1, 8',
    specialProvisions: '2, B9, B14, B32, B77, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Dimethyl sulfide',
    hazardClass: '3',
    idNumber: 'UN1164',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, IP8, T7, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Dimethyl thiophosphoryl chloride',
    hazardClass: '6.1',
    idNumber: 'UN2267',
    packingGroup: 'II',
    labelCodes: '6.1, 8',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '25, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Dimethylamine, anhydrous',
    hazardClass: '2.1',
    idNumber: 'UN1032',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'N87, T50',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Dimethylamine solution',
    hazardClass: '3',
    idNumber: 'UN1160',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'IB2, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '52.',
  },
  {
    symbols: '',
    properShippingName: '2-Dimethylaminoacetonitrile',
    hazardClass: '3',
    idNumber: 'UN2378',
    packingGroup: 'II',
    labelCodes: '3, 6.1',
    specialProvisions: 'IB2, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: '2-Dimethylaminoethanol',
    hazardClass: '8',
    idNumber: 'UN2051',
    packingGroup: 'II',
    labelCodes: '8, 3',
    specialProvisions: 'B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: '2-Dimethylaminoethyl acrylate, stabilized',
    hazardClass: '6.1',
    idNumber: 'UN3302',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: '387, IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: '2-Dimethylaminoethyl methacrylate, stabilized',
    hazardClass: '6.1',
    idNumber: 'UN2522',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: '387, IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'N,N-Dimethylaniline',
    hazardClass: '6.1',
    idNumber: 'UN2253',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB1, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '2,3-Dimethylbutane',
    hazardClass: '3',
    idNumber: 'UN2457',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '1, 3-Dimethylbutylamine',
    hazardClass: '3',
    idNumber: 'UN2379',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'IB2, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '52.',
  },
  {
    symbols: '',
    properShippingName: 'Dimethylcarbamoyl chloride',
    hazardClass: '8',
    idNumber: 'UN2262',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Dimethylcyclohexanes',
    hazardClass: '3',
    idNumber: 'UN2263',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'N,N-Dimethylcyclohexylamine',
    hazardClass: '8',
    idNumber: 'UN2264',
    packingGroup: 'II',
    labelCodes: '8, 3',
    specialProvisions: 'B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Dimethyldichlorosilane',
    hazardClass: '3',
    idNumber: 'UN1162',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'B77, T10, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Dimethyldiethoxysilane',
    hazardClass: '3',
    idNumber: 'UN2380',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Dimethyldioxanes',
    hazardClass: '3',
    idNumber: 'UN2707',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'N,N-Dimethylformamide',
    hazardClass: '3',
    idNumber: 'UN2265',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Dimethylhydrazine, symmetrical',
    hazardClass: '6.1',
    idNumber: 'UN2382',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '2, B9, B14, B32, B77, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 52, 74.',
  },
  {
    symbols: '',
    properShippingName: 'Dimethylhydrazine, unsymmetrical',
    hazardClass: '6.1',
    idNumber: 'UN1163',
    packingGroup: 'I',
    labelCodes: '6.1, 3, 8',
    specialProvisions: '2, B7, B9, B14, B32, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '21, 38, 40, 52, 100.',
  },
  {
    symbols: '',
    properShippingName: '2,2-Dimethylpropane',
    hazardClass: '2.1',
    idNumber: 'UN2044',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Dinitro-o-cresol',
    hazardClass: '6.1',
    idNumber: 'UN1598',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Dinitroanilines',
    hazardClass: '6.1',
    idNumber: 'UN1596',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '91',
  },
  {
    symbols: '',
    properShippingName: 'Dinitrobenzenes, liquid',
    hazardClass: '6.1',
    idNumber: 'UN1597',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: '11, IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '91',
  },
  {
    symbols: '',
    properShippingName: 'Dinitrobenzenes, solid',
    hazardClass: '6.1',
    idNumber: 'UN3443',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '91',
  },
  {
    symbols: '',
    properShippingName: 'Dinitrogen tetroxide',
    hazardClass: '2.3',
    idNumber: 'UN1067',
    packingGroup: null,
    labelCodes: '2.3, 5.1, 8',
    specialProvisions: '1, B7, B14, B45, B46, B61, B66, B67, B77, T50, TP21',
    packagingExceptions: 'None',
    packagingNonBulk: '336',
    packagingBulk: '314',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 89, 90',
  },
  {
    symbols: '',
    properShippingName: 'Dinitroglycoluril or Dingu',
    hazardClass: '1.1D',
    idNumber: 'UN0489',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Dinitrophenol, dry or wetted with less than 15 percent water, by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0076',
    packingGroup: null,
    labelCodes: '1.1D, 6.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 5E',
  },
  {
    symbols: '',
    properShippingName: 'Dinitrophenol solutions',
    hazardClass: '6.1',
    idNumber: 'UN1599',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '36',
  },
  {
    symbols: '',
    properShippingName: 'Dinitrophenol, wetted with not less than 15 percent water, by mass',
    hazardClass: '4.1',
    idNumber: 'UN1320',
    packingGroup: 'I',
    labelCodes: '4.1, 6.1',
    specialProvisions: '23, A8, A19, A20, N41, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Dinitrophenolates alkali metals, dry or wetted with less than 15 percent water, by mass',
    hazardClass: '1.3C',
    idNumber: 'UN0077',
    packingGroup: null,
    labelCodes: '1.3C, 6.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 5E',
  },
  {
    symbols: '',
    properShippingName: 'Dinitrophenolates, wetted with not less than 15 percent water, by mass',
    hazardClass: '4.1',
    idNumber: 'UN1321',
    packingGroup: 'I',
    labelCodes: '4.1, 6.1',
    specialProvisions: '23, A8, A19, A20, N41, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Dinitroresorcinol, dry or wetted with less than 15 percent water, by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0078',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 5E',
  },
  {
    symbols: '',
    properShippingName: 'Dinitroresorcinol, wetted with not less than 15 percent water, by mass',
    hazardClass: '4.1',
    idNumber: 'UN1322',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '23, A8, A19, A20, N41, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Dinitrosobenzene',
    hazardClass: '1.3C',
    idNumber: 'UN0406',
    packingGroup: null,
    labelCodes: '1.3C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Dinitrotoluenes, liquid',
    hazardClass: '6.1',
    idNumber: 'UN2038',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Dinitrotoluenes, molten',
    hazardClass: '6.1',
    idNumber: 'UN1600',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'T7, TP3',
    packagingExceptions: 'None',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Dinitrotoluenes, solid',
    hazardClass: '6.1',
    idNumber: 'UN3454',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Dioxane',
    hazardClass: '3',
    idNumber: 'UN1165',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Dioxolane',
    hazardClass: '3',
    idNumber: 'UN1166',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Dipentene',
    hazardClass: '3',
    idNumber: 'UN2052',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Diphenylamine chloroarsine',
    hazardClass: '6.1',
    idNumber: 'UN1698',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T6, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Diphenylchloroarsine, liquid',
    hazardClass: '6.1',
    idNumber: 'UN1699',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'A8, B14, B32, N33, N34, T14, TP2, TP13, TP27, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Diphenylchloroarsine, solid',
    hazardClass: '6.1',
    idNumber: 'UN3450',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Diphenyldichlorosilane',
    hazardClass: '8',
    idNumber: 'UN1769',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, B2, N34, T10, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Diphenylmethyl bromide',
    hazardClass: '8',
    idNumber: 'UN1770',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Dipicryl sulfide, dry or wetted with less than 10 percent water, by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0401',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Dipicryl sulfide, wetted with not less than 10 percent water, by mass',
    hazardClass: '4.1',
    idNumber: 'UN2852',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '162, A2, N41, N84, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '0.5 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Di-n-propyl ether',
    hazardClass: '3',
    idNumber: 'UN2384',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Dipropyl ketone',
    hazardClass: '3',
    idNumber: 'UN2710',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Dipropylamine',
    hazardClass: '3',
    idNumber: 'UN2383',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'IB2, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '25, 52',
  },
  {
    symbols: 'G',
    properShippingName: 'Disinfectant, liquid, corrosive, n.o.s',
    hazardClass: '8',
    idNumber: 'UN1903',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'A7, B10, T14, TP2, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Disinfectants, liquid, corrosive n.o.s.',
    hazardClass: '8',
    idNumber: 'UN1903',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Disinfectants, liquid, toxic, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN3142',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'A4, T14, TP2, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Disinfectants, solid, toxic, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN1601',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Disodium trioxosilicate',
    hazardClass: '8',
    idNumber: 'UN3253',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52.',
  },
  {
    symbols: '',
    properShippingName: 'Divinyl ether, stabilized',
    hazardClass: '3',
    idNumber: 'UN1167',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: '387, A7, T11, TP2',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Dodecyltrichlorosilane',
    hazardClass: '8',
    idNumber: 'UN1771',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, B2, B6, N34, T10, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: 'G',
    properShippingName: 'Dyes, liquid, corrosive, n.o.s. or Dye intermediates, liquid, corrosive, n.o.s',
    hazardClass: '8',
    idNumber: 'UN2801',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: '11, B10, T14, TP2, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Dyes, liquid, toxic, n.o.s. or Dye intermediates, liquid, toxic, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN1602',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Dyes, solid, corrosive, n.o.s. or Dye intermediates, solid, corrosive, n.o.s.',
    hazardClass: '8',
    idNumber: 'UN3147',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Dyes, solid, toxic, n.o.s. or Dye intermediates, solid, toxic, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN3143',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'A5, IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName:
      'Elevated temperature liquid, flammable, n.o.s., with flash point above 37.8 C, at or above its flash point',
    hazardClass: '3',
    idNumber: 'UN3256',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'IB1, T3, TP3, TP29',
    packagingExceptions: 'None',
    packagingNonBulk: 'None',
    packagingBulk: '247',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName:
      'Elevated temperature liquid, n.o.s., at or above 100 C and below its flash point (including molten metals, molten salts, etc.)',
    hazardClass: '9',
    idNumber: 'UN3257',
    packingGroup: 'III',
    labelCodes: '9',
    specialProvisions: 'IB1, T3, TP3, TP29',
    packagingExceptions: 'None',
    packagingNonBulk: 'None',
    packagingBulk: '247',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '85',
  },
  {
    symbols: 'G',
    properShippingName: 'Elevated temperature solid, n.o.s., at or above 240 C, see § 173.247(h)(4)',
    hazardClass: '9',
    idNumber: 'UN3258',
    packingGroup: 'III',
    labelCodes: '9',
    specialProvisions: '',
    packagingExceptions: '247 (h)(4)',
    packagingNonBulk: 'None',
    packagingBulk: '247',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '85',
  },
  {
    symbols: '',
    properShippingName:
      'Engine, internal combustion, flammable gas powered or Engine, fuel cell, flammable gas powered or Machinery, internal combustion, flammable gas powered or Machinery, fuel cell, flammable gas powered',
    hazardClass: '2.1',
    idNumber: 'UN3529',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '135, A200',
    packagingExceptions: '220',
    packagingNonBulk: '220',
    packagingBulk: '220',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'No limit',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Engine, internal combustion, flammable liquid powered or Engine, fuel cell, flammable liquid powered or Machinery, internal combustion, flammable liquid powered or Machinery, fuel cell, flammable liquid powered',
    hazardClass: '3',
    idNumber: 'UN3528',
    packingGroup: null,
    labelCodes: '3',
    specialProvisions: '135, A200',
    packagingExceptions: '220',
    packagingNonBulk: '220',
    packagingBulk: '220',
    passengerQtyLimit: 'No limit',
    cargoQtyLimit: 'No limit',
    vesselStowageLocation: 'E',
    vesselStowageOther: '149',
  },
  {
    symbols: '',
    properShippingName: 'Engine, internal combustion or Machinery, internal combustion',
    hazardClass: '9',
    idNumber: 'UN3530',
    packingGroup: null,
    labelCodes: '9',
    specialProvisions: '135, A200',
    packagingExceptions: '220',
    packagingNonBulk: '220',
    packagingBulk: '220',
    passengerQtyLimit: 'No limit',
    cargoQtyLimit: 'No limit',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Environmentally hazardous substance, liquid, n.o.s.',
    hazardClass: '9',
    idNumber: 'UN3082',
    packingGroup: 'III',
    labelCodes: '9',
    specialProvisions: '8, 146, 173, 335, 441, IB3,T4, TP1, TP29',
    packagingExceptions: '155',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: 'No limit',
    cargoQtyLimit: 'No limit',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Environmentally hazardous substance, solid, n.o.s.',
    hazardClass: '9',
    idNumber: 'UN3077',
    packingGroup: 'III',
    labelCodes: '9',
    specialProvisions: '8, 146, 335, 384, 441, A112,B54, B120, IB8, IP3,N20, N91, T1, TP33',
    packagingExceptions: '155',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: 'No limit',
    cargoQtyLimit: 'No limit',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Epibromohydrin',
    hazardClass: '6.1',
    idNumber: 'UN2558',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: 'T14, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '+',
    properShippingName: 'Epichlorohydrin',
    hazardClass: '6.1',
    idNumber: 'UN2023',
    packingGroup: 'II',
    labelCodes: '6.1, 3',
    specialProvisions: 'IB2, T7, TP2, TP13',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: '1,2-Epoxy-3-ethoxypropane',
    hazardClass: '3',
    idNumber: 'UN2752',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Esters, n.o.s.',
    hazardClass: '3',
    idNumber: 'UN3272',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T7, TP1, TP8, TP28',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethane',
    hazardClass: '2.1',
    idNumber: 'UN1035',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '302',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: 'D',
    properShippingName: 'Ethane-Propane mixture, refrigerated liquid',
    hazardClass: '2.1',
    idNumber: 'NA1961',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'T75, TP5',
    packagingExceptions: 'None',
    packagingNonBulk: '316',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Ethane, refrigerated liquid',
    hazardClass: '2.1',
    idNumber: 'UN1961',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'T75, TP5',
    packagingExceptions: 'None',
    packagingNonBulk: 'None',
    packagingBulk: '315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName:
      'Ethanol and gasoline mixture or Ethanol and motor spirit mixture or Ethanol and petrol mixture, with more than 10% ethanol',
    hazardClass: '3',
    idNumber: 'UN3475',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: '144, 177, IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethanol or Ethyl alcohol or Ethanol solutions or Ethyl alcohol solutions',
    hazardClass: '3',
    idNumber: 'UN1170',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: '24, IB2, T4, TP1',
    packagingExceptions: '4b, 150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethanolamine or Ethanolamine solutions',
    hazardClass: '8',
    idNumber: 'UN2491',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52.',
  },
  {
    symbols: '',
    properShippingName: 'Ethers, n.o.s.',
    hazardClass: '3',
    idNumber: 'UN3271',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T7, TP1, TP8, TP28',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl acetate',
    hazardClass: '3',
    idNumber: 'UN1173',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl acrylate, stabilized',
    hazardClass: '3',
    idNumber: 'UN1917',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: '387, IB2, T4, TP1, TP13',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl amyl ketone',
    hazardClass: '3',
    idNumber: 'UN2271',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'N-Ethylbenzyltoluidines, solid',
    hazardClass: '6.1',
    idNumber: 'UN3460',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'N-Ethyl-N-benzylaniline',
    hazardClass: '6.1',
    idNumber: 'UN2274',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl borate',
    hazardClass: '3',
    idNumber: 'UN1176',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl bromide',
    hazardClass: '3',
    idNumber: 'UN1891',
    packingGroup: 'II',
    labelCodes: '3, 6.1',
    specialProvisions: 'IB2, IP8, T7, TP2, TP13',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 85',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl bromoacetate',
    hazardClass: '6.1',
    idNumber: 'UN1603',
    packingGroup: 'II',
    labelCodes: '6.1, 3',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl butyl ether',
    hazardClass: '3',
    idNumber: 'UN1179',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'B1, IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl butyrate',
    hazardClass: '3',
    idNumber: 'UN1180',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl chloride',
    hazardClass: '2.1',
    idNumber: 'UN1037',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'B77, N86, T50',
    packagingExceptions: 'None',
    packagingNonBulk: '322',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl chloroacetate',
    hazardClass: '6.1',
    idNumber: 'UN1181',
    packingGroup: 'II',
    labelCodes: '6.1, 3',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl chloroformate',
    hazardClass: '6.1',
    idNumber: 'UN1182',
    packingGroup: 'I',
    labelCodes: '6.1, 3, 8',
    specialProvisions: '2, B9, B14, B32, N34, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '21, 40, 53, 58, 100',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl 2-chloropropionate',
    hazardClass: '3',
    idNumber: 'UN2935',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '+',
    properShippingName: 'Ethyl chlorothioformate',
    hazardClass: '8',
    idNumber: 'UN2826',
    packingGroup: 'II',
    labelCodes: '8, 6.1, 3',
    specialProvisions: '2, B9, B14, B32, T20, TP2, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl crotonate',
    hazardClass: '3',
    idNumber: 'UN1862',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl fluoride or Refrigerant gas R161',
    hazardClass: '2.1',
    idNumber: 'UN2453',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl formate',
    hazardClass: '3',
    idNumber: 'UN1190',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl isobutyrate',
    hazardClass: '3',
    idNumber: 'UN2385',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '+',
    properShippingName: 'Ethyl isocyanate',
    hazardClass: '6.1',
    idNumber: 'UN2481',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '1, B9, B14, B30, T20, TP2, TP13, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl lactate',
    hazardClass: '3',
    idNumber: 'UN1192',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl mercaptan',
    hazardClass: '3',
    idNumber: 'UN2363',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'T11, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '95, 102',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl methacrylate, stabilized',
    hazardClass: '3',
    idNumber: 'UN2277',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: '387, IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl methyl ether',
    hazardClass: '2.1',
    idNumber: 'UN1039',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl methyl ketone or Methyl ethyl ketone',
    hazardClass: '3',
    idNumber: 'UN1193',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl nitrite solutions',
    hazardClass: '3',
    idNumber: 'UN1194',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40, 105',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl orthoformate',
    hazardClass: '3',
    idNumber: 'UN2524',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl oxalate',
    hazardClass: '6.1',
    idNumber: 'UN2525',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'D',
    properShippingName: 'Ethyl phosphonothioic dichloride, anhydrous',
    hazardClass: '6.1',
    idNumber: 'NA2927',
    packingGroup: 'I',
    labelCodes: '6.1, 8',
    specialProvisions: '2, B9, B14, B32, T20, TP4, TP12, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'D',
    properShippingName: 'Ethyl phosphonous dichloride, anhydrous pyrophoric liquid',
    hazardClass: '6.1',
    idNumber: 'NA2845',
    packingGroup: 'I',
    labelCodes: '6.1, 4.2',
    specialProvisions: '2, B9, B14, B32, T20, TP4, TP12, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '18',
  },
  {
    symbols: 'D',
    properShippingName: 'Ethyl phosphorodichloridate',
    hazardClass: '6.1',
    idNumber: 'NA2927',
    packingGroup: 'I',
    labelCodes: '6.1, 8',
    specialProvisions: '2, B9, B14, B32, T20, TP4, TP12, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl propionate',
    hazardClass: '3',
    idNumber: 'UN1195',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethyl propyl ether',
    hazardClass: '3',
    idNumber: 'UN2615',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethylacetylene, stabilized',
    hazardClass: '2.1',
    idNumber: 'UN2452',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '387, N88',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Ethylamine',
    hazardClass: '2.1',
    idNumber: 'UN1036',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'B77, N87, T50',
    packagingExceptions: 'None',
    packagingNonBulk: '321',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName:
      'Ethylamine, aqueous solution with not less than 50 percent but not more than 70 percent ethylamine',
    hazardClass: '3',
    idNumber: 'UN2270',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'IB2, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 52.',
  },
  {
    symbols: '',
    properShippingName: 'N-Ethylaniline',
    hazardClass: '6.1',
    idNumber: 'UN2272',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52, 74',
  },
  {
    symbols: '',
    properShippingName: '2-Ethylaniline',
    hazardClass: '6.1',
    idNumber: 'UN2273',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52, 74',
  },
  {
    symbols: '',
    properShippingName: 'Ethylbenzene',
    hazardClass: '3',
    idNumber: 'UN1175',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'N-Ethylbenzyltoluidines liquid',
    hazardClass: '6.1',
    idNumber: 'UN2753',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T7, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '2-Ethylbutanol',
    hazardClass: '3',
    idNumber: 'UN2275',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '2-Ethylbutyl acetate',
    hazardClass: '3',
    idNumber: 'UN1177',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '2-Ethylbutyraldehyde',
    hazardClass: '3',
    idNumber: 'UN1178',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'B1, IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethyldichloroarsine',
    hazardClass: '6.1',
    idNumber: 'UN1892',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '2, B9, B14, B32, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Ethyldichlorosilane',
    hazardClass: '4.3',
    idNumber: 'UN1183',
    packingGroup: 'I',
    labelCodes: '4.3, 8, 3',
    specialProvisions: 'A2, A7, N34, T14, TP2, TP7, TP13, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '1 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '21, 40, 49, 53, 58, 100',
  },
  {
    symbols: '',
    properShippingName:
      'Ethylene, acetylene and propylene in mixture, refrigerated liquid with at least 71.5 percent ethylene with not more than 22.5 percent acetylene and not more than 6 percent propylene',
    hazardClass: '2.1',
    idNumber: 'UN3138',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'T75, TP5',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 57',
  },
  {
    symbols: '',
    properShippingName: 'Ethylene chlorohydrin',
    hazardClass: '6.1',
    idNumber: 'UN1135',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '2, B9, B14, B32, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Ethylene',
    hazardClass: '2.1',
    idNumber: 'UN1962',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '302',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Ethylene dibromide',
    hazardClass: '6.1',
    idNumber: 'UN1605',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '2, B9, B14, B32, B77, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Ethylene dichloride',
    hazardClass: '3',
    idNumber: 'UN1184',
    packingGroup: 'II',
    labelCodes: '3, 6.1',
    specialProvisions: 'IB2, N36, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Ethylene glycol diethyl ether',
    hazardClass: '3',
    idNumber: 'UN1153',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethylene glycol monoethyl ether',
    hazardClass: '3',
    idNumber: 'UN1171',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethylene glycol monoethyl ether acetate',
    hazardClass: '3',
    idNumber: 'UN1172',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethylene glycol monomethyl ether',
    hazardClass: '3',
    idNumber: 'UN1188',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethylene glycol monomethyl ether acetate',
    hazardClass: '3',
    idNumber: 'UN1189',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethylene oxide and carbon dioxide mixture with more than 87 percent ethylene oxide',
    hazardClass: '2.3',
    idNumber: 'UN3300',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '4',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName:
      'Ethylene oxide and carbon dioxide mixtures with more than 9 percent but not more than 87 percent ethylene oxide',
    hazardClass: '2.1',
    idNumber: 'UN1041',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Ethylene oxide and carbon dioxide mixtures with not more than 9 percent ethylene oxide',
    hazardClass: '2.2',
    idNumber: 'UN1952',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Ethylene oxide and chlorotetrafluoroethane mixture with not more than 8.8 percent ethylene oxide',
    hazardClass: '2.2',
    idNumber: 'UN3297',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Ethylene oxide and dichlorodifluoromethane mixture, with not more than 12.5 percent ethylene oxide',
    hazardClass: '2.2',
    idNumber: 'UN3070',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethylene oxide and pentafluoroethane mixture with not more than 7.9 percent ethylene oxide',
    hazardClass: '2.2',
    idNumber: 'UN3298',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethylene oxide and propylene oxide mixtures, with not more than 30 percent ethylene oxide',
    hazardClass: '3',
    idNumber: 'UN2983',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: '5, A11, N4, N34, T14, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Ethylene oxide and tetrafluoroethane mixture with not more than 5.6 percent ethylene oxide',
    hazardClass: '2.2',
    idNumber: 'UN3299',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Ethylene oxide or Ethylene oxide with nitrogen up to a total pressure of 1 MPa (10 bar) at 50 degrees C',
    hazardClass: '2.3',
    idNumber: 'UN1040',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '4, 342, T50, TP20',
    packagingExceptions: 'None',
    packagingNonBulk: '323',
    packagingBulk: '323',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Ethylene, refrigerated liquid (cryogenic liquid)',
    hazardClass: '2.1',
    idNumber: 'UN1038',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'T75, TP5',
    packagingExceptions: 'None',
    packagingNonBulk: '316',
    packagingBulk: '318, 319',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Ethylenediamine',
    hazardClass: '8',
    idNumber: 'UN1604',
    packingGroup: 'II',
    labelCodes: '8, 3',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 52.',
  },
  {
    symbols: '',
    properShippingName: 'Ethyleneimine, stabilized',
    hazardClass: '6.1',
    idNumber: 'UN1185',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '1, 387, B9, B14, B30, B77, N25, N32, T22, TP2, TP13, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: '2-Ethylhexyl chloroformate',
    hazardClass: '6.1',
    idNumber: 'UN2748',
    packingGroup: 'II',
    labelCodes: '6.1, 8',
    specialProvisions: 'IB2, T7, TP2, TP13',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 13, 25, 40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: '2-Ethylhexylamine',
    hazardClass: '3',
    idNumber: 'UN2276',
    packingGroup: 'III',
    labelCodes: '3, 8',
    specialProvisions: 'B1, IB3, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Ethylphenyldichlorosilane',
    hazardClass: '8',
    idNumber: 'UN2435',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, B2, N34, T10, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: '1-Ethylpiperidine',
    hazardClass: '3',
    idNumber: 'UN2386',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'IB2, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '52.',
  },
  {
    symbols: '',
    properShippingName: 'N-Ethyltoluidines',
    hazardClass: '6.1',
    idNumber: 'UN2754',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ethyltrichlorosilane',
    hazardClass: '3',
    idNumber: 'UN1196',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'A7, N34, T10, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Explosive, blasting, type A',
    hazardClass: '1.1D',
    idNumber: 'UN0081',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '148',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 19E, 21E',
  },
  {
    symbols: '',
    properShippingName: 'Explosive, blasting, type B',
    hazardClass: '1.1D',
    idNumber: 'UN0082',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 19E',
  },
  {
    symbols: '',
    properShippingName: 'Explosive, blasting, type B or Agent blasting, Type B',
    hazardClass: '1.5D',
    idNumber: 'UN0331',
    packingGroup: null,
    labelCodes: '1.5D',
    specialProvisions: '105, 106, 148',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25, 19E',
  },
  {
    symbols: '',
    properShippingName: 'Explosive, blasting, type C',
    hazardClass: '1.1D',
    idNumber: 'UN0083',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '123',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 22E',
  },
  {
    symbols: '',
    properShippingName: 'Explosive, blasting, type D',
    hazardClass: '1.1D',
    idNumber: 'UN0084',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Explosive, blasting, type E',
    hazardClass: '1.1D',
    idNumber: 'UN0241',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '148',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 19E',
  },
  {
    symbols: '',
    properShippingName: 'Explosive, blasting, type E or Agent blasting, type E',
    hazardClass: '1.5D',
    idNumber: 'UN0332',
    packingGroup: null,
    labelCodes: '1.5D',
    specialProvisions: '105, 106, 148, TP48',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25, 19E',
  },
  {
    symbols: '',
    properShippingName: 'Extracts, liquid, for flavor or aroma',
    hazardClass: '3',
    idNumber: 'UN1197',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: '149, IB2, T4, TP1, TP8',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Extracts, liquid, for flavor or aroma',
    hazardClass: '3',
    idNumber: 'UN1197',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ferric arsenate',
    hazardClass: '6.1',
    idNumber: 'UN1606',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ferric arsenite',
    hazardClass: '6.1',
    idNumber: 'UN1607',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ferric chloride, anhydrous',
    hazardClass: '8',
    idNumber: 'UN1773',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Ferric chloride, solution',
    hazardClass: '8',
    idNumber: 'UN2582',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'B15, IB3, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Ferric nitrate',
    hazardClass: '5.1',
    idNumber: 'UN1466',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: 'A1, A29, IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Ferrocerium',
    hazardClass: '4.1',
    idNumber: 'UN1323',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: '59, A19, IB8, IP2, IP4, T3, TP33, W100',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 147, 148',
  },
  {
    symbols: '',
    properShippingName: 'Ferrosilicon with 30 percent or more but less than 90 percent silicon',
    hazardClass: '4.3',
    idNumber: 'UN1408',
    packingGroup: 'III',
    labelCodes: '4.3, 6.1',
    specialProvisions: 'A1, A19, B6, IB8, IP4, IP7, T1, TP33, W100',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 40, 52, 53, 85, 103, 148',
  },
  {
    symbols: '',
    properShippingName: 'Ferrous arsenate',
    hazardClass: '6.1',
    idNumber: 'UN1608',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'D',
    properShippingName: 'Ferrous chloride, solid',
    hazardClass: '8',
    idNumber: 'NA1759',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'D',
    properShippingName: 'Ferrous chloride, solution',
    hazardClass: '8',
    idNumber: 'NA1760',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B3, IB2, T11, TP2, TP27',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName:
      'Ferrous metal borings or Ferrous metal shavings or Ferrous metal turnings or Ferrous metal cuttings in a form liable to self-heating',
    hazardClass: '4.2',
    idNumber: 'UN2793',
    packingGroup: 'III',
    labelCodes: '4.2',
    specialProvisions: 'A1, A19, B134, B136, IB8, IP3, IP7, IP21, W100',
    packagingExceptions: 'None',
    packagingNonBulk: '213',
    packagingBulk: '241',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: '',
    properShippingName: 'Fertilizer ammoniating solution with free ammonia',
    hazardClass: '2.2',
    idNumber: 'UN1043',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'N87',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: 'A I W',
    properShippingName: 'Fibers, animal or Fibers, vegetable burnt, wet or damp',
    hazardClass: '4.2',
    idNumber: 'UN1372',
    packingGroup: 'III',
    labelCodes: '4.2',
    specialProvisions: '',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'A, I, W',
    properShippingName: 'Fibers, vegetable, dry',
    hazardClass: '4.1',
    idNumber: 'UN3360',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: '137',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'A W',
    properShippingName: 'Fibers or Fabrics, animal or vegetable or Synthetic, n.o.s. with animal or vegetable oil',
    hazardClass: '4.2',
    idNumber: 'UN1373',
    packingGroup: 'III',
    labelCodes: '4.2',
    specialProvisions: '137, IB8, IP3, T1, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '213',
    packagingBulk: '241',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Fibers or Fabrics impregnated with weakly nitrated nitrocellulose, n.o.s',
    hazardClass: '4.1',
    idNumber: 'UN1353',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: 'A1, IB8, IP3',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Films, nitrocellulose base, gelatine coated (except scrap)',
    hazardClass: '4.1',
    idNumber: 'UN1324',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: '',
    packagingExceptions: '151',
    packagingNonBulk: '183',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '28',
  },
  {
    symbols: '',
    properShippingName: 'Fire extinguisher charges, corrosive liquid',
    hazardClass: '8',
    idNumber: 'UN1774',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'N41',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: 'None',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Fire extinguishers containing compressed or liquefied gas',
    hazardClass: '2.2',
    idNumber: 'UN1044',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '110',
    packagingExceptions: '309',
    packagingNonBulk: '309',
    packagingBulk: 'None',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Firelighters, solid with flammable liquid',
    hazardClass: '4.1',
    idNumber: 'UN2623',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: 'A1, A19',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Fireworks',
    hazardClass: '1.1G',
    idNumber: 'UN0333',
    packingGroup: null,
    labelCodes: '1.1G',
    specialProvisions: '108',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Fireworks',
    hazardClass: '1.2G',
    idNumber: 'UN0334',
    packingGroup: null,
    labelCodes: '1.2G',
    specialProvisions: '108',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Fireworks',
    hazardClass: '1.3G',
    idNumber: 'UN0335',
    packingGroup: null,
    labelCodes: '1.3G',
    specialProvisions: '108',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Fireworks',
    hazardClass: '1.4G',
    idNumber: 'UN0336',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '108, 200',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Fireworks',
    hazardClass: '1.4S',
    idNumber: 'UN0337',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '108',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'First aid kit',
    hazardClass: '9',
    idNumber: 'UN3316',
    packingGroup: null,
    labelCodes: '9',
    specialProvisions: '15',
    packagingExceptions: '161',
    packagingNonBulk: '161',
    packagingBulk: 'None',
    passengerQtyLimit: '10 kg',
    cargoQtyLimit: '10 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'A, W',
    properShippingName: 'Fish meal, stabilized or Fish scrap, stabilized',
    hazardClass: '9',
    idNumber: 'UN2216',
    packingGroup: 'III',
    labelCodes: 'None',
    specialProvisions: '155, B136, IB8, IP3, T1, TP33',
    packagingExceptions: '155',
    packagingNonBulk: '218',
    packagingBulk: '218',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '25, 88, 122, 128',
  },
  {
    symbols: '',
    properShippingName: 'Fish meal, unstablized or Fish scrap, unstabilized',
    hazardClass: '4.2',
    idNumber: 'UN1374',
    packingGroup: 'II',
    labelCodes: '4.2',
    specialProvisions: '155, A1, A19, IB8, IP2, IP4, T3, TP33, W31, W40',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'B',
    vesselStowageOther: '18, 25, 128',
  },
  {
    symbols: 'G',
    properShippingName: 'Flammable liquid, toxic, corrosive, n.o.s.',
    hazardClass: '3',
    idNumber: 'UN3286',
    packingGroup: 'I',
    labelCodes: '3, 6.1, 8',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '21, 40, 100',
  },
  {
    symbols: 'G',
    properShippingName: 'Flammable liquids, corrosive, n.o.s.',
    hazardClass: '3',
    idNumber: 'UN2924',
    packingGroup: 'I',
    labelCodes: '3, 8',
    specialProvisions: 'T14, TP2',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Flammable liquids, n.o.s.',
    hazardClass: '3',
    idNumber: 'UN1993',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'T11, TP1, TP27',
    packagingExceptions: '150',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Flammable liquids, toxic, n.o.s.',
    hazardClass: '3',
    idNumber: 'UN1992',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Flammable solid, corrosive, inorganic, n.o.s.',
    hazardClass: '4.1',
    idNumber: 'UN3180',
    packingGroup: 'II',
    labelCodes: '4.1, 8',
    specialProvisions: 'A1, IB6, IP2, T3, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Flammable solid, inorganic, n.o.s.',
    hazardClass: '4.1',
    idNumber: 'UN3178',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: 'A1, IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Flammable solid, organic, molten, n.o.s.',
    hazardClass: '4.1',
    idNumber: 'UN3176',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: 'IB1, T3, TP3, TP26',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Flammable solid, oxidizing, n.o.s',
    hazardClass: '4.1',
    idNumber: 'UN3097',
    packingGroup: 'II',
    labelCodes: '4.1, 5.1',
    specialProvisions: '131',
    packagingExceptions: '151',
    packagingNonBulk: '214',
    packagingBulk: '214',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Flammable solid, toxic, inorganic, n.o.s.',
    hazardClass: '4.1',
    idNumber: 'UN3179',
    packingGroup: 'II',
    labelCodes: '4.1, 6.1',
    specialProvisions: 'A1, IB6, IP2, T3, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Flammable solids, corrosive, organic, n.o.s.',
    hazardClass: '4.1',
    idNumber: 'UN2925',
    packingGroup: 'II',
    labelCodes: '4.1, 8',
    specialProvisions: 'A1, IB6, IP2, T3, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Flammable solids, organic, n.o.s.',
    hazardClass: '4.1',
    idNumber: 'UN1325',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: 'A1, IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Flammable solids, toxic, organic, n.o.s.',
    hazardClass: '4.1',
    idNumber: 'UN2926',
    packingGroup: 'II',
    labelCodes: '4.1, 6.1',
    specialProvisions: 'A1, IB6, IP2, T3, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Flares, aerial',
    hazardClass: '1.3G',
    idNumber: 'UN0093',
    packingGroup: null,
    labelCodes: '1.3G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Flares, aerial',
    hazardClass: '1.4G',
    idNumber: 'UN0403',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Flares, aerial',
    hazardClass: '1.4S',
    idNumber: 'UN0404',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Flares, aerial',
    hazardClass: '1.1G',
    idNumber: 'UN0420',
    packingGroup: null,
    labelCodes: '1.1G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Flares, aerial',
    hazardClass: '1.2G',
    idNumber: 'UN0421',
    packingGroup: null,
    labelCodes: '1.2G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Flares, surface',
    hazardClass: '1.3G',
    idNumber: 'UN0092',
    packingGroup: null,
    labelCodes: '1.3G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Flares, surface',
    hazardClass: '1.1G',
    idNumber: 'UN0418',
    packingGroup: null,
    labelCodes: '1.1G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Flares, surface',
    hazardClass: '1.2G',
    idNumber: 'UN0419',
    packingGroup: null,
    labelCodes: '1.2G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Flash powder',
    hazardClass: '1.1G',
    idNumber: 'UN0094',
    packingGroup: null,
    labelCodes: '1.1G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Flash powder',
    hazardClass: '1.3G',
    idNumber: 'UN0305',
    packingGroup: null,
    labelCodes: '1.3G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Fluorine, compressed',
    hazardClass: '2.3',
    idNumber: 'UN1045',
    packingGroup: null,
    labelCodes: '2.3, 5.1, 8',
    specialProvisions: '1, N86',
    packagingExceptions: 'None',
    packagingNonBulk: '302',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 89, 90',
  },
  {
    symbols: '',
    properShippingName: 'Fluoroacetic acid',
    hazardClass: '6.1',
    idNumber: 'UN2642',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Fluoroanilines',
    hazardClass: '6.1',
    idNumber: 'UN2941',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Fluorobenzene',
    hazardClass: '3',
    idNumber: 'UN2387',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Fluoroboric acid',
    hazardClass: '8',
    idNumber: 'UN1775',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, B2, B15, IB2, N3, N34, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Fluorophosphoric acid anhydrous',
    hazardClass: '8',
    idNumber: 'UN1776',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, B2, IB2, N3, N34, T8, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: 'G',
    properShippingName: 'Fluorosilicates, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN2856',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Fluorosilicic acid',
    hazardClass: '8',
    idNumber: 'UN1778',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, B2, B15, IB2, N3, N34, T8, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Fluorosulfonic acid',
    hazardClass: '8',
    idNumber: 'UN1777',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'A7, A10, B6, B10, N3, N36, T10, TP2',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Fluorotoluenes',
    hazardClass: '3',
    idNumber: 'UN2388',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Formaldehyde solutions, flammable',
    hazardClass: '3',
    idNumber: 'UN1198',
    packingGroup: 'III',
    labelCodes: '3, 8',
    specialProvisions: '176, B1, IB3, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Formaldehyde solutions, with not less than 25 percent formaldehyde',
    hazardClass: '8',
    idNumber: 'UN2209',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: '',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Formic acid with not less than 10% but not more than 85% acid by mass',
    hazardClass: '8',
    idNumber: 'UN3412',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Formic acid with not less than 5% but less than 10% acid by mass',
    hazardClass: '8',
    idNumber: 'UN3412',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Formic acid with more than 85% acid by mass',
    hazardClass: '8',
    idNumber: 'UN1779',
    packingGroup: 'II',
    labelCodes: '8, 3',
    specialProvisions: 'B2, B28, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Fracturing devices, explosive, without detonators for oil wells',
    hazardClass: '1.1D',
    idNumber: 'UN0099',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Fuel, aviation, turbine engine',
    hazardClass: '3',
    idNumber: 'UN1863',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: '144, T11, TP1, TP8, TP28',
    packagingExceptions: '150',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Fuel cell cartridges or Fuel cell cartridges contained in equipment or Fuel cell cartridges packed with equipment, containing corrosive substances',
    hazardClass: '8',
    idNumber: 'UN3477',
    packingGroup: null,
    labelCodes: '8',
    specialProvisions: '328',
    packagingExceptions: '230',
    packagingNonBulk: '230',
    packagingBulk: '230',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Fuel cell cartridges or Fuel cell cartridges contained in equipment or Fuel cell cartridges packed with equipment, containing flammable liquids',
    hazardClass: '3',
    idNumber: 'UN3473',
    packingGroup: null,
    labelCodes: '3',
    specialProvisions: '328',
    packagingExceptions: '230',
    packagingNonBulk: '230',
    packagingBulk: '230',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Fuel cell cartridges or Fuel cell cartridges contained in equipment or Fuel cell cartridges packed with equipment, containing hydrogen in metal hydride',
    hazardClass: '2.1',
    idNumber: 'UN3479',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '328',
    packagingExceptions: '230',
    packagingNonBulk: '230',
    packagingBulk: '230',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Fuel cell cartridges or Fuel cell cartridges contained in equipment or Fuel cell cartridges packed with equipment, containing liquefied flammable gas',
    hazardClass: '2.1',
    idNumber: 'UN3478',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '328',
    packagingExceptions: '230',
    packagingNonBulk: '230',
    packagingBulk: '230',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Fuel cell cartridges or Fuel cell cartridges contained in equipment or Fuel cell cartridges packed with equipment, containing water-reactive substances',
    hazardClass: '4.3',
    idNumber: 'UN3476',
    packingGroup: null,
    labelCodes: '4.3',
    specialProvisions: '328',
    packagingExceptions: '230',
    packagingNonBulk: '230',
    packagingBulk: '230',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: 'D',
    properShippingName: 'Fuel oil (No. 1, 2, 4, 5, or 6)',
    hazardClass: '3',
    idNumber: 'NA1993',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: '144, B1, IB3, T4, TP1, TP29',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Fumaryl chloride',
    hazardClass: '8',
    idNumber: 'UN1780',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '8, 40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Furaldehydes',
    hazardClass: '6.1',
    idNumber: 'UN1199',
    packingGroup: 'II',
    labelCodes: '6.1, 3',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Furan',
    hazardClass: '3',
    idNumber: 'UN2389',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'T12, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Furfuryl alcohol',
    hazardClass: '6.1',
    idNumber: 'UN2874',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52, 74',
  },
  {
    symbols: '',
    properShippingName: 'Furfurylamine',
    hazardClass: '3',
    idNumber: 'UN2526',
    packingGroup: 'III',
    labelCodes: '3, 8',
    specialProvisions: 'B1, IB3, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Fuse, igniter tubular metal clad',
    hazardClass: '1.4G',
    idNumber: 'UN0103',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Fuse, non-detonating instantaneous or quickmatch',
    hazardClass: '1.3G',
    idNumber: 'UN0101',
    packingGroup: null,
    labelCodes: '1.3G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Fuse, safety',
    hazardClass: '1.4S',
    idNumber: 'UN0105',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: 'D',
    properShippingName: 'Fusee (railway or highway)',
    hazardClass: '4.1',
    idNumber: 'NA1325',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: '381',
    packagingExceptions: 'None',
    packagingNonBulk: '184',
    packagingBulk: 'None',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Fusel oil',
    hazardClass: '3',
    idNumber: 'UN1201',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Fuzes, detonating',
    hazardClass: '1.1B',
    idNumber: 'UN0106',
    packingGroup: null,
    labelCodes: '1.1B',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Fuzes, detonating',
    hazardClass: '1.2B',
    idNumber: 'UN0107',
    packingGroup: null,
    labelCodes: '1.2B',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Fuzes, detonating',
    hazardClass: '1.4B',
    idNumber: 'UN0257',
    packingGroup: null,
    labelCodes: '1.4B',
    specialProvisions: '116',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Fuzes, detonating',
    hazardClass: '1.4S',
    idNumber: 'UN0367',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '116, 347',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Fuzes, detonating, with protective features',
    hazardClass: '1.1D',
    idNumber: 'UN0408',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Fuzes, detonating, with protective features',
    hazardClass: '1.2D',
    idNumber: 'UN0409',
    packingGroup: null,
    labelCodes: '1.2D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Fuzes, detonating, with protective features',
    hazardClass: '1.4D',
    idNumber: 'UN0410',
    packingGroup: null,
    labelCodes: '1.4D',
    specialProvisions: '116',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Fuzes, igniting',
    hazardClass: '1.3G',
    idNumber: 'UN0316',
    packingGroup: null,
    labelCodes: '1.3G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Fuzes, igniting',
    hazardClass: '1.4G',
    idNumber: 'UN0317',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Fuzes, igniting',
    hazardClass: '1.4S',
    idNumber: 'UN0368',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Gallium',
    hazardClass: '8',
    idNumber: 'UN2803',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '162',
    packagingBulk: '240',
    passengerQtyLimit: '20 kg',
    cargoQtyLimit: '20 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Gas cartridges, (flammable) without a release device, non-refillable',
    hazardClass: '2.1',
    idNumber: 'UN2037',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: 'None',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 157',
  },
  {
    symbols: 'D',
    properShippingName: 'Gas identification set',
    hazardClass: '2.3',
    idNumber: 'NA9035',
    packingGroup: null,
    labelCodes: '2.3',
    specialProvisions: '6',
    packagingExceptions: 'None',
    packagingNonBulk: '194',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Gas oil',
    hazardClass: '3',
    idNumber: 'UN1202',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: '144, B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Gas, refrigerated liquid, flammable, n.o.s. (cryogenic liquid)',
    hazardClass: '2.1',
    idNumber: 'UN3312',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'T75, TP5',
    packagingExceptions: 'None',
    packagingNonBulk: '316',
    packagingBulk: '318',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Gas, refrigerated liquid, n.o.s. (cryogenic liquid)',
    hazardClass: '2.2',
    idNumber: 'UN3158',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T75, TP5',
    packagingExceptions: '320',
    packagingNonBulk: '316',
    packagingBulk: '318',
    passengerQtyLimit: '50 kg',
    cargoQtyLimit: '500 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Gas, refrigerated liquid, oxidizing, n.o.s. (cryogenic liquid)',
    hazardClass: '2.2',
    idNumber: 'UN3311',
    packingGroup: null,
    labelCodes: '2.2, 5.1',
    specialProvisions: 'T75, TP5, TP22',
    packagingExceptions: '320',
    packagingNonBulk: '316',
    packagingBulk: '318',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Gas sample, non-pressurized, flammable, n.o.s., not refrigerated liquid',
    hazardClass: '2.1',
    idNumber: 'UN3167',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '302, 304',
    packagingBulk: 'None',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Gas sample, non-pressurized, toxic, flammable, n.o.s., not refrigerated liquid',
    hazardClass: '2.3',
    idNumber: 'UN3168',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '6',
    packagingExceptions: '306',
    packagingNonBulk: '302',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '1 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Gas sample, non-pressurized, toxic, n.o.s., not refrigerated liquid',
    hazardClass: '2.3',
    idNumber: 'UN3169',
    packingGroup: null,
    labelCodes: '2.3',
    specialProvisions: '6',
    packagingExceptions: '306',
    packagingNonBulk: '302, 304',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '1 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Gasoline includes gasoline mixed with ethyl alcohol, with not more than 10% alcohol',
    hazardClass: '3',
    idNumber: 'UN1203',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: '144, 177, B1, B33, IB2, T4',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Germane',
    hazardClass: '2.3',
    idNumber: 'UN2192',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '2',
    packagingExceptions: 'None',
    packagingNonBulk: '302',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Germane, adsorbed',
    hazardClass: '2.3',
    idNumber: 'UN3523',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '2',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Glycerol alpha-monochlorohydrin',
    hazardClass: '6.1',
    idNumber: 'UN2689',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Glycidaldehyde',
    hazardClass: '3',
    idNumber: 'UN2622',
    packingGroup: 'II',
    labelCodes: '3, 6.1',
    specialProvisions: 'IB2, IP8, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Grenades, hand or rifle, with bursting charge',
    hazardClass: '1.1D',
    idNumber: 'UN0284',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Grenades, hand or rifle, with bursting charge',
    hazardClass: '1.2D',
    idNumber: 'UN0285',
    packingGroup: null,
    labelCodes: '1.2D',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Grenades, hand or rifle, with bursting charge',
    hazardClass: '1.1F',
    idNumber: 'UN0292',
    packingGroup: null,
    labelCodes: '1.1F',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Grenades, hand or rifle, with bursting charge',
    hazardClass: '1.2F',
    idNumber: 'UN0293',
    packingGroup: null,
    labelCodes: '1.2F',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Grenades, practice, hand or rifle',
    hazardClass: '1.4S',
    idNumber: 'UN0110',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Grenades, practice, hand or rifle',
    hazardClass: '1.3G',
    idNumber: 'UN0318',
    packingGroup: null,
    labelCodes: '1.3G',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Grenades, practice, hand or rifle',
    hazardClass: '1.2G',
    idNumber: 'UN0372',
    packingGroup: null,
    labelCodes: '1.2G',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Grenades practice, hand or rifle',
    hazardClass: '1.4G',
    idNumber: 'UN0452',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Guanidine nitrate',
    hazardClass: '5.1',
    idNumber: 'UN1467',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: 'A1, IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '73',
  },
  {
    symbols: '',
    properShippingName: 'Guanyl nitrosaminoguanylidene hydrazine, wetted with not less than 30 percent water, by mass',
    hazardClass: '1.1A',
    idNumber: 'UN0113',
    packingGroup: null,
    labelCodes: '1.1A',
    specialProvisions: '111, 117',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName:
      'Guanyl nitrosaminoguanyltetrazene, wetted or Tetrazene, wetted with not less than 30 percent water or mixture of alcohol and water, by mass',
    hazardClass: '1.1A',
    idNumber: 'UN0114',
    packingGroup: null,
    labelCodes: '1.1A',
    specialProvisions: '111, 117',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Hafnium powder, dry',
    hazardClass: '4.2',
    idNumber: 'UN2545',
    packingGroup: 'I',
    labelCodes: '4.2',
    specialProvisions: 'W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: '',
    properShippingName:
      'Hafnium powder, wetted with not less than 25 percent water (a visible excess of water must be present) (a) mechanically produced, particle size less than 53 microns; (b) chemically produced, particle size less than 840 microns',
    hazardClass: '4.1',
    idNumber: 'UN1326',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: 'A6, A19, A20, IB6, IP2, N34, T3, TP33, W31, W40',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '74',
  },
  {
    symbols: 'D G',
    properShippingName: 'Hazardous waste, liquid, n.o.s.',
    hazardClass: '9',
    idNumber: 'NA3082',
    packingGroup: 'III',
    labelCodes: '9',
    specialProvisions: 'IB3, T2, TP1',
    packagingExceptions: '155',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: 'No limit',
    cargoQtyLimit: 'No limit',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'D G',
    properShippingName: 'Hazardous waste, solid, n.o.s.',
    hazardClass: '9',
    idNumber: 'NA3077',
    packingGroup: 'III',
    labelCodes: '9',
    specialProvisions: 'B54, IB8, IP2, T1, TP33',
    packagingExceptions: '155',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: 'No limit',
    cargoQtyLimit: 'No limit',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Heating oil, light',
    hazardClass: '3',
    idNumber: 'UN1202',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Helium, compressed',
    hazardClass: '2.2',
    idNumber: 'UN1046',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '',
    packagingExceptions: '306, 307',
    packagingNonBulk: '302',
    packagingBulk: '302, 314',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '85',
  },
  {
    symbols: '',
    properShippingName: 'Helium, refrigerated liquid (cryogenic liquid)',
    hazardClass: '2.2',
    idNumber: 'UN1963',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T75, TP5',
    packagingExceptions: '320',
    packagingNonBulk: '316',
    packagingBulk: '318',
    passengerQtyLimit: '50 kg',
    cargoQtyLimit: '500 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Heptafluoropropane or Refrigerant gas R 227',
    hazardClass: '2.2',
    idNumber: 'UN3296',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'n-Heptaldehyde',
    hazardClass: '3',
    idNumber: 'UN3056',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Heptanes',
    hazardClass: '3',
    idNumber: 'UN1206',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'n-Heptene',
    hazardClass: '3',
    idNumber: 'UN2278',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Hexachloroacetone',
    hazardClass: '6.1',
    idNumber: 'UN2661',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '12, 40',
  },
  {
    symbols: '',
    properShippingName: 'Hexachlorobenzene',
    hazardClass: '6.1',
    idNumber: 'UN2729',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'B3, IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Hexachlorobutadiene',
    hazardClass: '6.1',
    idNumber: 'UN2279',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Hexachlorocyclopentadiene',
    hazardClass: '6.1',
    idNumber: 'UN2646',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '2, B9, B14, B32, B77, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Hexachlorophene',
    hazardClass: '6.1',
    idNumber: 'UN2875',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Hexadecyltrichlorosilane',
    hazardClass: '8',
    idNumber: 'UN1781',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, B2, B6, N34, T10, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Hexadienes',
    hazardClass: '3',
    idNumber: 'UN2458',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Hexaethyl tetraphosphate and compressed gas mixtures',
    hazardClass: '2.3',
    idNumber: 'UN1612',
    packingGroup: null,
    labelCodes: '2.3',
    specialProvisions: '3',
    packagingExceptions: 'None',
    packagingNonBulk: '334',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Hexaethyl tetraphosphate, liquid',
    hazardClass: '6.1',
    idNumber: 'UN1611',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, N76, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Hexaethyl tetraphosphate, solid',
    hazardClass: '6.1',
    idNumber: 'UN1611',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, N76',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Hexafluoroacetone',
    hazardClass: '2.3',
    idNumber: 'UN2420',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '2, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Hexafluoroacetone hydrate, liquid',
    hazardClass: '6.1',
    idNumber: 'UN2552',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Hexafluoroacetone hydrate, solid',
    hazardClass: '6.1',
    idNumber: 'UN3436',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Hexafluoroethane, or Refrigerant gas R 116',
    hazardClass: '2.2',
    idNumber: 'UN2193',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Hexafluorophosphoric acid',
    hazardClass: '8',
    idNumber: 'UN1782',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, B2, IB2, N3, N34, T8, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Hexafluoropropylene compressed or Refrigerant gas R 1216',
    hazardClass: '2.2',
    idNumber: 'UN1858',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Hexaldehyde',
    hazardClass: '3',
    idNumber: 'UN1207',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Hexamethylene diisocyanate',
    hazardClass: '6.1',
    idNumber: 'UN2281',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2, TP13',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '13, 40',
  },
  {
    symbols: '',
    properShippingName: 'Hexamethylenediamine, solid',
    hazardClass: '8',
    idNumber: 'UN2280',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 25, 52',
  },
  {
    symbols: '',
    properShippingName: 'Hexamethylenediamine solution',
    hazardClass: '8',
    idNumber: 'UN1783',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Hexamethyleneimine',
    hazardClass: '3',
    idNumber: 'UN2493',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'IB2, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Hexamethylenetetramine',
    hazardClass: '4.1',
    idNumber: 'UN1328',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: 'A1, IB8, IP3, T1, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Hexanes',
    hazardClass: '3',
    idNumber: 'UN1208',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Hexanitrodiphenylamine or Dipicrylamine or Hexyl',
    hazardClass: '1.1D',
    idNumber: 'UN0079',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Hexanitrostilbene',
    hazardClass: '1.1D',
    idNumber: 'UN0392',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Hexanols',
    hazardClass: '3',
    idNumber: 'UN2282',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '74',
  },
  {
    symbols: '',
    properShippingName: '1-Hexene',
    hazardClass: '3',
    idNumber: 'UN2370',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Hexolite, or Hexotol dry or wetted with less than 15 percent water, by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0118',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Hexotonal',
    hazardClass: '1.1D',
    idNumber: 'UN0393',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Hexyltrichlorosilane',
    hazardClass: '8',
    idNumber: 'UN1784',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, B2, B6, N34, T10, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Hydrazine, anhydrous',
    hazardClass: '8',
    idNumber: 'UN2029',
    packingGroup: 'I',
    labelCodes: '8, 3, 6.1',
    specialProvisions: 'A7, A10, B7, B16, B53',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 52, 125',
  },
  {
    symbols: '',
    properShippingName: 'Hydrazine, aqueous solution, with not more than 37 percent hydrazine, by mass',
    hazardClass: '6.1',
    idNumber: 'UN3293',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52.',
  },
  {
    symbols: '',
    properShippingName: 'Hydrazine aqueous solution, flammable with more than 37% hydrazine, by mass',
    hazardClass: '8',
    idNumber: 'UN3484',
    packingGroup: 'I',
    labelCodes: '8, 3, 6.1',
    specialProvisions: 'B16, B53, T10, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 52, 125',
  },
  {
    symbols: '',
    properShippingName: 'Hydrazine aqueous solution, with more than 37% hydrazine, by mass',
    hazardClass: '8',
    idNumber: 'UN2030',
    packingGroup: 'I',
    labelCodes: '8, 6.1',
    specialProvisions: 'B16, B53, T10, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Hydriodic acid',
    hazardClass: '8',
    idNumber: 'UN1787',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A3, B2, IB2, N41, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Hydrobromic acid, with more than 49 percent hydrobromic acid',
    hazardClass: '8',
    idNumber: 'UN1788',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, B15, IB2, N41, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'C',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Hydrobromic acid, with not more than 49 percent hydrobromic acid',
    hazardClass: '8',
    idNumber: 'UN1788',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A3, B2, B15, IB2, N41, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Hydrocarbon gas mixture, compressed, n.o.s.',
    hazardClass: '2.1',
    idNumber: 'UN1964',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '302',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Hydrocarbon gas mixture, liquefied, n.o.s.',
    hazardClass: '2.1',
    idNumber: 'UN1965',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Hydrocarbons, liquid, n.o.s.',
    hazardClass: '3',
    idNumber: 'UN3295',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: '144, T11, TP1, TP8, TP28',
    packagingExceptions: '150',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Hydrochloric acid',
    hazardClass: '8',
    idNumber: 'UN1789',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: '386, A3, B3, B15, B133, IB2, N41, T8, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName:
      'Hydrocyanic acid, aqueous solutions or Hydrogen cyanide, aqueous solutions with not more than 20 percent hydrogen cyanide',
    hazardClass: '6.1',
    idNumber: 'UN1613',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '2, B61, B65, B77, B82, T20, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '195',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'D',
    properShippingName: 'Hydrocyanic acid, aqueous solutions with less than 5 percent hydrogen cyanide',
    hazardClass: '6.1',
    idNumber: 'NA1613',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB1, T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '195',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Hydrofluoric acid and Sulfuric acid mixtures',
    hazardClass: '8',
    idNumber: 'UN1786',
    packingGroup: 'I',
    labelCodes: '8, 6.1',
    specialProvisions: 'A7, B15, B23, N5, N34, T10, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Hydrofluoric acid, with more than 60 percent strength',
    hazardClass: '8',
    idNumber: 'UN1790',
    packingGroup: 'I',
    labelCodes: '8, 6.1',
    specialProvisions: 'A7, B4, B15, B23, N5, N34, T10, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Hydrofluoric acid, with not more than 60 percent strength',
    hazardClass: '8',
    idNumber: 'UN1790',
    packingGroup: 'II',
    labelCodes: '8, 6.1',
    specialProvisions: 'A7, B15, IB2, N5, N34, T8, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Hydrogen and Methane mixtures, compressed',
    hazardClass: '2.1',
    idNumber: 'UN2034',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'N89',
    packagingExceptions: '306',
    packagingNonBulk: '302',
    packagingBulk: '302, 314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40, 57',
  },
  {
    symbols: '',
    properShippingName: 'Hydrogen bromide, anhydrous',
    hazardClass: '2.3',
    idNumber: 'UN1048',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '3, B14, N86, N89',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Hydrogen chloride, anhydrous',
    hazardClass: '2.3',
    idNumber: 'UN1050',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '3, N86, N89',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Hydrogen chloride, refrigerated liquid',
    hazardClass: '2.3',
    idNumber: 'UN2186',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '3, B6',
    packagingExceptions: 'None',
    packagingNonBulk: 'None',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Hydrogen, compressed',
    hazardClass: '2.1',
    idNumber: 'UN1049',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'N89',
    packagingExceptions: '306',
    packagingNonBulk: '302',
    packagingBulk: '302, 314',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40, 57',
  },
  {
    symbols: '',
    properShippingName: 'Hydrogen cyanide, solution in alcohol with not more than 45 percent hydrogen cyanide',
    hazardClass: '6.1',
    idNumber: 'UN3294',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '2, B9, B14, B32, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Hydrogen cyanide, stabilized with less than 3 percent water',
    hazardClass: '6.1',
    idNumber: 'UN1051',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '1, 387, B35, B61, B65, B77, B82',
    packagingExceptions: 'None',
    packagingNonBulk: '195',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName:
      'Hydrogen cyanide, stabilized, with less than 3 percent water and absorbed in a porous inert material',
    hazardClass: '6.1',
    idNumber: 'UN1614',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '5, 387',
    packagingExceptions: 'None',
    packagingNonBulk: '195',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Hydrogen fluoride, anhydrous',
    hazardClass: '8',
    idNumber: 'UN1052',
    packingGroup: 'I',
    labelCodes: '8.6.1',
    specialProvisions: '3, B7, B46, B77, N86, T10, TP2',
    packagingExceptions: 'None',
    packagingNonBulk: '163',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName:
      'Hydrogen in a metal hydride storage system or Hydrogen in a metal hydride storage system contained in equipment or Hydrogen in a metal hydride storage system packed with equipment',
    hazardClass: '2.1',
    idNumber: 'UN3468',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '167',
    packagingExceptions: 'None',
    packagingNonBulk: '311',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Hydrogen iodide, anhydrous',
    hazardClass: '2.3',
    idNumber: 'UN2197',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '3, B14, N86, N89',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName:
      'Hydrogen peroxide and peroxyacetic acid mixtures, stabilized with acids, water, and not more than 5 percent peroxyacetic acid',
    hazardClass: '5.1',
    idNumber: 'UN3149',
    packingGroup: 'II',
    labelCodes: '5.1, 8',
    specialProvisions: '145, A2, A3, B53, IB2, IP5, T7, TP2, TP6, TP24',
    packagingExceptions: '152',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 66, 75',
  },
  {
    symbols: '',
    properShippingName:
      'Hydrogen peroxide, aqueous solutions with more than 40 percent but not more than 60 percent hydrogen peroxide (stabilized as necessary)',
    hazardClass: '5.1',
    idNumber: 'UN2014',
    packingGroup: 'II',
    labelCodes: '5.1, 8',
    specialProvisions: '12, A60, B53, B80, B81, B85, IB2, IP5, T7, TP2, TP6, TP24, TP37',
    packagingExceptions: '152',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 66, 75',
  },
  {
    symbols: '',
    properShippingName:
      'Hydrogen peroxide, aqueous solutions with not less than 20 percent but not more than 40 percent hydrogen peroxide (stabilized as necessary)',
    hazardClass: '5.1',
    idNumber: 'UN2014',
    packingGroup: 'II',
    labelCodes: '5.1, 8',
    specialProvisions: 'A2, A3, B53, IB2, IP5, T7, TP2, TP6, TP24, TP37',
    packagingExceptions: '152',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 66, 75',
  },
  {
    symbols: '',
    properShippingName:
      'Hydrogen, peroxide, aqueous solutions with not less than 8 percent but less than 20 percent hydrogen peroxide (stabilized as necessary)',
    hazardClass: '5.1',
    idNumber: 'UN2984',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: 'A1, IB2, IP5, T4, TP1, TP6, TP24, TP37',
    packagingExceptions: '152',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '2.5 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '25, 66, 75',
  },
  {
    symbols: '',
    properShippingName:
      'Hydrogen peroxide, stabilized or Hydrogen peroxide aqueous solutions, stabilized with more than 60 percent hydrogen peroxide',
    hazardClass: '5.1',
    idNumber: 'UN2015',
    packingGroup: 'I',
    labelCodes: '5.1, 8',
    specialProvisions: '12, B53, B80, B81, B85, T9, TP2, TP6, TP24, TP37',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 66, 75.',
  },
  {
    symbols: '',
    properShippingName: 'Hydrogen, refrigerated liquid (cryogenic liquid)',
    hazardClass: '2.1',
    idNumber: 'UN1966',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'T75, TP5',
    packagingExceptions: 'None',
    packagingNonBulk: '316',
    packagingBulk: '318, 319',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 57',
  },
  {
    symbols: '',
    properShippingName: 'Hydrogen selenide, adsorbed',
    hazardClass: '2.3',
    idNumber: 'UN3526',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Hydrogen selenide, anhydrous',
    hazardClass: '2.3',
    idNumber: 'UN2202',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '192',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Hydrogen sulfide',
    hazardClass: '2.3',
    idNumber: 'UN1053',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '2, B9, B14, N89',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Hydrogendifluoride, solid, n.o.s.',
    hazardClass: '8',
    idNumber: 'UN1740',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB8, IP2, IP4, N3, N34, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '25, 40, 52, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Hydrogendifluoride solution, n.o.s',
    hazardClass: '8',
    idNumber: 'UN3471',
    packingGroup: 'II',
    labelCodes: '8, 6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '25, 40, 52.',
  },
  {
    symbols: '',
    properShippingName: '1-Hydroxybenzotriazole, anhydrous, dry or wetted with less than 20 percent water, by mass',
    hazardClass: '1.3C',
    idNumber: 'UN0508',
    packingGroup: null,
    labelCodes: '1.3C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: '1-Hydroxybenzotriazole, monohydrate',
    hazardClass: '4.1',
    idNumber: 'UN3474',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: 'N90',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: '0.5 kg',
    cargoQtyLimit: '0.5 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Hydroxylamine sulfate',
    hazardClass: '8',
    idNumber: 'UN2865',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Hypochlorite solutions',
    hazardClass: '8',
    idNumber: 'UN1791',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: '148, A7, B2, B15, IB2, IP5, N34, T7, TP2, TP24',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '26',
  },
  {
    symbols: 'G',
    properShippingName: 'Hypochlorites, inorganic, n.o.s',
    hazardClass: '5.1',
    idNumber: 'UN3212',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: '349, A9, IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '4, 25, 52, 56, 58, 69, 116, 118',
  },
  {
    symbols: '',
    properShippingName: 'Igniters',
    hazardClass: '1.1G',
    idNumber: 'UN0121',
    packingGroup: null,
    labelCodes: '1.1G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Igniters',
    hazardClass: '1.2G',
    idNumber: 'UN0314',
    packingGroup: null,
    labelCodes: '1.2G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Igniters',
    hazardClass: '1.3G',
    idNumber: 'UN0315',
    packingGroup: null,
    labelCodes: '1.3G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Igniters',
    hazardClass: '1.4G',
    idNumber: 'UN0325',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Igniters',
    hazardClass: '1.4S',
    idNumber: 'UN0454',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: '3,3′-Iminodipropylamine',
    hazardClass: '8',
    idNumber: 'UN2269',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T4, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: 'G',
    properShippingName: 'Infectious substances, affecting animals only',
    hazardClass: '6.2',
    idNumber: 'UN2900',
    packingGroup: null,
    labelCodes: '6.2',
    specialProvisions: 'A82',
    packagingExceptions: '134',
    packagingNonBulk: '196',
    packagingBulk: 'None',
    passengerQtyLimit: '50 mL or 50 g',
    cargoQtyLimit: '4 L or 4 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 95, 155',
  },
  {
    symbols: 'G',
    properShippingName: 'Infectious substances, affecting humans',
    hazardClass: '6.2',
    idNumber: 'UN2814',
    packingGroup: null,
    labelCodes: '6.2',
    specialProvisions: 'A82',
    packagingExceptions: '134',
    packagingNonBulk: '196',
    packagingBulk: 'None',
    passengerQtyLimit: '50 mL or 50 g',
    cargoQtyLimit: '4 L or 4 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 95, 155',
  },
  {
    symbols: 'G',
    properShippingName: 'Insecticide gases, n.o.s.',
    hazardClass: '2.2',
    idNumber: 'UN1968',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Insecticide gases, flammable, n.o.s.',
    hazardClass: '2.1',
    idNumber: 'UN3354',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Insecticide gases, toxic, flammable, n.o.s. Inhalation hazard Zone A',
    hazardClass: '2.3',
    idNumber: 'UN3355',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '192',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Insecticide gases, toxic, flammable, n.o.s. Inhalation hazard Zone B',
    hazardClass: '2.3',
    idNumber: 'UN3355',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '2, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Insecticide gases, toxic, flammable, n.o.s. Inhalation hazard Zone C',
    hazardClass: '2.3',
    idNumber: 'UN3355',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '3, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Insecticide gases, toxic, flammable, n.o.s. Inhalation hazard Zone D',
    hazardClass: '2.3',
    idNumber: 'UN3355',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '4',
    packagingExceptions: 'None',
    packagingNonBulk: '302, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Insecticide gases, toxic, n.o.s.',
    hazardClass: '2.3',
    idNumber: 'UN1967',
    packingGroup: null,
    labelCodes: '2.3',
    specialProvisions: '3',
    packagingExceptions: 'None',
    packagingNonBulk: '193, 334',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '+',
    properShippingName: 'Iodine',
    hazardClass: '8',
    idNumber: 'UN3495',
    packingGroup: 'III',
    labelCodes: '8, 6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 55',
  },
  {
    symbols: '',
    properShippingName: 'Iodine monochloride, liquid',
    hazardClass: '8',
    idNumber: 'UN3498',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 53, 58, 66, 74, 89, 90',
  },
  {
    symbols: '',
    properShippingName: 'Iodine monochloride, solid',
    hazardClass: '8',
    idNumber: 'UN1792',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B6, IB8, IP2, IP4, N41, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 53, 58, 66, 74',
  },
  {
    symbols: '',
    properShippingName: 'Iodine pentafluoride',
    hazardClass: '5.1',
    idNumber: 'UN2495',
    packingGroup: 'I',
    labelCodes: '5.1, 6.1, 8',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '205',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40, 52, 53, 58, 66, 90',
  },
  {
    symbols: '',
    properShippingName: '2-Iodobutane',
    hazardClass: '3',
    idNumber: 'UN2390',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Iodomethylpropanes',
    hazardClass: '3',
    idNumber: 'UN2391',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Iodopropanes',
    hazardClass: '3',
    idNumber: 'UN2392',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Iron oxide, spent, or Iron sponge, spent obtained from coal gas purification',
    hazardClass: '4.2',
    idNumber: 'UN1376',
    packingGroup: 'III',
    labelCodes: '4.2',
    specialProvisions: 'B18, B134, IB8, IP21, T1, TP33, W100',
    packagingExceptions: 'None',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: '',
    properShippingName: 'Iron pentacarbonyl',
    hazardClass: '6.1',
    idNumber: 'UN1994',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '1, B9, B14, B30, B77, T22, TP2, TP13, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Isobutane see also Petroleum gases, liquefied',
    hazardClass: '2.1',
    idNumber: 'UN1969',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '19, T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Isobutanol or Isobutyl alcohol',
    hazardClass: '3',
    idNumber: 'UN1212',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Isobutyl acetate',
    hazardClass: '3',
    idNumber: 'UN1213',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Isobutyl acrylate, stabilized',
    hazardClass: '3',
    idNumber: 'UN2527',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: '387, B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Isobutyl formate',
    hazardClass: '3',
    idNumber: 'UN2393',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Isobutyl isobutyrate',
    hazardClass: '3',
    idNumber: 'UN2528',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '+',
    properShippingName: 'Isobutyl isocyanate',
    hazardClass: '6.1',
    idNumber: 'UN2486',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '1, B9, B14, B30, T20, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Isobutyl methacrylate, stabilized',
    hazardClass: '3',
    idNumber: 'UN2283',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: '387, B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Isobutyl propionate',
    hazardClass: '3',
    idNumber: 'UN2394',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Isobutylamine',
    hazardClass: '3',
    idNumber: 'UN1214',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'IB2, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Isobutylene see also Petroleum gases, liquefied',
    hazardClass: '2.1',
    idNumber: 'UN1055',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '19, T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Isobutyraldehyde or Isobutyl aldehyde',
    hazardClass: '3',
    idNumber: 'UN2045',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Isobutyric acid',
    hazardClass: '3',
    idNumber: 'UN2529',
    packingGroup: 'III',
    labelCodes: '3, 8',
    specialProvisions: 'B1, IB3, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Isobutyronitrile',
    hazardClass: '3',
    idNumber: 'UN2284',
    packingGroup: 'II',
    labelCodes: '3, 6.1',
    specialProvisions: 'IB2, T7, TP2, TP13',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Isobutyryl chloride',
    hazardClass: '3',
    idNumber: 'UN2395',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'IB1, T7, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: 'G',
    properShippingName:
      'Isocyanates, flammable, toxic, n.o.s. or Isocyanate solutions, flammable, toxic, n.o.s. flash point less than 23 degrees C',
    hazardClass: '3',
    idNumber: 'UN2478',
    packingGroup: 'II',
    labelCodes: '3, 6.1',
    specialProvisions: '5, A3, A7, IB2, T11, TP2, TP13, TP27, W31',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName:
      'Isocyanates, toxic, flammable, n.o.s. or Isocyanate solutions, toxic, flammable, n.o.s., flash point not less than 23 degrees C but not more than 61 degrees C and boiling point less than 300 degrees C',
    hazardClass: '6.1',
    idNumber: 'UN3080',
    packingGroup: 'II',
    labelCodes: '6.1, 3',
    specialProvisions: 'IB2, T11, TP2, TP13, TP27',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: 'G',
    properShippingName:
      'Isocyanates, toxic, n.o.s. or Isocyanate solutions, toxic, n.o.s., flash point more than 61 degrees C and boiling point less than 300 degrees C',
    hazardClass: '6.1',
    idNumber: 'UN2206',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T11, TP2, TP13, TP27',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Isocyanatobenzotrifluorides',
    hazardClass: '6.1',
    idNumber: 'UN2285',
    packingGroup: 'II',
    labelCodes: '6.1, 3',
    specialProvisions: '5, IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Isoheptenes',
    hazardClass: '3',
    idNumber: 'UN2287',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Isohexenes',
    hazardClass: '3',
    idNumber: 'UN2288',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, IP8, T11, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Isooctenes',
    hazardClass: '3',
    idNumber: 'UN1216',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Isopentenes',
    hazardClass: '3',
    idNumber: 'UN2371',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'T11, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Isophorone diisocyanate',
    hazardClass: '6.1',
    idNumber: 'UN2290',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Isophoronediamine',
    hazardClass: '8',
    idNumber: 'UN2289',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Isoprene, stabilized',
    hazardClass: '3',
    idNumber: 'UN1218',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: '387, T11, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Isopropanol or Isopropyl alcohol',
    hazardClass: '3',
    idNumber: 'UN1219',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '4b, 150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Isopropenyl acetate',
    hazardClass: '3',
    idNumber: 'UN2403',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Isopropenylbenzene',
    hazardClass: '3',
    idNumber: 'UN2303',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Isopropyl acetate',
    hazardClass: '3',
    idNumber: 'UN1220',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Isopropyl acid phosphate',
    hazardClass: '8',
    idNumber: 'UN1793',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Isopropyl butyrate',
    hazardClass: '3',
    idNumber: 'UN2405',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Isopropyl chloroacetate',
    hazardClass: '3',
    idNumber: 'UN2947',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Isopropyl chloroformate',
    hazardClass: '6.1',
    idNumber: 'UN2407',
    packingGroup: 'I',
    labelCodes: '6.1, 3, 8',
    specialProvisions: '2, B9, B14, B32, B77, T20, TP2, TP13, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'B',
    vesselStowageOther: '21, 40, 53, 58, 100',
  },
  {
    symbols: '',
    properShippingName: 'Isopropyl 2-chloropropionate',
    hazardClass: '3',
    idNumber: 'UN2934',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Isopropyl isobutyrate',
    hazardClass: '3',
    idNumber: 'UN2406',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '+',
    properShippingName: 'Isopropyl isocyanate',
    hazardClass: '6.1',
    idNumber: 'UN2483',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '1, B9, B14, B30, T20, TP2, TP13, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Isopropyl nitrate',
    hazardClass: '3',
    idNumber: 'UN1222',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB9',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: 'None',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Isopropyl propionate',
    hazardClass: '3',
    idNumber: 'UN2409',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Isopropylamine',
    hazardClass: '3',
    idNumber: 'UN1221',
    packingGroup: 'I',
    labelCodes: '3, 8',
    specialProvisions: 'T11, TP2',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Isopropylbenzene',
    hazardClass: '3',
    idNumber: 'UN1918',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Isosorbide dinitrate mixture with not less than 60 percent lactose, mannose, starch or calcium hydrogen phosphate',
    hazardClass: '4.1',
    idNumber: 'UN2907',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: 'IB6, IP2, N85',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: 'None',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Isosorbide-5-mononitrate',
    hazardClass: '4.1',
    idNumber: 'UN3251',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: '66, 159, IB8',
    packagingExceptions: '151',
    packagingNonBulk: '223',
    packagingBulk: '240',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 40, 84',
  },
  {
    symbols: 'D',
    properShippingName: 'Jet perforating guns, charged oil well with detonator',
    hazardClass: '1.1D',
    idNumber: 'NA0124',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '55, 56',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25, 154',
  },
  {
    symbols: 'D',
    properShippingName: 'Jet perforating guns, charged oil well, with detonator',
    hazardClass: '1.4D',
    idNumber: 'NA0494',
    packingGroup: null,
    labelCodes: '1.4D',
    specialProvisions: '55, 56',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '02',
    vesselStowageOther: '25, 154',
  },
  {
    symbols: '',
    properShippingName: 'Jet perforating guns, charged, oil well, without detonator',
    hazardClass: '1.4D',
    idNumber: 'UN0494',
    packingGroup: null,
    labelCodes: '1.4D',
    specialProvisions: '55, 114',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '300 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25, 154',
  },
  {
    symbols: '',
    properShippingName: 'Jet perforating guns, charged oil well without detonator',
    hazardClass: '1.1D',
    idNumber: 'UN0124',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '55',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25, 154',
  },
  {
    symbols: '',
    properShippingName: 'Kerosene',
    hazardClass: '3',
    idNumber: 'UN1223',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: '144, B1, IB3, T2, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Ketones, liquid, n.o.s.',
    hazardClass: '3',
    idNumber: 'UN1224',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'T11, TP1, TP8, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Krill meal',
    hazardClass: '4.2',
    idNumber: 'UN3497',
    packingGroup: 'II',
    labelCodes: '4.2',
    specialProvisions: '155, IB6, IP2, T3, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '25, 88, 128',
  },
  {
    symbols: '',
    properShippingName: 'Krypton, compressed',
    hazardClass: '2.2',
    idNumber: 'UN1056',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '',
    packagingExceptions: '306, 307',
    packagingNonBulk: '302',
    packagingBulk: 'None',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Krypton, refrigerated liquid (cryogenic liquid)',
    hazardClass: '2.2',
    idNumber: 'UN1970',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T75, TP5',
    packagingExceptions: '320',
    packagingNonBulk: 'None',
    packagingBulk: 'None',
    passengerQtyLimit: '50 kg',
    cargoQtyLimit: '500 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Lead acetate',
    hazardClass: '6.1',
    idNumber: 'UN1616',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Lead arsenates',
    hazardClass: '6.1',
    idNumber: 'UN1617',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Lead arsenites',
    hazardClass: '6.1',
    idNumber: 'UN1618',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Lead azide, wetted with not less than 20 percent water or mixture of alcohol and water, by mass',
    hazardClass: '1.1A',
    idNumber: 'UN0129',
    packingGroup: null,
    labelCodes: '1.1A',
    specialProvisions: '111, 117',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Lead compounds, soluble, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN2291',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: '138, IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Lead cyanide',
    hazardClass: '6.1',
    idNumber: 'UN1620',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Lead dioxide',
    hazardClass: '5.1',
    idNumber: 'UN1872',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: 'A1, IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Lead nitrate',
    hazardClass: '5.1',
    idNumber: 'UN1469',
    packingGroup: 'II',
    labelCodes: '5.1, 6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Lead perchlorate, solid',
    hazardClass: '5.1',
    idNumber: 'UN1470',
    packingGroup: 'II',
    labelCodes: '5.1, 6.1',
    specialProvisions: 'IB6, IP2, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Lead perchlorate, solution',
    hazardClass: '5.1',
    idNumber: 'UN3408',
    packingGroup: 'II',
    labelCodes: '5.1, 6.1',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '152',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Lead phosphite, dibasic',
    hazardClass: '4.1',
    idNumber: 'UN2989',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '34',
  },
  {
    symbols: '',
    properShippingName:
      'Lead styphnate, wetted or Lead trinitroresorcinate, wetted with not less than 20 percent water or mixture of alcohol and water, by mass',
    hazardClass: '1.1A',
    idNumber: 'UN0130',
    packingGroup: null,
    labelCodes: '1.1A',
    specialProvisions: '111, 117',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Lead sulfate with more than 3 percent free acid',
    hazardClass: '8',
    idNumber: 'UN1794',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Life-saving appliances, not self inflating containing dangerous goods as equipment',
    hazardClass: '9',
    idNumber: 'UN3072',
    packingGroup: null,
    labelCodes: 'None',
    specialProvisions: '182',
    packagingExceptions: 'None',
    packagingNonBulk: '219',
    packagingBulk: 'None',
    passengerQtyLimit: 'No limit',
    cargoQtyLimit: 'No limit',
    vesselStowageLocation: 'A',
    vesselStowageOther: '122',
  },
  {
    symbols: '',
    properShippingName: 'Life-saving appliances, self inflating',
    hazardClass: '9',
    idNumber: 'UN2990',
    packingGroup: null,
    labelCodes: 'None',
    specialProvisions: '338',
    packagingExceptions: 'None',
    packagingNonBulk: '219',
    packagingBulk: 'None',
    passengerQtyLimit: 'No limit',
    cargoQtyLimit: 'No limit',
    vesselStowageLocation: 'A',
    vesselStowageOther: '122',
  },
  {
    symbols: '',
    properShippingName: 'Lighters containing flammable gas',
    hazardClass: '2.1',
    idNumber: 'UN1057',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '168',
    packagingExceptions: '21,308',
    packagingNonBulk: '21,308',
    packagingBulk: 'None',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Lighters, non-pressurized, containing flammable liquid,',
    hazardClass: '3',
    idNumber: 'NA1057',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: '168',
    packagingExceptions: '21',
    packagingNonBulk: 'None',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName:
      'Lighter refills containing flammable gas not exceeding 4 fluid ounces (7.22 cubic inches) and 65 grams of flammable gas',
    hazardClass: '2.1',
    idNumber: 'UN1057',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '169',
    packagingExceptions: '306',
    packagingNonBulk: '306',
    packagingBulk: 'None',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Lighters, fuse',
    hazardClass: '1.4S',
    idNumber: 'UN0131',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Liquefied gas, flammable, n.o.s.',
    hazardClass: '2.1',
    idNumber: 'UN3161',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Liquefied gas, n.o.s.',
    hazardClass: '2.2',
    idNumber: 'UN3163',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Liquefied gas, oxidizing, n.o.s.',
    hazardClass: '2.2',
    idNumber: 'UN3157',
    packingGroup: null,
    labelCodes: '2.2, 5.1',
    specialProvisions: 'A14',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: 'G I',
    properShippingName: 'Liquefied gas, toxic, corrosive, n.o.s. Inhalation Hazard Zone A',
    hazardClass: '2.3',
    idNumber: 'UN3308',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '192',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G I',
    properShippingName: 'Liquefied gas, toxic, corrosive, n.o.s. Inhalation Hazard Zone B',
    hazardClass: '2.3',
    idNumber: 'UN3308',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '2, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G I',
    properShippingName: 'Liquefied gas, toxic, corrosive, n.o.s. Inhalation Hazard Zone C',
    hazardClass: '2.3',
    idNumber: 'UN3308',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '3, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G I',
    properShippingName: 'Liquefied gas, toxic, corrosive, n.o.s. Inhalation Hazard Zone D',
    hazardClass: '2.3',
    idNumber: 'UN3308',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '4',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G I',
    properShippingName: 'Liquefied gas, toxic, flammable, corrosive, n.o.s. Inhalation Hazard Zone A',
    hazardClass: '2.3',
    idNumber: 'UN3309',
    packingGroup: null,
    labelCodes: '2.3, 2.1, 8',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '192',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '17, 40',
  },
  {
    symbols: 'G I',
    properShippingName: 'Liquefied gas toxic, flammable, corrosive, n.o.s. Inhalation Hazard Zone B',
    hazardClass: '2.3',
    idNumber: 'UN3309',
    packingGroup: null,
    labelCodes: '2.3, 2.1, 8',
    specialProvisions: '2, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '17, 40',
  },
  {
    symbols: 'G I',
    properShippingName: 'Liquefied gas, toxic, flammable, corrosive, n.o.s. Inhalation Hazard Zone C',
    hazardClass: '2.3',
    idNumber: 'UN3309',
    packingGroup: null,
    labelCodes: '2.3, 2.1, 8',
    specialProvisions: '3, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '17, 40',
  },
  {
    symbols: 'G I',
    properShippingName: 'Liquefied gas, toxic, flammable, corrosive, n.o.s. Inhalation Hazard Zone D',
    hazardClass: '2.3',
    idNumber: 'UN3309',
    packingGroup: null,
    labelCodes: '2.3, 2.1, 8',
    specialProvisions: '4',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '17, 40',
  },
  {
    symbols: 'G',
    properShippingName: 'Liquefied gas, toxic, flammable, n.o.s. Inhalation Hazard Zone A',
    hazardClass: '2.3',
    idNumber: 'UN3160',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '192',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Liquefied gas, toxic, flammable, n.o.s. Inhalation Hazard Zone B',
    hazardClass: '2.3',
    idNumber: 'UN3160',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '2, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Liquefied gas, toxic, flammable, n.o.s. Inhalation Hazard Zone C',
    hazardClass: '2.3',
    idNumber: 'UN3160',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '3, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Liquefied gas, toxic, flammable, n.o.s. Inhalation Hazard Zone D',
    hazardClass: '2.3',
    idNumber: 'UN3160',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '4',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Liquefied gas, toxic, n.o.s. Inhalation Hazard Zone A',
    hazardClass: '2.3',
    idNumber: 'UN3162',
    packingGroup: null,
    labelCodes: '2.3',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '192',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Liquefied gas, toxic, n.o.s. Inhalation Hazard Zone B',
    hazardClass: '2.3',
    idNumber: 'UN3162',
    packingGroup: null,
    labelCodes: '2.3',
    specialProvisions: '2, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Liquefied gas, toxic, n.o.s. Inhalation Hazard Zone C',
    hazardClass: '2.3',
    idNumber: 'UN3162',
    packingGroup: null,
    labelCodes: '2.3',
    specialProvisions: '3, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Liquefied gas, toxic, n.o.s. Inhalation Hazard Zone D',
    hazardClass: '2.3',
    idNumber: 'UN3162',
    packingGroup: null,
    labelCodes: '2.3',
    specialProvisions: '4',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G I',
    properShippingName: 'Liquefied gas, toxic, oxidizing, corrosive, n.o.s. Inhalation Hazard Zone A',
    hazardClass: '2.3',
    idNumber: 'UN3310',
    packingGroup: null,
    labelCodes: '2.3, 5.1, 8',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '192',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 89, 90',
  },
  {
    symbols: 'G I',
    properShippingName: 'Liquefied gas, toxic, oxidizing, corrosive, n.o.s. Inhalation Hazard Zone B',
    hazardClass: '2.3',
    idNumber: 'UN3310',
    packingGroup: null,
    labelCodes: '2.3, 5.1, 8',
    specialProvisions: '2, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 89, 90',
  },
  {
    symbols: 'G I',
    properShippingName: 'Liquefied gas, toxic, oxidizing, corrosive, n.o.s. Inhalation Hazard Zone C',
    hazardClass: '2.3',
    idNumber: 'UN3310',
    packingGroup: null,
    labelCodes: '2.3, 5.1, 8',
    specialProvisions: '3, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 89, 90',
  },
  {
    symbols: 'G I',
    properShippingName: 'Liquefied gas, toxic, oxidizing, corrosive, n.o.s. Inhalation Hazard Zone D',
    hazardClass: '2.3',
    idNumber: 'UN3310',
    packingGroup: null,
    labelCodes: '2.3, 5.1, 8',
    specialProvisions: '4',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 89, 90',
  },
  {
    symbols: 'G',
    properShippingName: 'Liquefied gas, toxic, oxidizing, n.o.s. Inhalation Hazard Zone A',
    hazardClass: '2.3',
    idNumber: 'UN3307',
    packingGroup: null,
    labelCodes: '2.3, 5.1',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '192',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Liquefied gas, toxic, oxidizing, n.o.s. Inhalation Hazard Zone B',
    hazardClass: '2.3',
    idNumber: 'UN3307',
    packingGroup: null,
    labelCodes: '2.3, 5.1',
    specialProvisions: '2, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Liquefied gas, toxic, oxidizing, n.o.s. Inhalation Hazard Zone C',
    hazardClass: '2.3',
    idNumber: 'UN3307',
    packingGroup: null,
    labelCodes: '2.3, 5.1',
    specialProvisions: '3, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Liquefied gas, toxic, oxidizing, n.o.s. Inhalation Hazard Zone D',
    hazardClass: '2.3',
    idNumber: 'UN3307',
    packingGroup: null,
    labelCodes: '2.3, 5.1',
    specialProvisions: '4',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Liquefied gases, non-flammable charged with nitrogen, carbon dioxide or air',
    hazardClass: '2.2',
    idNumber: 'UN1058',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: 'None',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Lithium',
    hazardClass: '4.3',
    idNumber: 'UN1415',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A7, A19, IB4, IP1, N45, T9, TP7, TP33, W31',
    packagingExceptions: '151',
    packagingNonBulk: '211',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Lithium aluminum hydride',
    hazardClass: '4.3',
    idNumber: 'UN1410',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A19, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Lithium aluminum hydride, ethereal',
    hazardClass: '4.3',
    idNumber: 'UN1411',
    packingGroup: 'I',
    labelCodes: '4.3, 3',
    specialProvisions: 'A2, A11, N34',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '1 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 40, 148',
  },
  {
    symbols: '',
    properShippingName:
      'Lithium batteries installed in cargo transport unit lithium ion batteries or lithium metal batteries',
    hazardClass: '9',
    idNumber: 'UN3536',
    packingGroup: null,
    labelCodes: '',
    specialProvisions: '389',
    packagingExceptions: '',
    packagingNonBulk: '',
    packagingBulk: '',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Lithium borohydride',
    hazardClass: '4.3',
    idNumber: 'UN1413',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A19, N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Lithium ferrosilicon',
    hazardClass: '4.3',
    idNumber: 'UN2830',
    packingGroup: 'II',
    labelCodes: '4.3',
    specialProvisions: 'A19, IB7, IP2, IP21, T3, TP33, W31, W40',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 85, 103, 148',
  },
  {
    symbols: '',
    properShippingName: 'Lithium hydride',
    hazardClass: '4.3',
    idNumber: 'UN1414',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A19, N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Lithium hydride, fused solid',
    hazardClass: '4.3',
    idNumber: 'UN2805',
    packingGroup: 'II',
    labelCodes: '4.3',
    specialProvisions: 'A8, A19, A20, IB4, T3, TP33, W31, W40',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Lithium hydroxide',
    hazardClass: '8',
    idNumber: 'UN2680',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52.',
  },
  {
    symbols: '',
    properShippingName: 'Lithium hydroxide, solution',
    hazardClass: '8',
    idNumber: 'UN2679',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '29, 52.',
  },
  {
    symbols: '',
    properShippingName: 'Lithium hypochlorite, dry or Lithium hypochlorite mixture',
    hazardClass: '5.1',
    idNumber: 'UN1471',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'A9, IB8, IP2, IP4, N34, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '4, 25, 52, 56, 58, 69, 106, 116',
  },
  {
    symbols: '',
    properShippingName: 'Lithium ion batteries including lithium ion polymer batteries',
    hazardClass: '9',
    idNumber: 'UN3480',
    packingGroup: null,
    labelCodes: '9',
    specialProvisions: '388, 422, A54, A100',
    packagingExceptions: '185',
    packagingNonBulk: '185',
    packagingBulk: '185',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '35 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '156',
  },
  {
    symbols: '',
    properShippingName: 'Lithium ion batteries contained in equipment including lithium ion polymer batteries',
    hazardClass: '9',
    idNumber: 'UN3481',
    packingGroup: null,
    labelCodes: '9',
    specialProvisions: '181, 360, 388, 422, A54',
    packagingExceptions: '185',
    packagingNonBulk: '185',
    packagingBulk: '185',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '35 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '156',
  },
  {
    symbols: '',
    properShippingName: 'Lithium ion batteries packed with equipment including lithium ion polymer batteries',
    hazardClass: '9',
    idNumber: 'UN3481',
    packingGroup: null,
    labelCodes: '9',
    specialProvisions: '181, 360, 388, 422, A54',
    packagingExceptions: '185',
    packagingNonBulk: '185',
    packagingBulk: '185',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '35 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '156',
  },
  {
    symbols: '',
    properShippingName: 'Lithium metal batteries including lithium alloy batteries',
    hazardClass: '9',
    idNumber: 'UN3090',
    packingGroup: null,
    labelCodes: '9',
    specialProvisions: '388, 422, A54',
    packagingExceptions: '185',
    packagingNonBulk: '185',
    packagingBulk: '185',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '35 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '156',
  },
  {
    symbols: '',
    properShippingName: 'Lithium metal batteries contained in equipment including lithium alloy batteries',
    hazardClass: '9',
    idNumber: 'UN3091',
    packingGroup: null,
    labelCodes: '9',
    specialProvisions: '181, 360, 388, 422, A54, A101',
    packagingExceptions: '185',
    packagingNonBulk: '185',
    packagingBulk: '185',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '35 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '156',
  },
  {
    symbols: '',
    properShippingName: 'Lithium metal batteries packed with equipment including lithium alloy batteries',
    hazardClass: '9',
    idNumber: 'UN3091',
    packingGroup: null,
    labelCodes: '9',
    specialProvisions: '181, 360, 388, 422, A54',
    packagingExceptions: '185',
    packagingNonBulk: '185',
    packagingBulk: '185',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '35 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '156',
  },
  {
    symbols: '',
    properShippingName: 'Lithium nitrate',
    hazardClass: '5.1',
    idNumber: 'UN2722',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: 'A1, IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Lithium nitride',
    hazardClass: '4.3',
    idNumber: 'UN2806',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A19, IB4, IP1, N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Lithium peroxide',
    hazardClass: '5.1',
    idNumber: 'UN1472',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'A9, IB6, IP2, N34, T3, TP33, W100',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: 'None',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '13, 52, 66, 75, 148',
  },
  {
    symbols: '',
    properShippingName: 'Lithium silicon',
    hazardClass: '4.3',
    idNumber: 'UN1417',
    packingGroup: 'II',
    labelCodes: '4.3',
    specialProvisions: 'A19, A20, IB7, IP2, IP21, T3, TP33, W31, W40',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 85, 103, 148',
  },
  {
    symbols: '',
    properShippingName: 'London purple',
    hazardClass: '6.1',
    idNumber: 'UN1621',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Magnesium aluminum phosphide',
    hazardClass: '4.3',
    idNumber: 'UN1419',
    packingGroup: 'I',
    labelCodes: '4.3, 6.1',
    specialProvisions: 'A19, N34, N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 52, 85, 148',
  },
  {
    symbols: '+',
    properShippingName: 'Magnesium arsenate',
    hazardClass: '6.1',
    idNumber: 'UN1622',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Magnesium bromate',
    hazardClass: '5.1',
    idNumber: 'UN1473',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'A1, IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Magnesium chlorate',
    hazardClass: '5.1',
    idNumber: 'UN2723',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Magnesium diamide',
    hazardClass: '4.2',
    idNumber: 'UN2004',
    packingGroup: 'II',
    labelCodes: '4.2',
    specialProvisions: 'A8, A19, A20, IB6, T3, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: '',
    properShippingName: 'Magnesium fluorosilicate',
    hazardClass: '6.1',
    idNumber: 'UN2853',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Magnesium granules, coated, particle size not less than 149 microns',
    hazardClass: '4.3',
    idNumber: 'UN2950',
    packingGroup: 'III',
    labelCodes: '4.3',
    specialProvisions: 'A1, A19, IB8, IP4, T1, TP33, W100',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Magnesium hydride',
    hazardClass: '4.3',
    idNumber: 'UN2010',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A19, N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName:
      'Magnesium or Magnesium alloys with more than 50 percent magnesium in pellets, turnings or ribbons',
    hazardClass: '4.1',
    idNumber: 'UN1869',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: 'A1, B134, IB8, IP21, T1, TP33, W100',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 39, 52, 53, 74, 101, 147, 148',
  },
  {
    symbols: '',
    properShippingName: 'Magnesium nitrate',
    hazardClass: '5.1',
    idNumber: 'UN1474',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: '332, A1, B120, IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Magnesium perchlorate',
    hazardClass: '5.1',
    idNumber: 'UN1475',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB6, IP2, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Magnesium peroxide',
    hazardClass: '5.1',
    idNumber: 'UN1476',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB6, IP2, T3, TP33, W100',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '13, 52, 66, 75, 148',
  },
  {
    symbols: '',
    properShippingName: 'Magnesium phosphide',
    hazardClass: '4.3',
    idNumber: 'UN2011',
    packingGroup: 'I',
    labelCodes: '4.3, 6.1',
    specialProvisions: 'A19, N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 52, 85, 148',
  },
  {
    symbols: '',
    properShippingName: 'Magnesium, powder or Magnesium alloys, powder',
    hazardClass: '4.3',
    idNumber: 'UN1418',
    packingGroup: 'I',
    labelCodes: '4.3, 4.2',
    specialProvisions: 'A19, B56, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 39, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Magnesium silicide',
    hazardClass: '4.3',
    idNumber: 'UN2624',
    packingGroup: 'II',
    labelCodes: '4.3',
    specialProvisions: 'A19, A20, IB7, IP2, IP21, T3, TP33, W31, W40',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '13, 85, 103, 148',
  },
  {
    symbols: '',
    properShippingName: 'Maleic anhydride',
    hazardClass: '8',
    idNumber: 'UN2215',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58, 95, 102',
  },
  {
    symbols: '',
    properShippingName: 'Maleic anhydride, molten',
    hazardClass: '8',
    idNumber: 'UN2215',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'T4, TP3',
    packagingExceptions: 'None',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58, 95, 102',
  },
  {
    symbols: '',
    properShippingName: 'Malononitrile',
    hazardClass: '6.1',
    idNumber: 'UN2647',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 25',
  },
  {
    symbols: '',
    properShippingName: 'Maneb or Maneb preparations with not less than 60 percent maneb',
    hazardClass: '4.2',
    idNumber: 'UN2210',
    packingGroup: 'III',
    labelCodes: '4.2, 4.3',
    specialProvisions: '57, A1, A19, IB6, T1, TP33, W100',
    packagingExceptions: 'None',
    packagingNonBulk: '213',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 34, 148',
  },
  {
    symbols: '',
    properShippingName: 'Maneb stabilized or Maneb preparations, stabilized against self-heating',
    hazardClass: '4.3',
    idNumber: 'UN2968',
    packingGroup: 'III',
    labelCodes: '4.3',
    specialProvisions: '54, A1, A19, IB8, IP4, T1, TP33, W100',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '13, 34, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Manganese nitrate',
    hazardClass: '5.1',
    idNumber: 'UN2724',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: 'A1, IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Manganese resinate',
    hazardClass: '4.1',
    idNumber: 'UN1330',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: 'A1, IB6, T1, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Mannitol hexanitrate, wetted or Nitromannite, wetted with not less than 40 percent water, or mixture of alcohol and water, by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0133',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '121',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Matches, fusee',
    hazardClass: '4.1',
    idNumber: 'UN2254',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: '',
    packagingExceptions: '186',
    packagingNonBulk: '186',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Matches, safety (book, card or strike on box)',
    hazardClass: '4.1',
    idNumber: 'UN1944',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: '',
    packagingExceptions: '186',
    packagingNonBulk: '186',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Matches, strike anywhere',
    hazardClass: '4.1',
    idNumber: 'UN1331',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: '',
    packagingExceptions: '186',
    packagingNonBulk: '186',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Matches, wax, Vesta',
    hazardClass: '4.1',
    idNumber: 'UN1945',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: '',
    packagingExceptions: '186',
    packagingNonBulk: '186',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Medical waste, category A, affecting humans, solid or Medical waste, category A, affecting animals only, solid',
    hazardClass: '6.2',
    idNumber: 'UN3549',
    packingGroup: null,
    labelCodes: '6.2',
    specialProvisions: '131, 430',
    packagingExceptions: '',
    packagingNonBulk: '',
    packagingBulk: '',
    passengerQtyLimit: '',
    cargoQtyLimit: '',
    vesselStowageLocation: '',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Medicine, liquid, flammable, toxic, n.o.s',
    hazardClass: '3',
    idNumber: 'UN3248',
    packingGroup: 'II',
    labelCodes: '3, 6.1',
    specialProvisions: 'IB2',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Medicine, liquid, toxic, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN1851',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: '',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Medicine, solid, toxic, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN3249',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Mercaptans, liquid, flammable, n.o.s. or Mercaptan mixture, liquid, flammable, n.o.s',
    hazardClass: '3',
    idNumber: 'UN3336',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'T11, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '95, 102',
  },
  {
    symbols: '',
    properShippingName:
      'Mercaptans, liquid, flammable, toxic, n.o.s. or Mercaptan mixtures, liquid, flammable, toxic, n.o.s.',
    hazardClass: '3',
    idNumber: 'UN1228',
    packingGroup: 'II',
    labelCodes: '3, 6.1',
    specialProvisions: 'IB2, T11, TP2, TP27',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 95, 102',
  },
  {
    symbols: '',
    properShippingName:
      'Mercaptans, liquid, toxic, flammable, n.o.s. or Mercaptan mixtures, liquid, toxic, flammable, n.o.s., flash point not less than 23 degrees C',
    hazardClass: '6.1',
    idNumber: 'UN3071',
    packingGroup: 'II',
    labelCodes: '6.1, 3',
    specialProvisions: 'IB2, T11, TP2, TP13, TP27',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 102, 121',
  },
  {
    symbols: '',
    properShippingName: '5-Mercaptotetrazol-1-acetic acid',
    hazardClass: '1.4C',
    idNumber: 'UN0448',
    packingGroup: null,
    labelCodes: '1.4C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Mercuric arsenate',
    hazardClass: '6.1',
    idNumber: 'UN1623',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Mercuric chloride',
    hazardClass: '6.1',
    idNumber: 'UN1624',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Mercuric nitrate',
    hazardClass: '6.1',
    idNumber: 'UN1625',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, N73, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '+',
    properShippingName: 'Mercuric potassium cyanide',
    hazardClass: '6.1',
    idNumber: 'UN1626',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, N74, N75, T6, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Mercurous nitrate',
    hazardClass: '6.1',
    idNumber: 'UN1627',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'A W',
    properShippingName: 'Mercury',
    hazardClass: '8',
    idNumber: 'UN2809',
    packingGroup: 'III',
    labelCodes: '8, 6.1',
    specialProvisions: '365',
    packagingExceptions: '164',
    packagingNonBulk: '164',
    packagingBulk: '240',
    passengerQtyLimit: '35 kg',
    cargoQtyLimit: '35 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 97',
  },
  {
    symbols: '',
    properShippingName: 'Mercury acetate',
    hazardClass: '6.1',
    idNumber: 'UN1629',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Mercury ammonium chloride',
    hazardClass: '6.1',
    idNumber: 'UN1630',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Mercury based pesticides, liquid, flammable, toxic, flash point less than 23 degrees C',
    hazardClass: '3',
    idNumber: 'UN2778',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Mercury based pesticides, liquid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN3012',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Mercury based pesticides, liquid, toxic, flammable, flash point not less than 23 degrees C',
    hazardClass: '6.1',
    idNumber: 'UN3011',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Mercury based pesticides, solid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN2777',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Mercury benzoate',
    hazardClass: '6.1',
    idNumber: 'UN1631',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Mercury bromides',
    hazardClass: '6.1',
    idNumber: 'UN1634',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Mercury compound, liquid, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN2024',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Mercury compound, solid, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN2025',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'A W',
    properShippingName: 'Mercury contained in manufactured articles',
    hazardClass: '8',
    idNumber: 'UN3506',
    packingGroup: null,
    labelCodes: '8, 6.1',
    specialProvisions: 'A191',
    packagingExceptions: '164',
    packagingNonBulk: 'None',
    packagingBulk: 'None',
    passengerQtyLimit: 'No limit',
    cargoQtyLimit: 'No limit',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 97',
  },
  {
    symbols: '',
    properShippingName: 'Mercury cyanide',
    hazardClass: '6.1',
    idNumber: 'UN1636',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, N74, N75, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName:
      'Mercury fulminate, wetted with not less than 20 percent water, or mixture of alcohol and water, by mass',
    hazardClass: '1.1A',
    idNumber: 'UN0135',
    packingGroup: null,
    labelCodes: '1.1A',
    specialProvisions: '111, 117',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Mercury gluconate',
    hazardClass: '6.1',
    idNumber: 'UN1637',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Mercury iodide',
    hazardClass: '6.1',
    idNumber: 'UN1638',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Mercury nucleate',
    hazardClass: '6.1',
    idNumber: 'UN1639',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Mercury oleate',
    hazardClass: '6.1',
    idNumber: 'UN1640',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Mercury oxide',
    hazardClass: '6.1',
    idNumber: 'UN1641',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Mercury oxycyanide, desensitized',
    hazardClass: '6.1',
    idNumber: 'UN1642',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52, 91',
  },
  {
    symbols: '',
    properShippingName: 'Mercury potassium iodide',
    hazardClass: '6.1',
    idNumber: 'UN1643',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Mercury salicylate',
    hazardClass: '6.1',
    idNumber: 'UN1644',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '+',
    properShippingName: 'Mercury sulfates',
    hazardClass: '6.1',
    idNumber: 'UN1645',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Mercury thiocyanate',
    hazardClass: '6.1',
    idNumber: 'UN1646',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Mesityl oxide',
    hazardClass: '3',
    idNumber: 'UN1229',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Metal carbonyls, liquid, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN3281',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '5, T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Metal carbonyls, solid, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN3466',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Metal catalyst, dry',
    hazardClass: '4.2',
    idNumber: 'UN2881',
    packingGroup: 'I',
    labelCodes: '4.2',
    specialProvisions: 'N34, T21, TP7, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '187',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'C',
    vesselStowageOther: '13, 147, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Metal catalyst, wetted with a visible excess of liquid',
    hazardClass: '4.2',
    idNumber: 'UN1378',
    packingGroup: 'II',
    labelCodes: '4.2',
    specialProvisions: 'A2, A8, IB1, N34, T3, TP33, W31, W40',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Metal hydrides, flammable, n.o.s',
    hazardClass: '4.1',
    idNumber: 'UN3182',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: 'A1, IB4, T3, TP33, W31, W40',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Metal hydrides, water reactive, n.o.s',
    hazardClass: '4.3',
    idNumber: 'UN1409',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A19, N34, N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Metal powder, self-heating, n.o.s',
    hazardClass: '4.2',
    idNumber: 'UN3189',
    packingGroup: 'II',
    labelCodes: '4.2',
    specialProvisions: 'IB6, IP2, T3, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: '',
    properShippingName: 'Metal powders, flammable, n.o.s',
    hazardClass: '4.1',
    idNumber: 'UN3089',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33, W100',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '13, 74, 147, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Metal salts of organic compounds, flammable, n.o.s',
    hazardClass: '4.1',
    idNumber: 'UN3181',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: 'A1, IB8, IP2, IP4, T3, TP33, W31',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Metaldehyde',
    hazardClass: '4.1',
    idNumber: 'UN1332',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: 'A1, IB8, IP3, T1, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Metallic substance, water-reactive, n.o.s',
    hazardClass: '4.3',
    idNumber: 'UN3208',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A7, IB4, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Metallic substance, water-reactive, self-heating, n.o.s',
    hazardClass: '4.3',
    idNumber: 'UN3209',
    packingGroup: 'I',
    labelCodes: '4.3, 4.2',
    specialProvisions: 'A7, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 148',
  },
  {
    symbols: '',
    properShippingName: 'Methacrylaldehyde, stabilized',
    hazardClass: '3',
    idNumber: 'UN2396',
    packingGroup: 'II',
    labelCodes: '3, 6.1',
    specialProvisions: '45, 387, IB2, T7, TP1, TP13',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Methacrylic acid, stabilized',
    hazardClass: '8',
    idNumber: 'UN2531',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: '41, 387, IB2, T7, TP1, TP18, TP30',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '25, 40, 53, 58',
  },
  {
    symbols: '+',
    properShippingName: 'Methacrylonitrile, stabilized',
    hazardClass: '6.1',
    idNumber: 'UN3079',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '2, 387, B9, B14, B32, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Methallyl alcohol',
    hazardClass: '3',
    idNumber: 'UN2614',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Methane, compressed or Natural gas, compressed (with high methane content)',
    hazardClass: '2.1',
    idNumber: 'UN1971',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '302',
    packagingBulk: '302',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName:
      'Methane, refrigerated liquid (cryogenic liquid) or Natural gas, refrigerated liquid (cryogenic liquid, with high methane content)',
    hazardClass: '2.1',
    idNumber: 'UN1972',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'T75, TP5',
    packagingExceptions: 'None',
    packagingNonBulk: 'None',
    packagingBulk: '318',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Methanesulfonyl chloride',
    hazardClass: '6.1',
    idNumber: 'UN3246',
    packingGroup: 'I',
    labelCodes: '6.1, 8',
    specialProvisions: '2, B9, B14, B32, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '+ I',
    properShippingName: 'Methanol',
    hazardClass: '3',
    idNumber: 'UN1230',
    packingGroup: 'II',
    labelCodes: '3, 6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: 'D',
    properShippingName: 'Methanol',
    hazardClass: '3',
    idNumber: 'UN1230',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: '4-Methoxy-4-methylpentan-2-one',
    hazardClass: '3',
    idNumber: 'UN2293',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '1-Methoxy-2-propanol',
    hazardClass: '3',
    idNumber: 'UN3092',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '+',
    properShippingName: 'Methoxymethyl isocyanate',
    hazardClass: '6.1',
    idNumber: 'UN2605',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '1, B9, B14, B30, T20, TP2, TP13, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Methyl acetate',
    hazardClass: '3',
    idNumber: 'UN1231',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Methyl acetylene and propadiene mixtures, stabilized',
    hazardClass: '2.1',
    idNumber: 'UN1060',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '387, N88, T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Methyl acrylate, stabilized',
    hazardClass: '3',
    idNumber: 'UN1919',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: '387, IB2, T4, TP1, TP13',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Methyl allyl chloride',
    hazardClass: '3',
    idNumber: 'UN2554',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1, TP13',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Methyl bromide',
    hazardClass: '2.3',
    idNumber: 'UN1062',
    packingGroup: null,
    labelCodes: '2.3',
    specialProvisions: '3, B14, N86, T50',
    packagingExceptions: 'None',
    packagingNonBulk: '193',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Methyl bromide and ethylene dibromide mixtures, liquid',
    hazardClass: '6.1',
    idNumber: 'UN1647',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '2, B9, B14, B32, N65, T20, TP2, TP13, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Methyl bromoacetate',
    hazardClass: '6.1',
    idNumber: 'UN2643',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: '2-Methylbutanal',
    hazardClass: '3',
    idNumber: 'UN3371',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '2-Methyl-1-butene',
    hazardClass: '3',
    idNumber: 'UN2459',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'T11, TP2',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '2-Methyl-2-butene',
    hazardClass: '3',
    idNumber: 'UN2460',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, IP8, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '3-Methyl-1-butene',
    hazardClass: '3',
    idNumber: 'UN2561',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'T11, TP2',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Methyl tert-butyl ether',
    hazardClass: '3',
    idNumber: 'UN2398',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Methyl butyrate',
    hazardClass: '3',
    idNumber: 'UN1237',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Methyl chloride or Refrigerant gas R 40',
    hazardClass: '2.1',
    idNumber: 'UN1063',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'N86, T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Methyl chloride and methylene chloride mixtures',
    hazardClass: '2.1',
    idNumber: 'UN1912',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'N86, T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Methyl chloroacetate',
    hazardClass: '6.1',
    idNumber: 'UN2295',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: 'T14, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Methyl chloroformate',
    hazardClass: '6.1',
    idNumber: 'UN1238',
    packingGroup: 'I',
    labelCodes: '6.1, 3, 8',
    specialProvisions: '1, B9, B14, B30, N34, T22, TP2, TP13, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '21, 40, 53, 58, 100',
  },
  {
    symbols: '',
    properShippingName: 'Methyl chloromethyl ether',
    hazardClass: '6.1',
    idNumber: 'UN1239',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '1, B9, B14, B30, T22, TP2, TP13, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Methyl 2-chloropropionate',
    hazardClass: '3',
    idNumber: 'UN2933',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Methyl dichloroacetate',
    hazardClass: '6.1',
    idNumber: 'UN2299',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '2-Methyl-5-ethylpyridine',
    hazardClass: '6.1',
    idNumber: 'UN2300',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Methyl fluoride, or Refrigerant gas R 41',
    hazardClass: '2.1',
    idNumber: 'UN2454',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Methyl formate',
    hazardClass: '3',
    idNumber: 'UN1243',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'T11, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '2-Methyl-2-heptanethiol',
    hazardClass: '6.1',
    idNumber: 'UN3023',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '2, B9, B14, B32, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 102',
  },
  {
    symbols: '',
    properShippingName: 'Methyl iodide',
    hazardClass: '6.1',
    idNumber: 'UN2644',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '2, B9, B14, B32, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Methyl isobutyl carbinol',
    hazardClass: '3',
    idNumber: 'UN2053',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Methyl isobutyl ketone',
    hazardClass: '3',
    idNumber: 'UN1245',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Methyl isocyanate',
    hazardClass: '6.1',
    idNumber: 'UN2480',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '1, B9, B14, B30, T22, TP2, TP13, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Methyl isopropenyl ketone, stabilized',
    hazardClass: '3',
    idNumber: 'UN1246',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: '387, IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Methyl isothiocyanate',
    hazardClass: '6.1',
    idNumber: 'UN2477',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '2, B9, B14, B32, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Methyl isovalerate',
    hazardClass: '3',
    idNumber: 'UN2400',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Methyl magnesium bromide, in ethyl ether',
    hazardClass: '4.3',
    idNumber: 'UN1928',
    packingGroup: 'I',
    labelCodes: '4.3, 3',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '1 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: '',
    properShippingName: 'Methyl mercaptan',
    hazardClass: '2.3',
    idNumber: 'UN1064',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '3, B7, B9, B14, N89, T50',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Methyl methacrylate monomer, stabilized',
    hazardClass: '3',
    idNumber: 'UN1247',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: '387, IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Methyl orthosilicate',
    hazardClass: '6.1',
    idNumber: 'UN2606',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '2, B9, B14, B32, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'D',
    properShippingName: 'Methyl phosphonic dichloride',
    hazardClass: '6.1',
    idNumber: 'NA9206',
    packingGroup: 'I',
    labelCodes: '6.1, 8',
    specialProvisions: '2, B9, B14, B32, N34, N43, T20, TP4, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: 'D',
    properShippingName: 'Methyl phosphonous dichloride, pyrophoric liquid',
    hazardClass: '6.1',
    idNumber: 'NA2845',
    packingGroup: 'I',
    labelCodes: '6.1, 4.2',
    specialProvisions: '2, B9, B14, B16, B32, T20, TP4, TP12, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '18',
  },
  {
    symbols: '',
    properShippingName: 'Methyl propionate',
    hazardClass: '3',
    idNumber: 'UN1248',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Methyl propyl ether',
    hazardClass: '3',
    idNumber: 'UN2612',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, IP8, T7, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Methyl propyl ketone',
    hazardClass: '3',
    idNumber: 'UN1249',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Methyl trichloroacetate',
    hazardClass: '6.1',
    idNumber: 'UN2533',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Methyl vinyl ketone, stabilized',
    hazardClass: '6.1',
    idNumber: 'UN1251',
    packingGroup: 'I',
    labelCodes: '6.1, 3, 8',
    specialProvisions: '1, 387, B9, B14, B30, T22, TP2, TP13, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'B',
    vesselStowageOther: '21, 25, 40, 100',
  },
  {
    symbols: '',
    properShippingName: 'Methylal',
    hazardClass: '3',
    idNumber: 'UN1234',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, IP8, T7, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Methylamine, anhydrous',
    hazardClass: '2.1',
    idNumber: 'UN1061',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'N87, T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Methylamine, aqueous solution',
    hazardClass: '3',
    idNumber: 'UN1235',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'B1, IB2, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '52, 135.',
  },
  {
    symbols: '',
    properShippingName: 'Methylamyl acetate',
    hazardClass: '3',
    idNumber: 'UN1233',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'N-Methylaniline',
    hazardClass: '6.1',
    idNumber: 'UN2294',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'alpha-Methylbenzyl alcohol, liquid',
    hazardClass: '6.1',
    idNumber: 'UN2937',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'alpha-Methylbenzyl alcohol, solid',
    hazardClass: '6.1',
    idNumber: 'UN3438',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '3-Methylbutan-2-one',
    hazardClass: '3',
    idNumber: 'UN2397',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'N-Methylbutylamine',
    hazardClass: '3',
    idNumber: 'UN2945',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'IB2, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Methylchlorosilane',
    hazardClass: '2.3',
    idNumber: 'UN2534',
    packingGroup: null,
    labelCodes: '2.3, 2.1, 8',
    specialProvisions: '2, B9, B14, N34',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '17, 40',
  },
  {
    symbols: '',
    properShippingName: 'Methylcyclohexane',
    hazardClass: '3',
    idNumber: 'UN2296',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'B1, IB2, T4, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Methylcyclohexanols, flammable',
    hazardClass: '3',
    idNumber: 'UN2617',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Methylcyclohexanone',
    hazardClass: '3',
    idNumber: 'UN2297',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Methylcyclopentane',
    hazardClass: '3',
    idNumber: 'UN2298',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: 'D',
    properShippingName: 'Methyldichloroarsine',
    hazardClass: '6.1',
    idNumber: 'NA1556',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '2, T20, TP4, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '192',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Methyldichlorosilane',
    hazardClass: '4.3',
    idNumber: 'UN1242',
    packingGroup: 'I',
    labelCodes: '4.3, 8, 3',
    specialProvisions: 'A2, A7, B6, B77, N34, T14, TP2, TP7, TP13, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '1 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '21, 40, 49, 53, 58, 100',
  },
  {
    symbols: '',
    properShippingName: '2-Methylfuran',
    hazardClass: '3',
    idNumber: 'UN2301',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '5-Methylhexan-2-one',
    hazardClass: '3',
    idNumber: 'UN2302',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Methylhydrazine',
    hazardClass: '6.1',
    idNumber: 'UN1244',
    packingGroup: 'I',
    labelCodes: '6.1, 3, 8',
    specialProvisions: '1, B7, B9, B14, B30, B77, N34, T22, TP2, TP13, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '21, 40, 49, 52 and 100',
  },
  {
    symbols: '',
    properShippingName: '4-Methylmorpholine or n-methylmorpholine',
    hazardClass: '3',
    idNumber: 'UN2535',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'B6, IB2, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Methylpentadienes',
    hazardClass: '3',
    idNumber: 'UN2461',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '2-Methylpentan-2-ol',
    hazardClass: '3',
    idNumber: 'UN2560',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Methylphenyldichlorosilane',
    hazardClass: '8',
    idNumber: 'UN2437',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'T10, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: '1-Methylpiperidine',
    hazardClass: '3',
    idNumber: 'UN2399',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'IB2, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '52.',
  },
  {
    symbols: '',
    properShippingName: 'Methyltetrahydrofuran',
    hazardClass: '3',
    idNumber: 'UN2536',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Methyltrichlorosilane',
    hazardClass: '3',
    idNumber: 'UN1250',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'A7, B6, B77, N34, T10, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'alpha-Methylvaleraldehyde',
    hazardClass: '3',
    idNumber: 'UN2367',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'B1, IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Mines with bursting charge',
    hazardClass: '1.1F',
    idNumber: 'UN0136',
    packingGroup: null,
    labelCodes: '1.1F',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Mines with bursting charge',
    hazardClass: '1.1D',
    idNumber: 'UN0137',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Mines with bursting charge',
    hazardClass: '1.2D',
    idNumber: 'UN0138',
    packingGroup: null,
    labelCodes: '1.2D',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Mines with bursting charge',
    hazardClass: '1.2F',
    idNumber: 'UN0294',
    packingGroup: null,
    labelCodes: '1.2F',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: 'D',
    properShippingName: 'Model rocket motor',
    hazardClass: '1.4C',
    idNumber: 'NA0276',
    packingGroup: null,
    labelCodes: '1.4C',
    specialProvisions: '51',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: 'D',
    properShippingName: 'Model rocket motor',
    hazardClass: '1.4S',
    idNumber: 'NA0323',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '51',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Molybdenum pentachloride',
    hazardClass: '8',
    idNumber: 'UN2508',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Morpholine',
    hazardClass: '8',
    idNumber: 'UN2054',
    packingGroup: 'I',
    labelCodes: '8, 3',
    specialProvisions: 'T10, TP2',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '+',
    properShippingName: 'Motor fuel anti-knock mixture, flammable',
    hazardClass: '6.1',
    idNumber: 'UN3483',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '14, T14, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '+',
    properShippingName: 'Motor fuel anti-knock mixtures',
    hazardClass: '6.1',
    idNumber: 'UN1649',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '14, B9, B90, T14, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Naphthalene, crude or Naphthalene, refined',
    hazardClass: '4.1',
    idNumber: 'UN1334',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: 'A1, B120,IB8, IP3, T1, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'beta-Naphthylamine, solid',
    hazardClass: '6.1',
    idNumber: 'UN1650',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'beta-Naphthylamine solution',
    hazardClass: '6.1',
    idNumber: 'UN3411',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'alpha-Naphthylamine',
    hazardClass: '6.1',
    idNumber: 'UN2077',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Naphthalene, molten',
    hazardClass: '4.1',
    idNumber: 'UN2304',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: 'IB1, T1, TP3',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '241',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Naphthylthiourea',
    hazardClass: '6.1',
    idNumber: 'UN1651',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Naphthylurea',
    hazardClass: '6.1',
    idNumber: 'UN1652',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Neon, compressed',
    hazardClass: '2.2',
    idNumber: 'UN1065',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '',
    packagingExceptions: '306, 307',
    packagingNonBulk: '302',
    packagingBulk: 'None',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Neon, refrigerated liquid (cryogenic liquid)',
    hazardClass: '2.2',
    idNumber: 'UN1913',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T75, TP5',
    packagingExceptions: '320',
    packagingNonBulk: '316',
    packagingBulk: 'None',
    passengerQtyLimit: '50 kg',
    cargoQtyLimit: '500 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nickel carbonyl',
    hazardClass: '6.1',
    idNumber: 'UN1259',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '198',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 78',
  },
  {
    symbols: '',
    properShippingName: 'Nickel cyanide',
    hazardClass: '6.1',
    idNumber: 'UN1653',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, N74, N75, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Nickel nitrate',
    hazardClass: '5.1',
    idNumber: 'UN2725',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: 'A1, IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nickel nitrite',
    hazardClass: '5.1',
    idNumber: 'UN2726',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: 'A1, IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Nicotine',
    hazardClass: '6.1',
    idNumber: 'UN1654',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Nicotine compounds, liquid, n.o.s. or Nicotine preparations, liquid, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN3144',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'A4',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Nicotine compounds, solid, n.o.s. or Nicotine preparations, solid, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN1655',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nicotine hydrochloride liquid or solution',
    hazardClass: '6.1',
    idNumber: 'UN1656',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nicotine hydrochloride, solid',
    hazardClass: '6.1',
    idNumber: 'UN3444',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nicotine salicylate',
    hazardClass: '6.1',
    idNumber: 'UN1657',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nicotine sulfate solution',
    hazardClass: '6.1',
    idNumber: 'UN1658',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nicotine sulphate, solid',
    hazardClass: '6.1',
    idNumber: 'UN3445',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nicotine tartrate',
    hazardClass: '6.1',
    idNumber: 'UN1659',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nitrates, inorganic, aqueous solution, n.o.s.',
    hazardClass: '5.1',
    idNumber: 'UN3218',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: '58, IB2, T4, TP1',
    packagingExceptions: '152',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '56, 58, 133',
  },
  {
    symbols: '',
    properShippingName: 'Nitrates, inorganic, n.o.s.',
    hazardClass: '5.1',
    idNumber: 'UN1477',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Nitrating acid mixtures, spent with more than 50 percent nitric acid',
    hazardClass: '8',
    idNumber: 'UN1826',
    packingGroup: 'I',
    labelCodes: '8, 5.1',
    specialProvisions: 'A7, T10, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '158',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 53, 58, 66',
  },
  {
    symbols: '',
    properShippingName: 'Nitrating acid mixtures spent with not more than 50 percent nitric acid',
    hazardClass: '8',
    idNumber: 'UN1826',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, B2, IB2, T8, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '158',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Nitrating acid mixtures with more than 50 percent nitric acid',
    hazardClass: '8',
    idNumber: 'UN1796',
    packingGroup: 'I',
    labelCodes: '8, 5.1',
    specialProvisions: 'A7, T10, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '158',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 53, 58, 66',
  },
  {
    symbols: '',
    properShippingName: 'Nitrating acid mixtures with not more than 50 percent nitric acid',
    hazardClass: '8',
    idNumber: 'UN1796',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, B2, IB2, T8, TP2, TP13',
    packagingExceptions: '154',
    packagingNonBulk: '158',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName:
      'Nitric acid other than red fuming, with at least 65 percent, but not more than 70 percent nitric acid',
    hazardClass: '8',
    idNumber: 'UN2031',
    packingGroup: 'II',
    labelCodes: '8, 5.1',
    specialProvisions: 'B2, B47, B53, IB2, IP15, T8, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '158',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '53, 58, 66, 74, 89, 90',
  },
  {
    symbols: '',
    properShippingName:
      'Nitric acid other than red fuming, with more than 20 percent and less than 65 percent nitric acid',
    hazardClass: '8',
    idNumber: 'UN2031',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A212, B2, B47, B53, IB2, IP15, T8, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '158',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '44, 66, 53, 58, 74, 89, 90',
  },
  {
    symbols: '',
    properShippingName: 'Nitric acid other than red fuming with not more than 20 percent nitric acid',
    hazardClass: '8',
    idNumber: 'UN2031',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, B47, B53, IB2, T8, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '158',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '+',
    properShippingName: 'Nitric acid, red fuming',
    hazardClass: '8',
    idNumber: 'UN2032',
    packingGroup: 'I',
    labelCodes: '8, 5.1, 6.1',
    specialProvisions: '2, B9, B32, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 53, 58, 66, 74, 89, 90',
  },
  {
    symbols: '',
    properShippingName: 'Nitric acid other than red fuming, with more than 70 percent nitric acid',
    hazardClass: '8',
    idNumber: 'UN2031',
    packingGroup: 'I',
    labelCodes: '8, 5.1',
    specialProvisions: 'B47, B53, T10, TP2, TP12, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '158',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '44, 53, 58, 66, 89, 90, 110, 111',
  },
  {
    symbols: '',
    properShippingName: 'Nitric oxide, compressed',
    hazardClass: '2.3',
    idNumber: 'UN1660',
    packingGroup: null,
    labelCodes: '2.3, 5.1, 8',
    specialProvisions: '1, B77',
    packagingExceptions: 'None',
    packagingNonBulk: '337',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 89, 90',
  },
  {
    symbols: '',
    properShippingName: 'Nitric oxide and dinitrogen tetroxide mixtures or Nitric oxide and nitrogen dioxide mixtures',
    hazardClass: '2.3',
    idNumber: 'UN1975',
    packingGroup: null,
    labelCodes: '2.3, 5.1, 8',
    specialProvisions: '1, B77',
    packagingExceptions: 'None',
    packagingNonBulk: '337',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 89, 90',
  },
  {
    symbols: 'G',
    properShippingName: 'Nitriles, flammable, toxic, n.o.s.',
    hazardClass: '3',
    idNumber: 'UN3273',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: 'G',
    properShippingName: 'Nitriles, liquid, toxic, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN3276',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '5, T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '52',
  },
  {
    symbols: 'G',
    properShippingName: 'Nitriles, solid, toxic, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN3439',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '52',
  },
  {
    symbols: 'G',
    properShippingName: 'Nitriles, toxic, flammable, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN3275',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '5, T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: 'G',
    properShippingName: 'Nitrites, inorganic, aqueous solution, n.o.s',
    hazardClass: '5.1',
    idNumber: 'UN3219',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: '148, IB1, T4, TP1',
    packagingExceptions: '152',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '46, 56, 58, 133',
  },
  {
    symbols: 'G',
    properShippingName: 'Nitrites, inorganic, n.o.s.',
    hazardClass: '5.1',
    idNumber: 'UN2627',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: '33, IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: 'None',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '46, 56, 58, 133',
  },
  {
    symbols: '',
    properShippingName: '3-Nitro-4-chlorobenzotrifluoride',
    hazardClass: '6.1',
    idNumber: 'UN2307',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Nitro urea',
    hazardClass: '1.1D',
    idNumber: 'UN0147',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '+',
    properShippingName: 'Nitroanilines (o-; m-; p-;)',
    hazardClass: '6.1',
    idNumber: 'UN1661',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nitroanisole, liquid',
    hazardClass: '6.1',
    idNumber: 'UN2730',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nitroanisoles, solid',
    hazardClass: '6.1',
    idNumber: 'UN3458',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '+',
    properShippingName: 'Nitrobenzene',
    hazardClass: '6.1',
    idNumber: 'UN1662',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Nitrobenzenesulfonic acid',
    hazardClass: '8',
    idNumber: 'UN2305',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, B4, IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: '5-Nitrobenzotriazol',
    hazardClass: '1.1D',
    idNumber: 'UN0385',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Nitrobenzotrifluorides, liquid',
    hazardClass: '6.1',
    idNumber: 'UN2306',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Nitrobenzotrifluorides, solid',
    hazardClass: '6.1',
    idNumber: 'UN3431',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Nitrobromobenzenes, liquid',
    hazardClass: '6.1',
    idNumber: 'UN2732',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nitrobromobenzenes, solid',
    hazardClass: '6.1',
    idNumber: 'UN3459',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nitrocellulose, dry or wetted with less than 25 percent water (or alcohol), by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0340',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '196',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 27E',
  },
  {
    symbols: '',
    properShippingName:
      'Nitrocellulose, with not more than 12.6 percent nitrogen, by dry mass mixture with or without plasticizer, with or without pigment',
    hazardClass: '4.1',
    idNumber: 'UN2557',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: '44, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: 'None',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Nitrocellulose membrane filters, with not more than 12.6% nitrogen, by dry mass',
    hazardClass: '4.1',
    idNumber: 'UN3270',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: '43, A1',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nitrocellulose, plasticized with not less than 18 percent plasticizing substance, by mass',
    hazardClass: '1.3C',
    idNumber: 'UN0343',
    packingGroup: null,
    labelCodes: '1.3C',
    specialProvisions: '196',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName:
      'Nitrocellulose, solution, flammable with not more than 12.6 percent nitrogen, by mass, and not more than 55 percent nitrocellulose',
    hazardClass: '3',
    idNumber: 'UN2059',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: '198, T11, TP1, TP8, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Nitrocellulose, unmodified or plasticized with less than 18 percent plasticizing substance, by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0341',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '196',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 27E',
  },
  {
    symbols: '',
    properShippingName: 'Nitrocellulose, wetted with not less than 25 percent alcohol, by mass',
    hazardClass: '1.3C',
    idNumber: 'UN0342',
    packingGroup: null,
    labelCodes: '1.3C',
    specialProvisions: '196',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName:
      'Nitrocellulose with alcohol with not less than 25 percent alcohol by mass, and with not more than 12.6 percent nitrogen, by dry mass',
    hazardClass: '4.1',
    idNumber: 'UN2556',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: 'W31',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: 'None',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Nitrocellulose with water with not less than 25 percent water, by mass',
    hazardClass: '4.1',
    idNumber: 'UN2555',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: 'W31',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: 'None',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Nitrocresols, liquid',
    hazardClass: '6.1',
    idNumber: 'UN3434',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nitrocresols, solid',
    hazardClass: '6.1',
    idNumber: 'UN2446',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nitroethane',
    hazardClass: '3',
    idNumber: 'UN2842',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nitrogen, compressed',
    hazardClass: '2.2',
    idNumber: 'UN1066',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '',
    packagingExceptions: '306, 307',
    packagingNonBulk: '302',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nitrogen, refrigerated liquid cryogenic liquid',
    hazardClass: '2.2',
    idNumber: 'UN1977',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '345, 346, T75, TP5',
    packagingExceptions: '320',
    packagingNonBulk: '316',
    packagingBulk: '318',
    passengerQtyLimit: '50 kg',
    cargoQtyLimit: '500 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nitrogen trifluoride',
    hazardClass: '2.2',
    idNumber: 'UN2451',
    packingGroup: null,
    labelCodes: '2.2, 5.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '302',
    packagingBulk: 'None',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Nitrogen trioxide',
    hazardClass: '2.3',
    idNumber: 'UN2421',
    packingGroup: null,
    labelCodes: '2.3, 5.1, 8',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '336',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 89, 90',
  },
  {
    symbols: '',
    properShippingName:
      'Nitroglycerin, desensitized with not less than 40 percent non-volatile water insoluble phlegmatizer, by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0143',
    packingGroup: null,
    labelCodes: '1.1D, 6.1',
    specialProvisions: '125',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 21E',
  },
  {
    symbols: '',
    properShippingName:
      'Nitroglycerin mixture, desensitized, liquid, flammable, n.o.s. with not more than 30 percent nitroglycerin, by mass',
    hazardClass: '3',
    idNumber: 'UN3343',
    packingGroup: null,
    labelCodes: '3',
    specialProvisions: '129',
    packagingExceptions: 'None',
    packagingNonBulk: '214',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Nitroglycerin mixture, desensitized, liquid, n.o.s. with not more than 30% nitroglycerin, by mass',
    hazardClass: '3',
    idNumber: 'UN3357',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: '142',
    packagingExceptions: 'None',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Nitroglycerin mixture, desensitized, solid, n.o.s. with more than 2 percent but not more than 10 percent nitroglycerin, by mass',
    hazardClass: '4.1',
    idNumber: 'UN3319',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: '118',
    packagingExceptions: 'None',
    packagingNonBulk: 'None',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '0.5 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Nitroglycerin, solution in alcohol, with more than 1 percent but not more than 5 percent nitroglycerin',
    hazardClass: '3',
    idNumber: 'UN3064',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'N8',
    packagingExceptions: 'None',
    packagingNonBulk: '202',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Nitroglycerin, solution in alcohol, with more than 1 percent but not more than 10 percent nitroglycerin',
    hazardClass: '1.1D',
    idNumber: 'UN0144',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 21E',
  },
  {
    symbols: '',
    properShippingName: 'Nitroglycerin solution in alcohol with not more than 1 percent nitroglycerin',
    hazardClass: '3',
    idNumber: 'UN1204',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, N34',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: 'None',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nitroguanidine or Picrite, dry or wetted with less than 20 percent water, by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0282',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Nitroguanidine, wetted or Picrite, wetted with not less than 20 percent water, by mass',
    hazardClass: '4.1',
    idNumber: 'UN1336',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '23, A8, A19, A20, N41, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Nitrohydrochloric acid',
    hazardClass: '8',
    idNumber: 'UN1798',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'B10, N41, T10, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 53, 58, 66, 74, 89, 90',
  },
  {
    symbols: '',
    properShippingName: 'Nitromethane',
    hazardClass: '3',
    idNumber: 'UN1261',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: '',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nitronaphthalene',
    hazardClass: '4.1',
    idNumber: 'UN2538',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: 'A1, IB8, IP3, T1, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '+',
    properShippingName: 'Nitrophenols (o-; m-; p-;)',
    hazardClass: '6.1',
    idNumber: 'UN1663',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '4-Nitrophenylhydrazine, with not less than 30 percent water, by mass',
    hazardClass: '4.1',
    idNumber: 'UN3376',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '162, A8, A19, A20, N41, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Nitropropanes',
    hazardClass: '3',
    idNumber: 'UN2608',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'p-Nitrosodimethylaniline',
    hazardClass: '4.2',
    idNumber: 'UN1369',
    packingGroup: 'II',
    labelCodes: '4.2',
    specialProvisions: 'A19, A20, IB6, IP2, N34, T3, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '34',
  },
  {
    symbols: '',
    properShippingName: 'Nitrostarch, dry or wetted with less than 20 percent water, by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0146',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Nitrostarch, wetted with not less than 20 percent water, by mass',
    hazardClass: '4.1',
    idNumber: 'UN1337',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '23, A8, A19, A20, N41, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Nitrosyl chloride',
    hazardClass: '2.3',
    idNumber: 'UN1069',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '3, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Nitrosylsulfuric acid, liquid',
    hazardClass: '8',
    idNumber: 'UN2308',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A3, A7, B2, IB2, N34, T8, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 53, 58, 66, 74, 89, 90',
  },
  {
    symbols: '',
    properShippingName: 'Nitrosylsulphuric acid, solid',
    hazardClass: '8',
    idNumber: 'UN3456',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 53, 58, 66, 74, 89, 90',
  },
  {
    symbols: '',
    properShippingName: 'Nitrotoluenes, liquid',
    hazardClass: '6.1',
    idNumber: 'UN1664',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nitrotoluenes, solid',
    hazardClass: '6.1',
    idNumber: 'UN3446',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nitrotoluidines (mono)',
    hazardClass: '6.1',
    idNumber: 'UN2660',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nitrotriazolone or NTO',
    hazardClass: '1.1D',
    idNumber: 'UN0490',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Nitrous oxide',
    hazardClass: '2.2',
    idNumber: 'UN1070',
    packingGroup: null,
    labelCodes: '2.2, 5.1',
    specialProvisions: 'A14',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Nitrous oxide, refrigerated liquid',
    hazardClass: '2.2',
    idNumber: 'UN2201',
    packingGroup: null,
    labelCodes: '2.2, 5.1',
    specialProvisions: 'B6, T75, TP5, TP22',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Nitroxylenes, liquid',
    hazardClass: '6.1',
    idNumber: 'UN1665',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nitroxylenes, solid',
    hazardClass: '6.1',
    idNumber: 'UN3447',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nonanes',
    hazardClass: '3',
    idNumber: 'UN1920',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Nonyltrichlorosilane',
    hazardClass: '8',
    idNumber: 'UN1799',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, B2, B6, N34, T10, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53,',
  },
  {
    symbols: '',
    properShippingName: 'Octadecyltrichlorosilane',
    hazardClass: '8',
    idNumber: 'UN1800',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, B2, B6, N34, T10, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Octadiene',
    hazardClass: '3',
    idNumber: 'UN2309',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'B1, IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Octafluorobut-2-ene or Refrigerant gas R 1318',
    hazardClass: '2.2',
    idNumber: 'UN2422',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Octafluorocyclobutane, or Refrigerant gas RC 318',
    hazardClass: '2.2',
    idNumber: 'UN1976',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Octafluoropropane or Refrigerant gas R 218',
    hazardClass: '2.2',
    idNumber: 'UN2424',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Octanes',
    hazardClass: '3',
    idNumber: 'UN1262',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Octolite or Octol, dry or wetted with less than 15 percent water, by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0266',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Octonal',
    hazardClass: '1.1D',
    idNumber: 'UN0496',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Octyl aldehydes',
    hazardClass: '3',
    idNumber: 'UN1191',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Octyltrichlorosilane',
    hazardClass: '8',
    idNumber: 'UN1801',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, B2, B6, N34, T10, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Oil gas, compressed',
    hazardClass: '2.3',
    idNumber: 'UN1071',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '6',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Organic peroxide type B, liquid',
    hazardClass: '5.2',
    idNumber: 'UN3101',
    packingGroup: null,
    labelCodes: '5.2, 1',
    specialProvisions: '53',
    packagingExceptions: '152',
    packagingNonBulk: '225',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Organic peroxide type B, liquid, temperature controlled',
    hazardClass: '5.2',
    idNumber: 'UN3111',
    packingGroup: null,
    labelCodes: '5.2, 1',
    specialProvisions: '53',
    packagingExceptions: 'None',
    packagingNonBulk: '225',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '2, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Organic peroxide type B, solid',
    hazardClass: '5.2',
    idNumber: 'UN3102',
    packingGroup: null,
    labelCodes: '5.2, 1',
    specialProvisions: '53',
    packagingExceptions: '152',
    packagingNonBulk: '225',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Organic peroxide type B, solid, temperature controlled',
    hazardClass: '5.2',
    idNumber: 'UN3112',
    packingGroup: null,
    labelCodes: '5.2, 1',
    specialProvisions: '53',
    packagingExceptions: 'None',
    packagingNonBulk: '225',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '2, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Organic peroxide type C, liquid',
    hazardClass: '5.2',
    idNumber: 'UN3103',
    packingGroup: null,
    labelCodes: '5.2',
    specialProvisions: '',
    packagingExceptions: '152',
    packagingNonBulk: '225',
    packagingBulk: 'None',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '10 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Organic peroxide type C, liquid, temperature controlled',
    hazardClass: '5.2',
    idNumber: 'UN3113',
    packingGroup: null,
    labelCodes: '5.2',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '225',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '2, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Organic peroxide type C, solid',
    hazardClass: '5.2',
    idNumber: 'UN3104',
    packingGroup: null,
    labelCodes: '5.2',
    specialProvisions: '',
    packagingExceptions: '152',
    packagingNonBulk: '225',
    packagingBulk: 'None',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '10 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Organic peroxide type C, solid, temperature controlled',
    hazardClass: '5.2',
    idNumber: 'UN3114',
    packingGroup: null,
    labelCodes: '5.2',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '225',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '2, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Organic peroxide type D, liquid',
    hazardClass: '5.2',
    idNumber: 'UN3105',
    packingGroup: null,
    labelCodes: '5.2',
    specialProvisions: '',
    packagingExceptions: '152',
    packagingNonBulk: '225',
    packagingBulk: 'None',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '10 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Organic peroxide type D, liquid, temperature controlled',
    hazardClass: '5.2',
    idNumber: 'UN3115',
    packingGroup: null,
    labelCodes: '5.2',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '225',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '2, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Organic peroxide type D, solid',
    hazardClass: '5.2',
    idNumber: 'UN3106',
    packingGroup: null,
    labelCodes: '5.2',
    specialProvisions: '',
    packagingExceptions: '152',
    packagingNonBulk: '225',
    packagingBulk: 'None',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '10 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Organic peroxide type D, solid, temperature controlled',
    hazardClass: '5.2',
    idNumber: 'UN3116',
    packingGroup: null,
    labelCodes: '5.2',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '225',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '2, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Organic peroxide type E, liquid',
    hazardClass: '5.2',
    idNumber: 'UN3107',
    packingGroup: null,
    labelCodes: '5.2',
    specialProvisions: 'A61',
    packagingExceptions: '152',
    packagingNonBulk: '225',
    packagingBulk: 'None',
    passengerQtyLimit: '10 L',
    cargoQtyLimit: '25 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Organic peroxide type E, liquid, temperature controlled',
    hazardClass: '5.2',
    idNumber: 'UN3117',
    packingGroup: null,
    labelCodes: '5.2',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '225',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '2, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Organic peroxide type E, solid',
    hazardClass: '5.2',
    idNumber: 'UN3108',
    packingGroup: null,
    labelCodes: '5.2',
    specialProvisions: '',
    packagingExceptions: '152',
    packagingNonBulk: '225',
    packagingBulk: 'None',
    passengerQtyLimit: '10 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Organic peroxide type E, solid, temperature controlled',
    hazardClass: '5.2',
    idNumber: 'UN3118',
    packingGroup: null,
    labelCodes: '5.2',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '225',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '2, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Organic peroxide type F, liquid',
    hazardClass: '5.2',
    idNumber: 'UN3109',
    packingGroup: null,
    labelCodes: '5.2',
    specialProvisions: 'A61, IP5',
    packagingExceptions: '152',
    packagingNonBulk: '225',
    packagingBulk: '225',
    passengerQtyLimit: '10 L',
    cargoQtyLimit: '25 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Organic peroxide type F, liquid, temperature controlled',
    hazardClass: '5.2',
    idNumber: 'UN3119',
    packingGroup: null,
    labelCodes: '5.2',
    specialProvisions: 'IP5',
    packagingExceptions: 'None',
    packagingNonBulk: '225',
    packagingBulk: '225',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '2, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Organic peroxide type F, solid',
    hazardClass: '5.2',
    idNumber: 'UN3110',
    packingGroup: null,
    labelCodes: '5.2',
    specialProvisions: 'TP33',
    packagingExceptions: '152',
    packagingNonBulk: '225',
    packagingBulk: '225',
    passengerQtyLimit: '10 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '12, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Organic peroxide type F, solid, temperature controlled',
    hazardClass: '5.2',
    idNumber: 'UN3120',
    packingGroup: null,
    labelCodes: '5.2',
    specialProvisions: 'TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '225',
    packagingBulk: '225',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '2, 25, 52, 53',
  },
  {
    symbols: 'D',
    properShippingName:
      'Organic phosphate, mixed with compressed gas or Organic phosphate compound, mixed with compressed gas or Organic phosphorus compound, mixed with compressed gas',
    hazardClass: '2.3',
    idNumber: 'NA1955',
    packingGroup: null,
    labelCodes: '2.3',
    specialProvisions: '3',
    packagingExceptions: 'None',
    packagingNonBulk: '334',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Organic pigments, self-heating',
    hazardClass: '4.2',
    idNumber: 'UN3313',
    packingGroup: 'II',
    labelCodes: '4.2',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Organoarsenic compound, liquid, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN3280',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '5, T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Organoarsenic compound, solid, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN3465',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Organochlorine pesticides liquid, flammable, toxic, flash point less than 23 degrees C',
    hazardClass: '3',
    idNumber: 'UN2762',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Organochlorine pesticides, liquid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN2996',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Organochlorine pesticides, liquid, toxic, flammable, flash point not less than 23 degrees C',
    hazardClass: '6.1',
    idNumber: 'UN2995',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Organochlorine pesticides, solid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN2761',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Organometallic compound, liquid, toxic, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN3282',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Organometallic compound, solid, toxic, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN3467',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Organometallic substance, liquid, pyrophoric',
    hazardClass: '4.2',
    idNumber: 'UN3392',
    packingGroup: 'I',
    labelCodes: '4.2',
    specialProvisions: 'B11, T21, TP2, TP7, TP36',
    packagingExceptions: 'None',
    packagingNonBulk: '181',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 78, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Organometallic substance, liquid, pyrophoric, water-reactive',
    hazardClass: '4.2',
    idNumber: 'UN3394',
    packingGroup: 'I',
    labelCodes: '4.2, 4.3',
    specialProvisions: 'B11, T21, TP2, TP7, TP36, TP47',
    packagingExceptions: 'None',
    packagingNonBulk: '181',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 52, 78, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Organometallic substance, liquid, water-reactive',
    hazardClass: '4.3',
    idNumber: 'UN3398',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'T13, TP2, TP7, TP36, TP47, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '1 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 40, 52, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Organometallic substance, liquid, water-reactive, flammable',
    hazardClass: '4.3',
    idNumber: 'UN3399',
    packingGroup: 'I',
    labelCodes: '4.3, 3',
    specialProvisions: 'T13, TP2, TP7, TP36, TP47, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '1 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 40, 52, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Organometallic substance, solid, pyrophoric',
    hazardClass: '4.2',
    idNumber: 'UN3391',
    packingGroup: 'I',
    labelCodes: '4.2',
    specialProvisions: 'T21, TP7, TP33, TP36',
    packagingExceptions: 'None',
    packagingNonBulk: '187',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Organometallic substance, solid, pyrophoric, water-reactive',
    hazardClass: '4.2',
    idNumber: 'UN3393',
    packingGroup: 'I',
    labelCodes: '4.2, 4.3',
    specialProvisions: 'B11, T21, TP7, TP33, TP36, TP47',
    packagingExceptions: 'None',
    packagingNonBulk: '187',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Organometallic substance, solid, self-heating',
    hazardClass: '4.2',
    idNumber: 'UN3400',
    packingGroup: 'II',
    labelCodes: '4.2',
    specialProvisions: 'IB6, T3, TP33, TP36',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Organometallic substance, solid, water-reactive',
    hazardClass: '4.3',
    idNumber: 'UN3395',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'N40, T9, TP7, TP33, TP36, TP47, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 52, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Organometallic substance, solid, water-reactive, flammable',
    hazardClass: '4.3',
    idNumber: 'UN3396',
    packingGroup: 'I',
    labelCodes: '4.3, 4.1',
    specialProvisions: 'N40, T9, TP7, TP33, TP36, TP47, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 52, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Organometallic substance, solid, water-reactive, self-heating',
    hazardClass: '4.3',
    idNumber: 'UN3397',
    packingGroup: 'I',
    labelCodes: '4.3, 4.2',
    specialProvisions: 'N40, T9, TP7, TP33, TP36, TP47, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Organophosphorus compound, toxic, flammable, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN3279',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '5, T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Organophosphorus compound, liquid, toxic, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN3278',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '5, T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Organophosphorus compound, solid, toxic, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN3464',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Organophosphorus pesticides, liquid, flammable, toxic, flash point less than 23 degrees C',
    hazardClass: '3',
    idNumber: 'UN2784',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Organophosphorus pesticides, liquid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN3018',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'N76, T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Organophosphorus pesticides, liquid, toxic, flammable, flash point not less than 23 degrees C',
    hazardClass: '6.1',
    idNumber: 'UN3017',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: 'N76, T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Organophosphorus pesticides, solid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN2783',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, N77, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Organotin compounds, liquid, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN2788',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'N33, N34, T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Organotin compounds, solid, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN3146',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'A5, IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Organotin pesticides, liquid, flammable, toxic, flash point less than 23 degrees C',
    hazardClass: '3',
    idNumber: 'UN2787',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Organotin pesticides, liquid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN3020',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Organotin pesticides, liquid, toxic, flammable, flash point not less than 23 degrees C',
    hazardClass: '6.1',
    idNumber: 'UN3019',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Organotin pesticides, solid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN2786',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Osmium tetroxide',
    hazardClass: '6.1',
    idNumber: 'UN2471',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'A8, IB7, IP1, N33, N34, T6, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: 'D G',
    properShippingName: 'Other regulated substances, liquid, n.o.s',
    hazardClass: '9',
    idNumber: 'NA3082',
    packingGroup: 'III',
    labelCodes: '9',
    specialProvisions: 'A189, IB3, T2, TP1',
    packagingExceptions: '155',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: 'No limit',
    cargoQtyLimit: 'No limit',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'D G',
    properShippingName: 'Other regulated substances, solid, n.o.s',
    hazardClass: '9',
    idNumber: 'NA3077',
    packingGroup: 'III',
    labelCodes: '9',
    specialProvisions: '384, B54, IB8, IP2, T1, TP33',
    packagingExceptions: '155',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: 'No limit',
    cargoQtyLimit: 'No limit',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Oxidizing liquid, corrosive, n.o.s.',
    hazardClass: '5.1',
    idNumber: 'UN3098',
    packingGroup: 'I',
    labelCodes: '5.1, 8',
    specialProvisions: '62',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 56, 58, 138',
  },
  {
    symbols: 'G',
    properShippingName: 'Oxidizing liquid, n.o.s',
    hazardClass: '5.1',
    idNumber: 'UN3139',
    packingGroup: 'I',
    labelCodes: '5.1',
    specialProvisions: '62, 127, A2',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '56, 58, 138',
  },
  {
    symbols: 'G',
    properShippingName: 'Oxidizing liquid, toxic, n.o.s',
    hazardClass: '5.1',
    idNumber: 'UN3099',
    packingGroup: 'I',
    labelCodes: '5.1, 6.1',
    specialProvisions: '62',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '56, 58, 138',
  },
  {
    symbols: 'G',
    properShippingName: 'Oxidizing solid, corrosive, n.o.s',
    hazardClass: '5.1',
    idNumber: 'UN3085',
    packingGroup: 'I',
    labelCodes: '5.1, 8',
    specialProvisions: '62',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 56, 58, 138',
  },
  {
    symbols: 'G',
    properShippingName: 'Oxidizing solid, flammable, n.o.s',
    hazardClass: '5.1',
    idNumber: 'UN3137',
    packingGroup: 'I',
    labelCodes: '5.1, 4.1',
    specialProvisions: '62',
    packagingExceptions: 'None',
    packagingNonBulk: '214',
    packagingBulk: '214',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '',
    vesselStowageOther: '13, 147, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Oxidizing solid, n.o.s.',
    hazardClass: '5.1',
    idNumber: 'UN1479',
    packingGroup: 'I',
    labelCodes: '5.1',
    specialProvisions: '62, IB5, IP1',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '56, 58, 106, 138',
  },
  {
    symbols: 'G',
    properShippingName: 'Oxidizing solid, self-heating, n.o.s.',
    hazardClass: '5.1',
    idNumber: 'UN3100',
    packingGroup: 'I',
    labelCodes: '5.1, 4.2',
    specialProvisions: '62',
    packagingExceptions: 'None',
    packagingNonBulk: '214',
    packagingBulk: '214',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Oxidizing solid, toxic, n.o.s.',
    hazardClass: '5.1',
    idNumber: 'UN3087',
    packingGroup: 'I',
    labelCodes: '5.1, 6.1',
    specialProvisions: '62',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '56, 58, 138',
  },
  {
    symbols: 'G',
    properShippingName: 'Oxidizing solid, water reactive, n.o.s',
    hazardClass: '5.1',
    idNumber: 'UN3121',
    packingGroup: 'I',
    labelCodes: '5.1, 4.3',
    specialProvisions: '62',
    packagingExceptions: 'None',
    packagingNonBulk: '214',
    packagingBulk: '214',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: '',
    properShippingName: 'Oxygen, compressed',
    hazardClass: '2.2',
    idNumber: 'UN1072',
    packingGroup: null,
    labelCodes: '2.2, 5.1',
    specialProvisions: '110, A14',
    packagingExceptions: '306',
    packagingNonBulk: '302',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Oxygen difluoride, compressed',
    hazardClass: '2.3',
    idNumber: 'UN2190',
    packingGroup: null,
    labelCodes: '2.3, 5.1, 8',
    specialProvisions: '1, N86',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 40, 89, 90',
  },
  {
    symbols: '',
    properShippingName:
      'Oxygen generator, chemical (including when contained in associated equipment, e.g., passenger service units (PSUs), portable breathing equipment (PBE), etc)',
    hazardClass: '5.1',
    idNumber: 'UN3356',
    packingGroup: null,
    labelCodes: '5.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '168',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '56, 58, 69, 106',
  },
  {
    symbols: '+',
    properShippingName: 'Oxygen generator, chemical, spent',
    hazardClass: '9',
    idNumber: 'NA3356',
    packingGroup: 'III',
    labelCodes: '9',
    specialProvisions: '61',
    packagingExceptions: 'None',
    packagingNonBulk: '213',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Oxygen, refrigerated liquid (cryogenic liquid)',
    hazardClass: '2.2',
    idNumber: 'UN1073',
    packingGroup: null,
    labelCodes: '2.2, 5.1',
    specialProvisions: 'T75, TP5, TP22',
    packagingExceptions: '320',
    packagingNonBulk: '316',
    packagingBulk: '318',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Paint (including paint, lacquer, enamel, stain, shellac solutions, varnish, polish, liquid filler and liquid lacquer base)',
    hazardClass: '3',
    idNumber: 'UN1263',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: '367, T11, TP1, TP8, TP27',
    packagingExceptions: '150',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Paint or Paint related material',
    hazardClass: '8',
    idNumber: 'UN3066',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: '367, B2, IB2, T7, TP2, TP28',
    packagingExceptions: '154',
    packagingNonBulk: '173',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName:
      'Paint, corrosive, flammable (including paint, lacquer, enamel, stain, shellac, varnish, polish, liquid filler, and liquid lacquer base)',
    hazardClass: '8',
    idNumber: 'UN3470',
    packingGroup: 'II',
    labelCodes: '8, 3',
    specialProvisions: '367, IB2, T7, TP2, TP8, TP28',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName:
      'Paint, flammable, corrosive, (including paint , lacquer, enamel, stain, shellac, varnish, polish, liquid filler and liquid lacquer base)',
    hazardClass: '3',
    idNumber: 'UN3469',
    packingGroup: 'I',
    labelCodes: '3, 8',
    specialProvisions: '367, T11, TP2, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Paint related material including paint thinning, drying, removing, or reducing compound',
    hazardClass: '3',
    idNumber: 'UN1263',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: '367, T11, TP1, TP8, TP27',
    packagingExceptions: '150',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Paint related material corrosive, flammable (including paint thinning or reducing compound)',
    hazardClass: '8',
    idNumber: 'UN3470',
    packingGroup: 'II',
    labelCodes: '8, 3',
    specialProvisions: '367, IB2, T7, TP2, TP8, TP28',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Paint related material, flammable, corrosive (including paint thinning or reducing compound)',
    hazardClass: '3',
    idNumber: 'UN3469',
    packingGroup: 'I',
    labelCodes: '3, 8',
    specialProvisions: '367, T11, TP2, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Paper, unsaturated oil treated incompletely dried (including carbon paper)',
    hazardClass: '4.2',
    idNumber: 'UN1379',
    packingGroup: 'III',
    labelCodes: '4.2',
    specialProvisions: 'IB8, IP3, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '213',
    packagingBulk: '241',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Paraformaldehyde',
    hazardClass: '4.1',
    idNumber: 'UN2213',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: 'A1, B120, IB8, IP3, T1, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Paraldehyde',
    hazardClass: '3',
    idNumber: 'UN1264',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'D',
    properShippingName: 'Parathion and compressed gas mixture',
    hazardClass: '2.3',
    idNumber: 'NA1967',
    packingGroup: null,
    labelCodes: '2.3',
    specialProvisions: '3',
    packagingExceptions: 'None',
    packagingNonBulk: '334',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '+',
    properShippingName: 'Pentaborane',
    hazardClass: '4.2',
    idNumber: 'UN1380',
    packingGroup: 'I',
    labelCodes: '4.2, 6.1',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '205',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: '',
    properShippingName: 'Pentachloroethane',
    hazardClass: '6.1',
    idNumber: 'UN1669',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Pentachlorophenol',
    hazardClass: '6.1',
    idNumber: 'UN3155',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Pentaerythrite tetranitrate mixture, desensitized, solid, n.o.s. or Pentaerythritol tetranitrate mixture, desensitized, solid, n.o.s. or PETN mixture, desensitized, solid, n.o.s., with more than 10 percent but not more than 20 percent PETN, by mass',
    hazardClass: '4.1',
    idNumber: 'UN3344',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: '118, N85',
    packagingExceptions: 'None',
    packagingNonBulk: '214',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Pentaerythrite tetranitrate or Pentaerythritol tetranitrate or PETN, with not less than 7 percent wax by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0411',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '120',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName:
      'Pentaerythrite tetranitrate, wetted or Pentaerythritol tetranitrate, wetted, or PETN, wetted with not less than 25 percent water, by mass, or Pentaerythrite tetranitrate, or Pentaerythritol tetranitrate or PETN, desensitized with not less than 15 percent phlegmatizer by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0150',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '121',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Pentafluoroethane or Refrigerant gas R 125',
    hazardClass: '2.2',
    idNumber: 'UN3220',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Pentamethylheptane',
    hazardClass: '3',
    idNumber: 'UN2286',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Pentane-2,4-dione',
    hazardClass: '3',
    idNumber: 'UN2310',
    packingGroup: 'III',
    labelCodes: '3, 6.1',
    specialProvisions: 'B1, IB3, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Pentanes',
    hazardClass: '3',
    idNumber: 'UN1265',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'T11, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Pentanols',
    hazardClass: '3',
    idNumber: 'UN1105',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1, TP29',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '1-Pentene (n-amylene)',
    hazardClass: '3',
    idNumber: 'UN1108',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'T11, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '1-Pentol',
    hazardClass: '8',
    idNumber: 'UN2705',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '26, 27',
  },
  {
    symbols: '',
    properShippingName: 'Pentolite, dry or wetted with less than 15 percent water, by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0151',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Perchlorates, inorganic, aqueous solution, n.o.s.',
    hazardClass: '5.1',
    idNumber: 'UN3211',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '152',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '56, 58, 133',
  },
  {
    symbols: '',
    properShippingName: 'Perchlorates, inorganic, n.o.s.',
    hazardClass: '5.1',
    idNumber: 'UN1481',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB6, IP2, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Perchloric acid with more than 50 percent but not more than 72 percent acid, by mass',
    hazardClass: '5.1',
    idNumber: 'UN1873',
    packingGroup: 'I',
    labelCodes: '5.1, 8',
    specialProvisions: 'A2, N41, T10, TP1',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '53, 58, 66',
  },
  {
    symbols: '',
    properShippingName: 'Perchloric acid with not more than 50 percent acid by mass',
    hazardClass: '8',
    idNumber: 'UN1802',
    packingGroup: 'II',
    labelCodes: '8, 5.1',
    specialProvisions: 'IB2, N41, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '53, 58, 66',
  },
  {
    symbols: '',
    properShippingName: 'Perchloromethyl mercaptan',
    hazardClass: '6.1',
    idNumber: 'UN1670',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '2, B9, B14, B32, N34, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Perchloryl fluoride',
    hazardClass: '2.3',
    idNumber: 'UN3083',
    packingGroup: null,
    labelCodes: '2.3, 5.1',
    specialProvisions: '2, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Perfluoro(ethyl vinyl ether)',
    hazardClass: '2.1',
    idNumber: 'UN3154',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '302, 304, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Perfluoro(methyl vinyl ether)',
    hazardClass: '2.1',
    idNumber: 'UN3153',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '302, 304, 305',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Perfumery products with flammable solvents',
    hazardClass: '3',
    idNumber: 'UN1266',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: '149, IB2, T4, TP1, TP8',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '15 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Permanganates, inorganic, aqueous solution, n.o.s',
    hazardClass: '5.1',
    idNumber: 'UN3214',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: '26, 353, IB2, T4, TP1',
    packagingExceptions: '152',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '56, 58, 133, 138',
  },
  {
    symbols: 'G',
    properShippingName: 'Permanganates, inorganic, n.o.s',
    hazardClass: '5.1',
    idNumber: 'UN1482',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: '26, 353, A30, IB6, IP2, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '56, 58, 138',
  },
  {
    symbols: '',
    properShippingName: 'Peroxides, inorganic, n.o.s',
    hazardClass: '5.1',
    idNumber: 'UN1483',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'A7, A20, IB6, IP2, N34, T3, TP33, W100',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '13, 52, 66, 75, 148',
  },
  {
    symbols: '',
    properShippingName: 'Persulfates, inorganic, aqueous solution, n.o.s',
    hazardClass: '5.1',
    idNumber: 'UN3216',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: 'IB2, T4, TP1, TP29',
    packagingExceptions: '152',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '2.5 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58, 133',
  },
  {
    symbols: '',
    properShippingName: 'Persulfates, inorganic, n.o.s.',
    hazardClass: '5.1',
    idNumber: 'UN3215',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: 'G',
    properShippingName: 'Pesticides, liquid, flammable, toxic, flash point less than 23 degrees C',
    hazardClass: '3',
    idNumber: 'UN3021',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: 'B5, T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Pesticides, liquid, toxic, flammable, n.o.s. flash point not less than 23 degrees C',
    hazardClass: '6.1',
    idNumber: 'UN2903',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Pesticides, liquid, toxic, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN2902',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Pesticides, solid, toxic, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN2588',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Petroleum crude oil',
    hazardClass: '3',
    idNumber: 'UN1267',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: '144, 357, T11, TP1, TP8',
    packagingExceptions: '150',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Petroleum distillates, n.o.s. or Petroleum products, n.o.s.',
    hazardClass: '3',
    idNumber: 'UN1268',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: '144, T11, TP1, TP8',
    packagingExceptions: '150',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Petroleum gases, liquefied or Liquefied petroleum gas',
    hazardClass: '2.1',
    idNumber: 'UN1075',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'T50, N95',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: 'D',
    properShippingName: 'Petroleum oil',
    hazardClass: '3',
    idNumber: 'NA1270',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: '144, T11, TP1',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: 'I',
    properShippingName: 'Petroleum sour crude oil, flammable, toxic',
    hazardClass: '3',
    idNumber: 'UN3494',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: '343, T14, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Phenacyl bromide',
    hazardClass: '6.1',
    idNumber: 'UN2645',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '+',
    properShippingName: 'Phenetidines',
    hazardClass: '6.1',
    idNumber: 'UN2311',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Phenol, molten',
    hazardClass: '6.1',
    idNumber: 'UN2312',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'B14, T7, TP3',
    packagingExceptions: 'None',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '+',
    properShippingName: 'Phenol, solid',
    hazardClass: '6.1',
    idNumber: 'UN1671',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, N78, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Phenol solutions',
    hazardClass: '6.1',
    idNumber: 'UN2821',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Phenolsulfonic acid, liquid',
    hazardClass: '8',
    idNumber: 'UN1803',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, N41, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '14, 53, 58',
  },
  {
    symbols: '',
    properShippingName:
      'Phenoxyacetic acid derivative pesticide, liquid, flammable, toxic flash point less than 23 degrees C',
    hazardClass: '3',
    idNumber: 'UN3346',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Phenoxyacetic acid derivative pesticide, liquid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN3348',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName:
      'Phenoxyacetic acid derivative pesticide, liquid, toxic, flammable, flash point not less than 23 degrees C',
    hazardClass: '6.1',
    idNumber: 'UN3347',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Phenoxyacetic acid derivative pesticide, solid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN3345',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Phenyl chloroformate',
    hazardClass: '6.1',
    idNumber: 'UN2746',
    packingGroup: 'II',
    labelCodes: '6.1, 8',
    specialProvisions: 'IB2, T7, TP2, TP13',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 13, 25, 40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Phenyl isocyanate',
    hazardClass: '6.1',
    idNumber: 'UN2487',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '2, B9, B14, B32, B77, N33, N34, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Phenyl mercaptan',
    hazardClass: '6.1',
    idNumber: 'UN2337',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '2, B9, B14, B32, B77, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Phenyl phosphorus dichloride',
    hazardClass: '8',
    idNumber: 'UN2798',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, B15, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Phenyl phosphorus thiodichloride',
    hazardClass: '8',
    idNumber: 'UN2799',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, B15, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Phenyl urea pesticides, liquid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN3002',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T14, TP2, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Phenylacetonitrile, liquid',
    hazardClass: '6.1',
    idNumber: 'UN2470',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Phenylacetyl chloride',
    hazardClass: '8',
    idNumber: 'UN2577',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Phenylcarbylamine chloride',
    hazardClass: '6.1',
    idNumber: 'UN1672',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '2, B9, B14, B32, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '+',
    properShippingName: 'Phenylenediamines (o-; m-; p-;)',
    hazardClass: '6.1',
    idNumber: 'UN1673',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Phenylhydrazine',
    hazardClass: '6.1',
    idNumber: 'UN2572',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Phenylmercuric acetate',
    hazardClass: '6.1',
    idNumber: 'UN1674',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Phenylmercuric compounds, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN2026',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Phenylmercuric hydroxide',
    hazardClass: '6.1',
    idNumber: 'UN1894',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Phenylmercuric nitrate',
    hazardClass: '6.1',
    idNumber: 'UN1895',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Phenyltrichlorosilane',
    hazardClass: '8',
    idNumber: 'UN1804',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, B6, N34, T10, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Phosgene',
    hazardClass: '2.3',
    idNumber: 'UN1076',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '1, B7, B46, N86',
    packagingExceptions: 'None',
    packagingNonBulk: '192',
    packagingBulk: '314',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: '9-Phosphabicyclononanes or Cyclooctadiene phosphines',
    hazardClass: '4.2',
    idNumber: 'UN2940',
    packingGroup: 'II',
    labelCodes: '4.2',
    specialProvisions: 'A19, IB6, IP2, T3, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Phosphine',
    hazardClass: '2.3',
    idNumber: 'UN2199',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '192',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Phosphine, adsorbed',
    hazardClass: '2.3',
    idNumber: 'UN3525',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Phosphoric acid solution',
    hazardClass: '8',
    idNumber: 'UN1805',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'A7, IB3, N34, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Phosphoric acid, solid',
    hazardClass: '8',
    idNumber: 'UN3453',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Phosphorous acid',
    hazardClass: '8',
    idNumber: 'UN2834',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '25, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Phosphorus, amorphous',
    hazardClass: '4.1',
    idNumber: 'UN1338',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: 'A1, A19, B1, B9, B26, IB8, IP3, T1, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '243',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '74',
  },
  {
    symbols: '',
    properShippingName: 'Phosphorus heptasulfide, free from yellow or white phosphorus',
    hazardClass: '4.1',
    idNumber: 'UN1339',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: 'A20, IB4, N34, T3, TP33, W31',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '13, 74, 147, 148',
  },
  {
    symbols: '',
    properShippingName: 'Phosphorus oxybromide',
    hazardClass: '8',
    idNumber: 'UN1939',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B8, IB8, IP2, IP4, N41, N43, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '12, 25, 40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Phosphorus oxybromide, molten',
    hazardClass: '8',
    idNumber: 'UN2576',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, B8, IB1, N41, N43, T7, TP3, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '+',
    properShippingName: 'Phosphorus oxychloride',
    hazardClass: '6.1',
    idNumber: 'UN1810',
    packingGroup: 'I',
    labelCodes: '6.1, 8',
    specialProvisions: '2, B9, B14, B32, B77, N34, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Phosphorus pentabromide',
    hazardClass: '8',
    idNumber: 'UN2691',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, IB8, IP2, IP4, N34, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '12, 25, 40, 53, 55, 58',
  },
  {
    symbols: '',
    properShippingName: 'Phosphorus pentachloride',
    hazardClass: '8',
    idNumber: 'UN1806',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, IB8, IP2, IP4, N34, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 44, 53, 58, 89, 100, 141',
  },
  {
    symbols: '',
    properShippingName: 'Phosphorus Pentafluoride',
    hazardClass: '2.3',
    idNumber: 'UN2198',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '2, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302, 304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Phosphorus pentafluoride, adsorbed',
    hazardClass: '2.3',
    idNumber: 'UN3524',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '2, B9, B14',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Phosphorus pentasulfide, free from yellow or white phosphorus',
    hazardClass: '4.3',
    idNumber: 'UN1340',
    packingGroup: 'II',
    labelCodes: '4.3, 4.1',
    specialProvisions: 'A20, B59, IB4, T3, TP33, W31, W40',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '13, 74, 148',
  },
  {
    symbols: '',
    properShippingName: 'Phosphorus pentoxide',
    hazardClass: '8',
    idNumber: 'UN1807',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, IB8, IP2, IP4, N34, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Phosphorus sesquisulfide, free from yellow or white phosphorus',
    hazardClass: '4.1',
    idNumber: 'UN1341',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: 'A20, IB4, N34, T3, TP33, W31',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '74',
  },
  {
    symbols: '',
    properShippingName: 'Phosphorus tribromide',
    hazardClass: '8',
    idNumber: 'UN1808',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A3, A7, B2, B25, IB2, N34, N43, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Phosphorus trichloride',
    hazardClass: '6.1',
    idNumber: 'UN1809',
    packingGroup: 'I',
    labelCodes: '6.1, 8',
    specialProvisions: '2, B9, B14, B15, B32, B77, N34, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Phosphorus trioxide',
    hazardClass: '8',
    idNumber: 'UN2578',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 25, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Phosphorus trisulfide, free from yellow or white phosphorus',
    hazardClass: '4.1',
    idNumber: 'UN1343',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: 'A20, IB4, N34, T3, TP33, W31',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '13, 74, 147, 148',
  },
  {
    symbols: '',
    properShippingName:
      'Phosphorus, white dry or Phosphorus, white, under water or Phosphorus white, in solution or Phosphorus, yellow dry or Phosphorus, yellow, under water or Phosphorus, yellow, in solution',
    hazardClass: '4.2',
    idNumber: 'UN1381',
    packingGroup: 'I',
    labelCodes: '4.2, 6.1',
    specialProvisions: 'B9, B26, N34, T9, TP3, TP31, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '188',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Phosphorus white, molten',
    hazardClass: '4.2',
    idNumber: 'UN2447',
    packingGroup: 'I',
    labelCodes: '4.2, 6.1',
    specialProvisions: 'B9, B26, N34, T21, TP3, TP7, TP26',
    packagingExceptions: 'None',
    packagingNonBulk: '188',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Phthalic anhydride with more than .05 percent maleic anhydride',
    hazardClass: '8',
    idNumber: 'UN2214',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Picolines',
    hazardClass: '3',
    idNumber: 'UN2313',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Pine oil',
    hazardClass: '3',
    idNumber: 'UN1272',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'alpha-Pinene',
    hazardClass: '3',
    idNumber: 'UN2368',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Piperazine',
    hazardClass: '8',
    idNumber: 'UN2579',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 25, 52',
  },
  {
    symbols: '',
    properShippingName: 'Piperidine',
    hazardClass: '8',
    idNumber: 'UN2401',
    packingGroup: 'I',
    labelCodes: '8, 3',
    specialProvisions: 'A10, T10, TP2',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Plastic molding compound in dough, sheet or extruded rope form evolving flammable vapor',
    hazardClass: '9',
    idNumber: 'UN3314',
    packingGroup: 'III',
    labelCodes: '9',
    specialProvisions: '32, IB8, IP3, IP7',
    packagingExceptions: '155',
    packagingNonBulk: '221',
    packagingBulk: '221',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '21, 25, 87, 144',
  },
  {
    symbols: '',
    properShippingName: 'Plastics, nitrocellulose-based, self-heating, n.o.s.',
    hazardClass: '4.2',
    idNumber: 'UN2006',
    packingGroup: 'III',
    labelCodes: '4.2',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '213',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Polychlorinated biphenyls, liquid',
    hazardClass: '9',
    idNumber: 'UN2315',
    packingGroup: 'II',
    labelCodes: '9',
    specialProvisions: '9, 81, 140, IB3, T4, TP1',
    packagingExceptions: '155',
    packagingNonBulk: '202',
    packagingBulk: '241',
    passengerQtyLimit: '100 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '95',
  },
  {
    symbols: '',
    properShippingName: 'Polychlorinated biphenyls, solid',
    hazardClass: '9',
    idNumber: 'UN3432',
    packingGroup: 'II',
    labelCodes: '9',
    specialProvisions: '9, 81,140, IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '155',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '95',
  },
  {
    symbols: '',
    properShippingName: 'Polyester resin kit, liquid base material',
    hazardClass: '3',
    idNumber: 'UN3269',
    packingGroup: null,
    labelCodes: '3',
    specialProvisions: '40, 149',
    packagingExceptions: '165',
    packagingNonBulk: '165',
    packagingBulk: 'None',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '5 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Polyester resin kit, solid base material',
    hazardClass: '4.1',
    idNumber: 'UN3527',
    packingGroup: null,
    labelCodes: '4.1',
    specialProvisions: '40, 157',
    packagingExceptions: '165',
    packagingNonBulk: '165',
    packagingBulk: 'None',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '5 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Polyhalogenated biphenyls, liquid or Halogenated monomethyldiphenyl-methanes, liquid or Polyhalogenated terphenyls, liquid',
    hazardClass: '9',
    idNumber: 'UN3151',
    packingGroup: 'II',
    labelCodes: '9',
    specialProvisions: 'IB2',
    packagingExceptions: '155',
    packagingNonBulk: '204',
    packagingBulk: '241',
    passengerQtyLimit: '100 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '95',
  },
  {
    symbols: '',
    properShippingName:
      'Polyhalogenated biphenyls, solid or Halogenated monomethyldiphenyl-methanes, solid or Polyhalogenated terphenyls, solid',
    hazardClass: '9',
    idNumber: 'UN3152',
    packingGroup: 'II',
    labelCodes: '9',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '155',
    packagingNonBulk: '204',
    packagingBulk: '241',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '95',
  },
  {
    symbols: '',
    properShippingName: 'Polymeric beads expandable, evolving flammable vapor',
    hazardClass: '9',
    idNumber: 'UN2211',
    packingGroup: 'III',
    labelCodes: '9',
    specialProvisions: '32, IB8, IP3, IP7, T1, TP33',
    packagingExceptions: '155',
    packagingNonBulk: '221',
    packagingBulk: '221',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '21, 25, 87, 144',
  },
  {
    symbols: 'G',
    properShippingName: 'Polymerizing substance, liquid, stabilized, n.o.s.',
    hazardClass: '4.1',
    idNumber: 'UN3532',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: '387, IB3, IP19, N92, T7, TP4, TP6',
    packagingExceptions: 'None',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '10 L',
    cargoQtyLimit: '25 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Polymerizing substance, liquid, temperature controlled, n.o.s.',
    hazardClass: '4.1',
    idNumber: 'UN3534',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: '387, IB3, IP19, N92, T7, TP4, TP6',
    packagingExceptions: 'None',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '2, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Polymerizing substance, solid, stabilized, n.o.s.',
    hazardClass: '4.1',
    idNumber: 'UN3531',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: '387, IB7, IP19, N92, T7, TP4, TP6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '10 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Polymerizing substance, solid, temperature controlled, n.o.s.',
    hazardClass: '4.1',
    idNumber: 'UN3533',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: '387, IB7, IP19, N92, T7, TP4, TP6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '2, 25, 52, 53',
  },
  {
    symbols: '',
    properShippingName: 'Potassium',
    hazardClass: '4.3',
    idNumber: 'UN2257',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A7, A19, A20, B27, IB4, IP1, N6, N34, T9, TP7, TP33, W31',
    packagingExceptions: '151',
    packagingNonBulk: '211',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Potassium arsenate',
    hazardClass: '6.1',
    idNumber: 'UN1677',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Potassium arsenite',
    hazardClass: '6.1',
    idNumber: 'UN1678',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Potassium borohydride',
    hazardClass: '4.3',
    idNumber: 'UN1870',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A19, N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Potassium bromate',
    hazardClass: '5.1',
    idNumber: 'UN1484',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Potassium chlorate',
    hazardClass: '5.1',
    idNumber: 'UN1485',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'A9, IB8, IP2, IP4, N34, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Potassium chlorate, aqueous solution',
    hazardClass: '5.1',
    idNumber: 'UN2427',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'A2, IB2, T4, TP1',
    packagingExceptions: '152',
    packagingNonBulk: '202',
    packagingBulk: '241',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '56, 58, 133',
  },
  {
    symbols: '',
    properShippingName: 'Potassium cuprocyanide',
    hazardClass: '6.1',
    idNumber: 'UN1679',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Potassium cyanide, solid',
    hazardClass: '6.1',
    idNumber: 'UN1680',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'B69, B77, IB7, IP1, N74, N75, T6, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Potassium cyanide solution',
    hazardClass: '6.1',
    idNumber: 'UN3413',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'B69, B77, N74, N75, T14, TP2, TP13, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Potassium dithionite or Potassium hydrosulfite',
    hazardClass: '4.2',
    idNumber: 'UN1929',
    packingGroup: 'II',
    labelCodes: '4.2',
    specialProvisions: 'A8, A19, A20, IB6, IP2, T3, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13',
  },
  {
    symbols: '',
    properShippingName: 'Potassium fluoride, solid',
    hazardClass: '6.1',
    idNumber: 'UN1812',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Potassium fluoride solution',
    hazardClass: '6.1',
    idNumber: 'UN3422',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Potassium fluoroacetate',
    hazardClass: '6.1',
    idNumber: 'UN2628',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Potassium fluorosilicate',
    hazardClass: '6.1',
    idNumber: 'UN2655',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Potassium hydrogen sulfate',
    hazardClass: '8',
    idNumber: 'UN2509',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, IB8, IP2, IP4, N34, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Potassium hydrogendifluoride solid',
    hazardClass: '8',
    idNumber: 'UN1811',
    packingGroup: 'II',
    labelCodes: '8, 6.1',
    specialProvisions: 'IB8, IP2, IP4, N3, N34, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '25, 40, 52, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Potassium hydrogendifluoride solution',
    hazardClass: '8',
    idNumber: 'UN3421',
    packingGroup: 'II',
    labelCodes: '8, 6.1',
    specialProvisions: 'IB2, N3, N34, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '25, 40, 52, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Potassium hydroxide, solid',
    hazardClass: '8',
    idNumber: 'UN1813',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52.',
  },
  {
    symbols: '',
    properShippingName: 'Potassium hydroxide, solution',
    hazardClass: '8',
    idNumber: 'UN1814',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52.',
  },
  {
    symbols: '',
    properShippingName: 'Potassium, metal alloys, liquid',
    hazardClass: '4.3',
    idNumber: 'UN1420',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A7, A19, A20, B27, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '1 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Potassium, metal alloys, solid',
    hazardClass: '4.3',
    idNumber: 'UN3403',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A19, A20, B27, IB4, IP1, T9, TP7, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Potassium metavanadate',
    hazardClass: '6.1',
    idNumber: 'UN2864',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Potassium monoxide',
    hazardClass: '8',
    idNumber: 'UN2033',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '29, 52.',
  },
  {
    symbols: '',
    properShippingName: 'Potassium nitrate',
    hazardClass: '5.1',
    idNumber: 'UN1486',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: 'A1, A29, B120 IB8, IP3, T1, TP33, W1',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Potassium nitrate and sodium nitrite mixtures',
    hazardClass: '5.1',
    idNumber: 'UN1487',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'B78, IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Potassium nitrite',
    hazardClass: '5.1',
    idNumber: 'UN1488',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Potassium perchlorate',
    hazardClass: '5.1',
    idNumber: 'UN1489',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB6, IP2, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Potassium permanganate',
    hazardClass: '5.1',
    idNumber: 'UN1490',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '56, 58, 138',
  },
  {
    symbols: '',
    properShippingName: 'Potassium peroxide',
    hazardClass: '5.1',
    idNumber: 'UN1491',
    packingGroup: 'I',
    labelCodes: '5.1',
    specialProvisions: 'A20, IB6, IP1, N34',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '13, 52, 66, 75, 148',
  },
  {
    symbols: '',
    properShippingName: 'Potassium persulfate',
    hazardClass: '5.1',
    idNumber: 'UN1492',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: 'A1, A29, IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '58, 145',
  },
  {
    symbols: '',
    properShippingName: 'Potassium phosphide',
    hazardClass: '4.3',
    idNumber: 'UN2012',
    packingGroup: 'I',
    labelCodes: '4.3, 6.1',
    specialProvisions: 'A19, N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 52, 85, 148',
  },
  {
    symbols: '',
    properShippingName: 'Potassium sodium alloys, liquid',
    hazardClass: '4.3',
    idNumber: 'UN1422',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A7, A19, B27, N34, N40, T9, TP3, TP7, TP31, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '1 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Potassium sodium alloys, solid',
    hazardClass: '4.3',
    idNumber: 'UN3404',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A19, B27, N34, N40, T9, TP7, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName:
      'Potassium sulfide, anhydrous or Potassium sulfide with less than 30 percent water of crystallization',
    hazardClass: '4.2',
    idNumber: 'UN1382',
    packingGroup: 'II',
    labelCodes: '4.2',
    specialProvisions: 'A19, A20, B16, IB6, IP2, N34, T3, TP33, W31, W40',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Potassium sulfide, hydrated with not less than 30 percent water of crystallization',
    hazardClass: '8',
    idNumber: 'UN1847',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Potassium superoxide',
    hazardClass: '5.1',
    idNumber: 'UN2466',
    packingGroup: 'I',
    labelCodes: '5.1',
    specialProvisions: 'A20, IB6, IP1',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 52, 66, 75, 148',
  },
  {
    symbols: '',
    properShippingName: 'Powder cake, wetted or Powder paste, wetted with not less than 17 percent alcohol by mass',
    hazardClass: '1.1C',
    idNumber: 'UN0433',
    packingGroup: null,
    labelCodes: '1.1C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Powder cake, wetted or Powder paste, wetted with not less than 25 percent water, by mass',
    hazardClass: '1.3C',
    idNumber: 'UN0159',
    packingGroup: null,
    labelCodes: '1.3C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Powder, smokeless',
    hazardClass: '1.1C',
    idNumber: 'UN0160',
    packingGroup: null,
    labelCodes: '1.1C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 26E',
  },
  {
    symbols: '',
    properShippingName: 'Powder, smokeless',
    hazardClass: '1.3C',
    idNumber: 'UN0161',
    packingGroup: null,
    labelCodes: '1.3C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 26E',
  },
  {
    symbols: '',
    properShippingName: 'Powder, smokeless',
    hazardClass: '1.4C',
    idNumber: 'UN0509',
    packingGroup: null,
    labelCodes: '1.4C',
    specialProvisions: '16',
    packagingExceptions: '171',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Primers, cap type',
    hazardClass: '1.4S',
    idNumber: 'UN0044',
    packingGroup: null,
    labelCodes: 'None',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Primers, cap type',
    hazardClass: '1.1B',
    idNumber: 'UN0377',
    packingGroup: null,
    labelCodes: '1.1B',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Primers, cap type',
    hazardClass: '1.4B',
    idNumber: 'UN0378',
    packingGroup: null,
    labelCodes: '1.4B',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Primers, tubular',
    hazardClass: '1.3G',
    idNumber: 'UN0319',
    packingGroup: null,
    labelCodes: '1.3G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Primers, tubular',
    hazardClass: '1.4G',
    idNumber: 'UN0320',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Primers, tubular',
    hazardClass: '1.4S',
    idNumber: 'UN0376',
    packingGroup: null,
    labelCodes: 'None',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName:
      'Printing ink, flammable or Printing ink related material (including printing ink thinning or reducing compound), flammable',
    hazardClass: '3',
    idNumber: 'UN1210',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: '367, T11, TP1, TP8',
    packagingExceptions: '150',
    packagingNonBulk: '173',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Projectiles, inert with tracer',
    hazardClass: '1.4S',
    idNumber: 'UN0345',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Projectiles, inert, with tracer',
    hazardClass: '1.3G',
    idNumber: 'UN0424',
    packingGroup: null,
    labelCodes: '1.3G',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Projectiles, inert, with tracer',
    hazardClass: '1.4G',
    idNumber: 'UN0425',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Projectiles, with burster or expelling charge',
    hazardClass: '1.2D',
    idNumber: 'UN0346',
    packingGroup: null,
    labelCodes: '1.2D',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Projectiles, with burster or expelling charge',
    hazardClass: '1.4D',
    idNumber: 'UN0347',
    packingGroup: null,
    labelCodes: '1.4D',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Projectiles, with burster or expelling charge',
    hazardClass: '1.2F',
    idNumber: 'UN0426',
    packingGroup: null,
    labelCodes: '1.2F',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Projectiles, with burster or expelling charge',
    hazardClass: '1.4F',
    idNumber: 'UN0427',
    packingGroup: null,
    labelCodes: '1.4F',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Projectiles, with burster or expelling charge',
    hazardClass: '1.2G',
    idNumber: 'UN0434',
    packingGroup: null,
    labelCodes: '1.2G',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Projectiles, with burster or expelling charge',
    hazardClass: '1.4G',
    idNumber: 'UN0435',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Projectiles, with bursting charge',
    hazardClass: '1.1F',
    idNumber: 'UN0167',
    packingGroup: null,
    labelCodes: '1.1F',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Projectiles, with bursting charge',
    hazardClass: '1.1D',
    idNumber: 'UN0168',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Projectiles, with bursting charge',
    hazardClass: '1.2D',
    idNumber: 'UN0169',
    packingGroup: null,
    labelCodes: '1.2D',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Projectiles, with bursting charge',
    hazardClass: '1.2F',
    idNumber: 'UN0324',
    packingGroup: null,
    labelCodes: '1.2F',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Projectiles, with bursting charge',
    hazardClass: '1.4D',
    idNumber: 'UN0344',
    packingGroup: null,
    labelCodes: '1.4D',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Propadiene, stabilized',
    hazardClass: '2.1',
    idNumber: 'UN2200',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '387',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Propane, see also Petroleum gases, liquefied',
    hazardClass: '2.1',
    idNumber: 'UN1978',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '19, T50, N95',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Propanethiols',
    hazardClass: '3',
    idNumber: 'UN2402',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1, TP13',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '95, 102',
  },
  {
    symbols: '',
    properShippingName: 'n-Propanol or Propyl alcohol, normal',
    hazardClass: '3',
    idNumber: 'UN1274',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'B1, IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Propellant, liquid',
    hazardClass: '1.3C',
    idNumber: 'UN0495',
    packingGroup: null,
    labelCodes: '1.3C',
    specialProvisions: '37',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Propellant, liquid',
    hazardClass: '1.1C',
    idNumber: 'UN0497',
    packingGroup: null,
    labelCodes: '1.1C',
    specialProvisions: '37',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Propellant, solid',
    hazardClass: '1.1C',
    idNumber: 'UN0498',
    packingGroup: null,
    labelCodes: '1.1C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 26E',
  },
  {
    symbols: '',
    properShippingName: 'Propellant, solid',
    hazardClass: '1.3C',
    idNumber: 'UN0499',
    packingGroup: null,
    labelCodes: '1.3C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 26E',
  },
  {
    symbols: '',
    properShippingName: 'Propellant, solid',
    hazardClass: '1.4C',
    idNumber: 'UN0501',
    packingGroup: null,
    labelCodes: '1.4C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Propionaldehyde',
    hazardClass: '3',
    idNumber: 'UN1275',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Propionic acid with not less than 90% acid by mass',
    hazardClass: '8',
    idNumber: 'UN3463',
    packingGroup: 'II',
    labelCodes: '8, 3',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Propionic acid with not less than 10% and less than 90% acid by mass',
    hazardClass: '8',
    idNumber: 'UN1848',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Propionic anhydride',
    hazardClass: '8',
    idNumber: 'UN2496',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Propionitrile',
    hazardClass: '3',
    idNumber: 'UN2404',
    packingGroup: 'II',
    labelCodes: '3, 6.1',
    specialProvisions: 'IB2, T7, TP1, TP13',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Propionyl chloride',
    hazardClass: '3',
    idNumber: 'UN1815',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'IB1, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'n-Propyl acetate',
    hazardClass: '3',
    idNumber: 'UN1276',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'n-Propyl benzene',
    hazardClass: '3',
    idNumber: 'UN2364',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'n-Propyl chloroformate',
    hazardClass: '6.1',
    idNumber: 'UN2740',
    packingGroup: 'I',
    labelCodes: '6.1, 3, 8',
    specialProvisions: '2, B9, B14, B32, B77, N34, T20, TP2, TP13, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'B',
    vesselStowageOther: '21, 40, 53, 58, 100',
  },
  {
    symbols: '',
    properShippingName: 'Propyl formates',
    hazardClass: '3',
    idNumber: 'UN1281',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'n-Propyl isocyanate',
    hazardClass: '6.1',
    idNumber: 'UN2482',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '1, B9, B14, B30, T20, TP2, TP13, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'n-Propyl nitrate',
    hazardClass: '3',
    idNumber: 'UN1865',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB9',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: 'None',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '44, 89, 90, 100',
  },
  {
    symbols: '',
    properShippingName: 'Propylamine',
    hazardClass: '3',
    idNumber: 'UN1277',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'A7, IB2, N34, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Propylene see also Petroleum gases, liquefied',
    hazardClass: '2.1',
    idNumber: 'UN1077',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '19, T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Propylene chlorohydrin',
    hazardClass: '6.1',
    idNumber: 'UN2611',
    packingGroup: 'II',
    labelCodes: '6.1, 3',
    specialProvisions: 'IB2, T7, TP2, TP13',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Propylene oxide',
    hazardClass: '3',
    idNumber: 'UN1280',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'N34, T11, TP2, TP7',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Propylene tetramer',
    hazardClass: '3',
    idNumber: 'UN2850',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '1,2-Propylenediamine',
    hazardClass: '8',
    idNumber: 'UN2258',
    packingGroup: 'II',
    labelCodes: '8, 3',
    specialProvisions: 'A3, IB2, N34, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Propyleneimine, stabilized',
    hazardClass: '3',
    idNumber: 'UN1921',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: 'N34, T14, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Propyltrichlorosilane',
    hazardClass: '8',
    idNumber: 'UN1816',
    packingGroup: 'II',
    labelCodes: '8, 3',
    specialProvisions: 'A7, B2, B6, N34, T10, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Pyrethroid pesticide, liquid, flammable, toxic, flash point less than 23 degrees C',
    hazardClass: '3',
    idNumber: 'UN3350',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Pyrethroid pesticide, liquid toxic',
    hazardClass: '6.1',
    idNumber: 'UN3352',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Pyrethroid pesticide, liquid, toxic, flammable, flash point not less than 23 degrees C',
    hazardClass: '6.1',
    idNumber: 'UN3351',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Pyrethroid pesticide, solid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN3349',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Pyridine',
    hazardClass: '3',
    idNumber: 'UN1282',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '21, 100',
  },
  {
    symbols: 'G',
    properShippingName: 'Pyrophoric liquid, inorganic, n.o.s',
    hazardClass: '4.2',
    idNumber: 'UN3194',
    packingGroup: 'I',
    labelCodes: '4.2',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '181',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 78, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Pyrophoric liquids, organic, n.o.s',
    hazardClass: '4.2',
    idNumber: 'UN2845',
    packingGroup: 'I',
    labelCodes: '4.2',
    specialProvisions: 'B11, T22, TP2, TP7, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '187',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 78, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Pyrophoric metals, n.o.s., or Pyrophoric alloys, n.o.s',
    hazardClass: '4.2',
    idNumber: 'UN1383',
    packingGroup: 'I',
    labelCodes: '4.2',
    specialProvisions: 'B11, T21, TP7, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '187',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Pyrophoric solid, inorganic, n.o.s',
    hazardClass: '4.2',
    idNumber: 'UN3200',
    packingGroup: 'I',
    labelCodes: '4.2',
    specialProvisions: 'T21, TP7, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '187',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Pyrophoric solids, organic, n.o.s',
    hazardClass: '4.2',
    idNumber: 'UN2846',
    packingGroup: 'I',
    labelCodes: '4.2',
    specialProvisions: 'W31',
    packagingExceptions: 'None',
    packagingNonBulk: '187',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: '',
    properShippingName: 'Pyrosulfuryl chloride',
    hazardClass: '8',
    idNumber: 'UN1817',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T8, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Pyrrolidine',
    hazardClass: '3',
    idNumber: 'UN1922',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'IB2, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Quinoline',
    hazardClass: '6.1',
    idNumber: 'UN2656',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 25',
  },
  {
    symbols: '',
    properShippingName:
      'Radioactive material, excepted package-articles manufactured from natural uranium or depleted uranium or natural thorium',
    hazardClass: '7',
    idNumber: 'UN2909',
    packingGroup: null,
    labelCodes: 'None',
    specialProvisions: '',
    packagingExceptions: '422, 426',
    packagingNonBulk: '422, 426',
    packagingBulk: '422, 426',
    passengerQtyLimit: '',
    cargoQtyLimit: '',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Radioactive material, excepted package-empty packaging',
    hazardClass: '7',
    idNumber: 'UN2908',
    packingGroup: null,
    labelCodes: 'Empty',
    specialProvisions: '368',
    packagingExceptions: '422, 428',
    packagingNonBulk: '422, 428',
    packagingBulk: '422, 428',
    passengerQtyLimit: '',
    cargoQtyLimit: '',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Radioactive material, excepted package-instruments or articles',
    hazardClass: '7',
    idNumber: 'UN2911',
    packingGroup: null,
    labelCodes: 'None',
    specialProvisions: '',
    packagingExceptions: '422, 424',
    packagingNonBulk: '422, 424',
    packagingBulk: '',
    passengerQtyLimit: '',
    cargoQtyLimit: '',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Radioactive material, excepted package-limited quantity of material',
    hazardClass: '7',
    idNumber: 'UN2910',
    packingGroup: null,
    labelCodes: 'None',
    specialProvisions: '368',
    packagingExceptions: '421, 422',
    packagingNonBulk: '421, 422',
    packagingBulk: '421, 422',
    passengerQtyLimit: '',
    cargoQtyLimit: '',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Radioactive material, low specific activity (LSA-I) non fissile or fissile-excepted',
    hazardClass: '7',
    idNumber: 'UN2912',
    packingGroup: null,
    labelCodes: '7',
    specialProvisions: '325, A56, T5, TP4, W7',
    packagingExceptions: '421, 422, 428',
    packagingNonBulk: '427',
    packagingBulk: '427',
    passengerQtyLimit: '',
    cargoQtyLimit: '',
    vesselStowageLocation: 'A',
    vesselStowageOther: '95, 129',
  },
  {
    symbols: '',
    properShippingName: 'Radioactive material, low specific activity (LSA-II) non fissile or fissile-excepted',
    hazardClass: '7',
    idNumber: 'UN3321',
    packingGroup: null,
    labelCodes: '7',
    specialProvisions: '325, A56, T5, TP4, W7',
    packagingExceptions: '421, 422, 428',
    packagingNonBulk: '427',
    packagingBulk: '427',
    passengerQtyLimit: '',
    cargoQtyLimit: '',
    vesselStowageLocation: 'A',
    vesselStowageOther: '95, 129',
  },
  {
    symbols: '',
    properShippingName: 'Radioactive material, low specific activity (LSA-III) non fissile or fissile excepted',
    hazardClass: '7',
    idNumber: 'UN3322',
    packingGroup: null,
    labelCodes: '7',
    specialProvisions: '325, A56, T5, TP4, W7',
    packagingExceptions: '421, 422, 428',
    packagingNonBulk: '427',
    packagingBulk: '427',
    passengerQtyLimit: '',
    cargoQtyLimit: '',
    vesselStowageLocation: 'A',
    vesselStowageOther: '95, 150',
  },
  {
    symbols: '',
    properShippingName:
      'Radioactive material, surface contaminated objects (SCO-I or SCO-II) non fissile or fissile-excepted',
    hazardClass: '7',
    idNumber: 'UN2913',
    packingGroup: null,
    labelCodes: '7',
    specialProvisions: '325, A56',
    packagingExceptions: '421, 422, 428',
    packagingNonBulk: '427',
    packagingBulk: '427',
    passengerQtyLimit: '',
    cargoQtyLimit: '',
    vesselStowageLocation: 'A',
    vesselStowageOther: '95',
  },
  {
    symbols: '',
    properShippingName: 'Radioactive material, transported under special arrangement, non fissile or fissile excepted',
    hazardClass: '7',
    idNumber: 'UN2919',
    packingGroup: null,
    labelCodes: '7',
    specialProvisions: '325, A56, 139',
    packagingExceptions: '',
    packagingNonBulk: '',
    packagingBulk: '',
    passengerQtyLimit: '',
    cargoQtyLimit: '',
    vesselStowageLocation: 'A',
    vesselStowageOther: '95, 105',
  },
  {
    symbols: '',
    properShippingName: 'Radioactive material, transported under special arrangement, fissile',
    hazardClass: '7',
    idNumber: 'UN3331',
    packingGroup: null,
    labelCodes: '7',
    specialProvisions: 'A56, 139',
    packagingExceptions: '',
    packagingNonBulk: '',
    packagingBulk: '',
    passengerQtyLimit: '',
    cargoQtyLimit: '',
    vesselStowageLocation: 'A',
    vesselStowageOther: '95, 105',
  },
  {
    symbols: '',
    properShippingName: 'Radioactive material, Type A package, fissile non-special form',
    hazardClass: '7',
    idNumber: 'UN3327',
    packingGroup: null,
    labelCodes: '7',
    specialProvisions: 'A56, W7, W8',
    packagingExceptions: '453',
    packagingNonBulk: '417',
    packagingBulk: '417',
    passengerQtyLimit: '',
    cargoQtyLimit: '',
    vesselStowageLocation: 'A',
    vesselStowageOther: '95, 105, 131',
  },
  {
    symbols: '',
    properShippingName: 'Radioactive material, Type A package non-special form, non fissile or fissile-excepted',
    hazardClass: '7',
    idNumber: 'UN2915',
    packingGroup: null,
    labelCodes: '7',
    specialProvisions: '325, A56, W7, W8',
    packagingExceptions: 'None',
    packagingNonBulk: '415, 418, 419',
    packagingBulk: '415, 418, 419',
    passengerQtyLimit: '',
    cargoQtyLimit: '',
    vesselStowageLocation: 'A',
    vesselStowageOther: '95, 130',
  },
  {
    symbols: '',
    properShippingName: 'Radioactive material, Type A package, special form non fissile or fissile-excepted',
    hazardClass: '7',
    idNumber: 'UN3332',
    packingGroup: null,
    labelCodes: '7',
    specialProvisions: 'A56, W7, W8',
    packagingExceptions: '',
    packagingNonBulk: '415, 476',
    packagingBulk: '415, 476',
    passengerQtyLimit: '',
    cargoQtyLimit: '',
    vesselStowageLocation: 'A',
    vesselStowageOther: '95',
  },
  {
    symbols: '',
    properShippingName: 'Radioactive material, Type A package, special form, fissile',
    hazardClass: '7',
    idNumber: 'UN3333',
    packingGroup: null,
    labelCodes: '7',
    specialProvisions: 'A56, W7, W8',
    packagingExceptions: '453',
    packagingNonBulk: '417, 476',
    packagingBulk: '417, 476',
    passengerQtyLimit: '',
    cargoQtyLimit: '',
    vesselStowageLocation: 'A',
    vesselStowageOther: '95, 105',
  },
  {
    symbols: '',
    properShippingName: 'Radioactive material, Type B(M) package, fissile',
    hazardClass: '7',
    idNumber: 'UN3329',
    packingGroup: null,
    labelCodes: '7',
    specialProvisions: 'A56',
    packagingExceptions: '453',
    packagingNonBulk: '417',
    packagingBulk: '417',
    passengerQtyLimit: '',
    cargoQtyLimit: '',
    vesselStowageLocation: 'A',
    vesselStowageOther: '95, 105',
  },
  {
    symbols: '',
    properShippingName: 'Radioactive material, Type B(M) package non fissile or fissile-excepted',
    hazardClass: '7',
    idNumber: 'UN2917',
    packingGroup: null,
    labelCodes: '7',
    specialProvisions: '325, A56',
    packagingExceptions: '',
    packagingNonBulk: '416',
    packagingBulk: '416',
    passengerQtyLimit: '',
    cargoQtyLimit: '',
    vesselStowageLocation: 'A',
    vesselStowageOther: '95, 105',
  },
  {
    symbols: '',
    properShippingName: 'Radioactive material, Type B(U) package, fissile',
    hazardClass: '7',
    idNumber: 'UN3328',
    packingGroup: null,
    labelCodes: '7',
    specialProvisions: 'A56',
    packagingExceptions: '453',
    packagingNonBulk: '417',
    packagingBulk: '417',
    passengerQtyLimit: '',
    cargoQtyLimit: '',
    vesselStowageLocation: 'A',
    vesselStowageOther: '95, 105',
  },
  {
    symbols: '',
    properShippingName: 'Radioactive material, Type B(U) package non fissile or fissile-excepted',
    hazardClass: '7',
    idNumber: 'UN2916',
    packingGroup: null,
    labelCodes: '7',
    specialProvisions: '325, A56',
    packagingExceptions: '',
    packagingNonBulk: '416',
    packagingBulk: '416',
    passengerQtyLimit: '',
    cargoQtyLimit: '',
    vesselStowageLocation: 'A',
    vesselStowageOther: '95, 105',
  },
  {
    symbols: '',
    properShippingName: 'Radioactive material, uranium hexafluoride non fissile or fissile-excepted',
    hazardClass: '7',
    idNumber: 'UN2978',
    packingGroup: null,
    labelCodes: '7, 6.1, 8',
    specialProvisions: '',
    packagingExceptions: '423',
    packagingNonBulk: '420, 427',
    packagingBulk: '420, 427',
    passengerQtyLimit: '',
    cargoQtyLimit: '',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 74, 95, 132, 151, 153',
  },
  {
    symbols: '',
    properShippingName: 'Radioactive material, uranium hexafluoride, fissile',
    hazardClass: '7',
    idNumber: 'UN2977',
    packingGroup: null,
    labelCodes: '7, 6.1, 8',
    specialProvisions: '',
    packagingExceptions: '453',
    packagingNonBulk: '417, 420',
    packagingBulk: '417, 420',
    passengerQtyLimit: '',
    cargoQtyLimit: '',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 74, 95, 132, 151, 153',
  },
  {
    symbols: 'A W',
    properShippingName: 'Rags, oily',
    hazardClass: '4.2',
    idNumber: 'UN1856',
    packingGroup: 'III',
    labelCodes: '4.2',
    specialProvisions: '',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'RDX and HMX mixtures, wetted with not less than 15 percent water by mass or RDX and HMX mixtures, desensitized with not less than 10 percent phlegmatizer by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0391',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName:
      'Receptacles, small, containing gas or gas cartridges (flammable) without release device, not refillable and not exceeding 1 L capacity',
    hazardClass: '2.1',
    idNumber: 'UN2037',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: 'None',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 157',
  },
  {
    symbols: '',
    properShippingName:
      'Receptacles, small, containing gas or gas cartridges (non-flammable) without release device, not refillable and not exceeding 1 L capacity',
    hazardClass: '2.2',
    idNumber: 'UN2037',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: 'None',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 157',
  },
  {
    symbols: '',
    properShippingName:
      'Receptacles, small, containing gas or gas cartridges (oxidizing), without release device, not refillable and not exceeding 1 L capacity',
    hazardClass: '2.2',
    idNumber: 'UN2037',
    packingGroup: null,
    labelCodes: '2.2, 5.1',
    specialProvisions: ', A14',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: 'None',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 157',
  },
  {
    symbols: '',
    properShippingName: 'Refrigerant gas R 404A',
    hazardClass: '2.2',
    idNumber: 'UN3337',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Refrigerant gas R 407A',
    hazardClass: '2.2',
    idNumber: 'UN3338',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Refrigerant gas R 407B',
    hazardClass: '2.2',
    idNumber: 'UN3339',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Refrigerant gas R 407C',
    hazardClass: '2.2',
    idNumber: 'UN3340',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Refrigerant gases, n.o.s.',
    hazardClass: '2.2',
    idNumber: 'UN1078',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'D',
    properShippingName: 'Refrigerant gases, n.o.s. or Dispersant gases, n.o.s.',
    hazardClass: '2.1',
    idNumber: 'NA1954',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Refrigerating machines, containing flammable, non-toxic, liquefied gas',
    hazardClass: '2.1',
    idNumber: 'UN3358',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '',
    packagingExceptions: '306, 307',
    packagingNonBulk: '306',
    packagingBulk: '306',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName:
      'Refrigerating machines, containing non-flammable, non-toxic gases, or ammonia solutions (UN2672)',
    hazardClass: '2.2',
    idNumber: 'UN2857',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'A53',
    packagingExceptions: '306, 307',
    packagingNonBulk: '306',
    packagingBulk: '306, 307',
    passengerQtyLimit: '450 kg',
    cargoQtyLimit: '450 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Regulated medical waste, n.o.s. or Clinical waste, unspecified, n.o.s. or (BIO) Medical waste, n.o.s. or Biomedical waste, n.o.s., or Medical Waste n.o.s.',
    hazardClass: '6.2',
    idNumber: 'UN3291',
    packingGroup: null,
    labelCodes: '6.2',
    specialProvisions: '41, 337, A13',
    packagingExceptions: '134',
    packagingNonBulk: '197',
    packagingBulk: '197',
    passengerQtyLimit: 'No limit',
    cargoQtyLimit: 'No limit',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Release devices, explosive',
    hazardClass: '1.4S',
    idNumber: 'UN0173',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Resin Solution, flammable',
    hazardClass: '3',
    idNumber: 'UN1866',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'B52, T11, TP1, TP8, TP28',
    packagingExceptions: '150',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Resorcinol',
    hazardClass: '6.1',
    idNumber: 'UN2876',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Rivets, explosive',
    hazardClass: '1.4S',
    idNumber: 'UN0174',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Rocket motors',
    hazardClass: '1.3C',
    idNumber: 'UN0186',
    packingGroup: null,
    labelCodes: '1.3C',
    specialProvisions: '109',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '220 kg',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Rocket motors',
    hazardClass: '1.1C',
    idNumber: 'UN0280',
    packingGroup: null,
    labelCodes: '1.1C',
    specialProvisions: '109',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Rocket motors',
    hazardClass: '1.2C',
    idNumber: 'UN0281',
    packingGroup: null,
    labelCodes: '1.2C',
    specialProvisions: '109',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Rocket motors',
    hazardClass: '1.4C',
    idNumber: 'UN0510',
    packingGroup: null,
    labelCodes: '1.4C',
    specialProvisions: '109',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Rocket motors, liquid fueled',
    hazardClass: '1.2J',
    idNumber: 'UN0395',
    packingGroup: null,
    labelCodes: '1.2J',
    specialProvisions: '109',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 23E',
  },
  {
    symbols: '',
    properShippingName: 'Rocket motors, liquid fueled',
    hazardClass: '1.3J',
    idNumber: 'UN0396',
    packingGroup: null,
    labelCodes: '1.3J',
    specialProvisions: '109',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 23E',
  },
  {
    symbols: '',
    properShippingName: 'Rocket motors with hypergolic liquids with or without an expelling charge',
    hazardClass: '1.3L',
    idNumber: 'UN0250',
    packingGroup: null,
    labelCodes: '1.3L',
    specialProvisions: '109',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 14E, 15E',
  },
  {
    symbols: '',
    properShippingName: 'Rocket motors with hypergolic liquids with or without an expelling charge',
    hazardClass: '1.2L',
    idNumber: 'UN0322',
    packingGroup: null,
    labelCodes: '1.2L',
    specialProvisions: '109',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 14E, 15E',
  },
  {
    symbols: '',
    properShippingName: 'Rockets, line-throwing',
    hazardClass: '1.2G',
    idNumber: 'UN0238',
    packingGroup: null,
    labelCodes: '1.2G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Rockets, line-throwing',
    hazardClass: '1.3G',
    idNumber: 'UN0240',
    packingGroup: null,
    labelCodes: '1.3G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Rockets, line-throwing',
    hazardClass: '1.4G',
    idNumber: 'UN0453',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Rockets, liquid fueled with bursting charge',
    hazardClass: '1.1J',
    idNumber: 'UN0397',
    packingGroup: null,
    labelCodes: '1.1J',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 23E',
  },
  {
    symbols: '',
    properShippingName: 'Rockets, liquid fueled with bursting charge',
    hazardClass: '1.2J',
    idNumber: 'UN0398',
    packingGroup: null,
    labelCodes: '1.2J',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 23E',
  },
  {
    symbols: '',
    properShippingName: 'Rockets, with bursting charge',
    hazardClass: '1.1F',
    idNumber: 'UN0180',
    packingGroup: null,
    labelCodes: '1.1F',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Rockets, with bursting charge',
    hazardClass: '1.1E',
    idNumber: 'UN0181',
    packingGroup: null,
    labelCodes: '1.1E',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Rockets, with bursting charge',
    hazardClass: '1.2E',
    idNumber: 'UN0182',
    packingGroup: null,
    labelCodes: '1.2E',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Rockets, with bursting charge',
    hazardClass: '1.2F',
    idNumber: 'UN0295',
    packingGroup: null,
    labelCodes: '1.2F',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Rockets, with expelling charge',
    hazardClass: '1.2C',
    idNumber: 'UN0436',
    packingGroup: null,
    labelCodes: '1.2C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Rockets, with expelling charge',
    hazardClass: '1.3C',
    idNumber: 'UN0437',
    packingGroup: null,
    labelCodes: '1.3C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Rockets, with expelling charge',
    hazardClass: '1.4C',
    idNumber: 'UN0438',
    packingGroup: null,
    labelCodes: '1.4C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Rockets, with inert head',
    hazardClass: '1.3C',
    idNumber: 'UN0183',
    packingGroup: null,
    labelCodes: '1.3C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Rockets, with inert head',
    hazardClass: '1.2C',
    idNumber: 'UN0502',
    packingGroup: null,
    labelCodes: '1.2C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25, 5E',
  },
  {
    symbols: '',
    properShippingName: 'Rosin oil',
    hazardClass: '3',
    idNumber: 'UN1286',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Rubber solution',
    hazardClass: '3',
    idNumber: 'UN1287',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: '149, IB2, T4, TP1, TP8',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Rubber scrap or shoddy, powdered or granulated, not exceeding 840 microns and rubber contend exceeding 45%',
    hazardClass: '4.1',
    idNumber: 'UN1345',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Rubidium',
    hazardClass: '4.3',
    idNumber: 'UN1423',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: '22, A7, A19, IB4, IP1, N34, N40, N45, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Rubidium hydroxide',
    hazardClass: '8',
    idNumber: 'UN2678',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '29, 52.',
  },
  {
    symbols: '',
    properShippingName: 'Rubidium hydroxide solution',
    hazardClass: '8',
    idNumber: 'UN2677',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '29, 52.',
  },
  {
    symbols: '',
    properShippingName: 'Safety devices, electrically initiated',
    hazardClass: '9',
    idNumber: 'UN3268',
    packingGroup: null,
    labelCodes: '9',
    specialProvisions: '160, A200',
    packagingExceptions: '166',
    packagingNonBulk: '166',
    packagingBulk: '166',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Safety devices, pyrotechnic',
    hazardClass: '1.4G',
    idNumber: 'UN0503',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: 'A200',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Samples, explosive, other than initiating explosives',
    hazardClass: '',
    idNumber: 'UN0190',
    packingGroup: null,
    labelCodes: '',
    specialProvisions: '113',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName:
      'Seed cake, containing vegetable oil solvent extractions and expelled seeds, with not more than 10 percent of oil and when the amount of moisture is higher than 11 percent, with not more than 20 percent of oil and moisture combined',
    hazardClass: '4.2',
    idNumber: 'UN1386',
    packingGroup: 'III',
    labelCodes: 'None',
    specialProvisions: 'B136, IB8, IP3, IP7, N7',
    packagingExceptions: 'None',
    packagingNonBulk: '213',
    packagingBulk: '241',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 25',
  },
  {
    symbols: 'I',
    properShippingName: 'Seed cake with more than 1.5 percent oil and not more than 11 percent moisture',
    hazardClass: '4.2',
    idNumber: 'UN1386',
    packingGroup: 'III',
    labelCodes: 'None',
    specialProvisions: 'B136, IB8, IP3, IP7, N7',
    packagingExceptions: 'None',
    packagingNonBulk: '213',
    packagingBulk: '241',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 25',
  },
  {
    symbols: 'I',
    properShippingName: 'Seed cake with not more than 1.5 percent oil and not more than 11 percent moisture',
    hazardClass: '4.2',
    idNumber: 'UN2217',
    packingGroup: 'III',
    labelCodes: 'None',
    specialProvisions: 'B136, IB8, IP3, IP7, N7',
    packagingExceptions: 'None',
    packagingNonBulk: '213',
    packagingBulk: '241',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 25, 120',
  },
  {
    symbols: 'G',
    properShippingName: 'Selenates or Selenites',
    hazardClass: '6.1',
    idNumber: 'UN2630',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Selenic acid',
    hazardClass: '8',
    idNumber: 'UN1905',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'IB7, IP1, N34, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: 'G',
    properShippingName: 'Selenium compound, liquid, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN3440',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T14, TP2, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Selenium compound, solid, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN3283',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Selenium disulfide',
    hazardClass: '6.1',
    idNumber: 'UN2657',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Selenium hexafluoride',
    hazardClass: '2.3',
    idNumber: 'UN2194',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '302',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Selenium oxychloride',
    hazardClass: '8',
    idNumber: 'UN2879',
    packingGroup: 'I',
    labelCodes: '8, 6.1',
    specialProvisions: 'A7, N34, T10, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '+ A D',
    properShippingName: 'Self-defense spray, non-pressurized',
    hazardClass: '9',
    idNumber: 'NA3334',
    packingGroup: 'III',
    labelCodes: '9',
    specialProvisions: 'A37',
    packagingExceptions: '155',
    packagingNonBulk: '203',
    packagingBulk: 'None',
    passengerQtyLimit: 'No limit',
    cargoQtyLimit: 'No limit',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-heating liquid, corrosive, inorganic, n.o.s',
    hazardClass: '4.2',
    idNumber: 'UN3188',
    packingGroup: 'II',
    labelCodes: '4.2, 8',
    specialProvisions: 'IB2, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-heating liquid, corrosive, organic, n.o.s',
    hazardClass: '4.2',
    idNumber: 'UN3185',
    packingGroup: 'II',
    labelCodes: '4.2, 8',
    specialProvisions: 'IB2, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-heating liquid, inorganic, n.o.s',
    hazardClass: '4.2',
    idNumber: 'UN3186',
    packingGroup: 'II',
    labelCodes: '4.2',
    specialProvisions: 'IB2, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-heating liquid, organic, n.o.s',
    hazardClass: '4.2',
    idNumber: 'UN3183',
    packingGroup: 'II',
    labelCodes: '4.2',
    specialProvisions: 'IB2, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-heating liquid, toxic, inorganic, n.o.s',
    hazardClass: '4.2',
    idNumber: 'UN3187',
    packingGroup: 'II',
    labelCodes: '4.2, 6.1',
    specialProvisions: 'IB2, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-heating liquid, toxic, organic, n.o.s',
    hazardClass: '4.2',
    idNumber: 'UN3184',
    packingGroup: 'II',
    labelCodes: '4.2, 6.1',
    specialProvisions: 'IB2, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-heating solid, corrosive, inorganic, n.o.s.',
    hazardClass: '4.2',
    idNumber: 'UN3192',
    packingGroup: 'II',
    labelCodes: '4.2, 8',
    specialProvisions: 'IB5, IP2, T3, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-heating solid, corrosive, organic, n.o.s',
    hazardClass: '4.2',
    idNumber: 'UN3126',
    packingGroup: 'II',
    labelCodes: '4.2, 8',
    specialProvisions: 'IB5, IP2, T3, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-heating solid, inorganic, n.o.s',
    hazardClass: '4.2',
    idNumber: 'UN3190',
    packingGroup: 'II',
    labelCodes: '4.2',
    specialProvisions: 'IB6, IP2, T3, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-heating solid, organic, n.o.s',
    hazardClass: '4.2',
    idNumber: 'UN3088',
    packingGroup: 'II',
    labelCodes: '4.2',
    specialProvisions: 'IB6, IP2, T3, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-heating solid, oxidizing, n.o.s.',
    hazardClass: '4.2',
    idNumber: 'UN3127',
    packingGroup: null,
    labelCodes: '4.2, 5.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '214',
    packagingBulk: '214',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-heating solid, toxic, inorganic, n.o.s.',
    hazardClass: '4.2',
    idNumber: 'UN3191',
    packingGroup: 'II',
    labelCodes: '4.2, 6.1',
    specialProvisions: 'IB5, IP2, T3, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-heating solid, toxic, organic, n.o.s',
    hazardClass: '4.2',
    idNumber: 'UN3128',
    packingGroup: 'II',
    labelCodes: '4.2, 6.1',
    specialProvisions: 'IB5, IP2, T3, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-reactive liquid type B',
    hazardClass: '4.1',
    idNumber: 'UN3221',
    packingGroup: null,
    labelCodes: '4.1',
    specialProvisions: '53',
    packagingExceptions: '151',
    packagingNonBulk: '224',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 52, 53, 127',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-reactive liquid type B, temperature controlled',
    hazardClass: '4.1',
    idNumber: 'UN3231',
    packingGroup: null,
    labelCodes: '4.1',
    specialProvisions: '53',
    packagingExceptions: 'None',
    packagingNonBulk: '224',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '2, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-reactive liquid type C',
    hazardClass: '4.1',
    idNumber: 'UN3223',
    packingGroup: null,
    labelCodes: '4.1',
    specialProvisions: '',
    packagingExceptions: '151',
    packagingNonBulk: '224',
    packagingBulk: 'None',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '10 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-reactive liquid type C, temperature controlled',
    hazardClass: '4.1',
    idNumber: 'UN3233',
    packingGroup: null,
    labelCodes: '4.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '224',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '2, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-reactive liquid type D',
    hazardClass: '4.1',
    idNumber: 'UN3225',
    packingGroup: null,
    labelCodes: '4.1',
    specialProvisions: '',
    packagingExceptions: '151',
    packagingNonBulk: '224',
    packagingBulk: 'None',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '10 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-reactive liquid type D, temperature controlled',
    hazardClass: '4.1',
    idNumber: 'UN3235',
    packingGroup: null,
    labelCodes: '4.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '224',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '2, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-reactive liquid type E',
    hazardClass: '4.1',
    idNumber: 'UN3227',
    packingGroup: null,
    labelCodes: '4.1',
    specialProvisions: '',
    packagingExceptions: '151',
    packagingNonBulk: '224',
    packagingBulk: 'None',
    passengerQtyLimit: '10 L',
    cargoQtyLimit: '25 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-reactive liquid type E, temperature controlled',
    hazardClass: '4.1',
    idNumber: 'UN3237',
    packingGroup: null,
    labelCodes: '4.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '224',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '2, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-reactive liquid type F',
    hazardClass: '4.1',
    idNumber: 'UN3229',
    packingGroup: null,
    labelCodes: '4.1',
    specialProvisions: '',
    packagingExceptions: '151',
    packagingNonBulk: '224',
    packagingBulk: 'None',
    passengerQtyLimit: '10 L',
    cargoQtyLimit: '25 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-reactive liquid type F, temperature controlled',
    hazardClass: '4.1',
    idNumber: 'UN3239',
    packingGroup: null,
    labelCodes: '4.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '224',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '2, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-reactive solid type B',
    hazardClass: '4.1',
    idNumber: 'UN3222',
    packingGroup: null,
    labelCodes: '4.1',
    specialProvisions: '53',
    packagingExceptions: '151',
    packagingNonBulk: '224',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 52, 53, 127',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-reactive solid type B, temperature controlled',
    hazardClass: '4.1',
    idNumber: 'UN3232',
    packingGroup: null,
    labelCodes: '4.1',
    specialProvisions: '53',
    packagingExceptions: 'None',
    packagingNonBulk: '224',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '2, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-reactive solid type C',
    hazardClass: '4.1',
    idNumber: 'UN3224',
    packingGroup: null,
    labelCodes: '4.1',
    specialProvisions: '',
    packagingExceptions: '151',
    packagingNonBulk: '224',
    packagingBulk: 'None',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '10 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-reactive solid type C, temperature controlled',
    hazardClass: '4.1',
    idNumber: 'UN3234',
    packingGroup: null,
    labelCodes: '4.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '224',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '2, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-reactive solid type D',
    hazardClass: '4.1',
    idNumber: 'UN3226',
    packingGroup: null,
    labelCodes: '4.1',
    specialProvisions: '',
    packagingExceptions: '151',
    packagingNonBulk: '224',
    packagingBulk: 'None',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '10 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-reactive solid type D, temperature controlled',
    hazardClass: '4.1',
    idNumber: 'UN3236',
    packingGroup: null,
    labelCodes: '4.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '224',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '2, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-reactive solid type E',
    hazardClass: '4.1',
    idNumber: 'UN3228',
    packingGroup: null,
    labelCodes: '4.1',
    specialProvisions: '',
    packagingExceptions: '151',
    packagingNonBulk: '224',
    packagingBulk: 'None',
    passengerQtyLimit: '10 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-reactive solid type E, temperature controlled',
    hazardClass: '4.1',
    idNumber: 'UN3238',
    packingGroup: null,
    labelCodes: '4.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '224',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '2, 25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-reactive solid type F',
    hazardClass: '4.1',
    idNumber: 'UN3230',
    packingGroup: null,
    labelCodes: '4.1',
    specialProvisions: '',
    packagingExceptions: '151',
    packagingNonBulk: '224',
    packagingBulk: 'None',
    passengerQtyLimit: '10 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 52, 53',
  },
  {
    symbols: 'G',
    properShippingName: 'Self-reactive solid type F, temperature controlled',
    hazardClass: '4.1',
    idNumber: 'UN3240',
    packingGroup: null,
    labelCodes: '4.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '224',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '2, 25, 52, 53',
  },
  {
    symbols: '',
    properShippingName: 'Shale oil',
    hazardClass: '3',
    idNumber: 'UN1288',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'T11, TP1, TP8, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Signal devices, hand',
    hazardClass: '1.4G',
    idNumber: 'UN0191',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '381',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Signal devices, hand',
    hazardClass: '1.4S',
    idNumber: 'UN0373',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '381',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Signals, distress, ship',
    hazardClass: '1.1G',
    idNumber: 'UN0194',
    packingGroup: null,
    labelCodes: '1.1G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Signals, distress, ship',
    hazardClass: '1.3G',
    idNumber: 'UN0195',
    packingGroup: null,
    labelCodes: '1.3G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Signals, distress, ship',
    hazardClass: '1.4G',
    idNumber: 'UN0505',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Signals, distress, ship',
    hazardClass: '1.4S',
    idNumber: 'UN0506',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Signals, railway track, explosive',
    hazardClass: '1.1G',
    idNumber: 'UN0192',
    packingGroup: null,
    labelCodes: '1.1G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Signals, railway track, explosive',
    hazardClass: '1.4S',
    idNumber: 'UN0193',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '381',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Signals, railway track, explosive',
    hazardClass: '1.3G',
    idNumber: 'UN0492',
    packingGroup: null,
    labelCodes: '1.3G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Signals, railway track, explosive',
    hazardClass: '1.4G',
    idNumber: 'UN0493',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Signals, smoke',
    hazardClass: '1.1G',
    idNumber: 'UN0196',
    packingGroup: null,
    labelCodes: '1.1G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Signals, smoke',
    hazardClass: '1.4G',
    idNumber: 'UN0197',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Signals, smoke',
    hazardClass: '1.2G',
    idNumber: 'UN0313',
    packingGroup: null,
    labelCodes: '1.2G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Signals, smoke',
    hazardClass: '1.3G',
    idNumber: 'UN0487',
    packingGroup: null,
    labelCodes: '1.3G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Signals, smoke',
    hazardClass: '1.4S',
    idNumber: 'UN0507',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Silane',
    hazardClass: '2.1',
    idNumber: 'UN2203',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '302',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40, 57, 104',
  },
  {
    symbols: '',
    properShippingName: 'Silicon powder, amorphous',
    hazardClass: '4.1',
    idNumber: 'UN1346',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: 'A1, IB8, IP3, T1, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '74',
  },
  {
    symbols: '',
    properShippingName: 'Silicon tetrachloride',
    hazardClass: '8',
    idNumber: 'UN1818',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A3, B2, B6, T10, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Silicon tetrafluoride',
    hazardClass: '2.3',
    idNumber: 'UN1859',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '2',
    packagingExceptions: 'None',
    packagingNonBulk: '302',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Silicon tetrafluoride, adsorbed',
    hazardClass: '2.3',
    idNumber: 'UN3521',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '2',
    packagingExceptions: 'None',
    packagingNonBulk: '302c',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Silver arsenite',
    hazardClass: '6.1',
    idNumber: 'UN1683',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Silver cyanide',
    hazardClass: '6.1',
    idNumber: 'UN1684',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Silver nitrate',
    hazardClass: '5.1',
    idNumber: 'UN1493',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Silver picrate, wetted with not less than 30 percent water, by mass',
    hazardClass: '4.1',
    idNumber: 'UN1347',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '23, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Sludge, acid',
    hazardClass: '8',
    idNumber: 'UN1906',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A3, A7, B2, IB2, N34, T8, TP2, TP28',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '14, 53, 58',
  },
  {
    symbols: 'D',
    properShippingName: 'Smokeless powder for small arms (100 pounds or less)',
    hazardClass: '4.1',
    idNumber: 'NA3178',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '16',
    packagingExceptions: 'None',
    packagingNonBulk: '171',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '7.3 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Soda lime with more than 4 percent sodium hydroxide',
    hazardClass: '8',
    idNumber: 'UN1907',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52.',
  },
  {
    symbols: '',
    properShippingName: 'Sodium',
    hazardClass: '4.3',
    idNumber: 'UN1428',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A7, A8, A19, A20, B9, B48, B68, IB4, IP1, N34, T9, TP7, TP33, TP46, W31',
    packagingExceptions: '151',
    packagingNonBulk: '211',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: 'A',
    properShippingName: 'Sodium aluminate, solid',
    hazardClass: '8',
    idNumber: 'UN2812',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Sodium aluminate, solution',
    hazardClass: '8',
    idNumber: 'UN1819',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52.',
  },
  {
    symbols: '',
    properShippingName: 'Sodium aluminum hydride',
    hazardClass: '4.3',
    idNumber: 'UN2835',
    packingGroup: 'II',
    labelCodes: '4.3',
    specialProvisions: 'A8, A19, A20, IB4, T3, TP33, W31, W40',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Sodium ammonium vanadate',
    hazardClass: '6.1',
    idNumber: 'UN2863',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Sodium arsanilate',
    hazardClass: '6.1',
    idNumber: 'UN2473',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Sodium arsenate',
    hazardClass: '6.1',
    idNumber: 'UN1685',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Sodium arsenite, aqueous solutions',
    hazardClass: '6.1',
    idNumber: 'UN1686',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Sodium arsenite, solid',
    hazardClass: '6.1',
    idNumber: 'UN2027',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Sodium azide',
    hazardClass: '6.1',
    idNumber: 'UN1687',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '36, 52, 91',
  },
  {
    symbols: '',
    properShippingName: 'Sodium borohydride',
    hazardClass: '4.3',
    idNumber: 'UN1426',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName:
      'Sodium borohydride and sodium hydroxide solution, with not more than 12 percent sodium borohydride and not more than 40 percent sodium hydroxide by mass',
    hazardClass: '8',
    idNumber: 'UN3320',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, N34, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Sodium bromate',
    hazardClass: '5.1',
    idNumber: 'UN1494',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Sodium cacodylate',
    hazardClass: '6.1',
    idNumber: 'UN1688',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Sodium carbonate peroxyhydrate',
    hazardClass: '5.1',
    idNumber: 'UN3378',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'B120, IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 25, 75',
  },
  {
    symbols: '',
    properShippingName: 'Sodium chlorate',
    hazardClass: '5.1',
    idNumber: 'UN1495',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'A9, IB8, IP2, IP4, N34, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Sodium chlorate, aqueous solution',
    hazardClass: '5.1',
    idNumber: 'UN2428',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'A2, IB2, T4, TP1',
    packagingExceptions: '152',
    packagingNonBulk: '202',
    packagingBulk: '241',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '56, 58, 133',
  },
  {
    symbols: '',
    properShippingName: 'Sodium chlorite',
    hazardClass: '5.1',
    idNumber: 'UN1496',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'A9, IB8, IP2, IP4, N34, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Sodium chloroacetate',
    hazardClass: '6.1',
    idNumber: 'UN2659',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Sodium cuprocyanide, solid',
    hazardClass: '6.1',
    idNumber: 'UN2316',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Sodium cuprocyanide, solution',
    hazardClass: '6.1',
    idNumber: 'UN2317',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T14, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Sodium cyanide, solid',
    hazardClass: '6.1',
    idNumber: 'UN1689',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'B69, B77, IB7, N74, N75, T6, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Sodium cyanide solution',
    hazardClass: '6.1',
    idNumber: 'UN3414',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'B69, B77, N74, N75, T14, TP2, TP13, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Sodium dinitro-o-cresolate, dry or wetted with less than 15 percent water, by mass',
    hazardClass: '1.3C',
    idNumber: 'UN0234',
    packingGroup: null,
    labelCodes: '1.3C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 5E',
  },
  {
    symbols: '',
    properShippingName: 'Sodium dinitro-o-cresolate, wetted with not less than 10% water, by mass',
    hazardClass: '4.1',
    idNumber: 'UN3369',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '162, A8, A19, N41, N84, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: '0.5 kg',
    cargoQtyLimit: '0.5 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Sodium dinitro-o-cresolate, wetted with not less than 15 percent water, by mass',
    hazardClass: '4.1',
    idNumber: 'UN1348',
    packingGroup: 'I',
    labelCodes: '4.1, 6.1',
    specialProvisions: '23, A8, A19, A20, N41, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Sodium dithionite or Sodium hydrosulfite',
    hazardClass: '4.2',
    idNumber: 'UN1384',
    packingGroup: 'II',
    labelCodes: '4.2',
    specialProvisions: 'A19, A20, IB6, IP2, T3, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13',
  },
  {
    symbols: '',
    properShippingName: 'Sodium fluoride, solid',
    hazardClass: '6.1',
    idNumber: 'UN1690',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Sodium fluoride solution',
    hazardClass: '6.1',
    idNumber: 'UN3415',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Sodium fluoroacetate',
    hazardClass: '6.1',
    idNumber: 'UN2629',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Sodium fluorosilicate',
    hazardClass: '6.1',
    idNumber: 'UN2674',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Sodium hydride',
    hazardClass: '4.3',
    idNumber: 'UN1427',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'A19, N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 52, 148',
  },
  {
    symbols: '',
    properShippingName: 'Sodium hydrogendifluoride',
    hazardClass: '8',
    idNumber: 'UN2439',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB8, IP2, IP4, N3, N34, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '12, 25, 40, 52, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Sodium hydrosulfide, with less than 25 percent water of crystallization',
    hazardClass: '4.2',
    idNumber: 'UN2318',
    packingGroup: 'II',
    labelCodes: '4.2',
    specialProvisions: 'A7, A19, A20, IB6, IP2, T3, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Sodium hydrosulfide with not less than 25 percent water of crystallization',
    hazardClass: '8',
    idNumber: 'UN2949',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, IB8, IP2, IP4, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Sodium hydroxide, solid',
    hazardClass: '8',
    idNumber: 'UN1823',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52.',
  },
  {
    symbols: '',
    properShippingName: 'Sodium hydroxide solution',
    hazardClass: '8',
    idNumber: 'UN1824',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, N34, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52.',
  },
  {
    symbols: '',
    properShippingName: 'Sodium methylate',
    hazardClass: '4.2',
    idNumber: 'UN1431',
    packingGroup: 'II',
    labelCodes: '4.2, 8',
    specialProvisions: 'A7, A19, IB5, IP2, T3, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Sodium methylate solutions in alcohol',
    hazardClass: '3',
    idNumber: 'UN1289',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'IB2, T7, TP1, TP8',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Sodium monoxide',
    hazardClass: '8',
    idNumber: 'UN1825',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52.',
  },
  {
    symbols: '',
    properShippingName: 'Sodium nitrate',
    hazardClass: '5.1',
    idNumber: 'UN1498',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: 'A1, A29, B120, IB8, IP3, T1, TP33, W1',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Sodium nitrate and potassium nitrate mixtures',
    hazardClass: '5.1',
    idNumber: 'UN1499',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: 'A1, A29, B120, IB8, IP3, T1, TP33, W1',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Sodium nitrite',
    hazardClass: '5.1',
    idNumber: 'UN1500',
    packingGroup: 'III',
    labelCodes: '5.1, 6.1',
    specialProvisions: 'A1, A29, IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Sodium pentachlorophenate',
    hazardClass: '6.1',
    idNumber: 'UN2567',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Sodium perborate monohydrate',
    hazardClass: '5.1',
    idNumber: 'UN3377',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: 'B120, IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 25, 75',
  },
  {
    symbols: '',
    properShippingName: 'Sodium perchlorate',
    hazardClass: '5.1',
    idNumber: 'UN1502',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB6, IP2, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Sodium permanganate',
    hazardClass: '5.1',
    idNumber: 'UN1503',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB6, IP2, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '56, 58, 138',
  },
  {
    symbols: '',
    properShippingName: 'Sodium peroxide',
    hazardClass: '5.1',
    idNumber: 'UN1504',
    packingGroup: 'I',
    labelCodes: '5.1',
    specialProvisions: 'A20, IB5, IP1, N34',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '13, 52, 66, 75, 148',
  },
  {
    symbols: '',
    properShippingName: 'Sodium peroxoborate, anhydrous',
    hazardClass: '5.1',
    idNumber: 'UN3247',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 25',
  },
  {
    symbols: '',
    properShippingName: 'Sodium persulfate',
    hazardClass: '5.1',
    idNumber: 'UN1505',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: 'A1, IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '58, 145',
  },
  {
    symbols: '',
    properShippingName: 'Sodium phosphide',
    hazardClass: '4.3',
    idNumber: 'UN1432',
    packingGroup: 'I',
    labelCodes: '4.3, 6.1',
    specialProvisions: 'A19, N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 52, 85, 148',
  },
  {
    symbols: '',
    properShippingName: 'Sodium picramate, dry or wetted with less than 20 percent water, by mass',
    hazardClass: '1.3C',
    idNumber: 'UN0235',
    packingGroup: null,
    labelCodes: '1.3C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 5E',
  },
  {
    symbols: '',
    properShippingName: 'Sodium picramate, wetted with not less than 20 percent water, by mass',
    hazardClass: '4.1',
    idNumber: 'UN1349',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '23, A8, A19, N41, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName:
      'Sodium sulfide, anhydrous or Sodium sulfide with less than 30 percent water of crystallization',
    hazardClass: '4.2',
    idNumber: 'UN1385',
    packingGroup: 'II',
    labelCodes: '4.2',
    specialProvisions: 'A19, A20, IB6, IP2, N34, T3, TP33, W31, W40',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Sodium sulfide, hydrated with not less than 30 percent water',
    hazardClass: '8',
    idNumber: 'UN1849',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52.',
  },
  {
    symbols: '',
    properShippingName: 'Sodium superoxide',
    hazardClass: '5.1',
    idNumber: 'UN2547',
    packingGroup: 'I',
    labelCodes: '5.1',
    specialProvisions: 'A20, IB6, IP1, N34',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 52, 66, 75, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Solids containing corrosive liquid, n.o.s.',
    hazardClass: '8',
    idNumber: 'UN3244',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: '49, IB5, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Solids containing flammable liquid, n.o.s.',
    hazardClass: '4.1',
    idNumber: 'UN3175',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: '47, IB6, IP2, T3, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Solids containing toxic liquid, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN3243',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: '48, IB2, T2, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Sounding devices, explosive',
    hazardClass: '1.2F',
    idNumber: 'UN0204',
    packingGroup: null,
    labelCodes: '1.2F',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Sounding devices, explosive',
    hazardClass: '1.1F',
    idNumber: 'UN0296',
    packingGroup: null,
    labelCodes: '1.1F',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Sounding devices, explosive',
    hazardClass: '1.1D',
    idNumber: 'UN0374',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Sounding devices, explosive',
    hazardClass: '1.2D',
    idNumber: 'UN0375',
    packingGroup: null,
    labelCodes: '1.2D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Stannic chloride, anhydrous',
    hazardClass: '8',
    idNumber: 'UN1827',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Stannic chloride pentahydrate',
    hazardClass: '8',
    idNumber: 'UN2440',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Stannic phosphide',
    hazardClass: '4.3',
    idNumber: 'UN1433',
    packingGroup: 'I',
    labelCodes: '4.3, 6.1',
    specialProvisions: 'A19, N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 52, 85, 148',
  },
  {
    symbols: '',
    properShippingName: 'Stibine',
    hazardClass: '2.3',
    idNumber: 'UN2676',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Strontium arsenite',
    hazardClass: '6.1',
    idNumber: 'UN1691',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Strontium chlorate',
    hazardClass: '5.1',
    idNumber: 'UN1506',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'A1, A9, IB8, IP2, IP4, N34, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Strontium nitrate',
    hazardClass: '5.1',
    idNumber: 'UN1507',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: 'A1, A29, IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Strontium perchlorate',
    hazardClass: '5.1',
    idNumber: 'UN1508',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB6, IP2, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Strontium peroxide',
    hazardClass: '5.1',
    idNumber: 'UN1509',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB6, IP2, T3, TP33, W100',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '13, 52, 66, 75, 148',
  },
  {
    symbols: '',
    properShippingName: 'Strontium phosphide',
    hazardClass: '4.3',
    idNumber: 'UN2013',
    packingGroup: 'I',
    labelCodes: '4.3, 6.1',
    specialProvisions: 'A19, N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 52, 85, 148',
  },
  {
    symbols: '',
    properShippingName: 'Strychnine or Strychnine salts',
    hazardClass: '6.1',
    idNumber: 'UN1692',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Styrene monomer, stabilized',
    hazardClass: '3',
    idNumber: 'UN2055',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: '387, B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Substances, explosive, n.o.s.',
    hazardClass: '1.1L',
    idNumber: 'UN0357',
    packingGroup: null,
    labelCodes: '1.1L',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 14E, 15E',
  },
  {
    symbols: 'G',
    properShippingName: 'Substances, explosive, n.o.s.',
    hazardClass: '1.2L',
    idNumber: 'UN0358',
    packingGroup: null,
    labelCodes: '1.2L',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 14E, 15E',
  },
  {
    symbols: 'G',
    properShippingName: 'Substances, explosive, n.o.s.',
    hazardClass: '1.3L',
    idNumber: 'UN0359',
    packingGroup: null,
    labelCodes: '1.3L',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 14E, 15E',
  },
  {
    symbols: 'G',
    properShippingName: 'Substances, explosive, n.o.s.',
    hazardClass: '1.1A',
    idNumber: 'UN0473',
    packingGroup: null,
    labelCodes: '1.1A',
    specialProvisions: '101, 111',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Substances, explosive, n.o.s.',
    hazardClass: '1.1C',
    idNumber: 'UN0474',
    packingGroup: null,
    labelCodes: '1.1C',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Substances, explosive, n.o.s.',
    hazardClass: '1.1D',
    idNumber: 'UN0475',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Substances, explosive, n.o.s.',
    hazardClass: '1.1G',
    idNumber: 'UN0476',
    packingGroup: null,
    labelCodes: '1.1G',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Substances, explosive, n.o.s.',
    hazardClass: '1.3C',
    idNumber: 'UN0477',
    packingGroup: null,
    labelCodes: '1.3C',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Substances, explosive, n.o.s.',
    hazardClass: '1.3G',
    idNumber: 'UN0478',
    packingGroup: null,
    labelCodes: '1.3G',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Substances, explosive, n.o.s.',
    hazardClass: '1.4C',
    idNumber: 'UN0479',
    packingGroup: null,
    labelCodes: '1.4C',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Substances, explosive, n.o.s.',
    hazardClass: '1.4D',
    idNumber: 'UN0480',
    packingGroup: null,
    labelCodes: '1.4D',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Substances, explosive, n.o.s',
    hazardClass: '1.4S',
    idNumber: 'UN0481',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '101, 347',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Substances, explosive, n.o.s.',
    hazardClass: '1.4G',
    idNumber: 'UN0485',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Substances, explosive, very insensitive, n.o.s. or Substances, EVI, n.o.s.',
    hazardClass: '1.5D',
    idNumber: 'UN0482',
    packingGroup: null,
    labelCodes: '1.5D',
    specialProvisions: '101',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName:
      'Substituted nitrophenol pesticides, liquid, flammable, toxic, flash point less than 23 degrees C',
    hazardClass: '3',
    idNumber: 'UN2780',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Substituted nitrophenol pesticides, liquid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN3014',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName:
      'Substituted nitrophenol pesticides, liquid, toxic, flammable, flash point not less than 23 degrees C',
    hazardClass: '6.1',
    idNumber: 'UN3013',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Substituted nitrophenol pesticides, solid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN2779',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Sulfamic acid',
    hazardClass: '8',
    idNumber: 'UN2967',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: 'D',
    properShippingName: 'Sulfur',
    hazardClass: '9',
    idNumber: 'NA1350',
    packingGroup: 'III',
    labelCodes: '9',
    specialProvisions: '30, B120, IB8, IP2',
    packagingExceptions: 'None',
    packagingNonBulk: 'None',
    packagingBulk: '240',
    passengerQtyLimit: 'No Limit',
    cargoQtyLimit: 'No Limit',
    vesselStowageLocation: 'A',
    vesselStowageOther: '25, 74',
  },
  {
    symbols: 'I',
    properShippingName: 'Sulfur',
    hazardClass: '4.1',
    idNumber: 'UN1350',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: '30, B120, IB8, IP3, T1, TP33',
    packagingExceptions: '151',
    packagingNonBulk: 'None',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '25, 74',
  },
  {
    symbols: '',
    properShippingName: 'Sulfur chlorides',
    hazardClass: '8',
    idNumber: 'UN1828',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: '5, A7, A10, B10, B77, N34, T20, TP2',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Sulfur dioxide',
    hazardClass: '2.3',
    idNumber: 'UN1079',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '3, B14, T50, TP19',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Sulfur hexafluoride',
    hazardClass: '2.2',
    idNumber: 'UN1080',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'D',
    properShippingName: 'Sulfur, molten',
    hazardClass: '9',
    idNumber: 'NA2448',
    packingGroup: 'III',
    labelCodes: '9',
    specialProvisions: '30,B13, IB3, R1, T1, TP3',
    packagingExceptions: 'None',
    packagingNonBulk: '213',
    packagingBulk: '247',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'C',
    vesselStowageOther: '61',
  },
  {
    symbols: 'I',
    properShippingName: 'Sulfur, molten',
    hazardClass: '4.1',
    idNumber: 'UN2448',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: '30, B13, IB1, R1, T1, TP3',
    packagingExceptions: 'None',
    packagingNonBulk: '213',
    packagingBulk: '247',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'C',
    vesselStowageOther: '74',
  },
  {
    symbols: '',
    properShippingName: 'Sulfur tetrafluoride',
    hazardClass: '2.3',
    idNumber: 'UN2418',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '302',
    packagingBulk: '245',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '+',
    properShippingName: 'Sulfur trioxide, stabilized',
    hazardClass: '8',
    idNumber: 'UN1829',
    packingGroup: 'I',
    labelCodes: '8, 6.1',
    specialProvisions: '2, 387, B9, B14, B32, B49, B77, N34, T20, TP4, TP13, TP25, TP26, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '25, 40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Sulfuric acid, fuming with less than 30 percent free sulfur trioxide',
    hazardClass: '8',
    idNumber: 'UN1831',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'A7, N34, T20, TP2,TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '14, 40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Sulfuric acid, fuming with 30 percent or more free sulfur trioxide',
    hazardClass: '8',
    idNumber: 'UN1831',
    packingGroup: 'I',
    labelCodes: '8, 6.1',
    specialProvisions: '2, B9, B14, B32, B77, B84, N34, T20, TP2, TP12, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'C',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Sulfuric acid, spent',
    hazardClass: '8',
    idNumber: 'UN1832',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A3, A7, B2, B83, B84, IB2, N34, T8, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '14, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Sulfuric acid with more than 51 percent acid',
    hazardClass: '8',
    idNumber: 'UN1830',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A3, A7, B3, B83, B84, IB2, N34, T8, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '14, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Sulfuric acid with not more than 51% acid',
    hazardClass: '8',
    idNumber: 'UN2796',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: '386, A3, A7, B2, B15, IB2, N6, N34, T8, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Sulfurous acid',
    hazardClass: '8',
    idNumber: 'UN1833',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B3, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '+',
    properShippingName: 'Sulfuryl chloride',
    hazardClass: '6.1',
    idNumber: 'UN1834',
    packingGroup: 'I',
    labelCodes: '6.1, 8',
    specialProvisions: '1, B6, B9, B10, B14, B30, B77, N34, T22, TP2, TP13, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Sulfuryl fluoride',
    hazardClass: '2.3',
    idNumber: 'UN2191',
    packingGroup: null,
    labelCodes: '2.3',
    specialProvisions: '4',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Tars, liquid including road oils and cutback bitumens',
    hazardClass: '3',
    idNumber: 'UN1999',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: '149, B13, IB2, T3, TP3, TP29',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Tear gas candles',
    hazardClass: '6.1',
    idNumber: 'UN1700',
    packingGroup: null,
    labelCodes: '6.1, 4.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '340',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'D',
    properShippingName: 'Tear gas devices with more than 2 percent tear gas substances, by mass',
    hazardClass: '6.1',
    idNumber: 'NA1693',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '340',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Tear gas substances, liquid, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN1693',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'W31',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Tear gas substance, solid, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN3448',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T6, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Tellurium compound, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN3284',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Tellurium hexafluoride',
    hazardClass: '2.3',
    idNumber: 'UN2195',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '1',
    packagingExceptions: 'None',
    packagingNonBulk: '302',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Terpene hydrocarbons, n.o.s.',
    hazardClass: '3',
    idNumber: 'UN2319',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T4, TP1, TP29',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Terpinolene',
    hazardClass: '3',
    idNumber: 'UN2541',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Tetrabromoethane',
    hazardClass: '6.1',
    idNumber: 'UN2504',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '1,1,2,2-Tetrachloroethane',
    hazardClass: '6.1',
    idNumber: 'UN1702',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, N36, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Tetrachloroethylene',
    hazardClass: '6.1',
    idNumber: 'UN1897',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, N36, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Tetraethyl dithiopyrophosphate',
    hazardClass: '6.1',
    idNumber: 'UN1704',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Tetraethyl silicate',
    hazardClass: '3',
    idNumber: 'UN1292',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Tetraethylenepentamine',
    hazardClass: '8',
    idNumber: 'UN2320',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52.',
  },
  {
    symbols: '',
    properShippingName: '1,1,1,2-Tetrafluoroethane or Refrigerant gas R 134a',
    hazardClass: '2.2',
    idNumber: 'UN3159',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Tetrafluoroethylene, stabilized',
    hazardClass: '2.1',
    idNumber: 'UN1081',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '387',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Tetrafluoromethane or Refrigerant gas R 14',
    hazardClass: '2.2',
    idNumber: 'UN1982',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '302',
    packagingBulk: 'None',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '1,2,3,6-Tetrahydrobenzaldehyde',
    hazardClass: '3',
    idNumber: 'UN2498',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Tetrahydrofuran',
    hazardClass: '3',
    idNumber: 'UN2056',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Tetrahydrofurfurylamine',
    hazardClass: '3',
    idNumber: 'UN2943',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Tetrahydrophthalic anhydrides with more than 0.05 percent of maleic anhydride',
    hazardClass: '8',
    idNumber: 'UN2698',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: '1,2,3,6-Tetrahydropyridine',
    hazardClass: '3',
    idNumber: 'UN2410',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Tetrahydrothiophene',
    hazardClass: '3',
    idNumber: 'UN2412',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Tetramethylammonium hydroxide, solid',
    hazardClass: '8',
    idNumber: 'UN3423',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Tetramethylammonium hydroxide solution',
    hazardClass: '8',
    idNumber: 'UN1835',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Tetramethylsilane',
    hazardClass: '3',
    idNumber: 'UN2749',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'A7, T14, TP2',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Tetranitroaniline',
    hazardClass: '1.1D',
    idNumber: 'UN0207',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '+',
    properShippingName: 'Tetranitromethane',
    hazardClass: '6.1',
    idNumber: 'UN1510',
    packingGroup: 'I',
    labelCodes: '6.1, 5.1',
    specialProvisions: '2, B32, T20, TP2, TP13, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 66',
  },
  {
    symbols: '',
    properShippingName: 'Tetrapropylorthotitanate',
    hazardClass: '3',
    idNumber: 'UN2413',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Tetrazol-1-acetic acid',
    hazardClass: '1.4C',
    idNumber: 'UN0407',
    packingGroup: null,
    labelCodes: '1.4C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: '1H-Tetrazole',
    hazardClass: '1.1D',
    idNumber: 'UN0504',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 5E',
  },
  {
    symbols: 'A I W',
    properShippingName: 'Textile waste, wet',
    hazardClass: '4.2',
    idNumber: 'UN1857',
    packingGroup: 'III',
    labelCodes: '4.2',
    specialProvisions: '',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Thallium chlorate',
    hazardClass: '5.1',
    idNumber: 'UN2573',
    packingGroup: 'II',
    labelCodes: '5.1, 6.1',
    specialProvisions: 'IB6, IP2, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: 'G',
    properShippingName: 'Thallium compounds, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN1707',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Thallium nitrate',
    hazardClass: '6.1',
    idNumber: 'UN2727',
    packingGroup: 'II',
    labelCodes: '6.1, 5.1',
    specialProvisions: 'IB6, IP2, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '4-Thiapentanal',
    hazardClass: '6.1',
    idNumber: 'UN2785',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1, W31',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 49',
  },
  {
    symbols: '',
    properShippingName: 'Thioacetic acid',
    hazardClass: '3',
    idNumber: 'UN2436',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Thiocarbamate pesticide, liquid, flammable, toxic, flash point less than 23 degrees C',
    hazardClass: '3',
    idNumber: 'UN2772',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Thiocarbamate pesticide, liquid, toxic, flammable, flash point not less than 23 degrees C',
    hazardClass: '6.1',
    idNumber: 'UN3005',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: 'T14, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Thiocarbamate pesticide, liquid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN3006',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T14, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Thiocarbamate pesticides, solid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN2771',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Thioglycol',
    hazardClass: '6.1',
    idNumber: 'UN2966',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Thioglycolic acid',
    hazardClass: '8',
    idNumber: 'UN1940',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, B2, IB2, N34, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Thiolactic acid',
    hazardClass: '6.1',
    idNumber: 'UN2936',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Thionyl chloride',
    hazardClass: '8',
    idNumber: 'UN1836',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'B6, B10, N34, T10, TP2, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Thiophene',
    hazardClass: '3',
    idNumber: 'UN2414',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '+',
    properShippingName: 'Thiophosgene',
    hazardClass: '6.1',
    idNumber: 'UN2474',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '2, B9, B14, B32, N33, N34, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Thiophosphoryl chloride',
    hazardClass: '8',
    idNumber: 'UN1837',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A3, A7, B2, B8, B25, IB2, N34, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Thiourea dioxide',
    hazardClass: '4.2',
    idNumber: 'UN3341',
    packingGroup: 'II',
    labelCodes: '4.2',
    specialProvisions: 'IB6, IP2, T3, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Tinctures, medicinal',
    hazardClass: '3',
    idNumber: 'UN1293',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1, TP8',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Titanium disulphide',
    hazardClass: '4.2',
    idNumber: 'UN3174',
    packingGroup: 'III',
    labelCodes: '4.2',
    specialProvisions: 'IB8, IP3, T1, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '213',
    packagingBulk: '241',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Titanium hydride',
    hazardClass: '4.1',
    idNumber: 'UN1871',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: 'A19, A20, IB4, N34, T3, TP33, W31, W40',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Titanium powder, dry',
    hazardClass: '4.2',
    idNumber: 'UN2546',
    packingGroup: 'I',
    labelCodes: '4.2',
    specialProvisions: 'W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: '',
    properShippingName:
      'Titanium powder, wetted with not less than 25 percent water (a visible excess of water must be present) (a) mechanically produced, particle size less than 53 microns; (b) chemically produced, particle size less than 840 microns',
    hazardClass: '4.1',
    idNumber: 'UN1352',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: 'A19, A20, IB6, IP2, N34, T3, TP33, W31, W40',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '74',
  },
  {
    symbols: '',
    properShippingName: 'Titanium sponge granules or Titanium sponge powders',
    hazardClass: '4.1',
    idNumber: 'UN2878',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: 'A1, B134, IB8, IP21, T1, TP33, W100',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 74, 147, 148',
  },
  {
    symbols: '+',
    properShippingName: 'Titanium tetrachloride',
    hazardClass: '6.1',
    idNumber: 'UN1838',
    packingGroup: 'I',
    labelCodes: '6.1, 8',
    specialProvisions: '2, B7, B9, B14, B32, B77, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Titanium trichloride mixtures',
    hazardClass: '8',
    idNumber: 'UN2869',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, IB8, IP2, IP4, N34, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Titanium trichloride, pyrophoric or Titanium trichloride mixtures, pyrophoric',
    hazardClass: '4.2',
    idNumber: 'UN2441',
    packingGroup: 'I',
    labelCodes: '4.2, 8',
    specialProvisions: 'N34, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '181',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 40, 148',
  },
  {
    symbols: '',
    properShippingName: 'Toluene',
    hazardClass: '3',
    idNumber: 'UN1294',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '+',
    properShippingName: 'Toluene diisocyanate',
    hazardClass: '6.1',
    idNumber: 'UN2078',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2, TP13',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '+',
    properShippingName: 'Toluidines, liquid',
    hazardClass: '6.1',
    idNumber: 'UN1708',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Toluidines, solid',
    hazardClass: '6.1',
    idNumber: 'UN3451',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '2,4-Toluylenediamine, solid or 2,4-Toluenediamine, solid',
    hazardClass: '6.1',
    idNumber: 'UN1709',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '2,4-Toluylenediamine solution or 2,4-Toluenediamine solution',
    hazardClass: '6.1',
    idNumber: 'UN3418',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Torpedoes, liquid fueled, with inert head',
    hazardClass: '1.3J',
    idNumber: 'UN0450',
    packingGroup: null,
    labelCodes: '1.3J',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 23E',
  },
  {
    symbols: '',
    properShippingName: 'Torpedoes, liquid fueled, with or without bursting charge',
    hazardClass: '1.1J',
    idNumber: 'UN0449',
    packingGroup: null,
    labelCodes: '1.1J',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '05',
    vesselStowageOther: '25, 23E',
  },
  {
    symbols: '',
    properShippingName: 'Torpedoes with bursting charge',
    hazardClass: '1.1E',
    idNumber: 'UN0329',
    packingGroup: null,
    labelCodes: '1.1E',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Torpedoes with bursting charge',
    hazardClass: '1.1F',
    idNumber: 'UN0330',
    packingGroup: null,
    labelCodes: '1.1F',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Torpedoes with bursting charge',
    hazardClass: '1.1D',
    idNumber: 'UN0451',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: '',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName:
      'Toxic by inhalation liquid, flammable, corrosive, n.o.s. with an LC50 lower than or equal to 200 ml/m3 and saturated vapor concentration greater than or equal to 500 LC50',
    hazardClass: '6.1',
    idNumber: 'UN3488',
    packingGroup: 'I',
    labelCodes: '6.1, 3, 8',
    specialProvisions: '1, B9, B14, B30, T22, TP2, TP13, TP27, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 125',
  },
  {
    symbols: 'G',
    properShippingName:
      'Toxic by inhalation liquid, flammable, corrosive, n.o.s. with an LC50 lower than or equal to 1000 ml/m3 and saturated vapor concentration greater than or equal to 10 LC50',
    hazardClass: '6.1',
    idNumber: 'UN3489',
    packingGroup: 'I',
    labelCodes: '6.1, 3, 8',
    specialProvisions: '2, B9, B14, B32, T20, TP2, TP13, TP27, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 125',
  },
  {
    symbols: 'G',
    properShippingName:
      'Toxic by inhalation liquid, n.o.s. with an LC50 lower than or equal to 200 ml/m3 and saturated vapor concentration greater than or equal to 500 LC50',
    hazardClass: '6.1',
    idNumber: 'UN3381',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '1, B9, B14, B30, T22, TP2, TP13, TP27, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName:
      'Toxic by inhalation liquid, n.o.s. with an LC50 lower than or equal to 1000 ml/m3 and saturated vapor concentration greater than or equal to 10 LC50',
    hazardClass: '6.1',
    idNumber: 'UN3382',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '2, B9, B14, B32, T20, TP2, TP13, TP27, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName:
      'Toxic by inhalation liquid, flammable, n.o.s. with an LC50 lower than or equal to 200 ml/m3 and saturated vapor concentration greater than or equal to 500 LC50',
    hazardClass: '6.1',
    idNumber: 'UN3383',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '1, B9, B14, B30, T22, TP2, TP13, TP27, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName:
      'Toxic by inhalation liquid, flammable, n.o.s. with an LC50 lower than or equal to 1000 ml/m3 and saturated vapor concentration greater than or equal to 10 LC50',
    hazardClass: '6.1',
    idNumber: 'UN3384',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '2, B9, B14, B32, T20, TP2, TP13, TP27, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName:
      'Toxic by inhalation liquid, water-reactive, n.o.s. with an LC50 lower than or equal to 200 ml/m3 and saturated vapor concentration greater than or equal to 500 LC50',
    hazardClass: '6.1',
    idNumber: 'UN3385',
    packingGroup: 'I',
    labelCodes: '6.1, 4.3',
    specialProvisions: '1, B9, B14, B30, T22, TP2, TP13, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 40, 148',
  },
  {
    symbols: 'G',
    properShippingName:
      'Toxic by inhalation liquid, water-reactive, n.o.s. with an LC50 lower than or equal to 1000 ml/m3 and saturated vapor concentration greater than or equal to 10 LC50',
    hazardClass: '6.1',
    idNumber: 'UN3386',
    packingGroup: 'I',
    labelCodes: '6.1, 4.3',
    specialProvisions: '2, B9, B14, B32, T20, TP2, TP13, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 40, 148',
  },
  {
    symbols: 'G',
    properShippingName:
      'Toxic by inhalation liquid, water-reactive, flammable, n.o.s. with an LC50 lower than or equal to 200 ml/m3 and saturated vapor concentration greater than or equal to 500 LC50',
    hazardClass: '6.1',
    idNumber: 'UN3490',
    packingGroup: 'I',
    labelCodes: '6.1, 4.3, 3',
    specialProvisions: '1, B9, B14, B30, T22, TP2, TP13, TP27, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 21, 40, 49, 148',
  },
  {
    symbols: 'G',
    properShippingName:
      'Toxic by inhalation liquid, water-reactive, flammable, n.o.s. with an LC50 lower or equal to 1000 ml/m3 and saturated vapor concentration greater than or equal to 10 LC50',
    hazardClass: '6.1',
    idNumber: 'UN3491',
    packingGroup: 'I',
    labelCodes: '6.1, 4.3, 3',
    specialProvisions: '2, B9, B14, B32, T20, TP2, TP13, TP27, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 21, 28, 40, 49, 148',
  },
  {
    symbols: 'G',
    properShippingName:
      'Toxic by inhalation liquid, oxidizing, n.o.s. with an LC50 lower than or equal to 200 ml/m3 and saturated vapor concentration greater than or equal to 500 LC50',
    hazardClass: '6.1',
    idNumber: 'UN3387',
    packingGroup: 'I',
    labelCodes: '6.1, 5.1',
    specialProvisions: '1, B9, B14, B30, T22, TP2, TP13, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName:
      'Toxic by inhalation liquid, oxidizing, n.o.s. with an LC50 lower than or equal to 1000 ml/m3 and saturated vapor concentration greater than or equal to 10 LC50',
    hazardClass: '6.1',
    idNumber: 'UN3388',
    packingGroup: 'I',
    labelCodes: '6.1, 5.1',
    specialProvisions: '2, B9, B14, B32, T20, TP2, TP13, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName:
      'Toxic by inhalation liquid, corrosive, n.o.s. with an LC50 lower than or equal to 200 ml/m3 and saturated vapor concentration greater than or equal to 500 LC50',
    hazardClass: '6.1',
    idNumber: 'UN3389',
    packingGroup: 'I',
    labelCodes: '6.1, 8',
    specialProvisions: '1, B9, B14, B30, T22, TP2, TP13, TP27, TP38, TP44',
    packagingExceptions: 'None',
    packagingNonBulk: '226',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName:
      'Toxic by inhalation liquid, corrosive, n.o.s. with an LC50 lower than or equal to 1000 ml/m3 and saturated vapor concentration greater than or equal to 10 LC50',
    hazardClass: '6.1',
    idNumber: 'UN3390',
    packingGroup: 'I',
    labelCodes: '6.1, 8',
    specialProvisions: '2, B9, B14, B32, T20, TP2, TP13, TP27, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Toxic liquid, corrosive, inorganic, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN3289',
    packingGroup: 'I',
    labelCodes: '6.1, 8',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Toxic liquid, inorganic, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN3287',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Toxic liquids, corrosive, organic, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN2927',
    packingGroup: 'I',
    labelCodes: '6.1, 8',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Toxic liquids, flammable, organic, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN2929',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Toxic, liquids, organic, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN2810',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Toxic liquids, oxidizing, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN3122',
    packingGroup: 'I',
    labelCodes: '6.1, 5.1',
    specialProvisions: 'A4',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Toxic liquids, water-reactive, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN3123',
    packingGroup: 'I',
    labelCodes: '6.1, 4.3',
    specialProvisions: 'A4',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '1 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Toxic solid, corrosive, inorganic, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN3290',
    packingGroup: 'I',
    labelCodes: '6.1, 8',
    specialProvisions: 'IB7, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Toxic solid, flammable, inorganic, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN3535',
    packingGroup: 'I',
    labelCodes: '6.1. 4.1',
    specialProvisions: 'IB6, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Toxic solid, inorganic, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN3288',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Toxic solids, corrosive, organic, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN2928',
    packingGroup: 'I',
    labelCodes: '6.1, 8',
    specialProvisions: 'IB7, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Toxic solids, flammable, organic, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN2930',
    packingGroup: 'I',
    labelCodes: '6.1, 4.1',
    specialProvisions: 'IB6, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Toxic solids, organic, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN2811',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Toxic solids, oxidizing, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN3086',
    packingGroup: 'I',
    labelCodes: '6.1, 5.1',
    specialProvisions: 'T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '',
  },
  {
    symbols: 'G',
    properShippingName: 'Toxic solids, self-heating, n.o.s.',
    hazardClass: '6.1',
    idNumber: 'UN3124',
    packingGroup: 'I',
    labelCodes: '6.1, 4.2',
    specialProvisions: 'A5, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Toxic solids, water-reactive, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN3125',
    packingGroup: 'I',
    labelCodes: '6.1, 4.3',
    specialProvisions: 'A5, T6, TP33, W100',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 40, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Toxins, extracted from living sources, liquid, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN3172',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '141',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: 'G',
    properShippingName: 'Toxins, extracted from living sources, solid, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN3462',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: '141, IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '243',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: 'D',
    properShippingName: 'Toy Caps',
    hazardClass: '1.4S',
    idNumber: 'NA0337',
    packingGroup: null,
    labelCodes: '1.4S',
    specialProvisions: '382',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: '01',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Tracers for ammunition',
    hazardClass: '1.3G',
    idNumber: 'UN0212',
    packingGroup: null,
    labelCodes: '1.3G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Tracers for ammunition',
    hazardClass: '1.4G',
    idNumber: 'UN0306',
    packingGroup: null,
    labelCodes: '1.4G',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Triallyl borate',
    hazardClass: '6.1',
    idNumber: 'UN2609',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13',
  },
  {
    symbols: '',
    properShippingName: 'Triallylamine',
    hazardClass: '3',
    idNumber: 'UN2610',
    packingGroup: 'III',
    labelCodes: '3, 8',
    specialProvisions: 'B1, IB3, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Triazine pesticides, liquid, flammable, toxic, flash point less than 23 degrees C',
    hazardClass: '3',
    idNumber: 'UN2764',
    packingGroup: 'I',
    labelCodes: '3, 6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Triazine pesticides, liquid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN2998',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Triazine pesticides, liquid, toxic, flammable, flash point not less than 23 degrees C',
    hazardClass: '6.1',
    idNumber: 'UN2997',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: 'T14, TP2, TP13, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Triazine pesticides, solid, toxic',
    hazardClass: '6.1',
    idNumber: 'UN2763',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Tributylamine',
    hazardClass: '6.1',
    idNumber: 'UN2542',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Tributylphosphane',
    hazardClass: '4.2',
    idNumber: 'UN3254',
    packingGroup: 'I',
    labelCodes: '4.2',
    specialProvisions: 'T21, TP7, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '136',
  },
  {
    symbols: '',
    properShippingName: 'Trichloroacetic acid',
    hazardClass: '8',
    idNumber: 'UN1839',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A7, IB8, IP2, IP4, N34, T3, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Trichloroacetic acid, solution',
    hazardClass: '8',
    idNumber: 'UN2564',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A3, A7, B2, IB2, N34, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '+',
    properShippingName: 'Trichloroacetyl chloride',
    hazardClass: '8',
    idNumber: 'UN2442',
    packingGroup: 'II',
    labelCodes: '8, 6.1',
    specialProvisions: '2, B9, B14, B32, N34, T20, TP2, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Trichlorobenzenes, liquid',
    hazardClass: '6.1',
    idNumber: 'UN2321',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Trichlorobutene',
    hazardClass: '6.1',
    idNumber: 'UN2322',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: '1,1,1-Trichloroethane',
    hazardClass: '6.1',
    idNumber: 'UN2831',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, N36, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Trichloroethylene',
    hazardClass: '6.1',
    idNumber: 'UN1710',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, N36, T4, TP1',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Trichloroisocyanuric acid, dry',
    hazardClass: '5.1',
    idNumber: 'UN2468',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13',
  },
  {
    symbols: '',
    properShippingName: 'Trichlorosilane',
    hazardClass: '4.3',
    idNumber: 'UN1295',
    packingGroup: 'I',
    labelCodes: '4.3, 3, 8',
    specialProvisions: 'N34, T14, TP2, TP7, TP13, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '21, 40, 49, 53, 58, 100',
  },
  {
    symbols: '',
    properShippingName: 'Tricresyl phosphate with more than 3 percent ortho isomer',
    hazardClass: '6.1',
    idNumber: 'UN2574',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'A3, IB2, N33, N34, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Triethyl phosphite',
    hazardClass: '3',
    idNumber: 'UN2323',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Triethylamine',
    hazardClass: '3',
    idNumber: 'UN1296',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'IB2, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Triethylenetetramine',
    hazardClass: '8',
    idNumber: 'UN2259',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'B2, IB2, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Trifluoroacetic acid',
    hazardClass: '8',
    idNumber: 'UN2699',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'A7, B4, N3, N34, N36, T10, TP2',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '12, 25, 40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Trifluoroacetyl chloride',
    hazardClass: '2.3',
    idNumber: 'UN3057',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '2, B7, B9, B14, T50, TP21',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Trifluorochloroethylene, stabilized or Refrigerant gas R 1113',
    hazardClass: '2.3',
    idNumber: 'UN1082',
    packingGroup: null,
    labelCodes: '2.3, 2.1',
    specialProvisions: '3, 387, B14, T50',
    packagingExceptions: 'None',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Trifluoromethane or Refrigerant gas R 23',
    hazardClass: '2.2',
    idNumber: 'UN1984',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Trifluoromethane, refrigerated liquid',
    hazardClass: '2.2',
    idNumber: 'UN3136',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T75, TP5',
    packagingExceptions: '306',
    packagingNonBulk: 'None',
    packagingBulk: '314, 315',
    passengerQtyLimit: '50 kg',
    cargoQtyLimit: '500 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '1,1,1-Trifluoroethane or Refrigerant gas, R 143a',
    hazardClass: '2.1',
    idNumber: 'UN2035',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: '2-Trifluoromethylaniline',
    hazardClass: '6.1',
    idNumber: 'UN2942',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: '3-Trifluoromethylaniline',
    hazardClass: '6.1',
    idNumber: 'UN2948',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Triisobutylene',
    hazardClass: '3',
    idNumber: 'UN2324',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Triisopropyl borate',
    hazardClass: '3',
    idNumber: 'UN2616',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: 'D',
    properShippingName: 'Trimethoxysilane',
    hazardClass: '6.1',
    idNumber: 'NA9269',
    packingGroup: 'I',
    labelCodes: '6.1, 3',
    specialProvisions: '2, B9, B14, B32, T20, TP4, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Trimethyl borate',
    hazardClass: '3',
    idNumber: 'UN2416',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T7, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Trimethyl phosphite',
    hazardClass: '3',
    idNumber: 'UN2329',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Trimethylacetyl chloride',
    hazardClass: '6.1',
    idNumber: 'UN2438',
    packingGroup: 'I',
    labelCodes: '6.1, 8, 3',
    specialProvisions: '2, B3, B9, B14, B32, N34, T20, TP2, TP13, TP38, TP45',
    packagingExceptions: 'None',
    packagingNonBulk: '227',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '21, 25, 40, 53, 58, 100',
  },
  {
    symbols: '',
    properShippingName: 'Trimethylamine, anhydrous',
    hazardClass: '2.1',
    idNumber: 'UN1083',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: 'N87, T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Trimethylamine, aqueous solutions with not more than 50 percent trimethylamine by mass',
    hazardClass: '3',
    idNumber: 'UN1297',
    packingGroup: 'I',
    labelCodes: '3, 8',
    specialProvisions: 'T11, TP1',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '0.5 L',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40, 52, 135',
  },
  {
    symbols: '',
    properShippingName: '1,3,5-Trimethylbenzene',
    hazardClass: '3',
    idNumber: 'UN2325',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Trimethylchlorosilane',
    hazardClass: '3',
    idNumber: 'UN1298',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'A3, A7, B77, N34, T10, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Trimethylcyclohexylamine',
    hazardClass: '8',
    idNumber: 'UN2326',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Trimethylhexamethylene diisocyanate',
    hazardClass: '6.1',
    idNumber: 'UN2328',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB3, T4, TP2, TP13',
    packagingExceptions: '153',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Trimethylhexamethylenediamines',
    hazardClass: '8',
    idNumber: 'UN2327',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T4, TP1',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Trinitro-m-cresol',
    hazardClass: '1.1D',
    idNumber: 'UN0216',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 5E',
  },
  {
    symbols: '',
    properShippingName: 'Trinitroaniline or Picramide',
    hazardClass: '1.1D',
    idNumber: 'UN0153',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Trinitroanisole',
    hazardClass: '1.1D',
    idNumber: 'UN0213',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Trinitrobenzene, dry or wetted with less than 30 percent water, by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0214',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Trinitrobenzene, wetted, with not less than 10% water, by mass',
    hazardClass: '4.1',
    idNumber: 'UN3367',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '162, A8, A19, N41, N84, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: '0.5 kg',
    cargoQtyLimit: '0.5 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Trinitrobenzene, wetted with not less than 30 percent water, by mass',
    hazardClass: '4.1',
    idNumber: 'UN1354',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '23, A2, A8, A19, N41, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: '0.5 kg',
    cargoQtyLimit: '0.5 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Trinitrobenzenesulfonic acid',
    hazardClass: '1.1D',
    idNumber: 'UN0386',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 5E',
  },
  {
    symbols: '',
    properShippingName: 'Trinitrobenzoic acid, dry or wetted with less than 30 percent water, by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0215',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Trinitrobenzoic acid, wetted with not less than 10% water by mass',
    hazardClass: '4.1',
    idNumber: 'UN3368',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '162, A8, A19, N41, N84, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: '0.5 kg',
    cargoQtyLimit: '0.5 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Trinitrobenzoic acid, wetted with not less than 30 percent water, by mass',
    hazardClass: '4.1',
    idNumber: 'UN1355',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '23, A2, A8, A19, N41, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: '0.5 kg',
    cargoQtyLimit: '0.5 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Trinitrochlorobenzene or Picryl chloride',
    hazardClass: '1.1D',
    idNumber: 'UN0155',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Trinitrochlorobenzene (picryl chloride), wetted, with not less than 10% water by mass',
    hazardClass: '4.1',
    idNumber: 'UN3365',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '162, A8, A19, N41, N84, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: '0.5 kg',
    cargoQtyLimit: '0.5 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Trinitrofluorenone',
    hazardClass: '1.1D',
    idNumber: 'UN0387',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Trinitronaphthalene',
    hazardClass: '1.1D',
    idNumber: 'UN0217',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Trinitrophenetole',
    hazardClass: '1.1D',
    idNumber: 'UN0218',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Trinitrophenol (picric acid), wetted, with not less than 10 percent water by mass',
    hazardClass: '4.1',
    idNumber: 'UN3364',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '23, A8, A19, N41, N84, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: '0.5 kg',
    cargoQtyLimit: '0.5 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Trinitrophenol or Picric acid, dry or wetted with less than 30 percent water, by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0154',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 5E',
  },
  {
    symbols: '',
    properShippingName: 'Trinitrophenol, wetted with not less than 30 percent water, by mass',
    hazardClass: '4.1',
    idNumber: 'UN1344',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '162, A8, A19, N41, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Trinitrophenylmethylnitramine or Tetryl',
    hazardClass: '1.1D',
    idNumber: 'UN0208',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName:
      'Trinitroresorcinol or Styphnic acid, dry or wetted with less than 20 percent water, or mixture of alcohol and water, by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0219',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 5E',
  },
  {
    symbols: '',
    properShippingName:
      'Trinitroresorcinol, wetted or Styphnic acid, wetted with not less than 20 percent water, or mixture of alcohol and water by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0394',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '385',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 5E',
  },
  {
    symbols: '',
    properShippingName:
      'Trinitrotoluene and Trinitrobenzene mixtures or TNT and trinitrobenzene mixtures or TNT and hexanitrostilbene mixtures or Trinitrotoluene and hexanitrostilnene mixtures',
    hazardClass: '1.1D',
    idNumber: 'UN0388',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName:
      'Trinitrotoluene mixtures containing Trinitrobenzene and Hexanitrostilbene or TNT mixtures containing trinitrobenzene and hexanitrostilbene',
    hazardClass: '1.1D',
    idNumber: 'UN0389',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Trinitrotoluene or TNT, dry or wetted with less than 30 percent water, by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0209',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Trinitrotoluene (TNT), wetted, with not less than 10 percent water by mass',
    hazardClass: '4.1',
    idNumber: 'UN3366',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '162, A8, A19, N41, N84, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: '0.5 kg',
    cargoQtyLimit: '0.5 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Trinitrotoluene, wetted or TNT, wetted, with not less than 30 percent water by mass',
    hazardClass: '4.1',
    idNumber: 'UN1356',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '23, A2, A8, A19, N41, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: '0.5 kg',
    cargoQtyLimit: '0.5 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Tripropylamine',
    hazardClass: '3',
    idNumber: 'UN2260',
    packingGroup: 'III',
    labelCodes: '3, 8',
    specialProvisions: 'B1, IB3, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 52',
  },
  {
    symbols: '',
    properShippingName: 'Tripropylene',
    hazardClass: '3',
    idNumber: 'UN2057',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Tris-(1-aziridinyl)phosphine oxide, solution',
    hazardClass: '6.1',
    idNumber: 'UN2501',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Tritonal',
    hazardClass: '1.1D',
    idNumber: 'UN0390',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Tungsten hexafluoride',
    hazardClass: '2.3',
    idNumber: 'UN2196',
    packingGroup: null,
    labelCodes: '2.3, 8',
    specialProvisions: '2, N86',
    packagingExceptions: 'None',
    packagingNonBulk: '338',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Turpentine',
    hazardClass: '3',
    idNumber: 'UN1299',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP2',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Turpentine substitute',
    hazardClass: '3',
    idNumber: 'UN1300',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: 'T11, TP1, TP8, TP27',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Undecane',
    hazardClass: '3',
    idNumber: 'UN2330',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: 'B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Uranium hexafluoride, radioactive material, excepted package, less than 0.1 kg per package, non-fissile or fissile-excepted',
    hazardClass: '6.1',
    idNumber: 'UN3507',
    packingGroup: 'I',
    labelCodes: '6.1, 7, 8',
    specialProvisions: '369',
    packagingExceptions: '420',
    packagingNonBulk: 'None',
    packagingBulk: 'None',
    passengerQtyLimit: 'Less than .1 kg',
    cargoQtyLimit: 'Less than .1 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '132, 152',
  },
  {
    symbols: '',
    properShippingName: 'Urea hydrogen peroxide',
    hazardClass: '5.1',
    idNumber: 'UN1511',
    packingGroup: 'III',
    labelCodes: '5.1, 8',
    specialProvisions: 'A1, A7, A29, IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13',
  },
  {
    symbols: '',
    properShippingName: 'Urea nitrate, dry or wetted with less than 20 percent water, by mass',
    hazardClass: '1.1D',
    idNumber: 'UN0220',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '119',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Urea nitrate, wetted, with not less than 10 percent water by mass',
    hazardClass: '4.1',
    idNumber: 'UN3370',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '162, A8, A19, N41, N84, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: '0.5 kg',
    cargoQtyLimit: '0.5 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Urea nitrate, wetted with not less than 20 percent water, by mass',
    hazardClass: '4.1',
    idNumber: 'UN1357',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '23, 39, A8, A19, N41, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Valeraldehyde',
    hazardClass: '3',
    idNumber: 'UN2058',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Valeryl chloride',
    hazardClass: '8',
    idNumber: 'UN2502',
    packingGroup: 'II',
    labelCodes: '8, 3',
    specialProvisions: 'A3, A7, B2, IB2, N34, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: 'G',
    properShippingName: 'Vanadium compound, n.o.s',
    hazardClass: '6.1',
    idNumber: 'UN3285',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Vanadium oxytrichloride',
    hazardClass: '8',
    idNumber: 'UN2443',
    packingGroup: 'II',
    labelCodes: '8',
    specialProvisions: 'A3, A7, B2, B16, IB2, N34, T7, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Vanadium pentoxide, non-fused form',
    hazardClass: '6.1',
    idNumber: 'UN2862',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Vanadium tetrachloride',
    hazardClass: '8',
    idNumber: 'UN2444',
    packingGroup: 'I',
    labelCodes: '8',
    specialProvisions: 'A7, B4, N34, T10, TP2',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '2.5 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Vanadium trichloride',
    hazardClass: '8',
    idNumber: 'UN2475',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Vanadyl sulfate',
    hazardClass: '6.1',
    idNumber: 'UN2931',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Vehicle, flammable gas powered or Vehicle, fuel cell, flammable gas powered',
    hazardClass: '9',
    idNumber: 'UN3166',
    packingGroup: null,
    labelCodes: '9',
    specialProvisions: '135, A200',
    packagingExceptions: '220',
    packagingNonBulk: '220',
    packagingBulk: '220',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'No limit',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Vehicle, flammable liquid powered or Vehicle, fuel cell, flammable liquid powered',
    hazardClass: '9',
    idNumber: 'UN3166',
    packingGroup: null,
    labelCodes: '9',
    specialProvisions: '135, A200',
    packagingExceptions: '220',
    packagingNonBulk: '220',
    packagingBulk: '220',
    passengerQtyLimit: 'No limit',
    cargoQtyLimit: 'No limit',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Vinyl acetate, stabilized',
    hazardClass: '3',
    idNumber: 'UN1301',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: '387, IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Vinyl bromide, stabilized',
    hazardClass: '2.1',
    idNumber: 'UN1085',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '387, N86, T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Vinyl butyrate, stabilized',
    hazardClass: '3',
    idNumber: 'UN2838',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: '387, IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Vinyl chloride, stabilized',
    hazardClass: '2.1',
    idNumber: 'UN1086',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '21, 387, B44, N86, T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Vinyl chloroacetate',
    hazardClass: '6.1',
    idNumber: 'UN2589',
    packingGroup: 'II',
    labelCodes: '6.1, 3',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Vinyl ethyl ether, stabilized',
    hazardClass: '3',
    idNumber: 'UN1302',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: '387, T11, TP2',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Vinyl fluoride, stabilized',
    hazardClass: '2.1',
    idNumber: 'UN1860',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '387, N86',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Vinyl isobutyl ether, stabilized',
    hazardClass: '3',
    idNumber: 'UN1304',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: '387, IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Vinyl methyl ether, stabilized',
    hazardClass: '2.1',
    idNumber: 'UN1087',
    packingGroup: null,
    labelCodes: '2.1',
    specialProvisions: '387, B44, T50',
    packagingExceptions: '306',
    packagingNonBulk: '304',
    packagingBulk: '314, 315',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Vinylidene chloride, stabilized',
    hazardClass: '3',
    idNumber: 'UN1303',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: '387, T12, TP2, TP7',
    packagingExceptions: '150',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '25, 40',
  },
  {
    symbols: '',
    properShippingName: 'Vinylpyridines, stabilized',
    hazardClass: '6.1',
    idNumber: 'UN3073',
    packingGroup: 'II',
    labelCodes: '6.1, 3, 8',
    specialProvisions: '387, IB1, T7, TP2, TP13',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '1 L',
    cargoQtyLimit: '30 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '21, 25, 40, 52, 100',
  },
  {
    symbols: '',
    properShippingName: 'Vinyltoluenes, stabilized',
    hazardClass: '3',
    idNumber: 'UN2618',
    packingGroup: 'III',
    labelCodes: '3',
    specialProvisions: '387, B1, IB3, T2, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '203',
    packagingBulk: '242',
    passengerQtyLimit: '60 L',
    cargoQtyLimit: '220 L',
    vesselStowageLocation: 'C',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Vinyltrichlorosilane',
    hazardClass: '3',
    idNumber: 'UN1305',
    packingGroup: 'II',
    labelCodes: '3, 8',
    specialProvisions: 'A3, A7, B6, N34, T10, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '206',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '5 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40, 53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Warheads, rocket with burster or expelling charge',
    hazardClass: '1.4D',
    idNumber: 'UN0370',
    packingGroup: null,
    labelCodes: '1.4D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '75 kg',
    vesselStowageLocation: '02',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Warheads, rocket with burster or expelling charge',
    hazardClass: '1.4F',
    idNumber: 'UN0371',
    packingGroup: null,
    labelCodes: '1.4F',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Warheads, rocket with bursting charge',
    hazardClass: '1.1D',
    idNumber: 'UN0286',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Warheads, rocket with bursting charge',
    hazardClass: '1.2D',
    idNumber: 'UN0287',
    packingGroup: null,
    labelCodes: '1.2D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Warheads, rocket with bursting charge',
    hazardClass: '1.1F',
    idNumber: 'UN0369',
    packingGroup: null,
    labelCodes: '1.1F',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: '',
    properShippingName: 'Warheads, torpedo with bursting charge',
    hazardClass: '1.1D',
    idNumber: 'UN0221',
    packingGroup: null,
    labelCodes: '1.1D',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: '62',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '03',
    vesselStowageOther: '25',
  },
  {
    symbols: 'G',
    properShippingName: 'Water-reactive liquid, corrosive, n.o.s.',
    hazardClass: '4.3',
    idNumber: 'UN3129',
    packingGroup: 'I',
    labelCodes: '4.3, 8',
    specialProvisions: 'T14, TP2, TP7, TP13',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '1 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Water-reactive liquid, n.o.s.',
    hazardClass: '4.3',
    idNumber: 'UN3148',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'T13, TP2, TP7, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '244',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '1 L',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Water-reactive liquid, toxic, n.o.s',
    hazardClass: '4.3',
    idNumber: 'UN3130',
    packingGroup: 'I',
    labelCodes: '4.3, 6.1',
    specialProvisions: 'A4',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '1 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Water-reactive solid, corrosive, n.o.s',
    hazardClass: '4.3',
    idNumber: 'UN3131',
    packingGroup: 'I',
    labelCodes: '4.3, 8',
    specialProvisions: 'IB4, IP1, N40, T9, TP7, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Water-reactive solid, flammable, n.o.s.',
    hazardClass: '4.3',
    idNumber: 'UN3132',
    packingGroup: 'I',
    labelCodes: '4.3, 4.1',
    specialProvisions: 'IB4, N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Water-reactive solid, n.o.s',
    hazardClass: '4.3',
    idNumber: 'UN2813',
    packingGroup: 'I',
    labelCodes: '4.3',
    specialProvisions: 'IB4, N40, T9, TP7, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Water-reactive, solid, oxidizing, n.o.s',
    hazardClass: '4.3',
    idNumber: 'UN3133',
    packingGroup: 'II',
    labelCodes: '4.3, 5.1',
    specialProvisions: '',
    packagingExceptions: '151',
    packagingNonBulk: '214',
    packagingBulk: '214',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Water-reactive solid, self-heating, n.o.s.',
    hazardClass: '4.3',
    idNumber: 'UN3135',
    packingGroup: 'I',
    labelCodes: '4.3, 4.2',
    specialProvisions: 'N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: 'G',
    properShippingName: 'Water-reactive solid, toxic, n.o.s',
    hazardClass: '4.3',
    idNumber: 'UN3134',
    packingGroup: 'I',
    labelCodes: '4.3, 6.1',
    specialProvisions: 'A8, IB4, IP1, N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: '',
    properShippingName: 'Wood preservatives, liquid',
    hazardClass: '3',
    idNumber: 'UN1306',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: '149, IB2, T4, TP1, TP8',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: 'A I W',
    properShippingName: 'Wool waste, wet',
    hazardClass: '4.2',
    idNumber: 'UN1387',
    packingGroup: 'III',
    labelCodes: '4.2',
    specialProvisions: '',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Xanthates',
    hazardClass: '4.2',
    idNumber: 'UN3342',
    packingGroup: 'II',
    labelCodes: '4.2',
    specialProvisions: 'IB6, IP2, T3, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Xenon, compressed',
    hazardClass: '2.2',
    idNumber: 'UN2036',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: '',
    packagingExceptions: '306, 307',
    packagingNonBulk: '302',
    packagingBulk: 'None',
    passengerQtyLimit: '75 kg',
    cargoQtyLimit: '150 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Xenon, refrigerated liquid (cryogenic liquids)',
    hazardClass: '2.2',
    idNumber: 'UN2591',
    packingGroup: null,
    labelCodes: '2.2',
    specialProvisions: 'T75, TP5',
    packagingExceptions: '320',
    packagingNonBulk: 'None',
    packagingBulk: 'None',
    passengerQtyLimit: '50 kg',
    cargoQtyLimit: '500 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Xylenes',
    hazardClass: '3',
    idNumber: 'UN1307',
    packingGroup: 'II',
    labelCodes: '3',
    specialProvisions: 'IB2, T4, TP1',
    packagingExceptions: '150',
    packagingNonBulk: '202',
    packagingBulk: '242',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Xylenols, solid',
    hazardClass: '6.1',
    idNumber: 'UN2261',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Xylenols, liquid',
    hazardClass: '6.1',
    idNumber: 'UN3430',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Xylidines, liquid',
    hazardClass: '6.1',
    idNumber: 'UN1711',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB2, T7, TP2',
    packagingExceptions: '153',
    packagingNonBulk: '202',
    packagingBulk: '243',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Xylidines, solid',
    hazardClass: '6.1',
    idNumber: 'UN3452',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Xylyl bromide, liquid',
    hazardClass: '6.1',
    idNumber: 'UN1701',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'A3, A7, IB2, N33, T7, TP2, TP13, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '340',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'D',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Xylyl bromide, solid',
    hazardClass: '6.1',
    idNumber: 'UN3417',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'A3, A6, A7, IB8, IP2, IP4, N33, T3, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '340',
    packagingBulk: 'None',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'B',
    vesselStowageOther: '40',
  },
  {
    symbols: '',
    properShippingName: 'Zinc ammonium nitrite',
    hazardClass: '5.1',
    idNumber: 'UN1512',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB8, IP4, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Zinc arsenate or Zinc arsenite or Zinc arsenate and zinc arsenite mixtures',
    hazardClass: '6.1',
    idNumber: 'UN1712',
    packingGroup: 'II',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Zinc ashes',
    hazardClass: '4.3',
    idNumber: 'UN1435',
    packingGroup: 'III',
    labelCodes: '4.3',
    specialProvisions: 'A1, A19, B136, IB8, IP4, T1, TP33, W100',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '241',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: '',
    properShippingName: 'Zinc bromate',
    hazardClass: '5.1',
    idNumber: 'UN2469',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: 'A1, A29, IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Zinc chlorate',
    hazardClass: '5.1',
    idNumber: 'UN1513',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'A9, IB8, IP2, IP4, N34, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '56, 58',
  },
  {
    symbols: '',
    properShippingName: 'Zinc chloride, anhydrous',
    hazardClass: '8',
    idNumber: 'UN2331',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Zinc chloride, solution',
    hazardClass: '8',
    idNumber: 'UN1840',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB3, T4, TP2',
    packagingExceptions: '154',
    packagingNonBulk: '203',
    packagingBulk: '241',
    passengerQtyLimit: '5 L',
    cargoQtyLimit: '60 L',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
  {
    symbols: '',
    properShippingName: 'Zinc cyanide',
    hazardClass: '6.1',
    idNumber: 'UN1713',
    packingGroup: 'I',
    labelCodes: '6.1',
    specialProvisions: 'IB7, IP1, T6, TP33',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Zinc dithionite or Zinc hydrosulfite',
    hazardClass: '9',
    idNumber: 'UN1931',
    packingGroup: 'III',
    labelCodes: 'None',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '155',
    packagingNonBulk: '204',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 26, 123',
  },
  {
    symbols: '',
    properShippingName: 'Zinc fluorosilicate',
    hazardClass: '6.1',
    idNumber: 'UN2855',
    packingGroup: 'III',
    labelCodes: '6.1',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '153',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '100 kg',
    cargoQtyLimit: '200 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '52',
  },
  {
    symbols: '',
    properShippingName: 'Zinc nitrate',
    hazardClass: '5.1',
    idNumber: 'UN1514',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB8, IP2, IP4, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Zinc permanganate',
    hazardClass: '5.1',
    idNumber: 'UN1515',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB6, IP2, T3, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '56, 58, 138',
  },
  {
    symbols: '',
    properShippingName: 'Zinc peroxide',
    hazardClass: '5.1',
    idNumber: 'UN1516',
    packingGroup: 'II',
    labelCodes: '5.1',
    specialProvisions: 'IB6, IP2, T3, TP33, W100',
    packagingExceptions: '152',
    packagingNonBulk: '212',
    packagingBulk: '242',
    passengerQtyLimit: '5 kg',
    cargoQtyLimit: '25 kg',
    vesselStowageLocation: 'C',
    vesselStowageOther: '13, 52, 66, 75, 148',
  },
  {
    symbols: '',
    properShippingName: 'Zinc phosphide',
    hazardClass: '4.3',
    idNumber: 'UN1714',
    packingGroup: 'I',
    labelCodes: '4.3, 6.1',
    specialProvisions: 'A19, N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 40, 52, 85, 148',
  },
  {
    symbols: '',
    properShippingName: 'Zinc powder or Zinc dust',
    hazardClass: '4.3',
    idNumber: 'UN1436',
    packingGroup: 'I',
    labelCodes: '4.3, 4.2',
    specialProvisions: 'A19, IB4, IP1, N40, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 52, 53, 148',
  },
  {
    symbols: '',
    properShippingName: 'Zinc resinate',
    hazardClass: '4.1',
    idNumber: 'UN2714',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: 'A1, IB6, T1, TP33',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName:
      'Zirconium, dry, coiled wire, finished metal sheets, strip (thinner than 254 microns but not thinner than 18 microns)',
    hazardClass: '4.1',
    idNumber: 'UN2858',
    packingGroup: 'III',
    labelCodes: '4.1',
    specialProvisions: 'A1, W100',
    packagingExceptions: '151',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '13, 147, 148',
  },
  {
    symbols: '',
    properShippingName: 'Zirconium, dry, finished sheets, strip or coiled wire',
    hazardClass: '4.2',
    idNumber: 'UN2009',
    packingGroup: 'III',
    labelCodes: '4.2',
    specialProvisions: 'A1, A19, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: '',
    properShippingName: 'Zirconium hydride',
    hazardClass: '4.1',
    idNumber: 'UN1437',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: 'A19, A20, IB4, N34, T3, TP33, W31, W40',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '240',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Zirconium nitrate',
    hazardClass: '5.1',
    idNumber: 'UN2728',
    packingGroup: 'III',
    labelCodes: '5.1',
    specialProvisions: 'A1, A29, IB8, IP3, T1, TP33',
    packagingExceptions: '152',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Zirconium picramate, dry or wetted with less than 20 percent water, by mass',
    hazardClass: '1.3C',
    idNumber: 'UN0236',
    packingGroup: null,
    labelCodes: '1.3C',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '62',
    packagingBulk: 'None',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: '04',
    vesselStowageOther: '25, 5E',
  },
  {
    symbols: '',
    properShippingName: 'Zirconium picramate, wetted with not less than 20 percent water, by mass',
    hazardClass: '4.1',
    idNumber: 'UN1517',
    packingGroup: 'I',
    labelCodes: '4.1',
    specialProvisions: '23, N41, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: 'None',
    passengerQtyLimit: '1 kg',
    cargoQtyLimit: '15 kg',
    vesselStowageLocation: 'D',
    vesselStowageOther: '28, 36',
  },
  {
    symbols: '',
    properShippingName: 'Zirconium powder, dry',
    hazardClass: '4.2',
    idNumber: 'UN2008',
    packingGroup: 'I',
    labelCodes: '4.2',
    specialProvisions: 'T21, TP7, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '211',
    packagingBulk: '242',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: '',
    properShippingName:
      'Zirconium powder, wetted with not less than 25 percent water (a visible excess of water must be present) (a) mechanically produced, particle size less than 53 microns; (b) chemically produced, particle size less than 840 microns',
    hazardClass: '4.1',
    idNumber: 'UN1358',
    packingGroup: 'II',
    labelCodes: '4.1',
    specialProvisions: 'A19, A20, IB6, IP2, N34, T3, TP33, W31, W40',
    packagingExceptions: '151',
    packagingNonBulk: '212',
    packagingBulk: '241',
    passengerQtyLimit: '15 kg',
    cargoQtyLimit: '50 kg',
    vesselStowageLocation: 'E',
    vesselStowageOther: '13, 74, 147, 148',
  },
  {
    symbols: '',
    properShippingName: 'Zirconium scrap',
    hazardClass: '4.2',
    idNumber: 'UN1932',
    packingGroup: 'III',
    labelCodes: '4.2',
    specialProvisions: 'B135, IB8, IP21, N34, T1, TP33, W31',
    packagingExceptions: 'None',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'D',
    vesselStowageOther: '13, 148',
  },
  {
    symbols: '',
    properShippingName: 'Zirconium suspended in a liquid',
    hazardClass: '3',
    idNumber: 'UN1308',
    packingGroup: 'I',
    labelCodes: '3',
    specialProvisions: '',
    packagingExceptions: 'None',
    packagingNonBulk: '201',
    packagingBulk: '243',
    passengerQtyLimit: 'Forbidden',
    cargoQtyLimit: 'Forbidden',
    vesselStowageLocation: 'B',
    vesselStowageOther: '',
  },
  {
    symbols: '',
    properShippingName: 'Zirconium tetrachloride',
    hazardClass: '8',
    idNumber: 'UN2503',
    packingGroup: 'III',
    labelCodes: '8',
    specialProvisions: 'IB8, IP3, T1, TP33',
    packagingExceptions: '154',
    packagingNonBulk: '213',
    packagingBulk: '240',
    passengerQtyLimit: '25 kg',
    cargoQtyLimit: '100 kg',
    vesselStowageLocation: 'A',
    vesselStowageOther: '53, 58',
  },
];

/** UN/NA ID -> matching table entries. Multiple entries per ID are common. */
export const HAZMAT_TABLE_BY_ID: Readonly<Record<string, HazmatTableEntry[]>> = (() => {
  const map: Record<string, HazmatTableEntry[]> = {};
  for (const entry of HAZMAT_TABLE) (map[entry.idNumber] ??= []).push(entry);
  return map;
})();
